/* tslint:disable */
/* eslint-disable */
/**
 * TopDeck API Documentation
 * Documentation for the TopDeck API.  Let someone know if there are serious issues.  Much of this is auto-generated.
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from './base'

/**
 *
 * @export
 * @interface AlarmContact
 */
export interface AlarmContact {
  /**
   *
   * @type {number}
   * @memberof AlarmContact
   */
  id?: number
  /**
   *
   * @type {UserSummary}
   * @memberof AlarmContact
   */
  user?: UserSummary
  /**
   *
   * @type {string}
   * @memberof AlarmContact
   */
  pin?: string | null
  /**
   *
   * @type {number}
   * @memberof AlarmContact
   */
  sequence: number
  /**
   *
   * @type {number}
   * @memberof AlarmContact
   */
  user_id: number
}
/**
 *
 * @export
 * @interface Analysis
 */
export interface Analysis {
  /**
   *
   * @type {number}
   * @memberof Analysis
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof Analysis
   */
  project?: number
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  start_datetime: string
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  end_datetime?: string | null
}
/**
 *
 * @export
 * @interface ArmScheduleEventDatetime
 */
export interface ArmScheduleEventDatetime {
  /**
   *
   * @type {boolean}
   * @memberof ArmScheduleEventDatetime
   */
  armed: boolean
  /**
   *
   * @type {string}
   * @memberof ArmScheduleEventDatetime
   */
  event_datetime: string
}
/**
 *
 * @export
 * @interface ArmingEvent
 */
export interface ArmingEvent {
  /**
   *
   * @type {number}
   * @memberof ArmingEvent
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ArmingEvent
   */
  performed_at: string
  /**
   *
   * @type {UserSummary}
   * @memberof ArmingEvent
   */
  performed_by: UserSummary
  /**
   *
   * @type {boolean}
   * @memberof ArmingEvent
   */
  armed: boolean
  /**
   *
   * @type {boolean}
   * @memberof ArmingEvent
   */
  manual?: boolean
}
/**
 *
 * @export
 * @interface ArmingScheduleItem
 */
export interface ArmingScheduleItem {
  /**
   *
   * @type {number}
   * @memberof ArmingScheduleItem
   */
  day: number
  /**
   *
   * @type {string}
   * @memberof ArmingScheduleItem
   */
  event_time: string
  /**
   *
   * @type {boolean}
   * @memberof ArmingScheduleItem
   */
  armed: boolean
}
/**
 *
 * @export
 * @interface ArmingScheduleUpdate
 */
export interface ArmingScheduleUpdate {
  /**
   *
   * @type {number}
   * @memberof ArmingScheduleUpdate
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ArmingScheduleUpdate
   */
  performed_at: string
  /**
   *
   * @type {UserSummary}
   * @memberof ArmingScheduleUpdate
   */
  performed_by: UserSummary
  /**
   *
   * @type {Array<ArmingScheduleItem>}
   * @memberof ArmingScheduleUpdate
   */
  data: Array<ArmingScheduleItem>
}
/**
 *
 * @export
 * @interface CamEvent
 */
export interface CamEvent {
  /**
   *
   * @type {number}
   * @memberof CamEvent
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  source_stream_name: string
  /**
   *
   * @type {number}
   * @memberof CamEvent
   */
  stream?: number
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  source: CamEventSourceEnum
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  event_time: string
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  event_type: string
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  video_url?: string
  /**
   *
   * @type {Array<CamEventImage>}
   * @memberof CamEvent
   */
  images?: Array<CamEventImage>
  /**
   *
   * @type {boolean}
   * @memberof CamEvent
   */
  alarm_active?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CamEvent
   */
  alarm_psap_contacted?: boolean
  /**
   *
   * @type {UserSummary}
   * @memberof CamEvent
   */
  alarm_canceled_by?: UserSummary
  /**
   *
   * @type {string}
   * @memberof CamEvent
   */
  alarm_canceled_at?: string
}

/**
 * @export
 * @enum {string}
 */
export enum CamEventSourceEnum {
  Email = 'email',
  Listener = 'listener',
  Unknown = 'unknown',
}

/**
 *
 * @export
 * @interface CamEventImage
 */
export interface CamEventImage {
  /**
   *
   * @type {number}
   * @memberof CamEventImage
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CamEventImage
   */
  file: string
  /**
   *
   * @type {number}
   * @memberof CamEventImage
   */
  sequence?: number
  /**
   *
   * @type {string}
   * @memberof CamEventImage
   */
  file_url?: string
}
/**
 *
 * @export
 * @interface Camera
 */
export interface Camera {
  /**
   *
   * @type {number}
   * @memberof Camera
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Camera
   */
  make: CameraMakeEnum
  /**
   *
   * @type {string}
   * @memberof Camera
   */
  model: string
  /**
   * Example: \"2560:1440\".
   * @type {string}
   * @memberof Camera
   */
  resolution: string
}

/**
 * @export
 * @enum {string}
 */
export enum CameraMakeEnum {
  Hikvision = 'Hikvision',
  Amcrest = 'Amcrest',
  Hanwha = 'Hanwha',
  Dahua = 'Dahua',
  Unknown = 'Unknown',
}

/**
 *
 * @export
 * @interface CameraPreset
 */
export interface CameraPreset {
  /**
   * ID of camera preset
   * @type {string}
   * @memberof CameraPreset
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CameraPreset
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof CameraPreset
   */
  enabled?: boolean
}
/**
 *
 * @export
 * @interface ClassLabel
 */
export interface ClassLabel {
  /**
   *
   * @type {string}
   * @memberof ClassLabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ClassLabel
   */
  color: string
}
/**
 *
 * @export
 * @interface Clip
 */
export interface Clip {
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  analysis?: number
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  stream: number
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  grouping?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Clip
   */
  featured?: boolean
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  start_datetime: string
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  end_datetime?: string | null
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  speed?: number
  /**
   *
   * @type {boolean}
   * @memberof Clip
   */
  stabilize_video?: boolean
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  h?: number | null
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  w?: number | null
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  x?: number | null
  /**
   *
   * @type {number}
   * @memberof Clip
   */
  y?: number | null
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  video_url?: string
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  image_url?: string
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  thumbnail_url?: string
  /**
   * initial is \"Initial\", extracting is \"Extracting\", failed is \"Failed\", completed is \"Completed\"
   * @type {string}
   * @memberof Clip
   */
  state?: ClipStateEnum
  /**
   *
   * @type {string}
   * @memberof Clip
   */
  failure_message?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum ClipStateEnum {
  Initial = 'initial',
  Extracting = 'extracting',
  Failed = 'failed',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface Crane
 */
export interface Crane {
  /**
   *
   * @type {number}
   * @memberof Crane
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Crane
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof Crane
   */
  project?: number
  /**
   *
   * @type {number}
   * @memberof Crane
   */
  jib_stream_original?: number
  /**
   *
   * @type {number}
   * @memberof Crane
   */
  jib_stream_with_boxes?: number
  /**
   * Unit of measure matches what EPSG system specifies.
   * @type {number}
   * @memberof Crane
   */
  jib_length?: number
  /**
   * If on a crane, this should be approximate location of the center of the crane.
   * @type {number}
   * @memberof Crane
   */
  latitude?: number | null
  /**
   * If on a crane, this should be approximate location of the center of the crane.
   * @type {number}
   * @memberof Crane
   */
  longitude?: number | null
}
/**
 *
 * @export
 * @interface CraneCalendarEntry
 */
export interface CraneCalendarEntry {
  /**
   *
   * @type {number}
   * @memberof CraneCalendarEntry
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CraneCalendarEntry
   */
  start_datetime: string
  /**
   *
   * @type {string}
   * @memberof CraneCalendarEntry
   */
  end_datetime: string
  /**
   *
   * @type {string}
   * @memberof CraneCalendarEntry
   */
  title?: string | null
  /**
   *
   * @type {number}
   * @memberof CraneCalendarEntry
   */
  subcontractor_link?: number | null
  /**
   *
   * @type {Subcontractor}
   * @memberof CraneCalendarEntry
   */
  subcontractor_attrs?: Subcontractor | null
  /**
   *
   * @type {string}
   * @memberof CraneCalendarEntry
   */
  description?: string | null
}
/**
 *
 * @export
 * @interface CraneDay
 */
export interface CraneDay {
  /**
   *
   * @type {number}
   * @memberof CraneDay
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CraneDay
   */
  day: string
  /**
   *
   * @type {boolean}
   * @memberof CraneDay
   */
  complete?: boolean
}
/**
 *
 * @export
 * @interface CraneEvent
 */
export interface CraneEvent {
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  crane: number
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  state: number
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  latitude?: number | null
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  longitude?: number | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  event_datetime: string
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  load_data?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  action?: string | null
  /**
   *
   * @type {boolean}
   * @memberof CraneEvent
   */
  rework?: boolean
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  subcontractor_link?: number | null
  /**
   *
   * @type {Subcontractor}
   * @memberof CraneEvent
   */
  subcontractor_attrs?: Subcontractor | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  from_level?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  to_level?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  from_element?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  to_element?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  from_side?: string | null
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  to_side?: string | null
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  created_by?: number | null
  /**
   *
   * @type {number}
   * @memberof CraneEvent
   */
  updated_by?: number | null
  /**
   *
   * @type {UserSummary}
   * @memberof CraneEvent
   */
  created_by_attrs?: UserSummary
  /**
   *
   * @type {UserSummary}
   * @memberof CraneEvent
   */
  updated_by_attrs?: UserSummary
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  created_at?: string
  /**
   *
   * @type {string}
   * @memberof CraneEvent
   */
  updated_at?: string
}
/**
 *
 * @export
 * @interface CraneEventState
 */
export interface CraneEventState {
  /**
   *
   * @type {number}
   * @memberof CraneEventState
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CraneEventState
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CraneEventState
   */
  slug: string
}
/**
 *
 * @export
 * @interface CranePick
 */
export interface CranePick {
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  crane: number
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  stream: number
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  start_longitude: number | null
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  start_latitude: number | null
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  end_longitude: number | null
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  end_latitude: number | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  in_between_start: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  in_between_idle: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  in_between_end: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_pick_start: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_pick_idle: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_pick_end: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  load_start: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  load_idle: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  load_end: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  travel_start: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  travel_idle: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  travel_end: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  unload_start: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  unload_idle: string
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  unload_end: string
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  quantity: number
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  load_data: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  action: string | null
  /**
   *
   * @type {boolean}
   * @memberof CranePick
   */
  rework?: boolean
  /**
   *
   * @type {number}
   * @memberof CranePick
   */
  subcontractor_id: number | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  subcontractor_name: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  subcontractor_color: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  from_level: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_level: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  from_element: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_element: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  from_side: string | null
  /**
   *
   * @type {string}
   * @memberof CranePick
   */
  to_side: string | null
}
/**
 *
 * @export
 * @interface CreatePhotosphereDrawingRequest
 */
export interface CreatePhotosphereDrawingRequest {
  /**
   *
   * @type {PhotosphereDrawing}
   * @memberof CreatePhotosphereDrawingRequest
   */
  drawing: PhotosphereDrawing
  /**
   *
   * @type {UploadInitRequest}
   * @memberof CreatePhotosphereDrawingRequest
   */
  upload_request: UploadInitRequest
}
/**
 *
 * @export
 * @interface CreatePhotosphereDrawingResponse
 */
export interface CreatePhotosphereDrawingResponse {
  /**
   *
   * @type {PhotosphereDrawing}
   * @memberof CreatePhotosphereDrawingResponse
   */
  drawing: PhotosphereDrawing
  /**
   *
   * @type {S3PresignedPost}
   * @memberof CreatePhotosphereDrawingResponse
   */
  presigned_post: S3PresignedPost
}
/**
 *
 * @export
 * @interface DateMetrics
 */
export interface DateMetrics {
  /**
   *
   * @type {string}
   * @memberof DateMetrics
   */
  timestamp: string
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof DateMetrics
   */
  metrics: { [key: string]: number }
}
/**
 *
 * @export
 * @interface DispatchRequestMetaCancelInfo
 */
export interface DispatchRequestMetaCancelInfo {
  /**
   *
   * @type {string}
   * @memberof DispatchRequestMetaCancelInfo
   */
  phone?: string
}
/**
 *
 * @export
 * @interface Frame
 */
export interface Frame {
  /**
   *
   * @type {number}
   * @memberof Frame
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof Frame
   */
  image_url: string
  /**
   *
   * @type {string}
   * @memberof Frame
   */
  mask_image_url?: string
  /**
   * Approximate datetime of image
   * @type {string}
   * @memberof Frame
   */
  image_datetime: string
  /**
   * unknown is \"Source unknown\", live is \"Frame pulled live from stream\", extracted is \"Frame pulled from a video.\"
   * @type {string}
   * @memberof Frame
   */
  frame_type: FrameFrameTypeEnum
  /**
   * Number of seconds into video the frame was extracted
   * @type {number}
   * @memberof Frame
   */
  offset_seconds: number
  /**
   * 1 is \"Old style of how the thumbnail is stored.\", 2 is \"Thumbnail is stored in backblaze.\"
   * @type {number}
   * @memberof Frame
   */
  storage_version: number
  /**
   *
   * @type {string}
   * @memberof Frame
   */
  local_image_datetime?: string
  /**
   *
   * @type {string}
   * @memberof Frame
   */
  thumbnail_url?: string
  /**
   *
   * @type {string}
   * @memberof Frame
   */
  annotationdb_dtkey?: string
  /**
   *
   * @type {Array<Array<Array<number>>>}
   * @memberof Frame
   */
  mask_polygons?: Array<Array<Array<number>>> | null
  /**
   *
   * @type {number}
   * @memberof Frame
   */
  video_id?: number | null
}

/**
 * @export
 * @enum {string}
 */
export enum FrameFrameTypeEnum {
  Unknown = 'unknown',
  Live = 'live',
  Extracted = 'extracted',
}

/**
 *
 * @export
 * @interface FrameMaskOnly
 */
export interface FrameMaskOnly {
  /**
   *
   * @type {Array<Array<Array<number>>>}
   * @memberof FrameMaskOnly
   */
  mask_polygons: Array<Array<Array<number>>> | null
}
/**
 *
 * @export
 * @interface Homography
 */
export interface Homography {
  /**
   *
   * @type {number}
   * @memberof Homography
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof Homography
   */
  stabilization_job: number
  /**
   *
   * @type {number}
   * @memberof Homography
   */
  upload: number
  /**
   *
   * @type {number}
   * @memberof Homography
   */
  upload_page_number: number
  /**
   *
   * @type {Array<number>}
   * @memberof Homography
   */
  transformation?: Array<number>
}
/**
 *
 * @export
 * @interface ISocketWebhook
 */
export interface ISocketWebhook {
  /**
   *
   * @type {string}
   * @memberof ISocketWebhook
   */
  timestamp?: string
  /**
   *
   * @type {string}
   * @memberof ISocketWebhook
   */
  tid?: string
  /**
   *
   * @type {string}
   * @memberof ISocketWebhook
   */
  alertTimeUtc?: string
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ISocketWebhook
   */
  Device?: { [key: string]: string }
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ISocketWebhook
   */
  Power?: { [key: string]: string }
}
/**
 *
 * @export
 * @interface ImageAnnotationBox
 */
export interface ImageAnnotationBox {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  id?: number
  /**
   *
   * @type {ImageLabel}
   * @memberof ImageAnnotationBox
   */
  label: ImageLabel
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  category_id?: number
  /**
   *
   * @type {ImageSublabel}
   * @memberof ImageAnnotationBox
   */
  sublabel?: ImageSublabel
  /**
   *
   * @type {Array<ImageAnnotationBoxComment>}
   * @memberof ImageAnnotationBox
   */
  comments: Array<ImageAnnotationBoxComment>
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBox
   */
  issue_flagged?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBox
   */
  issue_resolved?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBox
   */
  is_currently_valid: boolean
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  h: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  w: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  x: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBox
   */
  y: number
}
/**
 *
 * @export
 * @interface ImageAnnotationBoxAddComment
 */
export interface ImageAnnotationBoxAddComment {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationBoxAddComment
   */
  comment: string
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxAddComment
   */
  issue_resolved?: boolean
}
/**
 *
 * @export
 * @interface ImageAnnotationBoxComment
 */
export interface ImageAnnotationBoxComment {
  /**
   *
   * @type {UserSummary}
   * @memberof ImageAnnotationBoxComment
   */
  user: UserSummary
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationBoxComment
   */
  comment: string
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationBoxComment
   */
  comment_datetime: string
}
/**
 *
 * @export
 * @interface ImageAnnotationBoxComparison
 */
export interface ImageAnnotationBoxComparison {
  /**
   *
   * @type {ImageAnnotationBox}
   * @memberof ImageAnnotationBoxComparison
   */
  worker_box: ImageAnnotationBox
  /**
   *
   * @type {ImageAnnotationBox}
   * @memberof ImageAnnotationBoxComparison
   */
  editor_box: ImageAnnotationBox
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxComparison
   */
  relabeled: boolean
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxComparison
   */
  resized: boolean
}
/**
 *
 * @export
 * @interface ImageAnnotationBoxDetails
 */
export interface ImageAnnotationBoxDetails {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  id?: number
  /**
   *
   * @type {ImageLabel}
   * @memberof ImageAnnotationBoxDetails
   */
  label: ImageLabel
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  category_id?: number
  /**
   *
   * @type {ImageSublabel}
   * @memberof ImageAnnotationBoxDetails
   */
  sublabel?: ImageSublabel
  /**
   *
   * @type {Array<ImageAnnotationBoxComment>}
   * @memberof ImageAnnotationBoxDetails
   */
  comments: Array<ImageAnnotationBoxComment>
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxDetails
   */
  issue_flagged?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxDetails
   */
  issue_resolved?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ImageAnnotationBoxDetails
   */
  is_currently_valid: boolean
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  h: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  w: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  x: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationBoxDetails
   */
  y: number
  /**
   *
   * @type {Frame}
   * @memberof ImageAnnotationBoxDetails
   */
  frame?: Frame
}
/**
 *
 * @export
 * @interface ImageAnnotationComparison
 */
export interface ImageAnnotationComparison {
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof ImageAnnotationComparison
   */
  boxes_deleted: Array<ImageAnnotationBox>
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof ImageAnnotationComparison
   */
  boxes_added: Array<ImageAnnotationBox>
  /**
   *
   * @type {Array<ImageAnnotationBoxComparison>}
   * @memberof ImageAnnotationComparison
   */
  changes: Array<ImageAnnotationBoxComparison>
  /**
   *
   * @type {Array<ImageAnnotationBoxComparison>}
   * @memberof ImageAnnotationComparison
   */
  relabeled_changes: Array<ImageAnnotationBoxComparison>
  /**
   *
   * @type {Array<ImageAnnotationBoxComparison>}
   * @memberof ImageAnnotationComparison
   */
  resized_changes: Array<ImageAnnotationBoxComparison>
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_worker_boxes_all: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_worker_boxes_processed: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_worker_boxes_ignored: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_editor_boxes_all: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_editor_boxes_processed: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_editor_boxes_ignored: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_added: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_deleted: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_resized: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  num_relabeled: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationComparison
   */
  reporting_score: number
}
/**
 *
 * @export
 * @interface ImageAnnotationReportDetails
 */
export interface ImageAnnotationReportDetails {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationReportDetails
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportDetails
   */
  annotation_datetime?: string | null
  /**
   *
   * @type {Session}
   * @memberof ImageAnnotationReportDetails
   */
  session: Session
  /**
   *
   * @type {ImageCategorySummary}
   * @memberof ImageAnnotationReportDetails
   */
  category: ImageCategorySummary
  /**
   *
   * @type {Session}
   * @memberof ImageAnnotationReportDetails
   */
  review_session: Session
  /**
   *
   * @type {Frame}
   * @memberof ImageAnnotationReportDetails
   */
  frame: Frame
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportDetails
   */
  stream_name?: string
  /**
   * ai is \"AI Labeled\", tag is \"Tag\", review is \"Review\"
   * @type {string}
   * @memberof ImageAnnotationReportDetails
   */
  annotation_type: ImageAnnotationReportDetailsAnnotationTypeEnum
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportDetails
   */
  is_version_current?: string
  /**
   * Eligible to Be Paid
   * @type {boolean}
   * @memberof ImageAnnotationReportDetails
   */
  pay_eligible?: boolean
  /**
   * Initial Review At
   * @type {string}
   * @memberof ImageAnnotationReportDetails
   */
  initial_review_at?: string | null
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationReportDetails
   */
  reporting_score?: number | null
  /**
   *
   * @type {ImageAnnotationComparison}
   * @memberof ImageAnnotationReportDetails
   */
  report: ImageAnnotationComparison
}

/**
 * @export
 * @enum {string}
 */
export enum ImageAnnotationReportDetailsAnnotationTypeEnum {
  Ai = 'ai',
  Tag = 'tag',
  Review = 'review',
}

/**
 *
 * @export
 * @interface ImageAnnotationReportSummary
 */
export interface ImageAnnotationReportSummary {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationReportSummary
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportSummary
   */
  annotation_datetime?: string | null
  /**
   *
   * @type {Session}
   * @memberof ImageAnnotationReportSummary
   */
  session: Session
  /**
   *
   * @type {ImageCategorySummary}
   * @memberof ImageAnnotationReportSummary
   */
  category: ImageCategorySummary
  /**
   *
   * @type {Session}
   * @memberof ImageAnnotationReportSummary
   */
  review_session: Session
  /**
   *
   * @type {Frame}
   * @memberof ImageAnnotationReportSummary
   */
  frame: Frame
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportSummary
   */
  stream_name?: string
  /**
   * ai is \"AI Labeled\", tag is \"Tag\", review is \"Review\"
   * @type {string}
   * @memberof ImageAnnotationReportSummary
   */
  annotation_type: ImageAnnotationReportSummaryAnnotationTypeEnum
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationReportSummary
   */
  is_version_current?: string
  /**
   * Eligible to Be Paid
   * @type {boolean}
   * @memberof ImageAnnotationReportSummary
   */
  pay_eligible?: boolean
  /**
   * Initial Review At
   * @type {string}
   * @memberof ImageAnnotationReportSummary
   */
  initial_review_at?: string | null
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationReportSummary
   */
  reporting_score?: number | null
}

/**
 * @export
 * @enum {string}
 */
export enum ImageAnnotationReportSummaryAnnotationTypeEnum {
  Ai = 'ai',
  Tag = 'tag',
  Review = 'review',
}

/**
 *
 * @export
 * @interface ImageAnnotationSessionCompletion
 */
export interface ImageAnnotationSessionCompletion {
  /**
   *
   * @type {Array<NestedImageAnnotationBoxCreate>}
   * @memberof ImageAnnotationSessionCompletion
   */
  boxes: Array<NestedImageAnnotationBoxCreate>
}
/**
 *
 * @export
 * @interface ImageAnnotationSessionCreation
 */
export interface ImageAnnotationSessionCreation {
  /**
   *
   * @type {Array<number>}
   * @memberof ImageAnnotationSessionCreation
   */
  submission_ids: Array<number>
}
/**
 *
 * @export
 * @interface ImageAnnotationSummary
 */
export interface ImageAnnotationSummary {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationSummary
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationSummary
   */
  annotation_datetime?: string | null
  /**
   *
   * @type {Session}
   * @memberof ImageAnnotationSummary
   */
  session: Session
  /**
   * ai is \"AI Labeled\", tag is \"Tag\", review is \"Review\"
   * @type {string}
   * @memberof ImageAnnotationSummary
   */
  annotation_type: ImageAnnotationSummaryAnnotationTypeEnum
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationSummary
   */
  is_version_current: string
}

/**
 * @export
 * @enum {string}
 */
export enum ImageAnnotationSummaryAnnotationTypeEnum {
  Ai = 'ai',
  Tag = 'tag',
  Review = 'review',
}

/**
 *
 * @export
 * @interface ImageAnnotationUserReport
 */
export interface ImageAnnotationUserReport {
  /**
   *
   * @type {UserSummary}
   * @memberof ImageAnnotationUserReport
   */
  user: UserSummary
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  avg_score?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  num_annotations?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  num_boxes_annotated?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  num_boxes_reviewed?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  time?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  bonus?: number
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationUserReport
   */
  total?: number
}
/**
 *
 * @export
 * @interface ImageCandidate
 */
export interface ImageCandidate {
  /**
   *
   * @type {Frame}
   * @memberof ImageCandidate
   */
  frame: Frame
  /**
   *
   * @type {string}
   * @memberof ImageCandidate
   */
  stream_name?: string
  /**
   *
   * @type {string}
   * @memberof ImageCandidate
   */
  project_name?: string
  /**
   * Used in conjunction with categories field (SerializerMethodField)         The idea is to get the submissions_categoryids that is annotated         which is a list of categoryids that were already submitted.          Filter those out for each of the categories we are searching for.          NOTE: this requires using the Frame.objects.candidates_for_annotation         and with_annotationprojectname
   * @type {Array<ImageCategorySummary>}
   * @memberof ImageCandidate
   */
  available_categories?: Array<ImageCategorySummary>
}
/**
 *
 * @export
 * @interface ImageCandidateSubmissionRequest
 */
export interface ImageCandidateSubmissionRequest {
  /**
   *
   * @type {number}
   * @memberof ImageCandidateSubmissionRequest
   */
  frame_id: number
}
/**
 *
 * @export
 * @interface ImageCategoryDetails
 */
export interface ImageCategoryDetails {
  /**
   *
   * @type {number}
   * @memberof ImageCategoryDetails
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageCategoryDetails
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ImageCategoryDetails
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof ImageCategoryDetails
   */
  latest_category_version_datetime: string
}
/**
 *
 * @export
 * @interface ImageCategorySummary
 */
export interface ImageCategorySummary {
  /**
   *
   * @type {number}
   * @memberof ImageCategorySummary
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageCategorySummary
   */
  name: string
}
/**
 *
 * @export
 * @interface ImageFrameDetails
 */
export interface ImageFrameDetails {
  /**
   *
   * @type {number}
   * @memberof ImageFrameDetails
   */
  id?: number
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof ImageFrameDetails
   */
  latest_boxes?: Array<ImageAnnotationBox>
  /**
   *
   * @type {Frame}
   * @memberof ImageFrameDetails
   */
  frame?: Frame
  /**
   *
   * @type {Video}
   * @memberof ImageFrameDetails
   */
  video?: Video
  /**
   *
   * @type {Array<NestedImageSubmission>}
   * @memberof ImageFrameDetails
   */
  submissions?: Array<NestedImageSubmission>
}
/**
 *
 * @export
 * @interface ImageLabel
 */
export interface ImageLabel {
  /**
   *
   * @type {number}
   * @memberof ImageLabel
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ImageLabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ImageLabel
   */
  subcategory?: string | null
  /**
   *
   * @type {string}
   * @memberof ImageLabel
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof ImageLabel
   */
  color?: string
  /**
   *
   * @type {string}
   * @memberof ImageLabel
   */
  thumbnail_url?: string | null
}
/**
 *
 * @export
 * @interface ImageLabelInfo
 */
export interface ImageLabelInfo {
  /**
   *
   * @type {number}
   * @memberof ImageLabelInfo
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ImageLabelInfo
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ImageLabelInfo
   */
  subcategory: string
  /**
   *
   * @type {string}
   * @memberof ImageLabelInfo
   */
  description: string
  /**
   *
   * @type {number}
   * @memberof ImageLabelInfo
   */
  category_id?: number
  /**
   *
   * @type {string}
   * @memberof ImageLabelInfo
   */
  thumbnail_url: string
  /**
   *
   * @type {string}
   * @memberof ImageLabelInfo
   */
  color: string
  /**
   *
   * @type {boolean}
   * @memberof ImageLabelInfo
   */
  show_by_default: boolean
}
/**
 *
 * @export
 * @interface ImageSegmentation
 */
export interface ImageSegmentation {
  /**
   *
   * @type {number}
   * @memberof ImageSegmentation
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof ImageSegmentation
   */
  stream: number
  /**
   *
   * @type {string}
   * @memberof ImageSegmentation
   */
  image_datetime: string
  /**
   *
   * @type {string}
   * @memberof ImageSegmentation
   */
  original_image: string
  /**
   *
   * @type {string}
   * @memberof ImageSegmentation
   */
  mask_image: string
  /**
   *
   * @type {string}
   * @memberof ImageSegmentation
   */
  model_version: string
  /**
   *
   * @type {object}
   * @memberof ImageSegmentation
   */
  color_map?: object | null
  /**
   *
   * @type {boolean}
   * @memberof ImageSegmentation
   */
  defisheyed?: boolean
}
/**
 *
 * @export
 * @interface ImageSessionDetails
 */
export interface ImageSessionDetails {
  /**
   *
   * @type {number}
   * @memberof ImageSessionDetails
   */
  id: number
  /**
   *
   * @type {UserSummary}
   * @memberof ImageSessionDetails
   */
  user: UserSummary
  /**
   *
   * @type {string}
   * @memberof ImageSessionDetails
   */
  start_datetime: string
  /**
   *
   * @type {string}
   * @memberof ImageSessionDetails
   */
  end_datetime?: string | null
  /**
   *
   * @type {string}
   * @memberof ImageSessionDetails
   */
  paused_at?: string | null
  /**
   *
   * @type {string}
   * @memberof ImageSessionDetails
   */
  time_paused?: string
  /**
   *
   * @type {number}
   * @memberof ImageSessionDetails
   */
  duration: number
  /**
   *
   * @type {Array<ImageLabelInfo>}
   * @memberof ImageSessionDetails
   */
  labels: Array<ImageLabelInfo>
  /**
   *
   * @type {Array<ImageCategorySummary>}
   * @memberof ImageSessionDetails
   */
  categories: Array<ImageCategorySummary>
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof ImageSessionDetails
   */
  previous_boxes?: Array<ImageAnnotationBox>
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof ImageSessionDetails
   */
  boxes?: Array<ImageAnnotationBox>
  /**
   *
   * @type {Frame}
   * @memberof ImageSessionDetails
   */
  frame: Frame
  /**
   *
   * @type {Video}
   * @memberof ImageSessionDetails
   */
  video?: Video
  /**
   *
   * @type {Array<NestedImageSubmission>}
   * @memberof ImageSessionDetails
   */
  submissions?: Array<NestedImageSubmission>
}
/**
 *
 * @export
 * @interface ImageSublabel
 */
export interface ImageSublabel {
  /**
   *
   * @type {number}
   * @memberof ImageSublabel
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ImageSublabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ImageSublabel
   */
  description?: string | null
}
/**
 *
 * @export
 * @interface ImageSubmissionIndex
 */
export interface ImageSubmissionIndex {
  /**
   *
   * @type {number}
   * @memberof ImageSubmissionIndex
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ImageSubmissionIndex
   */
  state: ImageSubmissionIndexStateEnum
  /**
   *
   * @type {ImageCategorySummary}
   * @memberof ImageSubmissionIndex
   */
  category: ImageCategorySummary
  /**
   *
   * @type {Frame}
   * @memberof ImageSubmissionIndex
   */
  frame: Frame
  /**
   *
   * @type {string}
   * @memberof ImageSubmissionIndex
   */
  stream_name: string
  /**
   *
   * @type {string}
   * @memberof ImageSubmissionIndex
   */
  project_name: string
  /**
   *
   * @type {ImageAnnotationSummary}
   * @memberof ImageSubmissionIndex
   */
  latest_annotation?: ImageAnnotationSummary
}

/**
 * @export
 * @enum {string}
 */
export enum ImageSubmissionIndexStateEnum {
  Unlabeled = 'unlabeled',
  AiLabeled = 'ai_labeled',
  Labeling = 'labeling',
  Labeled = 'labeled',
}

/**
 *
 * @export
 * @interface ImageSubmissionMassCreationRequest
 */
export interface ImageSubmissionMassCreationRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof ImageSubmissionMassCreationRequest
   */
  category_ids: Array<number>
  /**
   *
   * @type {Array<ImageCandidateSubmissionRequest>}
   * @memberof ImageSubmissionMassCreationRequest
   */
  candidates: Array<ImageCandidateSubmissionRequest>
}
/**
 *
 * @export
 * @interface ImageSubmissionMassCreationResponse
 */
export interface ImageSubmissionMassCreationResponse {
  /**
   *
   * @type {Array<ImageSubmissionMin>}
   * @memberof ImageSubmissionMassCreationResponse
   */
  submissions_created: Array<ImageSubmissionMin>
  /**
   *
   * @type {Array<ImageSubmissionMin>}
   * @memberof ImageSubmissionMassCreationResponse
   */
  submissions_skipped: Array<ImageSubmissionMin>
}
/**
 *
 * @export
 * @interface ImageSubmissionMin
 */
export interface ImageSubmissionMin {
  /**
   *
   * @type {number}
   * @memberof ImageSubmissionMin
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof ImageSubmissionMin
   */
  frame_id?: number
  /**
   *
   * @type {number}
   * @memberof ImageSubmissionMin
   */
  category_id?: number
  /**
   *
   * @type {string}
   * @memberof ImageSubmissionMin
   */
  state?: ImageSubmissionMinStateEnum
}

/**
 * @export
 * @enum {string}
 */
export enum ImageSubmissionMinStateEnum {
  Unlabeled = 'unlabeled',
  AiLabeled = 'ai_labeled',
  Labeling = 'labeling',
  Labeled = 'labeled',
}

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  previous?: string | null
  /**
   *
   * @type {Array<ImageAnnotationReportSummary>}
   * @memberof InlineResponse200
   */
  results: Array<ImageAnnotationReportSummary>
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  previous?: string | null
  /**
   *
   * @type {Array<ImageCandidate>}
   * @memberof InlineResponse2001
   */
  results: Array<ImageCandidate>
}
/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  previous?: string | null
  /**
   *
   * @type {Array<ImageAnnotationBox>}
   * @memberof InlineResponse2002
   */
  results: Array<ImageAnnotationBox>
}
/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  previous?: string | null
  /**
   *
   * @type {Array<ImageSubmissionIndex>}
   * @memberof InlineResponse2003
   */
  results: Array<ImageSubmissionIndex>
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  previous?: string | null
  /**
   *
   * @type {Array<Analysis>}
   * @memberof InlineResponse2004
   */
  results: Array<Analysis>
}
/**
 *
 * @export
 * @interface LabelboxDatarow
 */
export interface LabelboxDatarow {
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  updatedAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  deletedAt: string | null
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  externalId: string
  /**
   *
   * @type {string}
   * @memberof LabelboxDatarow
   */
  rowData: string
}
/**
 *
 * @export
 * @interface LabelboxGeneric
 */
export interface LabelboxGeneric {
  /**
   *
   * @type {string}
   * @memberof LabelboxGeneric
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof LabelboxGeneric
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxGeneric
   */
  updatedAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxGeneric
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof LabelboxGeneric
   */
  description: string
  /**
   *
   * @type {boolean}
   * @memberof LabelboxGeneric
   */
  deleted: boolean
}
/**
 *
 * @export
 * @interface LabelboxUser
 */
export interface LabelboxUser {
  /**
   *
   * @type {string}
   * @memberof LabelboxUser
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof LabelboxUser
   */
  email: string
}
/**
 *
 * @export
 * @interface LabelboxWebhookResponse
 */
export interface LabelboxWebhookResponse {
  /**
   *
   * @type {string}
   * @memberof LabelboxWebhookResponse
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof LabelboxWebhookResponse
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxWebhookResponse
   */
  updatedAt: string
  /**
   *
   * @type {string}
   * @memberof LabelboxWebhookResponse
   */
  secondsToLabel: string
  /**
   *
   * @type {string}
   * @memberof LabelboxWebhookResponse
   */
  label: string
  /**
   *
   * @type {boolean}
   * @memberof LabelboxWebhookResponse
   */
  deleted: boolean
  /**
   *
   * @type {LabelboxGeneric}
   * @memberof LabelboxWebhookResponse
   */
  project: LabelboxGeneric
  /**
   *
   * @type {LabelboxDatarow}
   * @memberof LabelboxWebhookResponse
   */
  dataRow: LabelboxDatarow
  /**
   *
   * @type {LabelboxGeneric}
   * @memberof LabelboxWebhookResponse
   */
  dataset: LabelboxGeneric
  /**
   *
   * @type {LabelboxUser}
   * @memberof LabelboxWebhookResponse
   */
  user: LabelboxUser
}
/**
 *
 * @export
 * @interface LabelingImage
 */
export interface LabelingImage {
  /**
   *
   * @type {number}
   * @memberof LabelingImage
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof LabelingImage
   */
  frame?: number
  /**
   *
   * @type {string}
   * @memberof LabelingImage
   */
  local_date: string
  /**
   *
   * @type {string}
   * @memberof LabelingImage
   */
  local_time: string
  /**
   *
   * @type {string}
   * @memberof LabelingImage
   */
  external_id: string
  /**
   * Use original frame for image
   * @type {boolean}
   * @memberof LabelingImage
   */
  use_original: boolean
}
/**
 *
 * @export
 * @interface LabelingSubmission
 */
export interface LabelingSubmission {
  /**
   *
   * @type {number}
   * @memberof LabelingSubmission
   */
  id?: number
}
/**
 *
 * @export
 * @interface LiveAiData
 */
export interface LiveAiData {
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof LiveAiData
   */
  box_count_avg_by_class: { [key: string]: number }
  /**
   *
   * @type {string}
   * @memberof LiveAiData
   */
  timestamp: string
}
/**
 *
 * @export
 * @interface MapDetailsSerialzer
 */
export interface MapDetailsSerialzer {
  /**
   *
   * @type {number}
   * @memberof MapDetailsSerialzer
   */
  id?: number
  /**
   * Date this project shows up as
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  project_date?: string | null
  /**
   *
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  acquisition_date: string
  /**
   *
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  local_acquisition_date?: string
  /**
   * A Pix4d Embed URL
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  mesh?: string | null
  /**
   * A Pix4d Embed URL
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  ortho?: string | null
  /**
   * Example: mapbox://topdeck.7xggl8ff
   * @type {string}
   * @memberof MapDetailsSerialzer
   */
  mapbox_ortho_tileset?: string | null
  /**
   * An object that contains S3 URLs
   * @type {{ [key: string]: string; }}
   * @memberof MapDetailsSerialzer
   */
  asset_urls?: { [key: string]: string }
}
/**
 *
 * @export
 * @interface MapSummary
 */
export interface MapSummary {
  /**
   *
   * @type {number}
   * @memberof MapSummary
   */
  id: number
  /**
   * Date this project shows up as
   * @type {string}
   * @memberof MapSummary
   */
  project_date: string | null
  /**
   *
   * @type {string}
   * @memberof MapSummary
   */
  acquisition_date: string
  /**
   *
   * @type {string}
   * @memberof MapSummary
   */
  local_acquisition_date?: string
}
/**
 *
 * @export
 * @interface MappingOverlay
 */
export interface MappingOverlay {
  /**
   *
   * @type {number}
   * @memberof MappingOverlay
   */
  sequence: number
  /**
   *
   * @type {string}
   * @memberof MappingOverlay
   */
  display_name: string
  /**
   *
   * @type {string}
   * @memberof MappingOverlay
   */
  overlay_type: MappingOverlayOverlayTypeEnum
  /**
   *
   * @type {string}
   * @memberof MappingOverlay
   */
  style_type?: MappingOverlayStyleTypeEnum
  /**
   * Example: mapbox://topdeck.7xggl8ff
   * @type {string}
   * @memberof MappingOverlay
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof MappingOverlay
   */
  source_layer?: string | null
  /**
   *
   * @type {number}
   * @memberof MappingOverlay
   */
  default_opacity?: number
}

/**
 * @export
 * @enum {string}
 */
export enum MappingOverlayOverlayTypeEnum {
  Vector = 'vector',
  Raster = 'raster',
}
/**
 * @export
 * @enum {string}
 */
export enum MappingOverlayStyleTypeEnum {
  Fill = 'fill',
  Line = 'line',
  Symbol = 'symbol',
  Circle = 'circle',
  Heatmap = 'heatmap',
  FillExtrusion = 'fill-extrusion',
  Raster = 'raster',
  Hillshade = 'hillshade',
  Background = 'background',
}

/**
 *
 * @export
 * @interface MappingViewport
 */
export interface MappingViewport {
  /**
   *
   * @type {number}
   * @memberof MappingViewport
   */
  bearing?: number
  /**
   *
   * @type {number}
   * @memberof MappingViewport
   */
  latitude?: number
  /**
   *
   * @type {number}
   * @memberof MappingViewport
   */
  longitude?: number
  /**
   *
   * @type {number}
   * @memberof MappingViewport
   */
  zoom?: number
}
/**
 *
 * @export
 * @interface Masterplan
 */
export interface Masterplan {
  /**
   *
   * @type {number}
   * @memberof Masterplan
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Masterplan
   */
  unit_of_measure: MasterplanUnitOfMeasureEnum
  /**
   *
   * @type {number}
   * @memberof Masterplan
   */
  project: number
}

/**
 * @export
 * @enum {string}
 */
export enum MasterplanUnitOfMeasureEnum {
  In = 'in',
}

/**
 *
 * @export
 * @interface NestedImageAnnotationBoxCreate
 */
export interface NestedImageAnnotationBoxCreate {
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  label_id: number
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  sublabel_id?: number
  /**
   *
   * @type {string}
   * @memberof NestedImageAnnotationBoxCreate
   */
  comment?: string
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  h: number
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  w: number
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  x: number
  /**
   *
   * @type {number}
   * @memberof NestedImageAnnotationBoxCreate
   */
  y: number
}
/**
 *
 * @export
 * @interface NestedImageSubmission
 */
export interface NestedImageSubmission {
  /**
   *
   * @type {number}
   * @memberof NestedImageSubmission
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof NestedImageSubmission
   */
  state: NestedImageSubmissionStateEnum
  /**
   *
   * @type {ImageCategorySummary}
   * @memberof NestedImageSubmission
   */
  category: ImageCategorySummary
  /**
   *
   * @type {Array<ImageAnnotationSummary>}
   * @memberof NestedImageSubmission
   */
  annotations: Array<ImageAnnotationSummary>
}

/**
 * @export
 * @enum {string}
 */
export enum NestedImageSubmissionStateEnum {
  Unlabeled = 'unlabeled',
  AiLabeled = 'ai_labeled',
  Labeling = 'labeling',
  Labeled = 'labeled',
}

/**
 *
 * @export
 * @interface NoonlightDispatchEvent
 */
export interface NoonlightDispatchEvent {
  /**
   *
   * @type {string}
   * @memberof NoonlightDispatchEvent
   */
  event_id: string
  /**
   *
   * @type {string}
   * @memberof NoonlightDispatchEvent
   */
  event_type: NoonlightDispatchEventEventTypeEnum
  /**
   *
   * @type {string}
   * @memberof NoonlightDispatchEvent
   */
  event_time: string
  /**
   *
   * @type {NoonlightDispatchEventMeta}
   * @memberof NoonlightDispatchEvent
   */
  meta: NoonlightDispatchEventMeta
}

/**
 * @export
 * @enum {string}
 */
export enum NoonlightDispatchEventEventTypeEnum {
  StatusCanceled = 'alarm.status.canceled',
  Closed = 'alarm.closed',
  PsapContacted = 'alarm.psap_contacted',
}

/**
 *
 * @export
 * @interface NoonlightDispatchEventMeta
 */
export interface NoonlightDispatchEventMeta {
  /**
   *
   * @type {string}
   * @memberof NoonlightDispatchEventMeta
   */
  alarm_id: string
  /**
   *
   * @type {DispatchRequestMetaCancelInfo}
   * @memberof NoonlightDispatchEventMeta
   */
  canceled_by?: DispatchRequestMetaCancelInfo
}
/**
 *
 * @export
 * @interface NoonlightTaskResult
 */
export interface NoonlightTaskResult {
  /**
   *
   * @type {string}
   * @memberof NoonlightTaskResult
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof NoonlightTaskResult
   */
  conclusive: boolean
  /**
   *
   * @type {string}
   * @memberof NoonlightTaskResult
   */
  result?: NoonlightTaskResultResultEnum
  /**
   *
   * @type {string}
   * @memberof NoonlightTaskResult
   */
  error?: string
}

/**
 * @export
 * @enum {string}
 */
export enum NoonlightTaskResultResultEnum {
  Yes = 'yes',
  No = 'no',
}

/**
 *
 * @export
 * @interface OttToken
 */
export interface OttToken {
  /**
   *
   * @type {string}
   * @memberof OttToken
   */
  token: string
}
/**
 *
 * @export
 * @interface PTGUIProxyJob
 */
export interface PTGUIProxyJob {
  /**
   *
   * @type {number}
   * @memberof PTGUIProxyJob
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  created_at?: string
  /**
   * initial is \"Initial\", running is \"Running\", failed is \"Failed\", completed is \"Completed\"
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  state?: PTGUIProxyJobStateEnum
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  asset_zip_url?: string
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  result_url?: string | null
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  preview_url?: string | null
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyJob
   */
  failure_message: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum PTGUIProxyJobStateEnum {
  Initial = 'initial',
  Running = 'running',
  Failed = 'failed',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface PasswordReset
 */
export interface PasswordReset {
  /**
   *
   * @type {string}
   * @memberof PasswordReset
   */
  password1: string
  /**
   *
   * @type {string}
   * @memberof PasswordReset
   */
  password2: string
}
/**
 *
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
  /**
   *
   * @type {string}
   * @memberof PasswordResetRequest
   */
  email: string
}
/**
 *
 * @export
 * @interface Photosphere
 */
export interface Photosphere {
  /**
   *
   * @type {number}
   * @memberof Photosphere
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  public_id?: string
  /**
   *
   * @type {number}
   * @memberof Photosphere
   */
  template?: number
  /**
   *
   * @type {PhotosphereTemplatePanoAttrs}
   * @memberof Photosphere
   */
  template_panoattrs?: PhotosphereTemplatePanoAttrs
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  image_datetime: string
  /**
   * For GDrive URLS, is of the form https://drive.google.com/uc?id=SOMEID where SOMEID is the id
   * @type {string}
   * @memberof Photosphere
   */
  src_pano_url?: string | null
  /**
   * gdrive is \"Google Drive\", public is \"Public URL\"
   * @type {string}
   * @memberof Photosphere
   */
  src_pano_urltype?: PhotosphereSrcPanoUrltypeEnum
  /**
   * Used for the purposes of previewing the photosphere.
   * @type {string}
   * @memberof Photosphere
   */
  src_pano_thumbnail_url?: string | null
  /**
   *
   * @type {number}
   * @memberof Photosphere
   */
  latitude?: number | null
  /**
   *
   * @type {number}
   * @memberof Photosphere
   */
  longitude?: number | null
  /**
   *
   * @type {number}
   * @memberof Photosphere
   */
  bearing?: number | null
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  title?: string
  /**
   * scanning is \"Scanning In Progress\", acquired is \"Scans Acquired\", stitching is \"Currently Stitching\", stitched is \"Stitched\", approved is \"Approved\", rejected is \"Rejected\", makepano is \"Making Panoramic\", projection is \"Making Rectilinear Projection\", completed is \"Completed\", failed is \"Processing Failed\"
   * @type {string}
   * @memberof Photosphere
   */
  state?: PhotosphereStateEnum
  /**
   * Shape of the image pano
   * @type {string}
   * @memberof Photosphere
   */
  xml_shape?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  b2_pano_thumburl?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  b2_pano_previewurl?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  b2_pano_cubeurl?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_original_image_url?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_original_thumbnail_url?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_original_desktop_url?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_combined_image_url?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_combined_thumbnail_url?: string
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  rectilinear_combined_desktop_url?: string
  /**
   * This is automatically generated.
   * @type {string}
   * @memberof Photosphere
   */
  xml_resolutions?: string
  /**
   *
   * @type {MappingViewport}
   * @memberof Photosphere
   */
  mapping_viewport?: MappingViewport
  /**
   * This is automatically generated. Used for debugging.
   * @type {string}
   * @memberof Photosphere
   */
  failure_message?: string | null
  /**
   *
   * @type {string}
   * @memberof Photosphere
   */
  user_notes?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum PhotosphereSrcPanoUrltypeEnum {
  Gdrive = 'gdrive',
  Public = 'public',
}
/**
 * @export
 * @enum {string}
 */
export enum PhotosphereStateEnum {
  Scanning = 'scanning',
  Acquired = 'acquired',
  Stitching = 'stitching',
  Stitched = 'stitched',
  Approved = 'approved',
  Rejected = 'rejected',
  Makepano = 'makepano',
  Projection = 'projection',
  Completed = 'completed',
  Failed = 'failed',
}

/**
 *
 * @export
 * @interface PhotosphereDrawing
 */
export interface PhotosphereDrawing {
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof PhotosphereDrawing
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  template?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  sequence: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  alpha?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  scale?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  ath?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  tx?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  ty?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  tz?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  rx?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  ry?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  rz?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  ox?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  oy?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereDrawing
   */
  atv?: number
  /**
   *
   * @type {boolean}
   * @memberof PhotosphereDrawing
   */
  uploaded?: boolean
  /**
   *
   * @type {string}
   * @memberof PhotosphereDrawing
   */
  url?: string
}
/**
 *
 * @export
 * @interface PhotosphereTemplate
 */
export interface PhotosphereTemplate {
  /**
   *
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  stream?: number
  /**
   *
   * @type {string}
   * @memberof PhotosphereTemplate
   */
  stitch_template_url?: string
  /**
   *
   * @type {string}
   * @memberof PhotosphereTemplate
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof PhotosphereTemplate
   */
  public_naming_prefix: string
  /**
   * Used for whether to copy over coordinates in the template to the photosphere or not
   * @type {boolean}
   * @memberof PhotosphereTemplate
   */
  fixed_position?: boolean
  /**
   * Whether to perform realignment in PTGUI after stitching.
   * @type {boolean}
   * @memberof PhotosphereTemplate
   */
  realign?: boolean
  /**
   * Whether this photosphere templates is for jib photospheres
   * @type {boolean}
   * @memberof PhotosphereTemplate
   */
  is_jib?: boolean
  /**
   * Horizontal looking direction (-180 to 180). Used for rectilinear projections and panoramic viewing.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  hlookat?: number
  /**
   * Vertical looking direction (-90 to 90). Used for rectilinear projections and panoramic viewing.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  vlookat?: number
  /**
   * Minimum vertical looking position (-90 to 90). Used for panoramic viewing only.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  vlookatmin?: number
  /**
   * Minimum vertical looking position (-90 to 90). Used for panoramic viewing only.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  vlookatmax?: number
  /**
   * Roll/rotation of the view camera in degrees. Used for rectilinear projections only.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  camroll?: number
  /**
   * Field of view. Used for rectilinear projections only
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  fov?: number
  /**
   * Number of pixels. Used for crops of rectilinear projections.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  crop_x?: number
  /**
   * Number of pixels. Used for crops of rectilinear projections.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  crop_y?: number
  /**
   * Number of pixels. Used for crops of rectilinear projections.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  crop_h?: number
  /**
   * Number of pixels. Used for crops of rectilinear projections.
   * @type {number}
   * @memberof PhotosphereTemplate
   */
  crop_w?: number
}
/**
 *
 * @export
 * @interface PhotosphereTemplatePanoAttrs
 */
export interface PhotosphereTemplatePanoAttrs {
  /**
   * Used for whether to copy over coordinates in the template to the photosphere or not
   * @type {boolean}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  fixed_position?: boolean
  /**
   * Whether to perform realignment in PTGUI after stitching.
   * @type {boolean}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  realign?: boolean
  /**
   * Horizontal looking direction (-180 to 180). Used for rectilinear projections and panoramic viewing.
   * @type {number}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  hlookat?: number
  /**
   * Vertical looking direction (-90 to 90). Used for rectilinear projections and panoramic viewing.
   * @type {number}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  vlookat?: number
  /**
   * Minimum vertical looking position (-90 to 90). Used for panoramic viewing only.
   * @type {number}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  vlookatmin?: number
  /**
   * Minimum vertical looking position (-90 to 90). Used for panoramic viewing only.
   * @type {number}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  vlookatmax?: number
  /**
   * Roll/rotation of the view camera in degrees. Used for rectilinear projections only.
   * @type {number}
   * @memberof PhotosphereTemplatePanoAttrs
   */
  camroll?: number
}
/**
 *
 * @export
 * @interface PhotosphereUpdateByUser
 */
export interface PhotosphereUpdateByUser {
  /**
   *
   * @type {string}
   * @memberof PhotosphereUpdateByUser
   */
  user_notes?: string | null
}
/**
 *
 * @export
 * @interface PowerSensorMessage
 */
export interface PowerSensorMessage {
  /**
   *
   * @type {string}
   * @memberof PowerSensorMessage
   */
  body?: string | null
  /**
   *
   * @type {string}
   * @memberof PowerSensorMessage
   */
  message_datetime: string
  /**
   *
   * @type {string}
   * @memberof PowerSensorMessage
   */
  twilio_sid?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PowerSensorMessage
   */
  has_power: boolean
}
/**
 *
 * @export
 * @interface ProjectBarebones
 */
export interface ProjectBarebones {
  /**
   *
   * @type {number}
   * @memberof ProjectBarebones
   */
  id?: number
  /**
   * This is used within a project url.
   * @type {string}
   * @memberof ProjectBarebones
   */
  slug: string
  /**
   * Project key carried over from DynamoDB. 5 alphanumeric chars, a dash, then 4 alphanumeric chars.
   * @type {string}
   * @memberof ProjectBarebones
   */
  legacy_id?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectBarebones
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof ProjectBarebones
   */
  camevent_all_enabled?: boolean
}
/**
 *
 * @export
 * @interface ProjectConfig
 */
export interface ProjectConfig {
  /**
   *
   * @type {Array<Subcontractor>}
   * @memberof ProjectConfig
   */
  subcontractors: Array<Subcontractor>
  /**
   * Whether or not to show empty stats in the daily report panel
   * @type {boolean}
   * @memberof ProjectConfig
   */
  show_empty_stats?: boolean
  /**
   * The format to display pick rate in
   * @type {string}
   * @memberof ProjectConfig
   */
  pick_rate_format?: ProjectConfigPickRateFormatEnum
  /**
   * The type of chart to use for the utilization history chart
   * @type {string}
   * @memberof ProjectConfig
   */
  utilization_history_chart_type?: ProjectConfigUtilizationHistoryChartTypeEnum
  /**
   * Toggle showing weekly utilization in the daily report panel
   * @type {boolean}
   * @memberof ProjectConfig
   */
  show_weekly_utilization?: boolean
  /**
   * Toggle counting intra-pick idles toward utilization
   * @type {boolean}
   * @memberof ProjectConfig
   */
  count_intra_pick_idles_toward_utilization?: boolean
  /**
   * Toggle showing intra-pick idles table on the daily report
   * @type {boolean}
   * @memberof ProjectConfig
   */
  show_intra_pick_idles_on_daily_report?: boolean
  /**
   * Toggle consolidating supercategories in crane subs pie chart
   * @type {boolean}
   * @memberof ProjectConfig
   */
  consolidate_supercategories_in_pie_chart?: boolean
  /**
   * Show prefab/miscellaneous pie chart
   * @type {boolean}
   * @memberof ProjectConfig
   */
  show_prefab_misc_pie?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum ProjectConfigPickRateFormatEnum {
  PicksPerHour = 'picks_per_hour',
  MinutesPerPick = 'minutes_per_pick',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectConfigUtilizationHistoryChartTypeEnum {
  Bar = 'bar',
  Line = 'line',
}

/**
 *
 * @export
 * @interface ProjectCreate
 */
export interface ProjectCreate {
  /**
   *
   * @type {number}
   * @memberof ProjectCreate
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  name: string
  /**
   * This is used within a project url.
   * @type {string}
   * @memberof ProjectCreate
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  address_1: string
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  address_2?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  city: string
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  state?: ProjectCreateStateEnum
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  zip_code: string
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  country: ProjectCreateCountryEnum
}

/**
 * @export
 * @enum {string}
 */
export enum ProjectCreateStateEnum {
  Al = 'AL',
  Ak = 'AK',
  As = 'AS',
  Az = 'AZ',
  Ar = 'AR',
  Aa = 'AA',
  Ae = 'AE',
  Ap = 'AP',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Mp = 'MP',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Vi = 'VI',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectCreateCountryEnum {
  Us = 'US',
  Fr = 'FR',
}

/**
 *
 * @export
 * @interface ProjectDetails
 */
export interface ProjectDetails {
  /**
   *
   * @type {number}
   * @memberof ProjectDetails
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  name: string
  /**
   * This is used within a project url.
   * @type {string}
   * @memberof ProjectDetails
   */
  slug: string
  /**
   * Project key carried over from DynamoDB. 5 alphanumeric chars, a dash, then 4 alphanumeric chars.
   * @type {string}
   * @memberof ProjectDetails
   */
  legacy_id?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  address_1: string
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  address_2?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  city: string
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  state: ProjectDetailsStateEnum
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  zip_code: string
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  country: ProjectDetailsCountryEnum
  /**
   * Whether or not the project is live.
   * @type {boolean}
   * @memberof ProjectDetails
   */
  live: boolean
  /**
   * A valid timezone.  See  http://pytz.sourceforge.net/#helpers for list of valid values.
   * @type {string}
   * @memberof ProjectDetails
   */
  timezone: string
  /**
   * Annotation type
   * @type {string}
   * @memberof ProjectDetails
   */
  annotation?: string | null
  /**
   *
   * @type {ProjectSummaryUserAttrs}
   * @memberof ProjectDetails
   */
  user_attrs: ProjectSummaryUserAttrs
  /**
   *
   * @type {Array<Stream>}
   * @memberof ProjectDetails
   */
  streams?: Array<Stream>
  /**
   *
   * @type {boolean}
   * @memberof ProjectDetails
   */
  camevent_all_enabled?: boolean
  /**
   * en-US is \"English US\", fr-FR is \"French France\"
   * @type {string}
   * @memberof ProjectDetails
   */
  display_language?: ProjectDetailsDisplayLanguageEnum
  /**
   *
   * @type {boolean}
   * @memberof ProjectDetails
   */
  is_drone: boolean
  /**
   *
   * @type {number}
   * @memberof ProjectDetails
   */
  latitude?: number | null
  /**
   *
   * @type {number}
   * @memberof ProjectDetails
   */
  longitude?: number | null
  /**
   *
   * @type {MappingViewport}
   * @memberof ProjectDetails
   */
  mapping_viewport: MappingViewport
  /**
   *
   * @type {Array<MappingOverlay>}
   * @memberof ProjectDetails
   */
  mapping_overlays: Array<MappingOverlay>
  /**
   * geojson (Must be valid json).
   * @type {object}
   * @memberof ProjectDetails
   */
  mapping_annotations: any
  /**
   * Must start with \'/grafana\'
   * @type {string}
   * @memberof ProjectDetails
   */
  grafana_dashboard_path?: string | null
  /**
   *  List of pages a user should see based on the role.
   * @type {Array<string>}
   * @memberof ProjectDetails
   */
  pages: Array<string>
  /**
   * Mapping of role slug to a list of page slugs
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ProjectDetails
   */
  roles: { [key: string]: Array<string> }
  /**
   *
   * @type {Array<Crane>}
   * @memberof ProjectDetails
   */
  cranes?: Array<Crane>
  /**
   * This can be shown to users in a project for important news.
   * @type {string}
   * @memberof ProjectDetails
   */
  error_message?: string | null
  /**
   * An object that contains dates as keys and stream ids as values. This signifies what streams a day contains
   * @type {{ [key: string]: Array<number>; }}
   * @memberof ProjectDetails
   */
  videoarchive_dates?: { [key: string]: Array<number> }
  /**
   *
   * @type {Array<string>}
   * @memberof ProjectDetails
   */
  photo_dates?: Array<string>
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  support_contact_name?: string | null
  /**
   * Must be of format: +12125552368
   * @type {string}
   * @memberof ProjectDetails
   */
  support_contact_phone?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  support_contact_email?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectDetails
   */
  support_document_url?: string
  /**
   *
   * @type {Array<AlarmContact>}
   * @memberof ProjectDetails
   */
  contacts?: Array<AlarmContact>
  /**
   * Is there an alarm active?
   * @type {boolean}
   * @memberof ProjectDetails
   */
  alarm_active?: boolean
  /**
   *
   * @type {number}
   * @memberof ProjectDetails
   */
  daily_overtime_threshold?: number | null
}

/**
 * @export
 * @enum {string}
 */
export enum ProjectDetailsStateEnum {
  Al = 'AL',
  Ak = 'AK',
  As = 'AS',
  Az = 'AZ',
  Ar = 'AR',
  Aa = 'AA',
  Ae = 'AE',
  Ap = 'AP',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Mp = 'MP',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Vi = 'VI',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectDetailsCountryEnum {
  Us = 'US',
  Fr = 'FR',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectDetailsDisplayLanguageEnum {
  EnUs = 'en-US',
  FrFr = 'fr-FR',
}

/**
 *
 * @export
 * @interface ProjectSummary
 */
export interface ProjectSummary {
  /**
   *
   * @type {number}
   * @memberof ProjectSummary
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  name: string
  /**
   * This is used within a project url.
   * @type {string}
   * @memberof ProjectSummary
   */
  slug: string
  /**
   * Project key carried over from DynamoDB. 5 alphanumeric chars, a dash, then 4 alphanumeric chars.
   * @type {string}
   * @memberof ProjectSummary
   */
  legacy_id?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  address_1: string
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  address_2?: string | null
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  city: string
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  state?: ProjectSummaryStateEnum
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  zip_code: string
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  country: ProjectSummaryCountryEnum
  /**
   * Whether or not the project is live.
   * @type {boolean}
   * @memberof ProjectSummary
   */
  live: boolean
  /**
   *
   * @type {string}
   * @memberof ProjectSummary
   */
  timezone: ProjectSummaryTimezoneEnum
  /**
   * Annotation type
   * @type {string}
   * @memberof ProjectSummary
   */
  annotation?: string | null
  /**
   *
   * @type {ProjectSummaryUserAttrs}
   * @memberof ProjectSummary
   */
  user_attrs?: ProjectSummaryUserAttrs
  /**
   *
   * @type {Array<StreamMinimal>}
   * @memberof ProjectSummary
   */
  streams?: Array<StreamMinimal>
  /**
   *
   * @type {boolean}
   * @memberof ProjectSummary
   */
  camevent_all_enabled?: boolean
  /**
   * en-US is \"English US\", fr-FR is \"French France\"
   * @type {string}
   * @memberof ProjectSummary
   */
  display_language?: ProjectSummaryDisplayLanguageEnum
}

/**
 * @export
 * @enum {string}
 */
export enum ProjectSummaryStateEnum {
  Al = 'AL',
  Ak = 'AK',
  As = 'AS',
  Az = 'AZ',
  Ar = 'AR',
  Aa = 'AA',
  Ae = 'AE',
  Ap = 'AP',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Mp = 'MP',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Vi = 'VI',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectSummaryCountryEnum {
  Us = 'US',
  Fr = 'FR',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectSummaryTimezoneEnum {
  AfricaAbidjan = 'Africa/Abidjan',
  AfricaAccra = 'Africa/Accra',
  AfricaAddisAbaba = 'Africa/Addis_Ababa',
  AfricaAlgiers = 'Africa/Algiers',
  AfricaAsmara = 'Africa/Asmara',
  AfricaBamako = 'Africa/Bamako',
  AfricaBangui = 'Africa/Bangui',
  AfricaBanjul = 'Africa/Banjul',
  AfricaBissau = 'Africa/Bissau',
  AfricaBlantyre = 'Africa/Blantyre',
  AfricaBrazzaville = 'Africa/Brazzaville',
  AfricaBujumbura = 'Africa/Bujumbura',
  AfricaCairo = 'Africa/Cairo',
  AfricaCasablanca = 'Africa/Casablanca',
  AfricaCeuta = 'Africa/Ceuta',
  AfricaConakry = 'Africa/Conakry',
  AfricaDakar = 'Africa/Dakar',
  AfricaDarEsSalaam = 'Africa/Dar_es_Salaam',
  AfricaDjibouti = 'Africa/Djibouti',
  AfricaDouala = 'Africa/Douala',
  AfricaElAaiun = 'Africa/El_Aaiun',
  AfricaFreetown = 'Africa/Freetown',
  AfricaGaborone = 'Africa/Gaborone',
  AfricaHarare = 'Africa/Harare',
  AfricaJohannesburg = 'Africa/Johannesburg',
  AfricaJuba = 'Africa/Juba',
  AfricaKampala = 'Africa/Kampala',
  AfricaKhartoum = 'Africa/Khartoum',
  AfricaKigali = 'Africa/Kigali',
  AfricaKinshasa = 'Africa/Kinshasa',
  AfricaLagos = 'Africa/Lagos',
  AfricaLibreville = 'Africa/Libreville',
  AfricaLome = 'Africa/Lome',
  AfricaLuanda = 'Africa/Luanda',
  AfricaLubumbashi = 'Africa/Lubumbashi',
  AfricaLusaka = 'Africa/Lusaka',
  AfricaMalabo = 'Africa/Malabo',
  AfricaMaputo = 'Africa/Maputo',
  AfricaMaseru = 'Africa/Maseru',
  AfricaMbabane = 'Africa/Mbabane',
  AfricaMogadishu = 'Africa/Mogadishu',
  AfricaMonrovia = 'Africa/Monrovia',
  AfricaNairobi = 'Africa/Nairobi',
  AfricaNdjamena = 'Africa/Ndjamena',
  AfricaNiamey = 'Africa/Niamey',
  AfricaNouakchott = 'Africa/Nouakchott',
  AfricaOuagadougou = 'Africa/Ouagadougou',
  AfricaPortoNovo = 'Africa/Porto-Novo',
  AfricaSaoTome = 'Africa/Sao_Tome',
  AfricaTripoli = 'Africa/Tripoli',
  AfricaTunis = 'Africa/Tunis',
  AfricaWindhoek = 'Africa/Windhoek',
  AmericaAdak = 'America/Adak',
  AmericaAnchorage = 'America/Anchorage',
  AmericaAnguilla = 'America/Anguilla',
  AmericaAntigua = 'America/Antigua',
  AmericaAraguaina = 'America/Araguaina',
  AmericaArgentinaBuenosAires = 'America/Argentina/Buenos_Aires',
  AmericaArgentinaCatamarca = 'America/Argentina/Catamarca',
  AmericaArgentinaCordoba = 'America/Argentina/Cordoba',
  AmericaArgentinaJujuy = 'America/Argentina/Jujuy',
  AmericaArgentinaLaRioja = 'America/Argentina/La_Rioja',
  AmericaArgentinaMendoza = 'America/Argentina/Mendoza',
  AmericaArgentinaRioGallegos = 'America/Argentina/Rio_Gallegos',
  AmericaArgentinaSalta = 'America/Argentina/Salta',
  AmericaArgentinaSanJuan = 'America/Argentina/San_Juan',
  AmericaArgentinaSanLuis = 'America/Argentina/San_Luis',
  AmericaArgentinaTucuman = 'America/Argentina/Tucuman',
  AmericaArgentinaUshuaia = 'America/Argentina/Ushuaia',
  AmericaAruba = 'America/Aruba',
  AmericaAsuncion = 'America/Asuncion',
  AmericaAtikokan = 'America/Atikokan',
  AmericaBahia = 'America/Bahia',
  AmericaBahiaBanderas = 'America/Bahia_Banderas',
  AmericaBarbados = 'America/Barbados',
  AmericaBelem = 'America/Belem',
  AmericaBelize = 'America/Belize',
  AmericaBlancSablon = 'America/Blanc-Sablon',
  AmericaBoaVista = 'America/Boa_Vista',
  AmericaBogota = 'America/Bogota',
  AmericaBoise = 'America/Boise',
  AmericaCambridgeBay = 'America/Cambridge_Bay',
  AmericaCampoGrande = 'America/Campo_Grande',
  AmericaCancun = 'America/Cancun',
  AmericaCaracas = 'America/Caracas',
  AmericaCayenne = 'America/Cayenne',
  AmericaCayman = 'America/Cayman',
  AmericaChicago = 'America/Chicago',
  AmericaChihuahua = 'America/Chihuahua',
  AmericaCostaRica = 'America/Costa_Rica',
  AmericaCreston = 'America/Creston',
  AmericaCuiaba = 'America/Cuiaba',
  AmericaCuracao = 'America/Curacao',
  AmericaDanmarkshavn = 'America/Danmarkshavn',
  AmericaDawson = 'America/Dawson',
  AmericaDawsonCreek = 'America/Dawson_Creek',
  AmericaDenver = 'America/Denver',
  AmericaDetroit = 'America/Detroit',
  AmericaDominica = 'America/Dominica',
  AmericaEdmonton = 'America/Edmonton',
  AmericaEirunepe = 'America/Eirunepe',
  AmericaElSalvador = 'America/El_Salvador',
  AmericaFortNelson = 'America/Fort_Nelson',
  AmericaFortaleza = 'America/Fortaleza',
  AmericaGlaceBay = 'America/Glace_Bay',
  AmericaGooseBay = 'America/Goose_Bay',
  AmericaGrandTurk = 'America/Grand_Turk',
  AmericaGrenada = 'America/Grenada',
  AmericaGuadeloupe = 'America/Guadeloupe',
  AmericaGuatemala = 'America/Guatemala',
  AmericaGuayaquil = 'America/Guayaquil',
  AmericaGuyana = 'America/Guyana',
  AmericaHalifax = 'America/Halifax',
  AmericaHavana = 'America/Havana',
  AmericaHermosillo = 'America/Hermosillo',
  AmericaIndianaIndianapolis = 'America/Indiana/Indianapolis',
  AmericaIndianaKnox = 'America/Indiana/Knox',
  AmericaIndianaMarengo = 'America/Indiana/Marengo',
  AmericaIndianaPetersburg = 'America/Indiana/Petersburg',
  AmericaIndianaTellCity = 'America/Indiana/Tell_City',
  AmericaIndianaVevay = 'America/Indiana/Vevay',
  AmericaIndianaVincennes = 'America/Indiana/Vincennes',
  AmericaIndianaWinamac = 'America/Indiana/Winamac',
  AmericaInuvik = 'America/Inuvik',
  AmericaIqaluit = 'America/Iqaluit',
  AmericaJamaica = 'America/Jamaica',
  AmericaJuneau = 'America/Juneau',
  AmericaKentuckyLouisville = 'America/Kentucky/Louisville',
  AmericaKentuckyMonticello = 'America/Kentucky/Monticello',
  AmericaKralendijk = 'America/Kralendijk',
  AmericaLaPaz = 'America/La_Paz',
  AmericaLima = 'America/Lima',
  AmericaLosAngeles = 'America/Los_Angeles',
  AmericaLowerPrinces = 'America/Lower_Princes',
  AmericaMaceio = 'America/Maceio',
  AmericaManagua = 'America/Managua',
  AmericaManaus = 'America/Manaus',
  AmericaMarigot = 'America/Marigot',
  AmericaMartinique = 'America/Martinique',
  AmericaMatamoros = 'America/Matamoros',
  AmericaMazatlan = 'America/Mazatlan',
  AmericaMenominee = 'America/Menominee',
  AmericaMerida = 'America/Merida',
  AmericaMetlakatla = 'America/Metlakatla',
  AmericaMexicoCity = 'America/Mexico_City',
  AmericaMiquelon = 'America/Miquelon',
  AmericaMoncton = 'America/Moncton',
  AmericaMonterrey = 'America/Monterrey',
  AmericaMontevideo = 'America/Montevideo',
  AmericaMontserrat = 'America/Montserrat',
  AmericaNassau = 'America/Nassau',
  AmericaNewYork = 'America/New_York',
  AmericaNipigon = 'America/Nipigon',
  AmericaNome = 'America/Nome',
  AmericaNoronha = 'America/Noronha',
  AmericaNorthDakotaBeulah = 'America/North_Dakota/Beulah',
  AmericaNorthDakotaCenter = 'America/North_Dakota/Center',
  AmericaNorthDakotaNewSalem = 'America/North_Dakota/New_Salem',
  AmericaNuuk = 'America/Nuuk',
  AmericaOjinaga = 'America/Ojinaga',
  AmericaPanama = 'America/Panama',
  AmericaPangnirtung = 'America/Pangnirtung',
  AmericaParamaribo = 'America/Paramaribo',
  AmericaPhoenix = 'America/Phoenix',
  AmericaPortAuPrince = 'America/Port-au-Prince',
  AmericaPortOfSpain = 'America/Port_of_Spain',
  AmericaPortoVelho = 'America/Porto_Velho',
  AmericaPuertoRico = 'America/Puerto_Rico',
  AmericaPuntaArenas = 'America/Punta_Arenas',
  AmericaRainyRiver = 'America/Rainy_River',
  AmericaRankinInlet = 'America/Rankin_Inlet',
  AmericaRecife = 'America/Recife',
  AmericaRegina = 'America/Regina',
  AmericaResolute = 'America/Resolute',
  AmericaRioBranco = 'America/Rio_Branco',
  AmericaSantarem = 'America/Santarem',
  AmericaSantiago = 'America/Santiago',
  AmericaSantoDomingo = 'America/Santo_Domingo',
  AmericaSaoPaulo = 'America/Sao_Paulo',
  AmericaScoresbysund = 'America/Scoresbysund',
  AmericaSitka = 'America/Sitka',
  AmericaStBarthelemy = 'America/St_Barthelemy',
  AmericaStJohns = 'America/St_Johns',
  AmericaStKitts = 'America/St_Kitts',
  AmericaStLucia = 'America/St_Lucia',
  AmericaStThomas = 'America/St_Thomas',
  AmericaStVincent = 'America/St_Vincent',
  AmericaSwiftCurrent = 'America/Swift_Current',
  AmericaTegucigalpa = 'America/Tegucigalpa',
  AmericaThule = 'America/Thule',
  AmericaThunderBay = 'America/Thunder_Bay',
  AmericaTijuana = 'America/Tijuana',
  AmericaToronto = 'America/Toronto',
  AmericaTortola = 'America/Tortola',
  AmericaVancouver = 'America/Vancouver',
  AmericaWhitehorse = 'America/Whitehorse',
  AmericaWinnipeg = 'America/Winnipeg',
  AmericaYakutat = 'America/Yakutat',
  AmericaYellowknife = 'America/Yellowknife',
  AntarcticaCasey = 'Antarctica/Casey',
  AntarcticaDavis = 'Antarctica/Davis',
  AntarcticaDumontDUrville = 'Antarctica/DumontDUrville',
  AntarcticaMacquarie = 'Antarctica/Macquarie',
  AntarcticaMawson = 'Antarctica/Mawson',
  AntarcticaMcMurdo = 'Antarctica/McMurdo',
  AntarcticaPalmer = 'Antarctica/Palmer',
  AntarcticaRothera = 'Antarctica/Rothera',
  AntarcticaSyowa = 'Antarctica/Syowa',
  AntarcticaTroll = 'Antarctica/Troll',
  AntarcticaVostok = 'Antarctica/Vostok',
  ArcticLongyearbyen = 'Arctic/Longyearbyen',
  AsiaAden = 'Asia/Aden',
  AsiaAlmaty = 'Asia/Almaty',
  AsiaAmman = 'Asia/Amman',
  AsiaAnadyr = 'Asia/Anadyr',
  AsiaAqtau = 'Asia/Aqtau',
  AsiaAqtobe = 'Asia/Aqtobe',
  AsiaAshgabat = 'Asia/Ashgabat',
  AsiaAtyrau = 'Asia/Atyrau',
  AsiaBaghdad = 'Asia/Baghdad',
  AsiaBahrain = 'Asia/Bahrain',
  AsiaBaku = 'Asia/Baku',
  AsiaBangkok = 'Asia/Bangkok',
  AsiaBarnaul = 'Asia/Barnaul',
  AsiaBeirut = 'Asia/Beirut',
  AsiaBishkek = 'Asia/Bishkek',
  AsiaBrunei = 'Asia/Brunei',
  AsiaChita = 'Asia/Chita',
  AsiaChoibalsan = 'Asia/Choibalsan',
  AsiaColombo = 'Asia/Colombo',
  AsiaDamascus = 'Asia/Damascus',
  AsiaDhaka = 'Asia/Dhaka',
  AsiaDili = 'Asia/Dili',
  AsiaDubai = 'Asia/Dubai',
  AsiaDushanbe = 'Asia/Dushanbe',
  AsiaFamagusta = 'Asia/Famagusta',
  AsiaGaza = 'Asia/Gaza',
  AsiaHebron = 'Asia/Hebron',
  AsiaHoChiMinh = 'Asia/Ho_Chi_Minh',
  AsiaHongKong = 'Asia/Hong_Kong',
  AsiaHovd = 'Asia/Hovd',
  AsiaIrkutsk = 'Asia/Irkutsk',
  AsiaJakarta = 'Asia/Jakarta',
  AsiaJayapura = 'Asia/Jayapura',
  AsiaJerusalem = 'Asia/Jerusalem',
  AsiaKabul = 'Asia/Kabul',
  AsiaKamchatka = 'Asia/Kamchatka',
  AsiaKarachi = 'Asia/Karachi',
  AsiaKathmandu = 'Asia/Kathmandu',
  AsiaKhandyga = 'Asia/Khandyga',
  AsiaKolkata = 'Asia/Kolkata',
  AsiaKrasnoyarsk = 'Asia/Krasnoyarsk',
  AsiaKualaLumpur = 'Asia/Kuala_Lumpur',
  AsiaKuching = 'Asia/Kuching',
  AsiaKuwait = 'Asia/Kuwait',
  AsiaMacau = 'Asia/Macau',
  AsiaMagadan = 'Asia/Magadan',
  AsiaMakassar = 'Asia/Makassar',
  AsiaManila = 'Asia/Manila',
  AsiaMuscat = 'Asia/Muscat',
  AsiaNicosia = 'Asia/Nicosia',
  AsiaNovokuznetsk = 'Asia/Novokuznetsk',
  AsiaNovosibirsk = 'Asia/Novosibirsk',
  AsiaOmsk = 'Asia/Omsk',
  AsiaOral = 'Asia/Oral',
  AsiaPhnomPenh = 'Asia/Phnom_Penh',
  AsiaPontianak = 'Asia/Pontianak',
  AsiaPyongyang = 'Asia/Pyongyang',
  AsiaQatar = 'Asia/Qatar',
  AsiaQostanay = 'Asia/Qostanay',
  AsiaQyzylorda = 'Asia/Qyzylorda',
  AsiaRiyadh = 'Asia/Riyadh',
  AsiaSakhalin = 'Asia/Sakhalin',
  AsiaSamarkand = 'Asia/Samarkand',
  AsiaSeoul = 'Asia/Seoul',
  AsiaShanghai = 'Asia/Shanghai',
  AsiaSingapore = 'Asia/Singapore',
  AsiaSrednekolymsk = 'Asia/Srednekolymsk',
  AsiaTaipei = 'Asia/Taipei',
  AsiaTashkent = 'Asia/Tashkent',
  AsiaTbilisi = 'Asia/Tbilisi',
  AsiaTehran = 'Asia/Tehran',
  AsiaThimphu = 'Asia/Thimphu',
  AsiaTokyo = 'Asia/Tokyo',
  AsiaTomsk = 'Asia/Tomsk',
  AsiaUlaanbaatar = 'Asia/Ulaanbaatar',
  AsiaUrumqi = 'Asia/Urumqi',
  AsiaUstNera = 'Asia/Ust-Nera',
  AsiaVientiane = 'Asia/Vientiane',
  AsiaVladivostok = 'Asia/Vladivostok',
  AsiaYakutsk = 'Asia/Yakutsk',
  AsiaYangon = 'Asia/Yangon',
  AsiaYekaterinburg = 'Asia/Yekaterinburg',
  AsiaYerevan = 'Asia/Yerevan',
  AtlanticAzores = 'Atlantic/Azores',
  AtlanticBermuda = 'Atlantic/Bermuda',
  AtlanticCanary = 'Atlantic/Canary',
  AtlanticCapeVerde = 'Atlantic/Cape_Verde',
  AtlanticFaroe = 'Atlantic/Faroe',
  AtlanticMadeira = 'Atlantic/Madeira',
  AtlanticReykjavik = 'Atlantic/Reykjavik',
  AtlanticSouthGeorgia = 'Atlantic/South_Georgia',
  AtlanticStHelena = 'Atlantic/St_Helena',
  AtlanticStanley = 'Atlantic/Stanley',
  AustraliaAdelaide = 'Australia/Adelaide',
  AustraliaBrisbane = 'Australia/Brisbane',
  AustraliaBrokenHill = 'Australia/Broken_Hill',
  AustraliaDarwin = 'Australia/Darwin',
  AustraliaEucla = 'Australia/Eucla',
  AustraliaHobart = 'Australia/Hobart',
  AustraliaLindeman = 'Australia/Lindeman',
  AustraliaLordHowe = 'Australia/Lord_Howe',
  AustraliaMelbourne = 'Australia/Melbourne',
  AustraliaPerth = 'Australia/Perth',
  AustraliaSydney = 'Australia/Sydney',
  CanadaAtlantic = 'Canada/Atlantic',
  CanadaCentral = 'Canada/Central',
  CanadaEastern = 'Canada/Eastern',
  CanadaMountain = 'Canada/Mountain',
  CanadaNewfoundland = 'Canada/Newfoundland',
  CanadaPacific = 'Canada/Pacific',
  EuropeAmsterdam = 'Europe/Amsterdam',
  EuropeAndorra = 'Europe/Andorra',
  EuropeAstrakhan = 'Europe/Astrakhan',
  EuropeAthens = 'Europe/Athens',
  EuropeBelgrade = 'Europe/Belgrade',
  EuropeBerlin = 'Europe/Berlin',
  EuropeBratislava = 'Europe/Bratislava',
  EuropeBrussels = 'Europe/Brussels',
  EuropeBucharest = 'Europe/Bucharest',
  EuropeBudapest = 'Europe/Budapest',
  EuropeBusingen = 'Europe/Busingen',
  EuropeChisinau = 'Europe/Chisinau',
  EuropeCopenhagen = 'Europe/Copenhagen',
  EuropeDublin = 'Europe/Dublin',
  EuropeGibraltar = 'Europe/Gibraltar',
  EuropeGuernsey = 'Europe/Guernsey',
  EuropeHelsinki = 'Europe/Helsinki',
  EuropeIsleOfMan = 'Europe/Isle_of_Man',
  EuropeIstanbul = 'Europe/Istanbul',
  EuropeJersey = 'Europe/Jersey',
  EuropeKaliningrad = 'Europe/Kaliningrad',
  EuropeKiev = 'Europe/Kiev',
  EuropeKirov = 'Europe/Kirov',
  EuropeLisbon = 'Europe/Lisbon',
  EuropeLjubljana = 'Europe/Ljubljana',
  EuropeLondon = 'Europe/London',
  EuropeLuxembourg = 'Europe/Luxembourg',
  EuropeMadrid = 'Europe/Madrid',
  EuropeMalta = 'Europe/Malta',
  EuropeMariehamn = 'Europe/Mariehamn',
  EuropeMinsk = 'Europe/Minsk',
  EuropeMonaco = 'Europe/Monaco',
  EuropeMoscow = 'Europe/Moscow',
  EuropeOslo = 'Europe/Oslo',
  EuropeParis = 'Europe/Paris',
  EuropePodgorica = 'Europe/Podgorica',
  EuropePrague = 'Europe/Prague',
  EuropeRiga = 'Europe/Riga',
  EuropeRome = 'Europe/Rome',
  EuropeSamara = 'Europe/Samara',
  EuropeSanMarino = 'Europe/San_Marino',
  EuropeSarajevo = 'Europe/Sarajevo',
  EuropeSaratov = 'Europe/Saratov',
  EuropeSimferopol = 'Europe/Simferopol',
  EuropeSkopje = 'Europe/Skopje',
  EuropeSofia = 'Europe/Sofia',
  EuropeStockholm = 'Europe/Stockholm',
  EuropeTallinn = 'Europe/Tallinn',
  EuropeTirane = 'Europe/Tirane',
  EuropeUlyanovsk = 'Europe/Ulyanovsk',
  EuropeUzhgorod = 'Europe/Uzhgorod',
  EuropeVaduz = 'Europe/Vaduz',
  EuropeVatican = 'Europe/Vatican',
  EuropeVienna = 'Europe/Vienna',
  EuropeVilnius = 'Europe/Vilnius',
  EuropeVolgograd = 'Europe/Volgograd',
  EuropeWarsaw = 'Europe/Warsaw',
  EuropeZagreb = 'Europe/Zagreb',
  EuropeZaporozhye = 'Europe/Zaporozhye',
  EuropeZurich = 'Europe/Zurich',
  Gmt = 'GMT',
  IndianAntananarivo = 'Indian/Antananarivo',
  IndianChagos = 'Indian/Chagos',
  IndianChristmas = 'Indian/Christmas',
  IndianCocos = 'Indian/Cocos',
  IndianComoro = 'Indian/Comoro',
  IndianKerguelen = 'Indian/Kerguelen',
  IndianMahe = 'Indian/Mahe',
  IndianMaldives = 'Indian/Maldives',
  IndianMauritius = 'Indian/Mauritius',
  IndianMayotte = 'Indian/Mayotte',
  IndianReunion = 'Indian/Reunion',
  PacificApia = 'Pacific/Apia',
  PacificAuckland = 'Pacific/Auckland',
  PacificBougainville = 'Pacific/Bougainville',
  PacificChatham = 'Pacific/Chatham',
  PacificChuuk = 'Pacific/Chuuk',
  PacificEaster = 'Pacific/Easter',
  PacificEfate = 'Pacific/Efate',
  PacificFakaofo = 'Pacific/Fakaofo',
  PacificFiji = 'Pacific/Fiji',
  PacificFunafuti = 'Pacific/Funafuti',
  PacificGalapagos = 'Pacific/Galapagos',
  PacificGambier = 'Pacific/Gambier',
  PacificGuadalcanal = 'Pacific/Guadalcanal',
  PacificGuam = 'Pacific/Guam',
  PacificHonolulu = 'Pacific/Honolulu',
  PacificKanton = 'Pacific/Kanton',
  PacificKiritimati = 'Pacific/Kiritimati',
  PacificKosrae = 'Pacific/Kosrae',
  PacificKwajalein = 'Pacific/Kwajalein',
  PacificMajuro = 'Pacific/Majuro',
  PacificMarquesas = 'Pacific/Marquesas',
  PacificMidway = 'Pacific/Midway',
  PacificNauru = 'Pacific/Nauru',
  PacificNiue = 'Pacific/Niue',
  PacificNorfolk = 'Pacific/Norfolk',
  PacificNoumea = 'Pacific/Noumea',
  PacificPagoPago = 'Pacific/Pago_Pago',
  PacificPalau = 'Pacific/Palau',
  PacificPitcairn = 'Pacific/Pitcairn',
  PacificPohnpei = 'Pacific/Pohnpei',
  PacificPortMoresby = 'Pacific/Port_Moresby',
  PacificRarotonga = 'Pacific/Rarotonga',
  PacificSaipan = 'Pacific/Saipan',
  PacificTahiti = 'Pacific/Tahiti',
  PacificTarawa = 'Pacific/Tarawa',
  PacificTongatapu = 'Pacific/Tongatapu',
  PacificWake = 'Pacific/Wake',
  PacificWallis = 'Pacific/Wallis',
  Utc = 'UTC',
}
/**
 * @export
 * @enum {string}
 */
export enum ProjectSummaryDisplayLanguageEnum {
  EnUs = 'en-US',
  FrFr = 'fr-FR',
}

/**
 *
 * @export
 * @interface ProjectSummaryUserAttrs
 */
export interface ProjectSummaryUserAttrs {
  /**
   * One of admin, manager, viewer
   * @type {string}
   * @memberof ProjectSummaryUserAttrs
   */
  role: string
  /**
   * Whether or not a user has ptz access or not on project
   * @type {boolean}
   * @memberof ProjectSummaryUserAttrs
   */
  has_ptz_access: boolean
  /**
   * PTZ Level
   * @type {number}
   * @memberof ProjectSummaryUserAttrs
   */
  ptz_level: number
  /**
   * Whether the user has permission to initiate on-demand photosphere scans
   * @type {boolean}
   * @memberof ProjectSummaryUserAttrs
   */
  photosphere_on_demand_permission?: boolean
  /**
   * Whether the user has permission to set photosphere scan schedules
   * @type {boolean}
   * @memberof ProjectSummaryUserAttrs
   */
  photosphere_schedule_permission?: boolean
}
/**
 *
 * @export
 * @interface ProjectUpdateRequest
 */
export interface ProjectUpdateRequest {
  /**
   * geojson (Must be valid json).
   * @type {object}
   * @memberof ProjectUpdateRequest
   */
  mapping_annotations?: object
  /**
   *
   * @type {boolean}
   * @memberof ProjectUpdateRequest
   */
  camevent_all_enabled?: boolean
}
/**
 *
 * @export
 * @interface ProjectUser
 */
export interface ProjectUser {
  /**
   *
   * @type {UserSummary}
   * @memberof ProjectUser
   */
  user?: UserSummary
  /**
   *
   * @type {string}
   * @memberof ProjectUser
   */
  start_date?: string
  /**
   * One of admin, manager, viewer
   * @type {string}
   * @memberof ProjectUser
   */
  role: string
  /**
   *
   * @type {string}
   * @memberof ProjectUser
   */
  has_ptz_access?: string
  /**
   *
   * @type {number}
   * @memberof ProjectUser
   */
  ptz_level?: number
  /**
   *
   * @type {boolean}
   * @memberof ProjectUser
   */
  photosphere_on_demand_permission?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ProjectUser
   */
  photosphere_schedule_permission?: boolean
}
/**
 *
 * @export
 * @interface ProjectUserViaEmail
 */
export interface ProjectUserViaEmail {
  /**
   *
   * @type {Array<string>}
   * @memberof ProjectUserViaEmail
   */
  emails: Array<string>
  /**
   * One of admin, manager, viewer
   * @type {string}
   * @memberof ProjectUserViaEmail
   */
  role: string
  /**
   *
   * @type {number}
   * @memberof ProjectUserViaEmail
   */
  ptz_level?: number
  /**
   *
   * @type {boolean}
   * @memberof ProjectUserViaEmail
   */
  photosphere_on_demand_permission?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ProjectUserViaEmail
   */
  photosphere_schedule_permission?: boolean
}
/**
 *
 * @export
 * @interface PtzLock
 */
export interface PtzLock {
  /**
   *
   * @type {number}
   * @memberof PtzLock
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof PtzLock
   */
  source_stream_name?: string
  /**
   *
   * @type {boolean}
   * @memberof PtzLock
   */
  ptz_locked?: boolean
  /**
   *
   * @type {string}
   * @memberof PtzLock
   */
  ptz_lock_message?: string | null
}
/**
 *
 * @export
 * @interface PtzMovement
 */
export interface PtzMovement {
  /**
   * Horizontal: + right, - left
   * @type {number}
   * @memberof PtzMovement
   */
  pan?: number
  /**
   * Vertical: + up, - down
   * @type {number}
   * @memberof PtzMovement
   */
  tilt?: number
  /**
   * + to zoom in, - to zoom out
   * @type {number}
   * @memberof PtzMovement
   */
  zoom?: number
  /**
   *
   * @type {number}
   * @memberof PtzMovement
   */
  duration?: number
}
/**
 *
 * @export
 * @interface PublicProject
 */
export interface PublicProject {
  /**
   *
   * @type {string}
   * @memberof PublicProject
   */
  name: string
  /**
   * This is used within a project url.
   * @type {string}
   * @memberof PublicProject
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof PublicProject
   */
  timezone: PublicProjectTimezoneEnum
  /**
   * Whether or not the project is live.
   * @type {boolean}
   * @memberof PublicProject
   */
  live: boolean
  /**
   *
   * @type {Array<PublicStream>}
   * @memberof PublicProject
   */
  streams: Array<PublicStream>
}

/**
 * @export
 * @enum {string}
 */
export enum PublicProjectTimezoneEnum {
  AfricaAbidjan = 'Africa/Abidjan',
  AfricaAccra = 'Africa/Accra',
  AfricaAddisAbaba = 'Africa/Addis_Ababa',
  AfricaAlgiers = 'Africa/Algiers',
  AfricaAsmara = 'Africa/Asmara',
  AfricaBamako = 'Africa/Bamako',
  AfricaBangui = 'Africa/Bangui',
  AfricaBanjul = 'Africa/Banjul',
  AfricaBissau = 'Africa/Bissau',
  AfricaBlantyre = 'Africa/Blantyre',
  AfricaBrazzaville = 'Africa/Brazzaville',
  AfricaBujumbura = 'Africa/Bujumbura',
  AfricaCairo = 'Africa/Cairo',
  AfricaCasablanca = 'Africa/Casablanca',
  AfricaCeuta = 'Africa/Ceuta',
  AfricaConakry = 'Africa/Conakry',
  AfricaDakar = 'Africa/Dakar',
  AfricaDarEsSalaam = 'Africa/Dar_es_Salaam',
  AfricaDjibouti = 'Africa/Djibouti',
  AfricaDouala = 'Africa/Douala',
  AfricaElAaiun = 'Africa/El_Aaiun',
  AfricaFreetown = 'Africa/Freetown',
  AfricaGaborone = 'Africa/Gaborone',
  AfricaHarare = 'Africa/Harare',
  AfricaJohannesburg = 'Africa/Johannesburg',
  AfricaJuba = 'Africa/Juba',
  AfricaKampala = 'Africa/Kampala',
  AfricaKhartoum = 'Africa/Khartoum',
  AfricaKigali = 'Africa/Kigali',
  AfricaKinshasa = 'Africa/Kinshasa',
  AfricaLagos = 'Africa/Lagos',
  AfricaLibreville = 'Africa/Libreville',
  AfricaLome = 'Africa/Lome',
  AfricaLuanda = 'Africa/Luanda',
  AfricaLubumbashi = 'Africa/Lubumbashi',
  AfricaLusaka = 'Africa/Lusaka',
  AfricaMalabo = 'Africa/Malabo',
  AfricaMaputo = 'Africa/Maputo',
  AfricaMaseru = 'Africa/Maseru',
  AfricaMbabane = 'Africa/Mbabane',
  AfricaMogadishu = 'Africa/Mogadishu',
  AfricaMonrovia = 'Africa/Monrovia',
  AfricaNairobi = 'Africa/Nairobi',
  AfricaNdjamena = 'Africa/Ndjamena',
  AfricaNiamey = 'Africa/Niamey',
  AfricaNouakchott = 'Africa/Nouakchott',
  AfricaOuagadougou = 'Africa/Ouagadougou',
  AfricaPortoNovo = 'Africa/Porto-Novo',
  AfricaSaoTome = 'Africa/Sao_Tome',
  AfricaTripoli = 'Africa/Tripoli',
  AfricaTunis = 'Africa/Tunis',
  AfricaWindhoek = 'Africa/Windhoek',
  AmericaAdak = 'America/Adak',
  AmericaAnchorage = 'America/Anchorage',
  AmericaAnguilla = 'America/Anguilla',
  AmericaAntigua = 'America/Antigua',
  AmericaAraguaina = 'America/Araguaina',
  AmericaArgentinaBuenosAires = 'America/Argentina/Buenos_Aires',
  AmericaArgentinaCatamarca = 'America/Argentina/Catamarca',
  AmericaArgentinaCordoba = 'America/Argentina/Cordoba',
  AmericaArgentinaJujuy = 'America/Argentina/Jujuy',
  AmericaArgentinaLaRioja = 'America/Argentina/La_Rioja',
  AmericaArgentinaMendoza = 'America/Argentina/Mendoza',
  AmericaArgentinaRioGallegos = 'America/Argentina/Rio_Gallegos',
  AmericaArgentinaSalta = 'America/Argentina/Salta',
  AmericaArgentinaSanJuan = 'America/Argentina/San_Juan',
  AmericaArgentinaSanLuis = 'America/Argentina/San_Luis',
  AmericaArgentinaTucuman = 'America/Argentina/Tucuman',
  AmericaArgentinaUshuaia = 'America/Argentina/Ushuaia',
  AmericaAruba = 'America/Aruba',
  AmericaAsuncion = 'America/Asuncion',
  AmericaAtikokan = 'America/Atikokan',
  AmericaBahia = 'America/Bahia',
  AmericaBahiaBanderas = 'America/Bahia_Banderas',
  AmericaBarbados = 'America/Barbados',
  AmericaBelem = 'America/Belem',
  AmericaBelize = 'America/Belize',
  AmericaBlancSablon = 'America/Blanc-Sablon',
  AmericaBoaVista = 'America/Boa_Vista',
  AmericaBogota = 'America/Bogota',
  AmericaBoise = 'America/Boise',
  AmericaCambridgeBay = 'America/Cambridge_Bay',
  AmericaCampoGrande = 'America/Campo_Grande',
  AmericaCancun = 'America/Cancun',
  AmericaCaracas = 'America/Caracas',
  AmericaCayenne = 'America/Cayenne',
  AmericaCayman = 'America/Cayman',
  AmericaChicago = 'America/Chicago',
  AmericaChihuahua = 'America/Chihuahua',
  AmericaCostaRica = 'America/Costa_Rica',
  AmericaCreston = 'America/Creston',
  AmericaCuiaba = 'America/Cuiaba',
  AmericaCuracao = 'America/Curacao',
  AmericaDanmarkshavn = 'America/Danmarkshavn',
  AmericaDawson = 'America/Dawson',
  AmericaDawsonCreek = 'America/Dawson_Creek',
  AmericaDenver = 'America/Denver',
  AmericaDetroit = 'America/Detroit',
  AmericaDominica = 'America/Dominica',
  AmericaEdmonton = 'America/Edmonton',
  AmericaEirunepe = 'America/Eirunepe',
  AmericaElSalvador = 'America/El_Salvador',
  AmericaFortNelson = 'America/Fort_Nelson',
  AmericaFortaleza = 'America/Fortaleza',
  AmericaGlaceBay = 'America/Glace_Bay',
  AmericaGooseBay = 'America/Goose_Bay',
  AmericaGrandTurk = 'America/Grand_Turk',
  AmericaGrenada = 'America/Grenada',
  AmericaGuadeloupe = 'America/Guadeloupe',
  AmericaGuatemala = 'America/Guatemala',
  AmericaGuayaquil = 'America/Guayaquil',
  AmericaGuyana = 'America/Guyana',
  AmericaHalifax = 'America/Halifax',
  AmericaHavana = 'America/Havana',
  AmericaHermosillo = 'America/Hermosillo',
  AmericaIndianaIndianapolis = 'America/Indiana/Indianapolis',
  AmericaIndianaKnox = 'America/Indiana/Knox',
  AmericaIndianaMarengo = 'America/Indiana/Marengo',
  AmericaIndianaPetersburg = 'America/Indiana/Petersburg',
  AmericaIndianaTellCity = 'America/Indiana/Tell_City',
  AmericaIndianaVevay = 'America/Indiana/Vevay',
  AmericaIndianaVincennes = 'America/Indiana/Vincennes',
  AmericaIndianaWinamac = 'America/Indiana/Winamac',
  AmericaInuvik = 'America/Inuvik',
  AmericaIqaluit = 'America/Iqaluit',
  AmericaJamaica = 'America/Jamaica',
  AmericaJuneau = 'America/Juneau',
  AmericaKentuckyLouisville = 'America/Kentucky/Louisville',
  AmericaKentuckyMonticello = 'America/Kentucky/Monticello',
  AmericaKralendijk = 'America/Kralendijk',
  AmericaLaPaz = 'America/La_Paz',
  AmericaLima = 'America/Lima',
  AmericaLosAngeles = 'America/Los_Angeles',
  AmericaLowerPrinces = 'America/Lower_Princes',
  AmericaMaceio = 'America/Maceio',
  AmericaManagua = 'America/Managua',
  AmericaManaus = 'America/Manaus',
  AmericaMarigot = 'America/Marigot',
  AmericaMartinique = 'America/Martinique',
  AmericaMatamoros = 'America/Matamoros',
  AmericaMazatlan = 'America/Mazatlan',
  AmericaMenominee = 'America/Menominee',
  AmericaMerida = 'America/Merida',
  AmericaMetlakatla = 'America/Metlakatla',
  AmericaMexicoCity = 'America/Mexico_City',
  AmericaMiquelon = 'America/Miquelon',
  AmericaMoncton = 'America/Moncton',
  AmericaMonterrey = 'America/Monterrey',
  AmericaMontevideo = 'America/Montevideo',
  AmericaMontserrat = 'America/Montserrat',
  AmericaNassau = 'America/Nassau',
  AmericaNewYork = 'America/New_York',
  AmericaNipigon = 'America/Nipigon',
  AmericaNome = 'America/Nome',
  AmericaNoronha = 'America/Noronha',
  AmericaNorthDakotaBeulah = 'America/North_Dakota/Beulah',
  AmericaNorthDakotaCenter = 'America/North_Dakota/Center',
  AmericaNorthDakotaNewSalem = 'America/North_Dakota/New_Salem',
  AmericaNuuk = 'America/Nuuk',
  AmericaOjinaga = 'America/Ojinaga',
  AmericaPanama = 'America/Panama',
  AmericaPangnirtung = 'America/Pangnirtung',
  AmericaParamaribo = 'America/Paramaribo',
  AmericaPhoenix = 'America/Phoenix',
  AmericaPortAuPrince = 'America/Port-au-Prince',
  AmericaPortOfSpain = 'America/Port_of_Spain',
  AmericaPortoVelho = 'America/Porto_Velho',
  AmericaPuertoRico = 'America/Puerto_Rico',
  AmericaPuntaArenas = 'America/Punta_Arenas',
  AmericaRainyRiver = 'America/Rainy_River',
  AmericaRankinInlet = 'America/Rankin_Inlet',
  AmericaRecife = 'America/Recife',
  AmericaRegina = 'America/Regina',
  AmericaResolute = 'America/Resolute',
  AmericaRioBranco = 'America/Rio_Branco',
  AmericaSantarem = 'America/Santarem',
  AmericaSantiago = 'America/Santiago',
  AmericaSantoDomingo = 'America/Santo_Domingo',
  AmericaSaoPaulo = 'America/Sao_Paulo',
  AmericaScoresbysund = 'America/Scoresbysund',
  AmericaSitka = 'America/Sitka',
  AmericaStBarthelemy = 'America/St_Barthelemy',
  AmericaStJohns = 'America/St_Johns',
  AmericaStKitts = 'America/St_Kitts',
  AmericaStLucia = 'America/St_Lucia',
  AmericaStThomas = 'America/St_Thomas',
  AmericaStVincent = 'America/St_Vincent',
  AmericaSwiftCurrent = 'America/Swift_Current',
  AmericaTegucigalpa = 'America/Tegucigalpa',
  AmericaThule = 'America/Thule',
  AmericaThunderBay = 'America/Thunder_Bay',
  AmericaTijuana = 'America/Tijuana',
  AmericaToronto = 'America/Toronto',
  AmericaTortola = 'America/Tortola',
  AmericaVancouver = 'America/Vancouver',
  AmericaWhitehorse = 'America/Whitehorse',
  AmericaWinnipeg = 'America/Winnipeg',
  AmericaYakutat = 'America/Yakutat',
  AmericaYellowknife = 'America/Yellowknife',
  AntarcticaCasey = 'Antarctica/Casey',
  AntarcticaDavis = 'Antarctica/Davis',
  AntarcticaDumontDUrville = 'Antarctica/DumontDUrville',
  AntarcticaMacquarie = 'Antarctica/Macquarie',
  AntarcticaMawson = 'Antarctica/Mawson',
  AntarcticaMcMurdo = 'Antarctica/McMurdo',
  AntarcticaPalmer = 'Antarctica/Palmer',
  AntarcticaRothera = 'Antarctica/Rothera',
  AntarcticaSyowa = 'Antarctica/Syowa',
  AntarcticaTroll = 'Antarctica/Troll',
  AntarcticaVostok = 'Antarctica/Vostok',
  ArcticLongyearbyen = 'Arctic/Longyearbyen',
  AsiaAden = 'Asia/Aden',
  AsiaAlmaty = 'Asia/Almaty',
  AsiaAmman = 'Asia/Amman',
  AsiaAnadyr = 'Asia/Anadyr',
  AsiaAqtau = 'Asia/Aqtau',
  AsiaAqtobe = 'Asia/Aqtobe',
  AsiaAshgabat = 'Asia/Ashgabat',
  AsiaAtyrau = 'Asia/Atyrau',
  AsiaBaghdad = 'Asia/Baghdad',
  AsiaBahrain = 'Asia/Bahrain',
  AsiaBaku = 'Asia/Baku',
  AsiaBangkok = 'Asia/Bangkok',
  AsiaBarnaul = 'Asia/Barnaul',
  AsiaBeirut = 'Asia/Beirut',
  AsiaBishkek = 'Asia/Bishkek',
  AsiaBrunei = 'Asia/Brunei',
  AsiaChita = 'Asia/Chita',
  AsiaChoibalsan = 'Asia/Choibalsan',
  AsiaColombo = 'Asia/Colombo',
  AsiaDamascus = 'Asia/Damascus',
  AsiaDhaka = 'Asia/Dhaka',
  AsiaDili = 'Asia/Dili',
  AsiaDubai = 'Asia/Dubai',
  AsiaDushanbe = 'Asia/Dushanbe',
  AsiaFamagusta = 'Asia/Famagusta',
  AsiaGaza = 'Asia/Gaza',
  AsiaHebron = 'Asia/Hebron',
  AsiaHoChiMinh = 'Asia/Ho_Chi_Minh',
  AsiaHongKong = 'Asia/Hong_Kong',
  AsiaHovd = 'Asia/Hovd',
  AsiaIrkutsk = 'Asia/Irkutsk',
  AsiaJakarta = 'Asia/Jakarta',
  AsiaJayapura = 'Asia/Jayapura',
  AsiaJerusalem = 'Asia/Jerusalem',
  AsiaKabul = 'Asia/Kabul',
  AsiaKamchatka = 'Asia/Kamchatka',
  AsiaKarachi = 'Asia/Karachi',
  AsiaKathmandu = 'Asia/Kathmandu',
  AsiaKhandyga = 'Asia/Khandyga',
  AsiaKolkata = 'Asia/Kolkata',
  AsiaKrasnoyarsk = 'Asia/Krasnoyarsk',
  AsiaKualaLumpur = 'Asia/Kuala_Lumpur',
  AsiaKuching = 'Asia/Kuching',
  AsiaKuwait = 'Asia/Kuwait',
  AsiaMacau = 'Asia/Macau',
  AsiaMagadan = 'Asia/Magadan',
  AsiaMakassar = 'Asia/Makassar',
  AsiaManila = 'Asia/Manila',
  AsiaMuscat = 'Asia/Muscat',
  AsiaNicosia = 'Asia/Nicosia',
  AsiaNovokuznetsk = 'Asia/Novokuznetsk',
  AsiaNovosibirsk = 'Asia/Novosibirsk',
  AsiaOmsk = 'Asia/Omsk',
  AsiaOral = 'Asia/Oral',
  AsiaPhnomPenh = 'Asia/Phnom_Penh',
  AsiaPontianak = 'Asia/Pontianak',
  AsiaPyongyang = 'Asia/Pyongyang',
  AsiaQatar = 'Asia/Qatar',
  AsiaQostanay = 'Asia/Qostanay',
  AsiaQyzylorda = 'Asia/Qyzylorda',
  AsiaRiyadh = 'Asia/Riyadh',
  AsiaSakhalin = 'Asia/Sakhalin',
  AsiaSamarkand = 'Asia/Samarkand',
  AsiaSeoul = 'Asia/Seoul',
  AsiaShanghai = 'Asia/Shanghai',
  AsiaSingapore = 'Asia/Singapore',
  AsiaSrednekolymsk = 'Asia/Srednekolymsk',
  AsiaTaipei = 'Asia/Taipei',
  AsiaTashkent = 'Asia/Tashkent',
  AsiaTbilisi = 'Asia/Tbilisi',
  AsiaTehran = 'Asia/Tehran',
  AsiaThimphu = 'Asia/Thimphu',
  AsiaTokyo = 'Asia/Tokyo',
  AsiaTomsk = 'Asia/Tomsk',
  AsiaUlaanbaatar = 'Asia/Ulaanbaatar',
  AsiaUrumqi = 'Asia/Urumqi',
  AsiaUstNera = 'Asia/Ust-Nera',
  AsiaVientiane = 'Asia/Vientiane',
  AsiaVladivostok = 'Asia/Vladivostok',
  AsiaYakutsk = 'Asia/Yakutsk',
  AsiaYangon = 'Asia/Yangon',
  AsiaYekaterinburg = 'Asia/Yekaterinburg',
  AsiaYerevan = 'Asia/Yerevan',
  AtlanticAzores = 'Atlantic/Azores',
  AtlanticBermuda = 'Atlantic/Bermuda',
  AtlanticCanary = 'Atlantic/Canary',
  AtlanticCapeVerde = 'Atlantic/Cape_Verde',
  AtlanticFaroe = 'Atlantic/Faroe',
  AtlanticMadeira = 'Atlantic/Madeira',
  AtlanticReykjavik = 'Atlantic/Reykjavik',
  AtlanticSouthGeorgia = 'Atlantic/South_Georgia',
  AtlanticStHelena = 'Atlantic/St_Helena',
  AtlanticStanley = 'Atlantic/Stanley',
  AustraliaAdelaide = 'Australia/Adelaide',
  AustraliaBrisbane = 'Australia/Brisbane',
  AustraliaBrokenHill = 'Australia/Broken_Hill',
  AustraliaDarwin = 'Australia/Darwin',
  AustraliaEucla = 'Australia/Eucla',
  AustraliaHobart = 'Australia/Hobart',
  AustraliaLindeman = 'Australia/Lindeman',
  AustraliaLordHowe = 'Australia/Lord_Howe',
  AustraliaMelbourne = 'Australia/Melbourne',
  AustraliaPerth = 'Australia/Perth',
  AustraliaSydney = 'Australia/Sydney',
  CanadaAtlantic = 'Canada/Atlantic',
  CanadaCentral = 'Canada/Central',
  CanadaEastern = 'Canada/Eastern',
  CanadaMountain = 'Canada/Mountain',
  CanadaNewfoundland = 'Canada/Newfoundland',
  CanadaPacific = 'Canada/Pacific',
  EuropeAmsterdam = 'Europe/Amsterdam',
  EuropeAndorra = 'Europe/Andorra',
  EuropeAstrakhan = 'Europe/Astrakhan',
  EuropeAthens = 'Europe/Athens',
  EuropeBelgrade = 'Europe/Belgrade',
  EuropeBerlin = 'Europe/Berlin',
  EuropeBratislava = 'Europe/Bratislava',
  EuropeBrussels = 'Europe/Brussels',
  EuropeBucharest = 'Europe/Bucharest',
  EuropeBudapest = 'Europe/Budapest',
  EuropeBusingen = 'Europe/Busingen',
  EuropeChisinau = 'Europe/Chisinau',
  EuropeCopenhagen = 'Europe/Copenhagen',
  EuropeDublin = 'Europe/Dublin',
  EuropeGibraltar = 'Europe/Gibraltar',
  EuropeGuernsey = 'Europe/Guernsey',
  EuropeHelsinki = 'Europe/Helsinki',
  EuropeIsleOfMan = 'Europe/Isle_of_Man',
  EuropeIstanbul = 'Europe/Istanbul',
  EuropeJersey = 'Europe/Jersey',
  EuropeKaliningrad = 'Europe/Kaliningrad',
  EuropeKiev = 'Europe/Kiev',
  EuropeKirov = 'Europe/Kirov',
  EuropeLisbon = 'Europe/Lisbon',
  EuropeLjubljana = 'Europe/Ljubljana',
  EuropeLondon = 'Europe/London',
  EuropeLuxembourg = 'Europe/Luxembourg',
  EuropeMadrid = 'Europe/Madrid',
  EuropeMalta = 'Europe/Malta',
  EuropeMariehamn = 'Europe/Mariehamn',
  EuropeMinsk = 'Europe/Minsk',
  EuropeMonaco = 'Europe/Monaco',
  EuropeMoscow = 'Europe/Moscow',
  EuropeOslo = 'Europe/Oslo',
  EuropeParis = 'Europe/Paris',
  EuropePodgorica = 'Europe/Podgorica',
  EuropePrague = 'Europe/Prague',
  EuropeRiga = 'Europe/Riga',
  EuropeRome = 'Europe/Rome',
  EuropeSamara = 'Europe/Samara',
  EuropeSanMarino = 'Europe/San_Marino',
  EuropeSarajevo = 'Europe/Sarajevo',
  EuropeSaratov = 'Europe/Saratov',
  EuropeSimferopol = 'Europe/Simferopol',
  EuropeSkopje = 'Europe/Skopje',
  EuropeSofia = 'Europe/Sofia',
  EuropeStockholm = 'Europe/Stockholm',
  EuropeTallinn = 'Europe/Tallinn',
  EuropeTirane = 'Europe/Tirane',
  EuropeUlyanovsk = 'Europe/Ulyanovsk',
  EuropeUzhgorod = 'Europe/Uzhgorod',
  EuropeVaduz = 'Europe/Vaduz',
  EuropeVatican = 'Europe/Vatican',
  EuropeVienna = 'Europe/Vienna',
  EuropeVilnius = 'Europe/Vilnius',
  EuropeVolgograd = 'Europe/Volgograd',
  EuropeWarsaw = 'Europe/Warsaw',
  EuropeZagreb = 'Europe/Zagreb',
  EuropeZaporozhye = 'Europe/Zaporozhye',
  EuropeZurich = 'Europe/Zurich',
  Gmt = 'GMT',
  IndianAntananarivo = 'Indian/Antananarivo',
  IndianChagos = 'Indian/Chagos',
  IndianChristmas = 'Indian/Christmas',
  IndianCocos = 'Indian/Cocos',
  IndianComoro = 'Indian/Comoro',
  IndianKerguelen = 'Indian/Kerguelen',
  IndianMahe = 'Indian/Mahe',
  IndianMaldives = 'Indian/Maldives',
  IndianMauritius = 'Indian/Mauritius',
  IndianMayotte = 'Indian/Mayotte',
  IndianReunion = 'Indian/Reunion',
  PacificApia = 'Pacific/Apia',
  PacificAuckland = 'Pacific/Auckland',
  PacificBougainville = 'Pacific/Bougainville',
  PacificChatham = 'Pacific/Chatham',
  PacificChuuk = 'Pacific/Chuuk',
  PacificEaster = 'Pacific/Easter',
  PacificEfate = 'Pacific/Efate',
  PacificFakaofo = 'Pacific/Fakaofo',
  PacificFiji = 'Pacific/Fiji',
  PacificFunafuti = 'Pacific/Funafuti',
  PacificGalapagos = 'Pacific/Galapagos',
  PacificGambier = 'Pacific/Gambier',
  PacificGuadalcanal = 'Pacific/Guadalcanal',
  PacificGuam = 'Pacific/Guam',
  PacificHonolulu = 'Pacific/Honolulu',
  PacificKanton = 'Pacific/Kanton',
  PacificKiritimati = 'Pacific/Kiritimati',
  PacificKosrae = 'Pacific/Kosrae',
  PacificKwajalein = 'Pacific/Kwajalein',
  PacificMajuro = 'Pacific/Majuro',
  PacificMarquesas = 'Pacific/Marquesas',
  PacificMidway = 'Pacific/Midway',
  PacificNauru = 'Pacific/Nauru',
  PacificNiue = 'Pacific/Niue',
  PacificNorfolk = 'Pacific/Norfolk',
  PacificNoumea = 'Pacific/Noumea',
  PacificPagoPago = 'Pacific/Pago_Pago',
  PacificPalau = 'Pacific/Palau',
  PacificPitcairn = 'Pacific/Pitcairn',
  PacificPohnpei = 'Pacific/Pohnpei',
  PacificPortMoresby = 'Pacific/Port_Moresby',
  PacificRarotonga = 'Pacific/Rarotonga',
  PacificSaipan = 'Pacific/Saipan',
  PacificTahiti = 'Pacific/Tahiti',
  PacificTarawa = 'Pacific/Tarawa',
  PacificTongatapu = 'Pacific/Tongatapu',
  PacificWake = 'Pacific/Wake',
  PacificWallis = 'Pacific/Wallis',
  Utc = 'UTC',
}

/**
 *
 * @export
 * @interface PublicStream
 */
export interface PublicStream {
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  url?: string | null
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof PublicStream
   */
  live?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof PublicStream
   */
  computed_error_messages?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof PublicStream
   */
  computed_warning_messages?: Array<string>
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  current_image_url?: string
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  current_thumbnail_url?: string
  /**
   *
   * @type {boolean}
   * @memberof PublicStream
   */
  show_still_image?: boolean
  /**
   *
   * @type {string}
   * @memberof PublicStream
   */
  aspect_ratio?: string
  /**
   * Rotation of a video.
   * @type {number}
   * @memberof PublicStream
   */
  rotation?: number
  /**
   * Whether or not a video appears full width of the screen.
   * @type {boolean}
   * @memberof PublicStream
   */
  full_width?: boolean
}
/**
 *
 * @export
 * @interface Role
 */
export interface Role {
  /**
   *
   * @type {number}
   * @memberof Role
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Role
   */
  slug: string
  /**
   *
   * @type {number}
   * @memberof Role
   */
  level?: number
  /**
   *
   * @type {string}
   * @memberof Role
   */
  name: string
}
/**
 *
 * @export
 * @interface S3PresignedPost
 */
export interface S3PresignedPost {
  /**
   *
   * @type {string}
   * @memberof S3PresignedPost
   */
  url: string
  /**
   * Paramaters to use with a client-side upload to S3.  For usage, see https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html
   * @type {{ [key: string]: string; }}
   * @memberof S3PresignedPost
   */
  fields: { [key: string]: string }
}
/**
 *
 * @export
 * @interface ScaleImageReading
 */
export interface ScaleImageReading {
  /**
   *
   * @type {number}
   * @memberof ScaleImageReading
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof ScaleImageReading
   */
  stream?: number
  /**
   *
   * @type {string}
   * @memberof ScaleImageReading
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof ScaleImageReading
   */
  start_time: string
  /**
   *
   * @type {string}
   * @memberof ScaleImageReading
   */
  end_time: string
  /**
   *
   * @type {number}
   * @memberof ScaleImageReading
   */
  maximum: number
  /**
   *
   * @type {number}
   * @memberof ScaleImageReading
   */
  count: number
  /**
   *
   * @type {number}
   * @memberof ScaleImageReading
   */
  mode: number
}
/**
 *
 * @export
 * @interface ScaleTripDayMetric
 */
export interface ScaleTripDayMetric {
  /**
   *
   * @type {string}
   * @memberof ScaleTripDayMetric
   */
  day: string
  /**
   *
   * @type {number}
   * @memberof ScaleTripDayMetric
   */
  avg_trip_duration?: number
  /**
   *
   * @type {number}
   * @memberof ScaleTripDayMetric
   */
  num_loads: number
  /**
   *
   * @type {number}
   * @memberof ScaleTripDayMetric
   */
  num_loads_with_extra: number
}
/**
 *
 * @export
 * @interface ScanImage
 */
export interface ScanImage {
  /**
   *
   * @type {number}
   * @memberof ScanImage
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof ScanImage
   */
  photosphere?: number
  /**
   *
   * @type {string}
   * @memberof ScanImage
   */
  image_datetime?: string
  /**
   *
   * @type {number}
   * @memberof ScanImage
   */
  azimuth?: number
  /**
   *
   * @type {number}
   * @memberof ScanImage
   */
  elevation?: number
  /**
   *
   * @type {number}
   * @memberof ScanImage
   */
  zoom?: number
  /**
   *
   * @type {string}
   * @memberof ScanImage
   */
  upload_url?: string
}
/**
 *
 * @export
 * @interface SegmentationDrawing
 */
export interface SegmentationDrawing {
  /**
   *
   * @type {number}
   * @memberof SegmentationDrawing
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof SegmentationDrawing
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof SegmentationDrawing
   */
  page_number?: number | null
  /**
   *
   * @type {number}
   * @memberof SegmentationDrawing
   */
  upload?: number
  /**
   *
   * @type {string}
   * @memberof SegmentationDrawing
   */
  upload_url?: string
  /**
   * Each sublist is a vector.
   * @type {Array<Array<number>>}
   * @memberof SegmentationDrawing
   */
  drawing_to_master?: Array<Array<number>> | null
  /**
   * Each sublist is a vector.
   * @type {Array<Array<number>>}
   * @memberof SegmentationDrawing
   */
  master_to_drawing?: Array<Array<number>> | null
}
/**
 *
 * @export
 * @interface SegmentationLabel
 */
export interface SegmentationLabel {
  /**
   *
   * @type {number}
   * @memberof SegmentationLabel
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof SegmentationLabel
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof SegmentationLabel
   */
  slug: string
}
/**
 *
 * @export
 * @interface SegmentationProgress
 */
export interface SegmentationProgress {
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  floor?: number
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  label?: number
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  start_datetime?: string | null
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  end_datetime: string
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  area_changed?: number
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  area_total?: number
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  seen_mask?: string | null
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  delta_mask?: string | null
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  resized_seen_mask?: string | null
  /**
   *
   * @type {string}
   * @memberof SegmentationProgress
   */
  resized_delta_mask?: string | null
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  w: number
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  h: number
  /**
   *
   * @type {number}
   * @memberof SegmentationProgress
   */
  scale: number
}
/**
 *
 * @export
 * @interface Session
 */
export interface Session {
  /**
   *
   * @type {number}
   * @memberof Session
   */
  id?: number
  /**
   *
   * @type {UserSummary}
   * @memberof Session
   */
  user?: UserSummary
  /**
   *
   * @type {string}
   * @memberof Session
   */
  start_datetime: string
  /**
   *
   * @type {string}
   * @memberof Session
   */
  end_datetime?: string | null
  /**
   *
   * @type {string}
   * @memberof Session
   */
  paused_at?: string | null
  /**
   *
   * @type {string}
   * @memberof Session
   */
  time_paused?: string
  /**
   *
   * @type {string}
   * @memberof Session
   */
  duration: string | null
}
/**
 *
 * @export
 * @interface ShoringBay
 */
export interface ShoringBay {
  /**
   *
   * @type {number}
   * @memberof ShoringBay
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  node_type?: string | null
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  start_time?: string | null
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  end_time?: string | null
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof ShoringBay
   */
  team?: string | null
  /**
   *
   * @type {number}
   * @memberof ShoringBay
   */
  worker_count?: number | null
  /**
   *
   * @type {Array<StreamCoordinates>}
   * @memberof ShoringBay
   */
  stream_coordinates?: Array<StreamCoordinates>
  /**
   *
   * @type {Array<UploadCoordinates>}
   * @memberof ShoringBay
   */
  upload_coordinates?: Array<UploadCoordinates>
}
/**
 *
 * @export
 * @interface ShoringBayRelation
 */
export interface ShoringBayRelation {
  /**
   *
   * @type {number}
   * @memberof ShoringBayRelation
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof ShoringBayRelation
   */
  predecessor: number
  /**
   *
   * @type {number}
   * @memberof ShoringBayRelation
   */
  successor: number
}
/**
 *
 * @export
 * @interface Stream
 */
export interface Stream {
  /**
   *
   * @type {number}
   * @memberof Stream
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  url?: string | null
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  live: boolean
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  aspect_ratio?: string
  /**
   *
   * @type {Camera}
   * @memberof Stream
   */
  camera?: Camera
  /**
   * Rotation of a video.
   * @type {number}
   * @memberof Stream
   */
  rotation?: number
  /**
   * Whether or not a video appears full width of the screen.
   * @type {boolean}
   * @memberof Stream
   */
  full_width: boolean
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  ptz: boolean
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  ptz_locked: boolean
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  ptz_copy?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  ptz_wiper?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  show_still_image?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Stream
   */
  has_ai_data?: boolean
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  ant_id?: string | null
  /**
   * A valid timezone.  See  http://pytz.sourceforge.net/#helpers for list of valid values.
   * @type {string}
   * @memberof Stream
   */
  timezone: string
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  start_date?: string
  /**
   * This message can be shown when a stream is not functioning.
   * @type {string}
   * @memberof Stream
   */
  error_message?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof Stream
   */
  computed_error_messages?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof Stream
   */
  computed_warning_messages?: Array<string>
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  current_image_url?: string
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  current_thumbnail_url?: string
  /**
   *
   * @type {string}
   * @memberof Stream
   */
  current_timelapse_url?: string
}
/**
 *
 * @export
 * @interface StreamCoordinates
 */
export interface StreamCoordinates {
  /**
   *
   * @type {number}
   * @memberof StreamCoordinates
   */
  stream_id: number
  /**
   *
   * @type {number}
   * @memberof StreamCoordinates
   */
  x: number
  /**
   *
   * @type {number}
   * @memberof StreamCoordinates
   */
  y: number
}
/**
 *
 * @export
 * @interface StreamMinimal
 */
export interface StreamMinimal {
  /**
   *
   * @type {number}
   * @memberof StreamMinimal
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof StreamMinimal
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof StreamMinimal
   */
  name: string
}
/**
 *
 * @export
 * @interface StreamSerializerWithProjects
 */
export interface StreamSerializerWithProjects {
  /**
   *
   * @type {number}
   * @memberof StreamSerializerWithProjects
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  url?: string | null
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  live?: boolean
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  aspect_ratio?: string
  /**
   *
   * @type {Camera}
   * @memberof StreamSerializerWithProjects
   */
  camera?: Camera
  /**
   * Rotation of a video.
   * @type {number}
   * @memberof StreamSerializerWithProjects
   */
  rotation?: number
  /**
   * Whether or not a video appears full width of the screen.
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  full_width?: boolean
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  ptz?: boolean
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  ptz_locked?: boolean
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  ptz_copy?: string | null
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  ptz_wiper?: boolean
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  show_still_image?: boolean
  /**
   *
   * @type {boolean}
   * @memberof StreamSerializerWithProjects
   */
  has_ai_data?: boolean
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  ant_id?: string | null
  /**
   * A valid timezone.  See  http://pytz.sourceforge.net/#helpers for list of valid values.
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  timezone: string
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  start_date?: string
  /**
   * This message can be shown when a stream is not functioning.
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  error_message?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof StreamSerializerWithProjects
   */
  computed_error_messages?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof StreamSerializerWithProjects
   */
  computed_warning_messages?: Array<string>
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  current_image_url?: string
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  current_thumbnail_url?: string
  /**
   *
   * @type {string}
   * @memberof StreamSerializerWithProjects
   */
  current_timelapse_url?: string
  /**
   *
   * @type {Array<ProjectBarebones>}
   * @memberof StreamSerializerWithProjects
   */
  projects: Array<ProjectBarebones>
}
/**
 *
 * @export
 * @interface StreamVideos
 */
export interface StreamVideos {
  /**
   *
   * @type {number}
   * @memberof StreamVideos
   */
  stream_id: number
  /**
   *
   * @type {Array<VideoSummary>}
   * @memberof StreamVideos
   */
  videos?: Array<VideoSummary>
}
/**
 *
 * @export
 * @interface Subcontractor
 */
export interface Subcontractor {
  /**
   *
   * @type {number}
   * @memberof Subcontractor
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Subcontractor
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Subcontractor
   */
  color?: string
  /**
   *
   * @type {string}
   * @memberof Subcontractor
   */
  supercategory?: string | null
}
/**
 *
 * @export
 * @interface SurroundingArmSchedule
 */
export interface SurroundingArmSchedule {
  /**
   *
   * @type {ArmScheduleEventDatetime}
   * @memberof SurroundingArmSchedule
   */
  prev_event: ArmScheduleEventDatetime
  /**
   *
   * @type {ArmScheduleEventDatetime}
   * @memberof SurroundingArmSchedule
   */
  curr_event: ArmScheduleEventDatetime
  /**
   *
   * @type {ArmScheduleEventDatetime}
   * @memberof SurroundingArmSchedule
   */
  next_event: ArmScheduleEventDatetime
  /**
   *
   * @type {ArmScheduleEventDatetime}
   * @memberof SurroundingArmSchedule
   */
  after_next: ArmScheduleEventDatetime
  /**
   *
   * @type {boolean}
   * @memberof SurroundingArmSchedule
   */
  disable_next_event: boolean
}
/**
 *
 * @export
 * @interface Timelapse
 */
export interface Timelapse {
  /**
   *
   * @type {number}
   * @memberof Timelapse
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Timelapse
   */
  req_datetime?: string
  /**
   *
   * @type {number}
   * @memberof Timelapse
   */
  project?: number
  /**
   *
   * @type {number}
   * @memberof Timelapse
   */
  stream: number
  /**
   *
   * @type {StreamMinimal}
   * @memberof Timelapse
   */
  stream_attrs?: StreamMinimal
  /**
   * Start of range to process.  Use local time of stream.
   * @type {string}
   * @memberof Timelapse
   */
  start_date: string
  /**
   * End of range to process. Use local time of stream.
   * @type {string}
   * @memberof Timelapse
   */
  end_date: string
  /**
   * Time of format hh:mm:ss
   * @type {string}
   * @memberof Timelapse
   */
  start_hour: string
  /**
   * Time of format hh:mm:ss
   * @type {string}
   * @memberof Timelapse
   */
  end_hour: string
  /**
   *
   * @type {string}
   * @memberof Timelapse
   */
  state?: TimelapseStateEnum
  /**
   *
   * @type {Array<number>}
   * @memberof Timelapse
   */
  days_of_week?: Array<number>
  /**
   *
   * @type {string}
   * @memberof Timelapse
   */
  video?: string
}

/**
 * @export
 * @enum {string}
 */
export enum TimelapseStateEnum {
  Initial = 'initial',
  Processing = 'processing',
  Failed = 'failed',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface Trip
 */
export interface Trip {
  /**
   *
   * @type {number}
   * @memberof Trip
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  start_time?: string | null
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  end_time?: string | null
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  license_plate?: string | null
  /**
   *
   * @type {number}
   * @memberof Trip
   */
  truck_number?: number | null
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  driver_name?: string | null
  /**
   *
   * @type {Array<TripWeighin>}
   * @memberof Trip
   */
  trip_weighins: Array<TripWeighin>
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  in_license_detection_image_url?: string
  /**
   *
   * @type {string}
   * @memberof Trip
   */
  out_license_detection_image_url?: string
}
/**
 *
 * @export
 * @interface TripWeighin
 */
export interface TripWeighin {
  /**
   *
   * @type {number}
   * @memberof TripWeighin
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof TripWeighin
   */
  tare_weight?: number | null
  /**
   *
   * @type {number}
   * @memberof TripWeighin
   */
  gross_weight?: number | null
  /**
   *
   * @type {number}
   * @memberof TripWeighin
   */
  reported_weight?: number | null
  /**
   *
   * @type {string}
   * @memberof TripWeighin
   */
  weigh_time?: string | null
  /**
   *
   * @type {number}
   * @memberof TripWeighin
   */
  scale_number?: number | null
  /**
   *
   * @type {string}
   * @memberof TripWeighin
   */
  license_detection_image_url?: string
}
/**
 *
 * @export
 * @interface TwilioWebhook
 */
export interface TwilioWebhook {
  /**
   *
   * @type {string}
   * @memberof TwilioWebhook
   */
  message_sid: string
  /**
   *
   * @type {string}
   * @memberof TwilioWebhook
   */
  body: string
  /**
   *
   * @type {string}
   * @memberof TwilioWebhook
   */
  from_number: string
}
/**
 *
 * @export
 * @interface UndistortJob
 */
export interface UndistortJob {
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  job_datetime?: string
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  image_datetime: string
  /**
   *
   * @type {number}
   * @memberof UndistortJob
   */
  stream?: number
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  source_stream_name: string
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  original_url: string
  /**
   *
   * @type {number}
   * @memberof UndistortJob
   */
  alpha: number
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  undistorted_url?: string
  /**
   *
   * @type {boolean}
   * @memberof UndistortJob
   */
  processed?: boolean
  /**
   *
   * @type {string}
   * @memberof UndistortJob
   */
  error_message?: string
  /**
   * standard is \"Standard\", fisheye is \"Fisheye\"
   * @type {string}
   * @memberof UndistortJob
   */
  job_type: UndistortJobJobTypeEnum
}

/**
 * @export
 * @enum {string}
 */
export enum UndistortJobJobTypeEnum {
  Standard = 'standard',
  Fisheye = 'fisheye',
}

/**
 *
 * @export
 * @interface Upload
 */
export interface Upload {
  /**
   *
   * @type {number}
   * @memberof Upload
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Upload
   */
  basename: string
  /**
   * MIME type of a File
   * @type {string}
   * @memberof Upload
   */
  content_type?: string
  /**
   * Whether the file is finished uploading or not.
   * @type {boolean}
   * @memberof Upload
   */
  uploaded?: boolean
  /**
   *
   * @type {string}
   * @memberof Upload
   */
  created_at?: string
  /**
   *
   * @type {string}
   * @memberof Upload
   */
  file_url?: string
}
/**
 *
 * @export
 * @interface UploadCoordinates
 */
export interface UploadCoordinates {
  /**
   *
   * @type {number}
   * @memberof UploadCoordinates
   */
  upload_id: number
  /**
   *
   * @type {number}
   * @memberof UploadCoordinates
   */
  page_number: number
  /**
   *
   * @type {number}
   * @memberof UploadCoordinates
   */
  x: number
  /**
   *
   * @type {number}
   * @memberof UploadCoordinates
   */
  y: number
}
/**
 *
 * @export
 * @interface UploadInitRequest
 */
export interface UploadInitRequest {
  /**
   * Example: blank.pdf
   * @type {string}
   * @memberof UploadInitRequest
   */
  basename: string
  /**
   *
   * @type {string}
   * @memberof UploadInitRequest
   */
  content_type: string
}
/**
 *
 * @export
 * @interface UploadInitResponse
 */
export interface UploadInitResponse {
  /**
   *
   * @type {Upload}
   * @memberof UploadInitResponse
   */
  upload: Upload
  /**
   *
   * @type {S3PresignedPost}
   * @memberof UploadInitResponse
   */
  presigned_post: S3PresignedPost
}
/**
 *
 * @export
 * @interface UserSummary
 */
export interface UserSummary {
  /**
   *
   * @type {number}
   * @memberof UserSummary
   */
  id?: number
  /**
   * Required. 150 characters or fewer. Letters, digits, _ only.
   * @type {string}
   * @memberof UserSummary
   */
  username?: string
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  annotation_role?: UserSummaryAnnotationRoleEnum
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  videoannotation_role?: UserSummaryVideoannotationRoleEnum
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  external_id?: string
  /**
   * Internal users are not visible on the project list to non internal users
   * @type {boolean}
   * @memberof UserSummary
   */
  internal?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  first_name?: string
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  last_name?: string
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  phone_number?: string | null
  /**
   *
   * @type {string}
   * @memberof UserSummary
   */
  latest_app_tour?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum UserSummaryAnnotationRoleEnum {
  Tagger = 'tagger',
  Reviewer = 'reviewer',
  Admin = 'admin',
}
/**
 * @export
 * @enum {string}
 */
export enum UserSummaryVideoannotationRoleEnum {
  Viewer = 'viewer',
  Annotator = 'annotator',
  Admin = 'admin',
}

/**
 *
 * @export
 * @interface VehicleStreamMap
 */
export interface VehicleStreamMap {
  /**
   *
   * @type {number}
   * @memberof VehicleStreamMap
   */
  enter: number | null
  /**
   *
   * @type {number}
   * @memberof VehicleStreamMap
   */
  exit: number | null
  /**
   *
   * @type {Array<VehicleStreamMapScale>}
   * @memberof VehicleStreamMap
   */
  scales: Array<VehicleStreamMapScale>
}
/**
 *
 * @export
 * @interface VehicleStreamMapScale
 */
export interface VehicleStreamMapScale {
  /**
   *
   * @type {number}
   * @memberof VehicleStreamMapScale
   */
  scale_number: number
  /**
   *
   * @type {number}
   * @memberof VehicleStreamMapScale
   */
  display: number | null
  /**
   *
   * @type {number}
   * @memberof VehicleStreamMapScale
   */
  lpr: number | null
}
/**
 *
 * @export
 * @interface Video
 */
export interface Video {
  /**
   *
   * @type {number}
   * @memberof Video
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Video
   */
  local_start_time: string
  /**
   * Full URL of file.  Example: https://aeromana.s3-us-west-2.amazonaws.com/monitoring/archive/400Broadway1.stream_2019-12-21-04.30.00.253-UTC.mp4
   * @type {string}
   * @memberof Video
   */
  url: string
  /**
   * 1x is \"Hourly Videos at 1x\", 20x is \"Hourly Videos at 20x\", 200x is \"Hourly Videos at 200x\", 4x-stab is \"Stabilized Hourly Videos at 4x\", 20x-stab is \"Stabilized Hourly Videos at 20x\", 200x-stab is \"Stabilized Hourly Videos at 200x\", daily is \"Daily Timelapse\"
   * @type {string}
   * @memberof Video
   */
  video_type: VideoVideoTypeEnum
  /**
   * S3 is \"Amazon S3\", B2 is \"Backblaze B2\"
   * @type {string}
   * @memberof Video
   */
  service: VideoServiceEnum
  /**
   * available is \"Available\", locked is \"Locked From Archiving\", pending is \"Pending Archival\", archived is \"Archived\", unarchiving is \"Currently Unarchiving\", limited is \"Temporarily Available\", missing is \"Missing\"
   * @type {string}
   * @memberof Video
   */
  state?: VideoStateEnum
  /**
   * For limited state, when state expires.
   * @type {string}
   * @memberof Video
   */
  state_expiry?: string | null
  /**
   * Filesize in bytes.
   * @type {number}
   * @memberof Video
   */
  size: number
  /**
   * Length of video in number of seconds
   * @type {number}
   * @memberof Video
   */
  length?: number | null
  /**
   *
   * @type {number}
   * @memberof Video
   */
  total_frames?: number | null
  /**
   *
   * @type {number}
   * @memberof Video
   */
  stabilization_job?: number | null
  /**
   * Datetime the video is of at the start.
   * @type {string}
   * @memberof Video
   */
  start_time: string
  /**
   * Path in bucket  Example: monitoring/archive/path/to/file
   * @type {string}
   * @memberof Video
   */
  path: string
}

/**
 * @export
 * @enum {string}
 */
export enum VideoVideoTypeEnum {
  _1x = '1x',
  _20x = '20x',
  _200x = '200x',
  _4xStab = '4x-stab',
  _20xStab = '20x-stab',
  _200xStab = '200x-stab',
  Daily = 'daily',
}
/**
 * @export
 * @enum {string}
 */
export enum VideoServiceEnum {
  S3 = 'S3',
  B2 = 'B2',
}
/**
 * @export
 * @enum {string}
 */
export enum VideoStateEnum {
  Available = 'available',
  Locked = 'locked',
  Pending = 'pending',
  Archived = 'archived',
  Unarchiving = 'unarchiving',
  Limited = 'limited',
  Missing = 'missing',
}

/**
 *
 * @export
 * @interface VideoRestoreRequestSerialzer
 */
export interface VideoRestoreRequestSerialzer {
  /**
   *
   * @type {number}
   * @memberof VideoRestoreRequestSerialzer
   */
  project_id: number
}
/**
 *
 * @export
 * @interface VideoScreenshotRequestSerialzer
 */
export interface VideoScreenshotRequestSerialzer {
  /**
   *
   * @type {string}
   * @memberof VideoScreenshotRequestSerialzer
   */
  timestamp: string
}
/**
 *
 * @export
 * @interface VideoStabilizationJob
 */
export interface VideoStabilizationJob {
  /**
   *
   * @type {number}
   * @memberof VideoStabilizationJob
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof VideoStabilizationJob
   */
  stream?: number
  /**
   *
   * @type {number}
   * @memberof VideoStabilizationJob
   */
  project: number
  /**
   * Start time of range to process.
   * @type {string}
   * @memberof VideoStabilizationJob
   */
  start_time: string
  /**
   * End time of range to process.
   * @type {string}
   * @memberof VideoStabilizationJob
   */
  end_time: string
  /**
   *
   * @type {string}
   * @memberof VideoStabilizationJob
   */
  state?: VideoStabilizationJobStateEnum
  /**
   *
   * @type {string}
   * @memberof VideoStabilizationJob
   */
  req_datetime?: string
}

/**
 * @export
 * @enum {string}
 */
export enum VideoStabilizationJobStateEnum {
  Initial = 'initial',
  Processing = 'processing',
  Failed = 'failed',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface VideoSummary
 */
export interface VideoSummary {
  /**
   *
   * @type {number}
   * @memberof VideoSummary
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof VideoSummary
   */
  local_start_time?: string
  /**
   * Full URL of file.  Example: https://aeromana.s3-us-west-2.amazonaws.com/monitoring/archive/400Broadway1.stream_2019-12-21-04.30.00.253-UTC.mp4
   * @type {string}
   * @memberof VideoSummary
   */
  url: string
  /**
   * 1x is \"Hourly Videos at 1x\", 20x is \"Hourly Videos at 20x\", 200x is \"Hourly Videos at 200x\", 4x-stab is \"Stabilized Hourly Videos at 4x\", 20x-stab is \"Stabilized Hourly Videos at 20x\", 200x-stab is \"Stabilized Hourly Videos at 200x\", daily is \"Daily Timelapse\"
   * @type {string}
   * @memberof VideoSummary
   */
  video_type: VideoSummaryVideoTypeEnum
  /**
   * S3 is \"Amazon S3\", B2 is \"Backblaze B2\"
   * @type {string}
   * @memberof VideoSummary
   */
  service: VideoSummaryServiceEnum
  /**
   * available is \"Available\", locked is \"Locked From Archiving\", pending is \"Pending Archival\", archived is \"Archived\", unarchiving is \"Currently Unarchiving\", limited is \"Temporarily Available\", missing is \"Missing\"
   * @type {string}
   * @memberof VideoSummary
   */
  state?: VideoSummaryStateEnum
  /**
   * For limited state, when state expires.
   * @type {string}
   * @memberof VideoSummary
   */
  state_expiry?: string | null
  /**
   * Filesize in bytes.
   * @type {number}
   * @memberof VideoSummary
   */
  size: number
  /**
   * Length of video in number of seconds
   * @type {number}
   * @memberof VideoSummary
   */
  length?: number | null
  /**
   *
   * @type {number}
   * @memberof VideoSummary
   */
  total_frames?: number | null
  /**
   *
   * @type {number}
   * @memberof VideoSummary
   */
  stabilization_job: number
}

/**
 * @export
 * @enum {string}
 */
export enum VideoSummaryVideoTypeEnum {
  _1x = '1x',
  _20x = '20x',
  _200x = '200x',
  _4xStab = '4x-stab',
  _20xStab = '20x-stab',
  _200xStab = '200x-stab',
  Daily = 'daily',
}
/**
 * @export
 * @enum {string}
 */
export enum VideoSummaryServiceEnum {
  S3 = 'S3',
  B2 = 'B2',
}
/**
 * @export
 * @enum {string}
 */
export enum VideoSummaryStateEnum {
  Available = 'available',
  Locked = 'locked',
  Pending = 'pending',
  Archived = 'archived',
  Unarchiving = 'unarchiving',
  Limited = 'limited',
  Missing = 'missing',
}

/**
 *
 * @export
 * @interface VideoUrlList
 */
export interface VideoUrlList {
  /**
   *
   * @type {Array<string>}
   * @memberof VideoUrlList
   */
  urls: Array<string>
}
/**
 *
 * @export
 * @interface VideoUrlListDeleteResponse
 */
export interface VideoUrlListDeleteResponse {
  /**
   *
   * @type {number}
   * @memberof VideoUrlListDeleteResponse
   */
  num_deleted: number
  /**
   *
   * @type {Array<string>}
   * @memberof VideoUrlListDeleteResponse
   */
  not_found: Array<string>
}

/**
 * AIApi - axios parameter creator
 * @export
 */
export const AIApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for showing what classes are available.
     * @summary Return AI Class Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveaiClassesList: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/liveai/classes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for showing average number of boxes.
     * @summary Return Historical Average Box Counts
     * @param {string} streamId
     * @param {string} startDatetime
     * @param {string} endDatetime
     * @param {1 | 5 | 60} intervalMins Size of bucket, in number of minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsHistoricalaiAverageboxesList: async (
      streamId: string,
      startDatetime: string,
      endDatetime: string,
      intervalMins: 1 | 5 | 60,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsHistoricalaiAverageboxesList.'
        )
      }
      // verify required parameter 'startDatetime' is not null or undefined
      if (startDatetime === null || startDatetime === undefined) {
        throw new RequiredError(
          'startDatetime',
          'Required parameter startDatetime was null or undefined when calling streamsHistoricalaiAverageboxesList.'
        )
      }
      // verify required parameter 'endDatetime' is not null or undefined
      if (endDatetime === null || endDatetime === undefined) {
        throw new RequiredError(
          'endDatetime',
          'Required parameter endDatetime was null or undefined when calling streamsHistoricalaiAverageboxesList.'
        )
      }
      // verify required parameter 'intervalMins' is not null or undefined
      if (intervalMins === null || intervalMins === undefined) {
        throw new RequiredError(
          'intervalMins',
          'Required parameter intervalMins was null or undefined when calling streamsHistoricalaiAverageboxesList.'
        )
      }
      const localVarPath = `/streams/{stream_id}/historicalai/averageboxes/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startDatetime !== undefined) {
        localVarQueryParameter['start_datetime'] =
          (startDatetime as any) instanceof Date
            ? (startDatetime as any).toISOString()
            : startDatetime
      }

      if (endDatetime !== undefined) {
        localVarQueryParameter['end_datetime'] =
          (endDatetime as any) instanceof Date
            ? (endDatetime as any).toISOString()
            : endDatetime
      }

      if (intervalMins !== undefined) {
        localVarQueryParameter['interval_mins'] = intervalMins
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get latest AI stats about a stream.
     * @summary Fetch Latest Live AI Data
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsLiveaiLatest: async (
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsLiveaiLatest.'
        )
      }
      const localVarPath = `/streams/{stream_id}/liveai/latest/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List Latest AI Data Entries for a stream
     * @summary List Lastest AI Data Entries for Stream
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsLiveaiList: async (
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsLiveaiList.'
        )
      }
      const localVarPath = `/streams/{stream_id}/liveai/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AIApi - functional programming interface
 * @export
 */
export const AIApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for showing what classes are available.
     * @summary Return AI Class Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveaiClassesList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ClassLabel>>
    > {
      const localVarAxiosArgs = await AIApiAxiosParamCreator(
        configuration
      ).liveaiClassesList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for showing average number of boxes.
     * @summary Return Historical Average Box Counts
     * @param {string} streamId
     * @param {string} startDatetime
     * @param {string} endDatetime
     * @param {1 | 5 | 60} intervalMins Size of bucket, in number of minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsHistoricalaiAverageboxesList(
      streamId: string,
      startDatetime: string,
      endDatetime: string,
      intervalMins: 1 | 5 | 60,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<DateMetrics>>
    > {
      const localVarAxiosArgs = await AIApiAxiosParamCreator(
        configuration
      ).streamsHistoricalaiAverageboxesList(
        streamId,
        startDatetime,
        endDatetime,
        intervalMins,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get latest AI stats about a stream.
     * @summary Fetch Latest Live AI Data
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsLiveaiLatest(
      streamId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveAiData>
    > {
      const localVarAxiosArgs = await AIApiAxiosParamCreator(
        configuration
      ).streamsLiveaiLatest(streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List Latest AI Data Entries for a stream
     * @summary List Lastest AI Data Entries for Stream
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsLiveaiList(
      streamId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<LiveAiData>>
    > {
      const localVarAxiosArgs = await AIApiAxiosParamCreator(
        configuration
      ).streamsLiveaiList(streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AIApi - factory interface
 * @export
 */
export const AIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for showing what classes are available.
     * @summary Return AI Class Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveaiClassesList(options?: any): AxiosPromise<Array<ClassLabel>> {
      return AIApiFp(configuration)
        .liveaiClassesList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for showing average number of boxes.
     * @summary Return Historical Average Box Counts
     * @param {string} streamId
     * @param {string} startDatetime
     * @param {string} endDatetime
     * @param {1 | 5 | 60} intervalMins Size of bucket, in number of minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsHistoricalaiAverageboxesList(
      streamId: string,
      startDatetime: string,
      endDatetime: string,
      intervalMins: 1 | 5 | 60,
      options?: any
    ): AxiosPromise<Array<DateMetrics>> {
      return AIApiFp(configuration)
        .streamsHistoricalaiAverageboxesList(
          streamId,
          startDatetime,
          endDatetime,
          intervalMins,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get latest AI stats about a stream.
     * @summary Fetch Latest Live AI Data
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsLiveaiLatest(
      streamId: string,
      options?: any
    ): AxiosPromise<LiveAiData> {
      return AIApiFp(configuration)
        .streamsLiveaiLatest(streamId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List Latest AI Data Entries for a stream
     * @summary List Lastest AI Data Entries for Stream
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsLiveaiList(
      streamId: string,
      options?: any
    ): AxiosPromise<Array<LiveAiData>> {
      return AIApiFp(configuration)
        .streamsLiveaiList(streamId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for streamsHistoricalaiAverageboxesList operation in AIApi.
 * @export
 * @interface AIApiStreamsHistoricalaiAverageboxesListRequest
 */
export interface AIApiStreamsHistoricalaiAverageboxesListRequest {
  /**
   *
   * @type {string}
   * @memberof AIApiStreamsHistoricalaiAverageboxesList
   */
  readonly streamId: string

  /**
   *
   * @type {string}
   * @memberof AIApiStreamsHistoricalaiAverageboxesList
   */
  readonly startDatetime: string

  /**
   *
   * @type {string}
   * @memberof AIApiStreamsHistoricalaiAverageboxesList
   */
  readonly endDatetime: string

  /**
   * Size of bucket, in number of minutes
   * @type {1 | 5 | 60}
   * @memberof AIApiStreamsHistoricalaiAverageboxesList
   */
  readonly intervalMins: 1 | 5 | 60
}

/**
 * Request parameters for streamsLiveaiLatest operation in AIApi.
 * @export
 * @interface AIApiStreamsLiveaiLatestRequest
 */
export interface AIApiStreamsLiveaiLatestRequest {
  /**
   *
   * @type {string}
   * @memberof AIApiStreamsLiveaiLatest
   */
  readonly streamId: string
}

/**
 * Request parameters for streamsLiveaiList operation in AIApi.
 * @export
 * @interface AIApiStreamsLiveaiListRequest
 */
export interface AIApiStreamsLiveaiListRequest {
  /**
   *
   * @type {string}
   * @memberof AIApiStreamsLiveaiList
   */
  readonly streamId: string
}

/**
 * AIApi - object-oriented interface
 * @export
 * @class AIApi
 * @extends {BaseAPI}
 */
export class AIApi extends BaseAPI {
  /**
   * Viewset for showing what classes are available.
   * @summary Return AI Class Labels
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AIApi
   */
  public liveaiClassesList(options?: any) {
    return AIApiFp(this.configuration)
      .liveaiClassesList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for showing average number of boxes.
   * @summary Return Historical Average Box Counts
   * @param {AIApiStreamsHistoricalaiAverageboxesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AIApi
   */
  public streamsHistoricalaiAverageboxesList(
    requestParameters: AIApiStreamsHistoricalaiAverageboxesListRequest,
    options?: any
  ) {
    return AIApiFp(this.configuration)
      .streamsHistoricalaiAverageboxesList(
        requestParameters.streamId,
        requestParameters.startDatetime,
        requestParameters.endDatetime,
        requestParameters.intervalMins,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get latest AI stats about a stream.
   * @summary Fetch Latest Live AI Data
   * @param {AIApiStreamsLiveaiLatestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AIApi
   */
  public streamsLiveaiLatest(
    requestParameters: AIApiStreamsLiveaiLatestRequest,
    options?: any
  ) {
    return AIApiFp(this.configuration)
      .streamsLiveaiLatest(requestParameters.streamId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List Latest AI Data Entries for a stream
   * @summary List Lastest AI Data Entries for Stream
   * @param {AIApiStreamsLiveaiListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AIApi
   */
  public streamsLiveaiList(
    requestParameters: AIApiStreamsLiveaiListRequest,
    options?: any
  ) {
    return AIApiFp(this.configuration)
      .streamsLiveaiList(requestParameters.streamId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AlertsApi - axios parameter creator
 * @export
 */
export const AlertsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * A webhook for alerts from Airvantage.
     * @summary Webhook for Airvantage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsAirvantageCreate: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/alerts/airvantage/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * A webhook for alerts from ISocket.
     * @summary Webhook for ISocket
     * @param {ISocketWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsIsocketCreate: async (
      data: ISocketWebhook,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling alertsIsocketCreate.'
        )
      }
      const localVarPath = `/alerts/isocket/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * A webhook for programmable SMS from Twilio.
     * @summary Webhook for Twilio
     * @param {string} token
     * @param {TwilioWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsTwilioWebhookCreate: async (
      token: string,
      data: TwilioWebhook,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      if (token === null || token === undefined) {
        throw new RequiredError(
          'token',
          'Required parameter token was null or undefined when calling alertsTwilioWebhookCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling alertsTwilioWebhookCreate.'
        )
      }
      const localVarPath = `/alerts/{token}/twilio-webhook/`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AlertsApi - functional programming interface
 * @export
 */
export const AlertsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * A webhook for alerts from Airvantage.
     * @summary Webhook for Airvantage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alertsAirvantageCreate(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await AlertsApiAxiosParamCreator(
        configuration
      ).alertsAirvantageCreate(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * A webhook for alerts from ISocket.
     * @summary Webhook for ISocket
     * @param {ISocketWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alertsIsocketCreate(
      data: ISocketWebhook,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PowerSensorMessage>
    > {
      const localVarAxiosArgs = await AlertsApiAxiosParamCreator(
        configuration
      ).alertsIsocketCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * A webhook for programmable SMS from Twilio.
     * @summary Webhook for Twilio
     * @param {string} token
     * @param {TwilioWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alertsTwilioWebhookCreate(
      token: string,
      data: TwilioWebhook,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PowerSensorMessage>
    > {
      const localVarAxiosArgs = await AlertsApiAxiosParamCreator(
        configuration
      ).alertsTwilioWebhookCreate(token, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AlertsApi - factory interface
 * @export
 */
export const AlertsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * A webhook for alerts from Airvantage.
     * @summary Webhook for Airvantage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsAirvantageCreate(options?: any): AxiosPromise<void> {
      return AlertsApiFp(configuration)
        .alertsAirvantageCreate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * A webhook for alerts from ISocket.
     * @summary Webhook for ISocket
     * @param {ISocketWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsIsocketCreate(
      data: ISocketWebhook,
      options?: any
    ): AxiosPromise<PowerSensorMessage> {
      return AlertsApiFp(configuration)
        .alertsIsocketCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * A webhook for programmable SMS from Twilio.
     * @summary Webhook for Twilio
     * @param {string} token
     * @param {TwilioWebhook} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alertsTwilioWebhookCreate(
      token: string,
      data: TwilioWebhook,
      options?: any
    ): AxiosPromise<PowerSensorMessage> {
      return AlertsApiFp(configuration)
        .alertsTwilioWebhookCreate(token, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for alertsIsocketCreate operation in AlertsApi.
 * @export
 * @interface AlertsApiAlertsIsocketCreateRequest
 */
export interface AlertsApiAlertsIsocketCreateRequest {
  /**
   *
   * @type {ISocketWebhook}
   * @memberof AlertsApiAlertsIsocketCreate
   */
  readonly data: ISocketWebhook
}

/**
 * Request parameters for alertsTwilioWebhookCreate operation in AlertsApi.
 * @export
 * @interface AlertsApiAlertsTwilioWebhookCreateRequest
 */
export interface AlertsApiAlertsTwilioWebhookCreateRequest {
  /**
   *
   * @type {string}
   * @memberof AlertsApiAlertsTwilioWebhookCreate
   */
  readonly token: string

  /**
   *
   * @type {TwilioWebhook}
   * @memberof AlertsApiAlertsTwilioWebhookCreate
   */
  readonly data: TwilioWebhook
}

/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
export class AlertsApi extends BaseAPI {
  /**
   * A webhook for alerts from Airvantage.
   * @summary Webhook for Airvantage
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertsApi
   */
  public alertsAirvantageCreate(options?: any) {
    return AlertsApiFp(this.configuration)
      .alertsAirvantageCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * A webhook for alerts from ISocket.
   * @summary Webhook for ISocket
   * @param {AlertsApiAlertsIsocketCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertsApi
   */
  public alertsIsocketCreate(
    requestParameters: AlertsApiAlertsIsocketCreateRequest,
    options?: any
  ) {
    return AlertsApiFp(this.configuration)
      .alertsIsocketCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * A webhook for programmable SMS from Twilio.
   * @summary Webhook for Twilio
   * @param {AlertsApiAlertsTwilioWebhookCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertsApi
   */
  public alertsTwilioWebhookCreate(
    requestParameters: AlertsApiAlertsTwilioWebhookCreateRequest,
    options?: any
  ) {
    return AlertsApiFp(this.configuration)
      .alertsTwilioWebhookCreate(
        requestParameters.token,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CamEventsApi - axios parameter creator
 * @export
 */
export const CamEventsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Add a Cam Event with images. This does some processing depending on what the payload is.
     * @summary Add a Cam Event
     * @param {CamEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cameventsCreate: async (
      data: CamEvent,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cameventsCreate.'
        )
      }
      const localVarPath = `/camevents/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CamEventsApi - functional programming interface
 * @export
 */
export const CamEventsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Add a Cam Event with images. This does some processing depending on what the payload is.
     * @summary Add a Cam Event
     * @param {CamEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cameventsCreate(
      data: CamEvent,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CamEvent>
    > {
      const localVarAxiosArgs = await CamEventsApiAxiosParamCreator(
        configuration
      ).cameventsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * CamEventsApi - factory interface
 * @export
 */
export const CamEventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Add a Cam Event with images. This does some processing depending on what the payload is.
     * @summary Add a Cam Event
     * @param {CamEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cameventsCreate(data: CamEvent, options?: any): AxiosPromise<CamEvent> {
      return CamEventsApiFp(configuration)
        .cameventsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for cameventsCreate operation in CamEventsApi.
 * @export
 * @interface CamEventsApiCameventsCreateRequest
 */
export interface CamEventsApiCameventsCreateRequest {
  /**
   *
   * @type {CamEvent}
   * @memberof CamEventsApiCameventsCreate
   */
  readonly data: CamEvent
}

/**
 * CamEventsApi - object-oriented interface
 * @export
 * @class CamEventsApi
 * @extends {BaseAPI}
 */
export class CamEventsApi extends BaseAPI {
  /**
   * Add a Cam Event with images. This does some processing depending on what the payload is.
   * @summary Add a Cam Event
   * @param {CamEventsApiCameventsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CamEventsApi
   */
  public cameventsCreate(
    requestParameters: CamEventsApiCameventsCreateRequest,
    options?: any
  ) {
    return CamEventsApiFp(this.configuration)
      .cameventsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CamlistenApi - axios parameter creator
 * @export
 */
export const CamlistenApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Hikvision camera data POST handler
     * @param {string} streamName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    camlistenCreate: async (
      streamName: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamName' is not null or undefined
      if (streamName === null || streamName === undefined) {
        throw new RequiredError(
          'streamName',
          'Required parameter streamName was null or undefined when calling camlistenCreate.'
        )
      }
      const localVarPath = `/camlisten/{stream_name}/`.replace(
        `{${'stream_name'}}`,
        encodeURIComponent(String(streamName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CamlistenApi - functional programming interface
 * @export
 */
export const CamlistenApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Hikvision camera data POST handler
     * @param {string} streamName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async camlistenCreate(
      streamName: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await CamlistenApiAxiosParamCreator(
        configuration
      ).camlistenCreate(streamName, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * CamlistenApi - factory interface
 * @export
 */
export const CamlistenApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Hikvision camera data POST handler
     * @param {string} streamName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    camlistenCreate(streamName: string, options?: any): AxiosPromise<void> {
      return CamlistenApiFp(configuration)
        .camlistenCreate(streamName, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for camlistenCreate operation in CamlistenApi.
 * @export
 * @interface CamlistenApiCamlistenCreateRequest
 */
export interface CamlistenApiCamlistenCreateRequest {
  /**
   *
   * @type {string}
   * @memberof CamlistenApiCamlistenCreate
   */
  readonly streamName: string
}

/**
 * CamlistenApi - object-oriented interface
 * @export
 * @class CamlistenApi
 * @extends {BaseAPI}
 */
export class CamlistenApi extends BaseAPI {
  /**
   * Hikvision camera data POST handler
   * @param {CamlistenApiCamlistenCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CamlistenApi
   */
  public camlistenCreate(
    requestParameters: CamlistenApiCamlistenCreateRequest,
    options?: any
  ) {
    return CamlistenApiFp(this.configuration)
      .camlistenCreate(requestParameters.streamName, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ClipsApi - axios parameter creator
 * @export
 */
export const ClipsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Lists a project\'s clips.
     * @summary List a Project\'s Clips
     * @param {string} projectId
     * @param {string} [analysis]
     * @param {string} [grouping]
     * @param {string} [startTime] Video ends after this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Video starts before this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsClipsList: async (
      projectId: string,
      analysis?: string,
      grouping?: string,
      startTime?: string,
      endTime?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsClipsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/clips/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (analysis !== undefined) {
        localVarQueryParameter['analysis'] = analysis
      }

      if (grouping !== undefined) {
        localVarQueryParameter['grouping'] = grouping
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve One Clip from Project.
     * @summary Retrieve a Project\'s Clip
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsClipsRead: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsClipsRead.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsClipsRead.'
        )
      }
      const localVarPath = `/projects/{project_id}/clips/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ClipsApi - functional programming interface
 * @export
 */
export const ClipsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Lists a project\'s clips.
     * @summary List a Project\'s Clips
     * @param {string} projectId
     * @param {string} [analysis]
     * @param {string} [grouping]
     * @param {string} [startTime] Video ends after this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Video starts before this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsClipsList(
      projectId: string,
      analysis?: string,
      grouping?: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Clip>>
    > {
      const localVarAxiosArgs = await ClipsApiAxiosParamCreator(
        configuration
      ).projectsClipsList(
        projectId,
        analysis,
        grouping,
        startTime,
        endTime,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Retrieve One Clip from Project.
     * @summary Retrieve a Project\'s Clip
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsClipsRead(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Clip>
    > {
      const localVarAxiosArgs = await ClipsApiAxiosParamCreator(
        configuration
      ).projectsClipsRead(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ClipsApi - factory interface
 * @export
 */
export const ClipsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Lists a project\'s clips.
     * @summary List a Project\'s Clips
     * @param {string} projectId
     * @param {string} [analysis]
     * @param {string} [grouping]
     * @param {string} [startTime] Video ends after this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Video starts before this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsClipsList(
      projectId: string,
      analysis?: string,
      grouping?: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): AxiosPromise<Array<Clip>> {
      return ClipsApiFp(configuration)
        .projectsClipsList(
          projectId,
          analysis,
          grouping,
          startTime,
          endTime,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve One Clip from Project.
     * @summary Retrieve a Project\'s Clip
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsClipsRead(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<Clip> {
      return ClipsApiFp(configuration)
        .projectsClipsRead(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsClipsList operation in ClipsApi.
 * @export
 * @interface ClipsApiProjectsClipsListRequest
 */
export interface ClipsApiProjectsClipsListRequest {
  /**
   *
   * @type {string}
   * @memberof ClipsApiProjectsClipsList
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ClipsApiProjectsClipsList
   */
  readonly analysis?: string

  /**
   *
   * @type {string}
   * @memberof ClipsApiProjectsClipsList
   */
  readonly grouping?: string

  /**
   * Video ends after this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ClipsApiProjectsClipsList
   */
  readonly startTime?: string

  /**
   * Video starts before this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ClipsApiProjectsClipsList
   */
  readonly endTime?: string
}

/**
 * Request parameters for projectsClipsRead operation in ClipsApi.
 * @export
 * @interface ClipsApiProjectsClipsReadRequest
 */
export interface ClipsApiProjectsClipsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ClipsApiProjectsClipsRead
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof ClipsApiProjectsClipsRead
   */
  readonly projectId: string
}

/**
 * ClipsApi - object-oriented interface
 * @export
 * @class ClipsApi
 * @extends {BaseAPI}
 */
export class ClipsApi extends BaseAPI {
  /**
   * Lists a project\'s clips.
   * @summary List a Project\'s Clips
   * @param {ClipsApiProjectsClipsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClipsApi
   */
  public projectsClipsList(
    requestParameters: ClipsApiProjectsClipsListRequest,
    options?: any
  ) {
    return ClipsApiFp(this.configuration)
      .projectsClipsList(
        requestParameters.projectId,
        requestParameters.analysis,
        requestParameters.grouping,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve One Clip from Project.
   * @summary Retrieve a Project\'s Clip
   * @param {ClipsApiProjectsClipsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClipsApi
   */
  public projectsClipsRead(
    requestParameters: ClipsApiProjectsClipsReadRequest,
    options?: any
  ) {
    return ClipsApiFp(this.configuration)
      .projectsClipsRead(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CraneApi - axios parameter creator
 * @export
 */
export const CraneApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for listing crane event states
     * @summary List Crane Event States
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    craneEventStatesList: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/crane_event_states/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Add Calendar Entry
     * @param {string} craneId
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarCreate: async (
      craneId: string,
      data: CraneCalendarEntry,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesCalendarCreate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Delete Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarDelete: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesCalendarDelete.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists a crane\'s calendar. Ordered by start_time.
     * @summary List Crane Calendar
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarList: async (
      craneId: string,
      startTime?: string,
      endTime?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarList.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarPartialUpdate: async (
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarPartialUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesCalendarPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesCalendarPartialUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Detail Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarRead: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarRead.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesCalendarRead.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarUpdate: async (
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesCalendarUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesCalendarUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesCalendarUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/calendar/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for days
     * @summary Add Day
     * @param {string} craneId
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysCreate: async (
      craneId: string,
      data: CraneDay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesDaysCreate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for days
     * @summary Delete Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysDelete: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesDaysDelete.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists days.
     * @summary List Day
     * @param {string} craneId
     * @param {string} [complete]
     * @param {string} [startDate] Greater than or equal to this day.
     * @param {string} [endDate] Less than this day.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysList: async (
      craneId: string,
      complete?: string,
      startDate?: string,
      endDate?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysList.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (complete !== undefined) {
        localVarQueryParameter['complete'] = complete
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start_date'] = startDate
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end_date'] = endDate
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysPartialUpdate: async (
      craneId: string,
      id: string,
      data: CraneDay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysPartialUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesDaysPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesDaysPartialUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for days
     * @summary Detail Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysRead: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysRead.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesDaysRead.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysUpdate: async (
      craneId: string,
      id: string,
      data: CraneDay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesDaysUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesDaysUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesDaysUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/days/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Add Event
     * @param {string} craneId
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsCreate: async (
      craneId: string,
      data: CraneEvent,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesEventsCreate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for scoped crane events
     * @summary Delete Event
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsDelete: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesEventsDelete.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists a crane\'s events. Ordered by start_time.
     * @summary List Crane Events
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsList: async (
      craneId: string,
      startTime?: string,
      endTime?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsList.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsPartialUpdate: async (
      craneId: string,
      id: string,
      data: CraneEvent,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsPartialUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesEventsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesEventsPartialUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for scoped crane events
     * @summary Event Details
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsRead: async (
      craneId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsRead.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesEventsRead.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsUpdate: async (
      craneId: string,
      id: string,
      data: CraneEvent,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesEventsUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling cranesEventsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling cranesEventsUpdate.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/events/{id}/`
        .replace(`{${'crane_id'}}`, encodeURIComponent(String(craneId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * CSV export of pick data.  This returns a csv file attachment. It will be text/csv not application/json.
     * @summary CSV Export of Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesPicksExport: async (
      craneId: string,
      startTime: string,
      endTime: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesPicksExport.'
        )
      }
      // verify required parameter 'startTime' is not null or undefined
      if (startTime === null || startTime === undefined) {
        throw new RequiredError(
          'startTime',
          'Required parameter startTime was null or undefined when calling cranesPicksExport.'
        )
      }
      // verify required parameter 'endTime' is not null or undefined
      if (endTime === null || endTime === undefined) {
        throw new RequiredError(
          'endTime',
          'Required parameter endTime was null or undefined when calling cranesPicksExport.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/picks/export/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List a calendar\'s picks, ordered by time.
     * @summary List Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesPicksList: async (
      craneId: string,
      startTime: string,
      endTime: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'craneId' is not null or undefined
      if (craneId === null || craneId === undefined) {
        throw new RequiredError(
          'craneId',
          'Required parameter craneId was null or undefined when calling cranesPicksList.'
        )
      }
      // verify required parameter 'startTime' is not null or undefined
      if (startTime === null || startTime === undefined) {
        throw new RequiredError(
          'startTime',
          'Required parameter startTime was null or undefined when calling cranesPicksList.'
        )
      }
      // verify required parameter 'endTime' is not null or undefined
      if (endTime === null || endTime === undefined) {
        throw new RequiredError(
          'endTime',
          'Required parameter endTime was null or undefined when calling cranesPicksList.'
        )
      }
      const localVarPath = `/cranes/{crane_id}/picks/`.replace(
        `{${'crane_id'}}`,
        encodeURIComponent(String(craneId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for showing crane project config
     * @summary Retrieve Crane Project Config
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCraneProjectConfigsList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsCraneProjectConfigsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/crane_project_configs/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CraneApi - functional programming interface
 * @export
 */
export const CraneApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for listing crane event states
     * @summary List Crane Event States
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async craneEventStatesList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CraneEventState>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).craneEventStatesList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Add Calendar Entry
     * @param {string} craneId
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarCreate(
      craneId: string,
      data: CraneCalendarEntry,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CraneCalendarEntry>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarCreate(craneId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Delete Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarDelete(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarDelete(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists a crane\'s calendar. Ordered by start_time.
     * @summary List Crane Calendar
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarList(
      craneId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CraneCalendarEntry>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarList(craneId, startTime, endTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarPartialUpdate(
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CraneCalendarEntry>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarPartialUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Detail Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarRead(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CraneCalendarEntry>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarRead(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesCalendarUpdate(
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CraneCalendarEntry>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesCalendarUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for days
     * @summary Add Day
     * @param {string} craneId
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysCreate(
      craneId: string,
      data: CraneDay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneDay>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysCreate(craneId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for days
     * @summary Delete Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysDelete(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysDelete(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists days.
     * @summary List Day
     * @param {string} craneId
     * @param {string} [complete]
     * @param {string} [startDate] Greater than or equal to this day.
     * @param {string} [endDate] Less than this day.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysList(
      craneId: string,
      complete?: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CraneDay>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysList(craneId, complete, startDate, endDate, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysPartialUpdate(
      craneId: string,
      id: string,
      data: CraneDay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneDay>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysPartialUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for days
     * @summary Detail Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysRead(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneDay>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysRead(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesDaysUpdate(
      craneId: string,
      id: string,
      data: CraneDay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneDay>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesDaysUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Add Event
     * @param {string} craneId
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsCreate(
      craneId: string,
      data: CraneEvent,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneEvent>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsCreate(craneId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for scoped crane events
     * @summary Delete Event
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsDelete(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsDelete(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists a crane\'s events. Ordered by start_time.
     * @summary List Crane Events
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsList(
      craneId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CraneEvent>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsList(craneId, startTime, endTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsPartialUpdate(
      craneId: string,
      id: string,
      data: CraneEvent,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneEvent>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsPartialUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for scoped crane events
     * @summary Event Details
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsRead(
      craneId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneEvent>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsRead(craneId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesEventsUpdate(
      craneId: string,
      id: string,
      data: CraneEvent,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CraneEvent>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesEventsUpdate(craneId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * CSV export of pick data.  This returns a csv file attachment. It will be text/csv not application/json.
     * @summary CSV Export of Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesPicksExport(
      craneId: string,
      startTime: string,
      endTime: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesPicksExport(craneId, startTime, endTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List a calendar\'s picks, ordered by time.
     * @summary List Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cranesPicksList(
      craneId: string,
      startTime: string,
      endTime: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CranePick>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).cranesPicksList(craneId, startTime, endTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for showing crane project config
     * @summary Retrieve Crane Project Config
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsCraneProjectConfigsList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ProjectConfig>>
    > {
      const localVarAxiosArgs = await CraneApiAxiosParamCreator(
        configuration
      ).projectsCraneProjectConfigsList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * CraneApi - factory interface
 * @export
 */
export const CraneApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for listing crane event states
     * @summary List Crane Event States
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    craneEventStatesList(options?: any): AxiosPromise<Array<CraneEventState>> {
      return CraneApiFp(configuration)
        .craneEventStatesList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for calendar entries.
     * @summary Add Calendar Entry
     * @param {string} craneId
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarCreate(
      craneId: string,
      data: CraneCalendarEntry,
      options?: any
    ): AxiosPromise<CraneCalendarEntry> {
      return CraneApiFp(configuration)
        .cranesCalendarCreate(craneId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for calendar entries.
     * @summary Delete Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarDelete(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return CraneApiFp(configuration)
        .cranesCalendarDelete(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists a crane\'s calendar. Ordered by start_time.
     * @summary List Crane Calendar
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarList(
      craneId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): AxiosPromise<Array<CraneCalendarEntry>> {
      return CraneApiFp(configuration)
        .cranesCalendarList(craneId, startTime, endTime, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarPartialUpdate(
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options?: any
    ): AxiosPromise<CraneCalendarEntry> {
      return CraneApiFp(configuration)
        .cranesCalendarPartialUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for calendar entries.
     * @summary Detail Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarRead(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<CraneCalendarEntry> {
      return CraneApiFp(configuration)
        .cranesCalendarRead(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for calendar entries.
     * @summary Update Calendar Entry
     * @param {string} craneId
     * @param {string} id
     * @param {CraneCalendarEntry} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesCalendarUpdate(
      craneId: string,
      id: string,
      data: CraneCalendarEntry,
      options?: any
    ): AxiosPromise<CraneCalendarEntry> {
      return CraneApiFp(configuration)
        .cranesCalendarUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for days
     * @summary Add Day
     * @param {string} craneId
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysCreate(
      craneId: string,
      data: CraneDay,
      options?: any
    ): AxiosPromise<CraneDay> {
      return CraneApiFp(configuration)
        .cranesDaysCreate(craneId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for days
     * @summary Delete Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysDelete(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return CraneApiFp(configuration)
        .cranesDaysDelete(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists days.
     * @summary List Day
     * @param {string} craneId
     * @param {string} [complete]
     * @param {string} [startDate] Greater than or equal to this day.
     * @param {string} [endDate] Less than this day.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysList(
      craneId: string,
      complete?: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<Array<CraneDay>> {
      return CraneApiFp(configuration)
        .cranesDaysList(craneId, complete, startDate, endDate, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysPartialUpdate(
      craneId: string,
      id: string,
      data: CraneDay,
      options?: any
    ): AxiosPromise<CraneDay> {
      return CraneApiFp(configuration)
        .cranesDaysPartialUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for days
     * @summary Detail Day
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysRead(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<CraneDay> {
      return CraneApiFp(configuration)
        .cranesDaysRead(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewsets for days
     * @summary Update Day
     * @param {string} craneId
     * @param {string} id
     * @param {CraneDay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesDaysUpdate(
      craneId: string,
      id: string,
      data: CraneDay,
      options?: any
    ): AxiosPromise<CraneDay> {
      return CraneApiFp(configuration)
        .cranesDaysUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Add Event
     * @param {string} craneId
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsCreate(
      craneId: string,
      data: CraneEvent,
      options?: any
    ): AxiosPromise<CraneEvent> {
      return CraneApiFp(configuration)
        .cranesEventsCreate(craneId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for scoped crane events
     * @summary Delete Event
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsDelete(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return CraneApiFp(configuration)
        .cranesEventsDelete(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists a crane\'s events. Ordered by start_time.
     * @summary List Crane Events
     * @param {string} craneId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsList(
      craneId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): AxiosPromise<Array<CraneEvent>> {
      return CraneApiFp(configuration)
        .cranesEventsList(craneId, startTime, endTime, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsPartialUpdate(
      craneId: string,
      id: string,
      data: CraneEvent,
      options?: any
    ): AxiosPromise<CraneEvent> {
      return CraneApiFp(configuration)
        .cranesEventsPartialUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for scoped crane events
     * @summary Event Details
     * @param {string} craneId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsRead(
      craneId: string,
      id: string,
      options?: any
    ): AxiosPromise<CraneEvent> {
      return CraneApiFp(configuration)
        .cranesEventsRead(craneId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Populates a user automatically.  Do not pass along one.
     * @summary Update Event
     * @param {string} craneId
     * @param {string} id
     * @param {CraneEvent} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesEventsUpdate(
      craneId: string,
      id: string,
      data: CraneEvent,
      options?: any
    ): AxiosPromise<CraneEvent> {
      return CraneApiFp(configuration)
        .cranesEventsUpdate(craneId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * CSV export of pick data.  This returns a csv file attachment. It will be text/csv not application/json.
     * @summary CSV Export of Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesPicksExport(
      craneId: string,
      startTime: string,
      endTime: string,
      options?: any
    ): AxiosPromise<void> {
      return CraneApiFp(configuration)
        .cranesPicksExport(craneId, startTime, endTime, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List a calendar\'s picks, ordered by time.
     * @summary List Picks
     * @param {string} craneId
     * @param {string} startTime Greater than or equal to this time.
     * @param {string} endTime Less than this time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cranesPicksList(
      craneId: string,
      startTime: string,
      endTime: string,
      options?: any
    ): AxiosPromise<Array<CranePick>> {
      return CraneApiFp(configuration)
        .cranesPicksList(craneId, startTime, endTime, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for showing crane project config
     * @summary Retrieve Crane Project Config
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCraneProjectConfigsList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<ProjectConfig>> {
      return CraneApiFp(configuration)
        .projectsCraneProjectConfigsList(projectId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for cranesCalendarCreate operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarCreateRequest
 */
export interface CraneApiCranesCalendarCreateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarCreate
   */
  readonly craneId: string

  /**
   *
   * @type {CraneCalendarEntry}
   * @memberof CraneApiCranesCalendarCreate
   */
  readonly data: CraneCalendarEntry
}

/**
 * Request parameters for cranesCalendarDelete operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarDeleteRequest
 */
export interface CraneApiCranesCalendarDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarDelete
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarDelete
   */
  readonly id: string
}

/**
 * Request parameters for cranesCalendarList operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarListRequest
 */
export interface CraneApiCranesCalendarListRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarList
   */
  readonly craneId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof CraneApiCranesCalendarList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof CraneApiCranesCalendarList
   */
  readonly endTime?: string
}

/**
 * Request parameters for cranesCalendarPartialUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarPartialUpdateRequest
 */
export interface CraneApiCranesCalendarPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarPartialUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneCalendarEntry}
   * @memberof CraneApiCranesCalendarPartialUpdate
   */
  readonly data: CraneCalendarEntry
}

/**
 * Request parameters for cranesCalendarRead operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarReadRequest
 */
export interface CraneApiCranesCalendarReadRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarRead
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarRead
   */
  readonly id: string
}

/**
 * Request parameters for cranesCalendarUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesCalendarUpdateRequest
 */
export interface CraneApiCranesCalendarUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesCalendarUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneCalendarEntry}
   * @memberof CraneApiCranesCalendarUpdate
   */
  readonly data: CraneCalendarEntry
}

/**
 * Request parameters for cranesDaysCreate operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysCreateRequest
 */
export interface CraneApiCranesDaysCreateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysCreate
   */
  readonly craneId: string

  /**
   *
   * @type {CraneDay}
   * @memberof CraneApiCranesDaysCreate
   */
  readonly data: CraneDay
}

/**
 * Request parameters for cranesDaysDelete operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysDeleteRequest
 */
export interface CraneApiCranesDaysDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysDelete
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysDelete
   */
  readonly id: string
}

/**
 * Request parameters for cranesDaysList operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysListRequest
 */
export interface CraneApiCranesDaysListRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysList
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysList
   */
  readonly complete?: string

  /**
   * Greater than or equal to this day.
   * @type {string}
   * @memberof CraneApiCranesDaysList
   */
  readonly startDate?: string

  /**
   * Less than this day.
   * @type {string}
   * @memberof CraneApiCranesDaysList
   */
  readonly endDate?: string
}

/**
 * Request parameters for cranesDaysPartialUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysPartialUpdateRequest
 */
export interface CraneApiCranesDaysPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysPartialUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneDay}
   * @memberof CraneApiCranesDaysPartialUpdate
   */
  readonly data: CraneDay
}

/**
 * Request parameters for cranesDaysRead operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysReadRequest
 */
export interface CraneApiCranesDaysReadRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysRead
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysRead
   */
  readonly id: string
}

/**
 * Request parameters for cranesDaysUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesDaysUpdateRequest
 */
export interface CraneApiCranesDaysUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesDaysUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneDay}
   * @memberof CraneApiCranesDaysUpdate
   */
  readonly data: CraneDay
}

/**
 * Request parameters for cranesEventsCreate operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsCreateRequest
 */
export interface CraneApiCranesEventsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsCreate
   */
  readonly craneId: string

  /**
   *
   * @type {CraneEvent}
   * @memberof CraneApiCranesEventsCreate
   */
  readonly data: CraneEvent
}

/**
 * Request parameters for cranesEventsDelete operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsDeleteRequest
 */
export interface CraneApiCranesEventsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsDelete
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsDelete
   */
  readonly id: string
}

/**
 * Request parameters for cranesEventsList operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsListRequest
 */
export interface CraneApiCranesEventsListRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsList
   */
  readonly craneId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof CraneApiCranesEventsList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof CraneApiCranesEventsList
   */
  readonly endTime?: string
}

/**
 * Request parameters for cranesEventsPartialUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsPartialUpdateRequest
 */
export interface CraneApiCranesEventsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsPartialUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneEvent}
   * @memberof CraneApiCranesEventsPartialUpdate
   */
  readonly data: CraneEvent
}

/**
 * Request parameters for cranesEventsRead operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsReadRequest
 */
export interface CraneApiCranesEventsReadRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsRead
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsRead
   */
  readonly id: string
}

/**
 * Request parameters for cranesEventsUpdate operation in CraneApi.
 * @export
 * @interface CraneApiCranesEventsUpdateRequest
 */
export interface CraneApiCranesEventsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsUpdate
   */
  readonly craneId: string

  /**
   *
   * @type {string}
   * @memberof CraneApiCranesEventsUpdate
   */
  readonly id: string

  /**
   *
   * @type {CraneEvent}
   * @memberof CraneApiCranesEventsUpdate
   */
  readonly data: CraneEvent
}

/**
 * Request parameters for cranesPicksExport operation in CraneApi.
 * @export
 * @interface CraneApiCranesPicksExportRequest
 */
export interface CraneApiCranesPicksExportRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesPicksExport
   */
  readonly craneId: string

  /**
   * Greater than or equal to this time.
   * @type {string}
   * @memberof CraneApiCranesPicksExport
   */
  readonly startTime: string

  /**
   * Less than this time.
   * @type {string}
   * @memberof CraneApiCranesPicksExport
   */
  readonly endTime: string
}

/**
 * Request parameters for cranesPicksList operation in CraneApi.
 * @export
 * @interface CraneApiCranesPicksListRequest
 */
export interface CraneApiCranesPicksListRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiCranesPicksList
   */
  readonly craneId: string

  /**
   * Greater than or equal to this time.
   * @type {string}
   * @memberof CraneApiCranesPicksList
   */
  readonly startTime: string

  /**
   * Less than this time.
   * @type {string}
   * @memberof CraneApiCranesPicksList
   */
  readonly endTime: string
}

/**
 * Request parameters for projectsCraneProjectConfigsList operation in CraneApi.
 * @export
 * @interface CraneApiProjectsCraneProjectConfigsListRequest
 */
export interface CraneApiProjectsCraneProjectConfigsListRequest {
  /**
   *
   * @type {string}
   * @memberof CraneApiProjectsCraneProjectConfigsList
   */
  readonly projectId: string
}

/**
 * CraneApi - object-oriented interface
 * @export
 * @class CraneApi
 * @extends {BaseAPI}
 */
export class CraneApi extends BaseAPI {
  /**
   * Viewset for listing crane event states
   * @summary List Crane Event States
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public craneEventStatesList(options?: any) {
    return CraneApiFp(this.configuration)
      .craneEventStatesList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for calendar entries.
   * @summary Add Calendar Entry
   * @param {CraneApiCranesCalendarCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarCreate(
    requestParameters: CraneApiCranesCalendarCreateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarCreate(
        requestParameters.craneId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for calendar entries.
   * @summary Delete Calendar Entry
   * @param {CraneApiCranesCalendarDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarDelete(
    requestParameters: CraneApiCranesCalendarDeleteRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarDelete(
        requestParameters.craneId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists a crane\'s calendar. Ordered by start_time.
   * @summary List Crane Calendar
   * @param {CraneApiCranesCalendarListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarList(
    requestParameters: CraneApiCranesCalendarListRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarList(
        requestParameters.craneId,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for calendar entries.
   * @summary Update Calendar Entry
   * @param {CraneApiCranesCalendarPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarPartialUpdate(
    requestParameters: CraneApiCranesCalendarPartialUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarPartialUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for calendar entries.
   * @summary Detail Calendar Entry
   * @param {CraneApiCranesCalendarReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarRead(
    requestParameters: CraneApiCranesCalendarReadRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarRead(
        requestParameters.craneId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for calendar entries.
   * @summary Update Calendar Entry
   * @param {CraneApiCranesCalendarUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesCalendarUpdate(
    requestParameters: CraneApiCranesCalendarUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesCalendarUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for days
   * @summary Add Day
   * @param {CraneApiCranesDaysCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysCreate(
    requestParameters: CraneApiCranesDaysCreateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysCreate(
        requestParameters.craneId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for days
   * @summary Delete Day
   * @param {CraneApiCranesDaysDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysDelete(
    requestParameters: CraneApiCranesDaysDeleteRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysDelete(
        requestParameters.craneId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists days.
   * @summary List Day
   * @param {CraneApiCranesDaysListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysList(
    requestParameters: CraneApiCranesDaysListRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysList(
        requestParameters.craneId,
        requestParameters.complete,
        requestParameters.startDate,
        requestParameters.endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for days
   * @summary Update Day
   * @param {CraneApiCranesDaysPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysPartialUpdate(
    requestParameters: CraneApiCranesDaysPartialUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysPartialUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for days
   * @summary Detail Day
   * @param {CraneApiCranesDaysReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysRead(
    requestParameters: CraneApiCranesDaysReadRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysRead(requestParameters.craneId, requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewsets for days
   * @summary Update Day
   * @param {CraneApiCranesDaysUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesDaysUpdate(
    requestParameters: CraneApiCranesDaysUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesDaysUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Populates a user automatically.  Do not pass along one.
   * @summary Add Event
   * @param {CraneApiCranesEventsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsCreate(
    requestParameters: CraneApiCranesEventsCreateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsCreate(
        requestParameters.craneId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for scoped crane events
   * @summary Delete Event
   * @param {CraneApiCranesEventsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsDelete(
    requestParameters: CraneApiCranesEventsDeleteRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsDelete(
        requestParameters.craneId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists a crane\'s events. Ordered by start_time.
   * @summary List Crane Events
   * @param {CraneApiCranesEventsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsList(
    requestParameters: CraneApiCranesEventsListRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsList(
        requestParameters.craneId,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Populates a user automatically.  Do not pass along one.
   * @summary Update Event
   * @param {CraneApiCranesEventsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsPartialUpdate(
    requestParameters: CraneApiCranesEventsPartialUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsPartialUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for scoped crane events
   * @summary Event Details
   * @param {CraneApiCranesEventsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsRead(
    requestParameters: CraneApiCranesEventsReadRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsRead(
        requestParameters.craneId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Populates a user automatically.  Do not pass along one.
   * @summary Update Event
   * @param {CraneApiCranesEventsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesEventsUpdate(
    requestParameters: CraneApiCranesEventsUpdateRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesEventsUpdate(
        requestParameters.craneId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * CSV export of pick data.  This returns a csv file attachment. It will be text/csv not application/json.
   * @summary CSV Export of Picks
   * @param {CraneApiCranesPicksExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesPicksExport(
    requestParameters: CraneApiCranesPicksExportRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesPicksExport(
        requestParameters.craneId,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List a calendar\'s picks, ordered by time.
   * @summary List Picks
   * @param {CraneApiCranesPicksListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public cranesPicksList(
    requestParameters: CraneApiCranesPicksListRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .cranesPicksList(
        requestParameters.craneId,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for showing crane project config
   * @summary Retrieve Crane Project Config
   * @param {CraneApiProjectsCraneProjectConfigsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CraneApi
   */
  public projectsCraneProjectConfigsList(
    requestParameters: CraneApiProjectsCraneProjectConfigsListRequest,
    options?: any
  ) {
    return CraneApiFp(this.configuration)
      .projectsCraneProjectConfigsList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FramesApi - axios parameter creator
 * @export
 */
export const FramesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Adds one frame to a stream.  There is one side effect: 1. It may update the current frame in Stream.
     * @summary Add a Frame To A Stream
     * @param {string} streamId
     * @param {Frame} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesCreate: async (
      streamId: string,
      data: Frame,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsFramesCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsFramesCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/frames/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes a Frame From the Database (not from file storage)
     * @summary Delete Record of a Frame
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesDelete: async (
      id: string,
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsFramesDelete.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsFramesDelete.'
        )
      }
      const localVarPath = `/streams/{stream_id}/frames/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists a stream\'s frames. (Ordered by image_datetime.)
     * @summary List a Stream\'s Frames
     * @param {string} streamId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [localTime] Should be of HH:MM[:SS] format (00:00:00 to 23:59:00)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesList: async (
      streamId: string,
      startTime?: string,
      endTime?: string,
      localTime?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsFramesList.'
        )
      }
      const localVarPath = `/streams/{stream_id}/frames/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (localTime !== undefined) {
        localVarQueryParameter['local_time'] = localTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * FramesApi - functional programming interface
 * @export
 */
export const FramesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Adds one frame to a stream.  There is one side effect: 1. It may update the current frame in Stream.
     * @summary Add a Frame To A Stream
     * @param {string} streamId
     * @param {Frame} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsFramesCreate(
      streamId: string,
      data: Frame,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Frame>
    > {
      const localVarAxiosArgs = await FramesApiAxiosParamCreator(
        configuration
      ).streamsFramesCreate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes a Frame From the Database (not from file storage)
     * @summary Delete Record of a Frame
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsFramesDelete(
      id: string,
      streamId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await FramesApiAxiosParamCreator(
        configuration
      ).streamsFramesDelete(id, streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists a stream\'s frames. (Ordered by image_datetime.)
     * @summary List a Stream\'s Frames
     * @param {string} streamId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [localTime] Should be of HH:MM[:SS] format (00:00:00 to 23:59:00)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsFramesList(
      streamId: string,
      startTime?: string,
      endTime?: string,
      localTime?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Frame>>
    > {
      const localVarAxiosArgs = await FramesApiAxiosParamCreator(
        configuration
      ).streamsFramesList(streamId, startTime, endTime, localTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * FramesApi - factory interface
 * @export
 */
export const FramesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Adds one frame to a stream.  There is one side effect: 1. It may update the current frame in Stream.
     * @summary Add a Frame To A Stream
     * @param {string} streamId
     * @param {Frame} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesCreate(
      streamId: string,
      data: Frame,
      options?: any
    ): AxiosPromise<Frame> {
      return FramesApiFp(configuration)
        .streamsFramesCreate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes a Frame From the Database (not from file storage)
     * @summary Delete Record of a Frame
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesDelete(
      id: string,
      streamId: string,
      options?: any
    ): AxiosPromise<void> {
      return FramesApiFp(configuration)
        .streamsFramesDelete(id, streamId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists a stream\'s frames. (Ordered by image_datetime.)
     * @summary List a Stream\'s Frames
     * @param {string} streamId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [localTime] Should be of HH:MM[:SS] format (00:00:00 to 23:59:00)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsFramesList(
      streamId: string,
      startTime?: string,
      endTime?: string,
      localTime?: string,
      options?: any
    ): AxiosPromise<Array<Frame>> {
      return FramesApiFp(configuration)
        .streamsFramesList(streamId, startTime, endTime, localTime, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for streamsFramesCreate operation in FramesApi.
 * @export
 * @interface FramesApiStreamsFramesCreateRequest
 */
export interface FramesApiStreamsFramesCreateRequest {
  /**
   *
   * @type {string}
   * @memberof FramesApiStreamsFramesCreate
   */
  readonly streamId: string

  /**
   *
   * @type {Frame}
   * @memberof FramesApiStreamsFramesCreate
   */
  readonly data: Frame
}

/**
 * Request parameters for streamsFramesDelete operation in FramesApi.
 * @export
 * @interface FramesApiStreamsFramesDeleteRequest
 */
export interface FramesApiStreamsFramesDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof FramesApiStreamsFramesDelete
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof FramesApiStreamsFramesDelete
   */
  readonly streamId: string
}

/**
 * Request parameters for streamsFramesList operation in FramesApi.
 * @export
 * @interface FramesApiStreamsFramesListRequest
 */
export interface FramesApiStreamsFramesListRequest {
  /**
   *
   * @type {string}
   * @memberof FramesApiStreamsFramesList
   */
  readonly streamId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof FramesApiStreamsFramesList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof FramesApiStreamsFramesList
   */
  readonly endTime?: string

  /**
   * Should be of HH:MM[:SS] format (00:00:00 to 23:59:00)
   * @type {string}
   * @memberof FramesApiStreamsFramesList
   */
  readonly localTime?: string
}

/**
 * FramesApi - object-oriented interface
 * @export
 * @class FramesApi
 * @extends {BaseAPI}
 */
export class FramesApi extends BaseAPI {
  /**
   * Adds one frame to a stream.  There is one side effect: 1. It may update the current frame in Stream.
   * @summary Add a Frame To A Stream
   * @param {FramesApiStreamsFramesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FramesApi
   */
  public streamsFramesCreate(
    requestParameters: FramesApiStreamsFramesCreateRequest,
    options?: any
  ) {
    return FramesApiFp(this.configuration)
      .streamsFramesCreate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes a Frame From the Database (not from file storage)
   * @summary Delete Record of a Frame
   * @param {FramesApiStreamsFramesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FramesApi
   */
  public streamsFramesDelete(
    requestParameters: FramesApiStreamsFramesDeleteRequest,
    options?: any
  ) {
    return FramesApiFp(this.configuration)
      .streamsFramesDelete(
        requestParameters.id,
        requestParameters.streamId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists a stream\'s frames. (Ordered by image_datetime.)
   * @summary List a Stream\'s Frames
   * @param {FramesApiStreamsFramesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FramesApi
   */
  public streamsFramesList(
    requestParameters: FramesApiStreamsFramesListRequest,
    options?: any
  ) {
    return FramesApiFp(this.configuration)
      .streamsFramesList(
        requestParameters.streamId,
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.localTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * HomographyApi - axios parameter creator
 * @export
 */
export const HomographyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for managing homography
     * @summary Add Homography
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyCreate: async (
      data: Homography,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling homographyCreate.'
        )
      }
      const localVarPath = `/homography/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for managing homography
     * @summary Delete Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyDelete: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling homographyDelete.'
        )
      }
      const localVarPath = `/homography/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for managing homography
     * @summary List Homography
     * @param {number} [stabilizationJobId]
     * @param {number} [videoId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyList: async (
      stabilizationJobId?: number,
      videoId?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/homography/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (stabilizationJobId !== undefined) {
        localVarQueryParameter['stabilization_job_id'] = stabilizationJobId
      }

      if (videoId !== undefined) {
        localVarQueryParameter['video_id'] = videoId
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyPartialUpdate: async (
      id: string,
      data: Homography,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling homographyPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling homographyPartialUpdate.'
        )
      }
      const localVarPath = `/homography/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for managing homography
     * @summary Retrieve Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling homographyRead.'
        )
      }
      const localVarPath = `/homography/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyUpdate: async (
      id: string,
      data: Homography,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling homographyUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling homographyUpdate.'
        )
      }
      const localVarPath = `/homography/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HomographyApi - functional programming interface
 * @export
 */
export const HomographyApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for managing homography
     * @summary Add Homography
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyCreate(
      data: Homography,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Homography>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for managing homography
     * @summary Delete Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyDelete(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyDelete(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for managing homography
     * @summary List Homography
     * @param {number} [stabilizationJobId]
     * @param {number} [videoId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyList(
      stabilizationJobId?: number,
      videoId?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Homography>>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyList(stabilizationJobId, videoId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyPartialUpdate(
      id: string,
      data: Homography,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Homography>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for managing homography
     * @summary Retrieve Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Homography>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async homographyUpdate(
      id: string,
      data: Homography,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Homography>
    > {
      const localVarAxiosArgs = await HomographyApiAxiosParamCreator(
        configuration
      ).homographyUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * HomographyApi - factory interface
 * @export
 */
export const HomographyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for managing homography
     * @summary Add Homography
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyCreate(
      data: Homography,
      options?: any
    ): AxiosPromise<Homography> {
      return HomographyApiFp(configuration)
        .homographyCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for managing homography
     * @summary Delete Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyDelete(id: string, options?: any): AxiosPromise<void> {
      return HomographyApiFp(configuration)
        .homographyDelete(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for managing homography
     * @summary List Homography
     * @param {number} [stabilizationJobId]
     * @param {number} [videoId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyList(
      stabilizationJobId?: number,
      videoId?: number,
      options?: any
    ): AxiosPromise<Array<Homography>> {
      return HomographyApiFp(configuration)
        .homographyList(stabilizationJobId, videoId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyPartialUpdate(
      id: string,
      data: Homography,
      options?: any
    ): AxiosPromise<Homography> {
      return HomographyApiFp(configuration)
        .homographyPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for managing homography
     * @summary Retrieve Homography
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyRead(id: string, options?: any): AxiosPromise<Homography> {
      return HomographyApiFp(configuration)
        .homographyRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for managing homography
     * @summary Update Homography
     * @param {string} id
     * @param {Homography} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    homographyUpdate(
      id: string,
      data: Homography,
      options?: any
    ): AxiosPromise<Homography> {
      return HomographyApiFp(configuration)
        .homographyUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for homographyCreate operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyCreateRequest
 */
export interface HomographyApiHomographyCreateRequest {
  /**
   *
   * @type {Homography}
   * @memberof HomographyApiHomographyCreate
   */
  readonly data: Homography
}

/**
 * Request parameters for homographyDelete operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyDeleteRequest
 */
export interface HomographyApiHomographyDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof HomographyApiHomographyDelete
   */
  readonly id: string
}

/**
 * Request parameters for homographyList operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyListRequest
 */
export interface HomographyApiHomographyListRequest {
  /**
   *
   * @type {number}
   * @memberof HomographyApiHomographyList
   */
  readonly stabilizationJobId?: number

  /**
   *
   * @type {number}
   * @memberof HomographyApiHomographyList
   */
  readonly videoId?: number
}

/**
 * Request parameters for homographyPartialUpdate operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyPartialUpdateRequest
 */
export interface HomographyApiHomographyPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof HomographyApiHomographyPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {Homography}
   * @memberof HomographyApiHomographyPartialUpdate
   */
  readonly data: Homography
}

/**
 * Request parameters for homographyRead operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyReadRequest
 */
export interface HomographyApiHomographyReadRequest {
  /**
   *
   * @type {string}
   * @memberof HomographyApiHomographyRead
   */
  readonly id: string
}

/**
 * Request parameters for homographyUpdate operation in HomographyApi.
 * @export
 * @interface HomographyApiHomographyUpdateRequest
 */
export interface HomographyApiHomographyUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof HomographyApiHomographyUpdate
   */
  readonly id: string

  /**
   *
   * @type {Homography}
   * @memberof HomographyApiHomographyUpdate
   */
  readonly data: Homography
}

/**
 * HomographyApi - object-oriented interface
 * @export
 * @class HomographyApi
 * @extends {BaseAPI}
 */
export class HomographyApi extends BaseAPI {
  /**
   * Viewset for managing homography
   * @summary Add Homography
   * @param {HomographyApiHomographyCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyCreate(
    requestParameters: HomographyApiHomographyCreateRequest,
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for managing homography
   * @summary Delete Homography
   * @param {HomographyApiHomographyDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyDelete(
    requestParameters: HomographyApiHomographyDeleteRequest,
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyDelete(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for managing homography
   * @summary List Homography
   * @param {HomographyApiHomographyListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyList(
    requestParameters: HomographyApiHomographyListRequest = {},
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyList(
        requestParameters.stabilizationJobId,
        requestParameters.videoId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for managing homography
   * @summary Update Homography
   * @param {HomographyApiHomographyPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyPartialUpdate(
    requestParameters: HomographyApiHomographyPartialUpdateRequest,
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for managing homography
   * @summary Retrieve Homography
   * @param {HomographyApiHomographyReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyRead(
    requestParameters: HomographyApiHomographyReadRequest,
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for managing homography
   * @summary Update Homography
   * @param {HomographyApiHomographyUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HomographyApi
   */
  public homographyUpdate(
    requestParameters: HomographyApiHomographyUpdateRequest,
    options?: any
  ) {
    return HomographyApiFp(this.configuration)
      .homographyUpdate(requestParameters.id, requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ImageAnnotationsApi - axios parameter creator
 * @export
 */
export const ImageAnnotationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Lists annotations for reporting purposes.
     * @summary List Completed Annotations
     * @param {number} [minScore]
     * @param {number} [maxScore]
     * @param {string} [userIds] Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [annotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [annotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [payEligible]
     * @param {string} [initialReviewStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [initialReviewEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [reviewed]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date, score, -score]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationAnnotationsList: async (
      minScore?: number,
      maxScore?: number,
      userIds?: string,
      streamIds?: string,
      categoryIds?: string,
      annotationStarttime?: string,
      annotationEndtime?: string,
      payEligible?: string,
      initialReviewStarttime?: string,
      initialReviewEndtime?: string,
      reviewed?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/annotations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (minScore !== undefined) {
        localVarQueryParameter['min_score'] = minScore
      }

      if (maxScore !== undefined) {
        localVarQueryParameter['max_score'] = maxScore
      }

      if (userIds !== undefined) {
        localVarQueryParameter['user_ids'] = userIds
      }

      if (streamIds !== undefined) {
        localVarQueryParameter['stream_ids'] = streamIds
      }

      if (categoryIds !== undefined) {
        localVarQueryParameter['category_ids'] = categoryIds
      }

      if (annotationStarttime !== undefined) {
        localVarQueryParameter['annotation_starttime'] = annotationStarttime
      }

      if (annotationEndtime !== undefined) {
        localVarQueryParameter['annotation_endtime'] = annotationEndtime
      }

      if (payEligible !== undefined) {
        localVarQueryParameter['pay_eligible'] = payEligible
      }

      if (initialReviewStarttime !== undefined) {
        localVarQueryParameter[
          'initial_review_starttime'
        ] = initialReviewStarttime
      }

      if (initialReviewEndtime !== undefined) {
        localVarQueryParameter['initial_review_endtime'] = initialReviewEndtime
      }

      if (reviewed !== undefined) {
        localVarQueryParameter['reviewed'] = reviewed
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get annotation details for a report.
     * @summary Retrieve Completed Annotations
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationAnnotationsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationAnnotationsRead.'
        )
      }
      const localVarPath = `/imageannotation/annotations/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists images that can be submitted for annotation.
     * @summary List Images Available for Submission
     * @param {string} categoryIds Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name]. Default is image_datetime.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationCandidatesList: async (
      categoryIds: string,
      streamIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryIds' is not null or undefined
      if (categoryIds === null || categoryIds === undefined) {
        throw new RequiredError(
          'categoryIds',
          'Required parameter categoryIds was null or undefined when calling imageannotationCandidatesList.'
        )
      }
      const localVarPath = `/imageannotation/candidates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (categoryIds !== undefined) {
        localVarQueryParameter['category_ids'] = categoryIds
      }

      if (streamIds !== undefined) {
        localVarQueryParameter['stream_ids'] = streamIds
      }

      if (imageStarttime !== undefined) {
        localVarQueryParameter['image_starttime'] = imageStarttime
      }

      if (imageEndtime !== undefined) {
        localVarQueryParameter['image_endtime'] = imageEndtime
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists image categories.  Only active categories.
     * @summary List Image Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationCategoriesList: async (
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/categories/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Requests the export of submissions in text format.  This will be available in the future in S3 under the bucket and key listed.
     * @summary Request Export Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationExportRequestSubmissions: async (
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/export/request_submissions/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (streamIds !== undefined) {
        localVarQueryParameter['stream_ids'] = streamIds
      }

      if (categoryIds !== undefined) {
        localVarQueryParameter['category_ids'] = categoryIds
      }

      if (imageStarttime !== undefined) {
        localVarQueryParameter['image_starttime'] = imageStarttime
      }

      if (imageEndtime !== undefined) {
        localVarQueryParameter['image_endtime'] = imageEndtime
      }

      if (latestAnnotationStarttime !== undefined) {
        localVarQueryParameter[
          'latest_annotation_starttime'
        ] = latestAnnotationStarttime
      }

      if (latestAnnotationEndtime !== undefined) {
        localVarQueryParameter[
          'latest_annotation_endtime'
        ] = latestAnnotationEndtime
      }

      if (latestAnnotationUserIds !== undefined) {
        localVarQueryParameter[
          'latest_annotation_user_ids'
        ] = latestAnnotationUserIds
      }

      if (latestAnnotationTypes !== undefined) {
        localVarQueryParameter[
          'latest_annotation_types'
        ] = latestAnnotationTypes
      }

      if (version !== undefined) {
        localVarQueryParameter['version'] = version
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Add a comment about the flagged box. Also, one can resolve the issue with the box.
     * @summary Add Comment To/Resolve Image Issue
     * @param {string} id
     * @param {ImageAnnotationBoxAddComment} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesAddComment: async (
      id: string,
      data: ImageAnnotationBoxAddComment,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationFlaggedboxesAddComment.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationFlaggedboxesAddComment.'
        )
      }
      const localVarPath = `/imageannotation/flaggedboxes/{id}/add_comment/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List out image annotation boxes with issues.
     * @summary List Boxes with Issues
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [issueResolved]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesList: async (
      streamIds?: string,
      issueResolved?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/flaggedboxes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (streamIds !== undefined) {
        localVarQueryParameter['stream_ids'] = streamIds
      }

      if (issueResolved !== undefined) {
        localVarQueryParameter['issue_resolved'] = issueResolved
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get details about a box with an issue. Comments are in reverse chronological order.
     * @summary Retrieve a Boxes with an Issue
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationFlaggedboxesRead.'
        )
      }
      const localVarPath = `/imageannotation/flaggedboxes/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Displays status information about submissionsregarding a specific frame.
     * @summary Show Image Frame Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFramesRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationFramesRead.'
        )
      }
      const localVarPath = `/imageannotation/frames/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Set the mask_polygons attribute for a frame.
     * @summary Set Mask for Frame
     * @param {string} id
     * @param {FrameMaskOnly} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFramesSetMask: async (
      id: string,
      data: FrameMaskOnly,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationFramesSetMask.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationFramesSetMask.'
        )
      }
      const localVarPath = `/imageannotation/frames/{id}/set_mask/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Show labels.
     * @summary List All Currently Valid Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationLabelsList: async (
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/labels/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Complete a labeling session by submitting labels.
     * @summary Complete Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsComplete: async (
      id: string,
      data: ImageAnnotationSessionCompletion,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationSessionsComplete.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationSessionsComplete.'
        )
      }
      const localVarPath = `/imageannotation/sessions/{id}/complete/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Starts an image annotation session.
     * @summary Start Image Annotation Session
     * @param {ImageAnnotationSessionCreation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsCreate: async (
      data: ImageAnnotationSessionCreation,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationSessionsCreate.'
        )
      }
      const localVarPath = `/imageannotation/sessions/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Pause labeling session
     * @summary Pause Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsPause: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationSessionsPause.'
        )
      }
      const localVarPath = `/imageannotation/sessions/{id}/pause/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve image annotation session information.
     * @summary Get Image Annotation Session Information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationSessionsRead.'
        )
      }
      const localVarPath = `/imageannotation/sessions/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Resume labeling session
     * @summary Resume Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsResume: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationSessionsResume.'
        )
      }
      const localVarPath = `/imageannotation/sessions/{id}/resume/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Saves a labeling session.  Does not mark as complete.
     * @summary Save Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsSave: async (
      id: string,
      data: ImageAnnotationSessionCompletion,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageannotationSessionsSave.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationSessionsSave.'
        )
      }
      const localVarPath = `/imageannotation/sessions/{id}/save/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists image sublabels.  Only active sublabels.
     * @summary List Image Sublabels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSublabelsList: async (
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/sublabels/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists image submissions that will be labeled.
     * @summary List Image Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [unlabeled, ai_labeled, labeling, labeled]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSubmissionsList: async (
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      states?: string,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/submissions/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (streamIds !== undefined) {
        localVarQueryParameter['stream_ids'] = streamIds
      }

      if (categoryIds !== undefined) {
        localVarQueryParameter['category_ids'] = categoryIds
      }

      if (imageStarttime !== undefined) {
        localVarQueryParameter['image_starttime'] = imageStarttime
      }

      if (imageEndtime !== undefined) {
        localVarQueryParameter['image_endtime'] = imageEndtime
      }

      if (latestAnnotationStarttime !== undefined) {
        localVarQueryParameter[
          'latest_annotation_starttime'
        ] = latestAnnotationStarttime
      }

      if (latestAnnotationEndtime !== undefined) {
        localVarQueryParameter[
          'latest_annotation_endtime'
        ] = latestAnnotationEndtime
      }

      if (latestAnnotationUserIds !== undefined) {
        localVarQueryParameter[
          'latest_annotation_user_ids'
        ] = latestAnnotationUserIds
      }

      if (latestAnnotationTypes !== undefined) {
        localVarQueryParameter[
          'latest_annotation_types'
        ] = latestAnnotationTypes
      }

      if (version !== undefined) {
        localVarQueryParameter['version'] = version
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (states !== undefined) {
        localVarQueryParameter['states'] = states
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Submit image submissions by using a list of categories and a list of frames.
     * @summary Submit a Multiple of Image Submissions
     * @param {ImageSubmissionMassCreationRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSubmissionsMassSubmit: async (
      data: ImageSubmissionMassCreationRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageannotationSubmissionsMassSubmit.'
        )
      }
      const localVarPath = `/imageannotation/submissions/mass_submit/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * User reports, specifically in relation to metrics for payments.
     * @summary User Reporting
     * @param {string} starttime Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} endtime Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationUserreportsList: async (
      starttime: string,
      endtime: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'starttime' is not null or undefined
      if (starttime === null || starttime === undefined) {
        throw new RequiredError(
          'starttime',
          'Required parameter starttime was null or undefined when calling imageannotationUserreportsList.'
        )
      }
      // verify required parameter 'endtime' is not null or undefined
      if (endtime === null || endtime === undefined) {
        throw new RequiredError(
          'endtime',
          'Required parameter endtime was null or undefined when calling imageannotationUserreportsList.'
        )
      }
      const localVarPath = `/imageannotation/userreports/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (starttime !== undefined) {
        localVarQueryParameter['starttime'] = starttime
      }

      if (endtime !== undefined) {
        localVarQueryParameter['endtime'] = endtime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists users that can use the image annotation dashboard.
     * @summary List Users of Image Annotation Dashboard
     * @param {string} [ordering] Choices: [first_name, -first_name, last_name, -last_name, email, -email]. Default is first_name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationUsersList: async (
      ordering?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imageannotation/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ImageAnnotationsApi - functional programming interface
 * @export
 */
export const ImageAnnotationsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Lists annotations for reporting purposes.
     * @summary List Completed Annotations
     * @param {number} [minScore]
     * @param {number} [maxScore]
     * @param {string} [userIds] Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [annotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [annotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [payEligible]
     * @param {string} [initialReviewStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [initialReviewEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [reviewed]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date, score, -score]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationAnnotationsList(
      minScore?: number,
      maxScore?: number,
      userIds?: string,
      streamIds?: string,
      categoryIds?: string,
      annotationStarttime?: string,
      annotationEndtime?: string,
      payEligible?: string,
      initialReviewStarttime?: string,
      initialReviewEndtime?: string,
      reviewed?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse200>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationAnnotationsList(
        minScore,
        maxScore,
        userIds,
        streamIds,
        categoryIds,
        annotationStarttime,
        annotationEndtime,
        payEligible,
        initialReviewStarttime,
        initialReviewEndtime,
        reviewed,
        ordering,
        page,
        per,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get annotation details for a report.
     * @summary Retrieve Completed Annotations
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationAnnotationsRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageAnnotationReportDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationAnnotationsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists images that can be submitted for annotation.
     * @summary List Images Available for Submission
     * @param {string} categoryIds Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name]. Default is image_datetime.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationCandidatesList(
      categoryIds: string,
      streamIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2001>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationCandidatesList(
        categoryIds,
        streamIds,
        imageStarttime,
        imageEndtime,
        ordering,
        page,
        per,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists image categories.  Only active categories.
     * @summary List Image Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationCategoriesList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ImageCategoryDetails>>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationCategoriesList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Requests the export of submissions in text format.  This will be available in the future in S3 under the bucket and key listed.
     * @summary Request Export Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationExportRequestSubmissions(
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationExportRequestSubmissions(
        streamIds,
        categoryIds,
        imageStarttime,
        imageEndtime,
        latestAnnotationStarttime,
        latestAnnotationEndtime,
        latestAnnotationUserIds,
        latestAnnotationTypes,
        version,
        ordering,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Add a comment about the flagged box. Also, one can resolve the issue with the box.
     * @summary Add Comment To/Resolve Image Issue
     * @param {string} id
     * @param {ImageAnnotationBoxAddComment} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationFlaggedboxesAddComment(
      id: string,
      data: ImageAnnotationBoxAddComment,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageAnnotationBoxDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationFlaggedboxesAddComment(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List out image annotation boxes with issues.
     * @summary List Boxes with Issues
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [issueResolved]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationFlaggedboxesList(
      streamIds?: string,
      issueResolved?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2002>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationFlaggedboxesList(
        streamIds,
        issueResolved,
        ordering,
        page,
        per,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get details about a box with an issue. Comments are in reverse chronological order.
     * @summary Retrieve a Boxes with an Issue
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationFlaggedboxesRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageAnnotationBoxDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationFlaggedboxesRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Displays status information about submissionsregarding a specific frame.
     * @summary Show Image Frame Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationFramesRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageFrameDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationFramesRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Set the mask_polygons attribute for a frame.
     * @summary Set Mask for Frame
     * @param {string} id
     * @param {FrameMaskOnly} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationFramesSetMask(
      id: string,
      data: FrameMaskOnly,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageFrameDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationFramesSetMask(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Show labels.
     * @summary List All Currently Valid Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationLabelsList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ImageLabelInfo>>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationLabelsList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Complete a labeling session by submitting labels.
     * @summary Complete Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsComplete(
      id: string,
      data: ImageAnnotationSessionCompletion,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsComplete(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Starts an image annotation session.
     * @summary Start Image Annotation Session
     * @param {ImageAnnotationSessionCreation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsCreate(
      data: ImageAnnotationSessionCreation,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Pause labeling session
     * @summary Pause Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsPause(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsPause(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Retrieve image annotation session information.
     * @summary Get Image Annotation Session Information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Resume labeling session
     * @summary Resume Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsResume(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsResume(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Saves a labeling session.  Does not mark as complete.
     * @summary Save Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSessionsSave(
      id: string,
      data: ImageAnnotationSessionCompletion,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSessionDetails>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSessionsSave(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists image sublabels.  Only active sublabels.
     * @summary List Image Sublabels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSublabelsList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ImageSublabel>>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSublabelsList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists image submissions that will be labeled.
     * @summary List Image Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [unlabeled, ai_labeled, labeling, labeled]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSubmissionsList(
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      states?: string,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2003>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSubmissionsList(
        streamIds,
        categoryIds,
        imageStarttime,
        imageEndtime,
        latestAnnotationStarttime,
        latestAnnotationEndtime,
        latestAnnotationUserIds,
        latestAnnotationTypes,
        version,
        ordering,
        states,
        page,
        per,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Submit image submissions by using a list of categories and a list of frames.
     * @summary Submit a Multiple of Image Submissions
     * @param {ImageSubmissionMassCreationRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationSubmissionsMassSubmit(
      data: ImageSubmissionMassCreationRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSubmissionMassCreationResponse>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationSubmissionsMassSubmit(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * User reports, specifically in relation to metrics for payments.
     * @summary User Reporting
     * @param {string} starttime Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} endtime Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationUserreportsList(
      starttime: string,
      endtime: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ImageAnnotationUserReport>>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationUserreportsList(starttime, endtime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists users that can use the image annotation dashboard.
     * @summary List Users of Image Annotation Dashboard
     * @param {string} [ordering] Choices: [first_name, -first_name, last_name, -last_name, email, -email]. Default is first_name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageannotationUsersList(
      ordering?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<UserSummary>>
    > {
      const localVarAxiosArgs = await ImageAnnotationsApiAxiosParamCreator(
        configuration
      ).imageannotationUsersList(ordering, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ImageAnnotationsApi - factory interface
 * @export
 */
export const ImageAnnotationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Lists annotations for reporting purposes.
     * @summary List Completed Annotations
     * @param {number} [minScore]
     * @param {number} [maxScore]
     * @param {string} [userIds] Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [annotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [annotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [payEligible]
     * @param {string} [initialReviewStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [initialReviewEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [reviewed]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date, score, -score]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationAnnotationsList(
      minScore?: number,
      maxScore?: number,
      userIds?: string,
      streamIds?: string,
      categoryIds?: string,
      annotationStarttime?: string,
      annotationEndtime?: string,
      payEligible?: string,
      initialReviewStarttime?: string,
      initialReviewEndtime?: string,
      reviewed?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse200> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationAnnotationsList(
          minScore,
          maxScore,
          userIds,
          streamIds,
          categoryIds,
          annotationStarttime,
          annotationEndtime,
          payEligible,
          initialReviewStarttime,
          initialReviewEndtime,
          reviewed,
          ordering,
          page,
          per,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get annotation details for a report.
     * @summary Retrieve Completed Annotations
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationAnnotationsRead(
      id: string,
      options?: any
    ): AxiosPromise<ImageAnnotationReportDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationAnnotationsRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists images that can be submitted for annotation.
     * @summary List Images Available for Submission
     * @param {string} categoryIds Multiple values may be separated by commas.
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name]. Default is image_datetime.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationCandidatesList(
      categoryIds: string,
      streamIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse2001> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationCandidatesList(
          categoryIds,
          streamIds,
          imageStarttime,
          imageEndtime,
          ordering,
          page,
          per,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists image categories.  Only active categories.
     * @summary List Image Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationCategoriesList(
      options?: any
    ): AxiosPromise<Array<ImageCategoryDetails>> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationCategoriesList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Requests the export of submissions in text format.  This will be available in the future in S3 under the bucket and key listed.
     * @summary Request Export Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationExportRequestSubmissions(
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      options?: any
    ): AxiosPromise<void> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationExportRequestSubmissions(
          streamIds,
          categoryIds,
          imageStarttime,
          imageEndtime,
          latestAnnotationStarttime,
          latestAnnotationEndtime,
          latestAnnotationUserIds,
          latestAnnotationTypes,
          version,
          ordering,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Add a comment about the flagged box. Also, one can resolve the issue with the box.
     * @summary Add Comment To/Resolve Image Issue
     * @param {string} id
     * @param {ImageAnnotationBoxAddComment} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesAddComment(
      id: string,
      data: ImageAnnotationBoxAddComment,
      options?: any
    ): AxiosPromise<ImageAnnotationBoxDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationFlaggedboxesAddComment(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List out image annotation boxes with issues.
     * @summary List Boxes with Issues
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [issueResolved]
     * @param {string} [ordering] Choices: [annotation_date, -annotation_date]. Default is -annotation_date.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesList(
      streamIds?: string,
      issueResolved?: string,
      ordering?: string,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse2002> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationFlaggedboxesList(
          streamIds,
          issueResolved,
          ordering,
          page,
          per,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get details about a box with an issue. Comments are in reverse chronological order.
     * @summary Retrieve a Boxes with an Issue
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFlaggedboxesRead(
      id: string,
      options?: any
    ): AxiosPromise<ImageAnnotationBoxDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationFlaggedboxesRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Displays status information about submissionsregarding a specific frame.
     * @summary Show Image Frame Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFramesRead(
      id: string,
      options?: any
    ): AxiosPromise<ImageFrameDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationFramesRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Set the mask_polygons attribute for a frame.
     * @summary Set Mask for Frame
     * @param {string} id
     * @param {FrameMaskOnly} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationFramesSetMask(
      id: string,
      data: FrameMaskOnly,
      options?: any
    ): AxiosPromise<ImageFrameDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationFramesSetMask(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Show labels.
     * @summary List All Currently Valid Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationLabelsList(
      options?: any
    ): AxiosPromise<Array<ImageLabelInfo>> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationLabelsList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Complete a labeling session by submitting labels.
     * @summary Complete Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsComplete(
      id: string,
      data: ImageAnnotationSessionCompletion,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsComplete(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Starts an image annotation session.
     * @summary Start Image Annotation Session
     * @param {ImageAnnotationSessionCreation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsCreate(
      data: ImageAnnotationSessionCreation,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Pause labeling session
     * @summary Pause Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsPause(
      id: string,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsPause(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve image annotation session information.
     * @summary Get Image Annotation Session Information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsRead(
      id: string,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Resume labeling session
     * @summary Resume Image Annotation Session
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsResume(
      id: string,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsResume(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Saves a labeling session.  Does not mark as complete.
     * @summary Save Image Annotation Session
     * @param {string} id
     * @param {ImageAnnotationSessionCompletion} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSessionsSave(
      id: string,
      data: ImageAnnotationSessionCompletion,
      options?: any
    ): AxiosPromise<ImageSessionDetails> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSessionsSave(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists image sublabels.  Only active sublabels.
     * @summary List Image Sublabels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSublabelsList(
      options?: any
    ): AxiosPromise<Array<ImageSublabel>> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSublabelsList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists image submissions that will be labeled.
     * @summary List Image Submissions
     * @param {string} [streamIds] Multiple values may be separated by commas.
     * @param {string} [categoryIds] Multiple values may be separated by commas.
     * @param {string} [imageStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [imageEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationStarttime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationEndtime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [latestAnnotationUserIds] Based on the last person who annotated this.
     * @param {string} [latestAnnotationTypes] Multiple values may be separated by commas.  Choices: [ai, tag, review]
     * @param {string} [version] Choices: [current, behind]
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [unlabeled, ai_labeled, labeling, labeled]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSubmissionsList(
      streamIds?: string,
      categoryIds?: string,
      imageStarttime?: string,
      imageEndtime?: string,
      latestAnnotationStarttime?: string,
      latestAnnotationEndtime?: string,
      latestAnnotationUserIds?: string,
      latestAnnotationTypes?: string,
      version?: string,
      ordering?: string,
      states?: string,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse2003> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSubmissionsList(
          streamIds,
          categoryIds,
          imageStarttime,
          imageEndtime,
          latestAnnotationStarttime,
          latestAnnotationEndtime,
          latestAnnotationUserIds,
          latestAnnotationTypes,
          version,
          ordering,
          states,
          page,
          per,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Submit image submissions by using a list of categories and a list of frames.
     * @summary Submit a Multiple of Image Submissions
     * @param {ImageSubmissionMassCreationRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationSubmissionsMassSubmit(
      data: ImageSubmissionMassCreationRequest,
      options?: any
    ): AxiosPromise<ImageSubmissionMassCreationResponse> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationSubmissionsMassSubmit(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * User reports, specifically in relation to metrics for payments.
     * @summary User Reporting
     * @param {string} starttime Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} endtime Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationUserreportsList(
      starttime: string,
      endtime: string,
      options?: any
    ): AxiosPromise<Array<ImageAnnotationUserReport>> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationUserreportsList(starttime, endtime, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists users that can use the image annotation dashboard.
     * @summary List Users of Image Annotation Dashboard
     * @param {string} [ordering] Choices: [first_name, -first_name, last_name, -last_name, email, -email]. Default is first_name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageannotationUsersList(
      ordering?: string,
      options?: any
    ): AxiosPromise<Array<UserSummary>> {
      return ImageAnnotationsApiFp(configuration)
        .imageannotationUsersList(ordering, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for imageannotationAnnotationsList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationAnnotationsListRequest
 */
export interface ImageAnnotationsApiImageannotationAnnotationsListRequest {
  /**
   *
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly minScore?: number

  /**
   *
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly maxScore?: number

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly userIds?: string

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly streamIds?: string

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly categoryIds?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly annotationStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly annotationEndtime?: string

  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly payEligible?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly initialReviewStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly initialReviewEndtime?: string

  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly reviewed?: string

  /**
   * Choices: [annotation_date, -annotation_date, score, -score]. Default is -annotation_date.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly ordering?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsList
   */
  readonly per?: number
}

/**
 * Request parameters for imageannotationAnnotationsRead operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationAnnotationsReadRequest
 */
export interface ImageAnnotationsApiImageannotationAnnotationsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationAnnotationsRead
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationCandidatesList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationCandidatesListRequest
 */
export interface ImageAnnotationsApiImageannotationCandidatesListRequest {
  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly categoryIds: string

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly streamIds?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly imageStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly imageEndtime?: string

  /**
   * Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name]. Default is image_datetime.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly ordering?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationCandidatesList
   */
  readonly per?: number
}

/**
 * Request parameters for imageannotationExportRequestSubmissions operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationExportRequestSubmissionsRequest
 */
export interface ImageAnnotationsApiImageannotationExportRequestSubmissionsRequest {
  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly streamIds?: string

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly categoryIds?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly imageStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly imageEndtime?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly latestAnnotationStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly latestAnnotationEndtime?: string

  /**
   * Based on the last person who annotated this.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly latestAnnotationUserIds?: string

  /**
   * Multiple values may be separated by commas.  Choices: [ai, tag, review]
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly latestAnnotationTypes?: string

  /**
   * Choices: [current, behind]
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly version?: string

  /**
   * Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationExportRequestSubmissions
   */
  readonly ordering?: string
}

/**
 * Request parameters for imageannotationFlaggedboxesAddComment operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationFlaggedboxesAddCommentRequest
 */
export interface ImageAnnotationsApiImageannotationFlaggedboxesAddCommentRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesAddComment
   */
  readonly id: string

  /**
   *
   * @type {ImageAnnotationBoxAddComment}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesAddComment
   */
  readonly data: ImageAnnotationBoxAddComment
}

/**
 * Request parameters for imageannotationFlaggedboxesList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationFlaggedboxesListRequest
 */
export interface ImageAnnotationsApiImageannotationFlaggedboxesListRequest {
  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesList
   */
  readonly streamIds?: string

  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesList
   */
  readonly issueResolved?: string

  /**
   * Choices: [annotation_date, -annotation_date]. Default is -annotation_date.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesList
   */
  readonly ordering?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesList
   */
  readonly per?: number
}

/**
 * Request parameters for imageannotationFlaggedboxesRead operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationFlaggedboxesReadRequest
 */
export interface ImageAnnotationsApiImageannotationFlaggedboxesReadRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFlaggedboxesRead
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationFramesRead operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationFramesReadRequest
 */
export interface ImageAnnotationsApiImageannotationFramesReadRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFramesRead
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationFramesSetMask operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationFramesSetMaskRequest
 */
export interface ImageAnnotationsApiImageannotationFramesSetMaskRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationFramesSetMask
   */
  readonly id: string

  /**
   *
   * @type {FrameMaskOnly}
   * @memberof ImageAnnotationsApiImageannotationFramesSetMask
   */
  readonly data: FrameMaskOnly
}

/**
 * Request parameters for imageannotationSessionsComplete operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsCompleteRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsCompleteRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSessionsComplete
   */
  readonly id: string

  /**
   *
   * @type {ImageAnnotationSessionCompletion}
   * @memberof ImageAnnotationsApiImageannotationSessionsComplete
   */
  readonly data: ImageAnnotationSessionCompletion
}

/**
 * Request parameters for imageannotationSessionsCreate operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsCreateRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsCreateRequest {
  /**
   *
   * @type {ImageAnnotationSessionCreation}
   * @memberof ImageAnnotationsApiImageannotationSessionsCreate
   */
  readonly data: ImageAnnotationSessionCreation
}

/**
 * Request parameters for imageannotationSessionsPause operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsPauseRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsPauseRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSessionsPause
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationSessionsRead operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsReadRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSessionsRead
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationSessionsResume operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsResumeRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsResumeRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSessionsResume
   */
  readonly id: string
}

/**
 * Request parameters for imageannotationSessionsSave operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSessionsSaveRequest
 */
export interface ImageAnnotationsApiImageannotationSessionsSaveRequest {
  /**
   *
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSessionsSave
   */
  readonly id: string

  /**
   *
   * @type {ImageAnnotationSessionCompletion}
   * @memberof ImageAnnotationsApiImageannotationSessionsSave
   */
  readonly data: ImageAnnotationSessionCompletion
}

/**
 * Request parameters for imageannotationSubmissionsList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSubmissionsListRequest
 */
export interface ImageAnnotationsApiImageannotationSubmissionsListRequest {
  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly streamIds?: string

  /**
   * Multiple values may be separated by commas.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly categoryIds?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly imageStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly imageEndtime?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly latestAnnotationStarttime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly latestAnnotationEndtime?: string

  /**
   * Based on the last person who annotated this.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly latestAnnotationUserIds?: string

  /**
   * Multiple values may be separated by commas.  Choices: [ai, tag, review]
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly latestAnnotationTypes?: string

  /**
   * Choices: [current, behind]
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly version?: string

  /**
   * Choices: [image_datetime, -image_datetime, project_name, -project_name, stream_name, -stream_name, latest_annotation_datetime, -latest_annotation_datetime]. Default is -image_datetime.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly ordering?: string

  /**
   * Multiple values may be separated by commas.  Choices: [unlabeled, ai_labeled, labeling, labeled]
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly states?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsList
   */
  readonly per?: number
}

/**
 * Request parameters for imageannotationSubmissionsMassSubmit operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationSubmissionsMassSubmitRequest
 */
export interface ImageAnnotationsApiImageannotationSubmissionsMassSubmitRequest {
  /**
   *
   * @type {ImageSubmissionMassCreationRequest}
   * @memberof ImageAnnotationsApiImageannotationSubmissionsMassSubmit
   */
  readonly data: ImageSubmissionMassCreationRequest
}

/**
 * Request parameters for imageannotationUserreportsList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationUserreportsListRequest
 */
export interface ImageAnnotationsApiImageannotationUserreportsListRequest {
  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationUserreportsList
   */
  readonly starttime: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationUserreportsList
   */
  readonly endtime: string
}

/**
 * Request parameters for imageannotationUsersList operation in ImageAnnotationsApi.
 * @export
 * @interface ImageAnnotationsApiImageannotationUsersListRequest
 */
export interface ImageAnnotationsApiImageannotationUsersListRequest {
  /**
   * Choices: [first_name, -first_name, last_name, -last_name, email, -email]. Default is first_name.
   * @type {string}
   * @memberof ImageAnnotationsApiImageannotationUsersList
   */
  readonly ordering?: string
}

/**
 * ImageAnnotationsApi - object-oriented interface
 * @export
 * @class ImageAnnotationsApi
 * @extends {BaseAPI}
 */
export class ImageAnnotationsApi extends BaseAPI {
  /**
   * Lists annotations for reporting purposes.
   * @summary List Completed Annotations
   * @param {ImageAnnotationsApiImageannotationAnnotationsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationAnnotationsList(
    requestParameters: ImageAnnotationsApiImageannotationAnnotationsListRequest = {},
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationAnnotationsList(
        requestParameters.minScore,
        requestParameters.maxScore,
        requestParameters.userIds,
        requestParameters.streamIds,
        requestParameters.categoryIds,
        requestParameters.annotationStarttime,
        requestParameters.annotationEndtime,
        requestParameters.payEligible,
        requestParameters.initialReviewStarttime,
        requestParameters.initialReviewEndtime,
        requestParameters.reviewed,
        requestParameters.ordering,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get annotation details for a report.
   * @summary Retrieve Completed Annotations
   * @param {ImageAnnotationsApiImageannotationAnnotationsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationAnnotationsRead(
    requestParameters: ImageAnnotationsApiImageannotationAnnotationsReadRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationAnnotationsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists images that can be submitted for annotation.
   * @summary List Images Available for Submission
   * @param {ImageAnnotationsApiImageannotationCandidatesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationCandidatesList(
    requestParameters: ImageAnnotationsApiImageannotationCandidatesListRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationCandidatesList(
        requestParameters.categoryIds,
        requestParameters.streamIds,
        requestParameters.imageStarttime,
        requestParameters.imageEndtime,
        requestParameters.ordering,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists image categories.  Only active categories.
   * @summary List Image Categories
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationCategoriesList(options?: any) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationCategoriesList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Requests the export of submissions in text format.  This will be available in the future in S3 under the bucket and key listed.
   * @summary Request Export Submissions
   * @param {ImageAnnotationsApiImageannotationExportRequestSubmissionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationExportRequestSubmissions(
    requestParameters: ImageAnnotationsApiImageannotationExportRequestSubmissionsRequest = {},
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationExportRequestSubmissions(
        requestParameters.streamIds,
        requestParameters.categoryIds,
        requestParameters.imageStarttime,
        requestParameters.imageEndtime,
        requestParameters.latestAnnotationStarttime,
        requestParameters.latestAnnotationEndtime,
        requestParameters.latestAnnotationUserIds,
        requestParameters.latestAnnotationTypes,
        requestParameters.version,
        requestParameters.ordering,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Add a comment about the flagged box. Also, one can resolve the issue with the box.
   * @summary Add Comment To/Resolve Image Issue
   * @param {ImageAnnotationsApiImageannotationFlaggedboxesAddCommentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationFlaggedboxesAddComment(
    requestParameters: ImageAnnotationsApiImageannotationFlaggedboxesAddCommentRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationFlaggedboxesAddComment(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List out image annotation boxes with issues.
   * @summary List Boxes with Issues
   * @param {ImageAnnotationsApiImageannotationFlaggedboxesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationFlaggedboxesList(
    requestParameters: ImageAnnotationsApiImageannotationFlaggedboxesListRequest = {},
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationFlaggedboxesList(
        requestParameters.streamIds,
        requestParameters.issueResolved,
        requestParameters.ordering,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get details about a box with an issue. Comments are in reverse chronological order.
   * @summary Retrieve a Boxes with an Issue
   * @param {ImageAnnotationsApiImageannotationFlaggedboxesReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationFlaggedboxesRead(
    requestParameters: ImageAnnotationsApiImageannotationFlaggedboxesReadRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationFlaggedboxesRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Displays status information about submissionsregarding a specific frame.
   * @summary Show Image Frame Details
   * @param {ImageAnnotationsApiImageannotationFramesReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationFramesRead(
    requestParameters: ImageAnnotationsApiImageannotationFramesReadRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationFramesRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Set the mask_polygons attribute for a frame.
   * @summary Set Mask for Frame
   * @param {ImageAnnotationsApiImageannotationFramesSetMaskRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationFramesSetMask(
    requestParameters: ImageAnnotationsApiImageannotationFramesSetMaskRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationFramesSetMask(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Show labels.
   * @summary List All Currently Valid Labels
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationLabelsList(options?: any) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationLabelsList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Complete a labeling session by submitting labels.
   * @summary Complete Image Annotation Session
   * @param {ImageAnnotationsApiImageannotationSessionsCompleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsComplete(
    requestParameters: ImageAnnotationsApiImageannotationSessionsCompleteRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsComplete(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Starts an image annotation session.
   * @summary Start Image Annotation Session
   * @param {ImageAnnotationsApiImageannotationSessionsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsCreate(
    requestParameters: ImageAnnotationsApiImageannotationSessionsCreateRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Pause labeling session
   * @summary Pause Image Annotation Session
   * @param {ImageAnnotationsApiImageannotationSessionsPauseRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsPause(
    requestParameters: ImageAnnotationsApiImageannotationSessionsPauseRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsPause(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve image annotation session information.
   * @summary Get Image Annotation Session Information
   * @param {ImageAnnotationsApiImageannotationSessionsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsRead(
    requestParameters: ImageAnnotationsApiImageannotationSessionsReadRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Resume labeling session
   * @summary Resume Image Annotation Session
   * @param {ImageAnnotationsApiImageannotationSessionsResumeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsResume(
    requestParameters: ImageAnnotationsApiImageannotationSessionsResumeRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsResume(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Saves a labeling session.  Does not mark as complete.
   * @summary Save Image Annotation Session
   * @param {ImageAnnotationsApiImageannotationSessionsSaveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSessionsSave(
    requestParameters: ImageAnnotationsApiImageannotationSessionsSaveRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSessionsSave(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists image sublabels.  Only active sublabels.
   * @summary List Image Sublabels
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSublabelsList(options?: any) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSublabelsList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists image submissions that will be labeled.
   * @summary List Image Submissions
   * @param {ImageAnnotationsApiImageannotationSubmissionsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSubmissionsList(
    requestParameters: ImageAnnotationsApiImageannotationSubmissionsListRequest = {},
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSubmissionsList(
        requestParameters.streamIds,
        requestParameters.categoryIds,
        requestParameters.imageStarttime,
        requestParameters.imageEndtime,
        requestParameters.latestAnnotationStarttime,
        requestParameters.latestAnnotationEndtime,
        requestParameters.latestAnnotationUserIds,
        requestParameters.latestAnnotationTypes,
        requestParameters.version,
        requestParameters.ordering,
        requestParameters.states,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Submit image submissions by using a list of categories and a list of frames.
   * @summary Submit a Multiple of Image Submissions
   * @param {ImageAnnotationsApiImageannotationSubmissionsMassSubmitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationSubmissionsMassSubmit(
    requestParameters: ImageAnnotationsApiImageannotationSubmissionsMassSubmitRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationSubmissionsMassSubmit(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * User reports, specifically in relation to metrics for payments.
   * @summary User Reporting
   * @param {ImageAnnotationsApiImageannotationUserreportsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationUserreportsList(
    requestParameters: ImageAnnotationsApiImageannotationUserreportsListRequest,
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationUserreportsList(
        requestParameters.starttime,
        requestParameters.endtime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists users that can use the image annotation dashboard.
   * @summary List Users of Image Annotation Dashboard
   * @param {ImageAnnotationsApiImageannotationUsersListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageAnnotationsApi
   */
  public imageannotationUsersList(
    requestParameters: ImageAnnotationsApiImageannotationUsersListRequest = {},
    options?: any
  ) {
    return ImageAnnotationsApiFp(this.configuration)
      .imageannotationUsersList(requestParameters.ordering, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ImageSegmentationApi - axios parameter creator
 * @export
 */
export const ImageSegmentationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Global viewset for image segmentations
     * @summary Create Image Segmentation Record
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsCreate: async (
      data: ImageSegmentation,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageSegmentationsCreate.'
        )
      }
      const localVarPath = `/image_segmentations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsPartialUpdate: async (
      id: string,
      data: ImageSegmentation,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageSegmentationsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageSegmentationsPartialUpdate.'
        )
      }
      const localVarPath = `/image_segmentations/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Get Image Segmentation Record
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageSegmentationsRead.'
        )
      }
      const localVarPath = `/image_segmentations/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsUpdate: async (
      id: string,
      data: ImageSegmentation,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling imageSegmentationsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling imageSegmentationsUpdate.'
        )
      }
      const localVarPath = `/image_segmentations/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ImageSegmentationApi - functional programming interface
 * @export
 */
export const ImageSegmentationApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Global viewset for image segmentations
     * @summary Create Image Segmentation Record
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageSegmentationsCreate(
      data: ImageSegmentation,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSegmentation>
    > {
      const localVarAxiosArgs = await ImageSegmentationApiAxiosParamCreator(
        configuration
      ).imageSegmentationsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageSegmentationsPartialUpdate(
      id: string,
      data: ImageSegmentation,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSegmentation>
    > {
      const localVarAxiosArgs = await ImageSegmentationApiAxiosParamCreator(
        configuration
      ).imageSegmentationsPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Get Image Segmentation Record
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageSegmentationsRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSegmentation>
    > {
      const localVarAxiosArgs = await ImageSegmentationApiAxiosParamCreator(
        configuration
      ).imageSegmentationsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageSegmentationsUpdate(
      id: string,
      data: ImageSegmentation,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ImageSegmentation>
    > {
      const localVarAxiosArgs = await ImageSegmentationApiAxiosParamCreator(
        configuration
      ).imageSegmentationsUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ImageSegmentationApi - factory interface
 * @export
 */
export const ImageSegmentationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Global viewset for image segmentations
     * @summary Create Image Segmentation Record
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsCreate(
      data: ImageSegmentation,
      options?: any
    ): AxiosPromise<ImageSegmentation> {
      return ImageSegmentationApiFp(configuration)
        .imageSegmentationsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsPartialUpdate(
      id: string,
      data: ImageSegmentation,
      options?: any
    ): AxiosPromise<ImageSegmentation> {
      return ImageSegmentationApiFp(configuration)
        .imageSegmentationsPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Global viewset for image segmentations
     * @summary Get Image Segmentation Record
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsRead(
      id: string,
      options?: any
    ): AxiosPromise<ImageSegmentation> {
      return ImageSegmentationApiFp(configuration)
        .imageSegmentationsRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Global viewset for image segmentations
     * @summary Update Image Segmentation Record
     * @param {string} id
     * @param {ImageSegmentation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageSegmentationsUpdate(
      id: string,
      data: ImageSegmentation,
      options?: any
    ): AxiosPromise<ImageSegmentation> {
      return ImageSegmentationApiFp(configuration)
        .imageSegmentationsUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for imageSegmentationsCreate operation in ImageSegmentationApi.
 * @export
 * @interface ImageSegmentationApiImageSegmentationsCreateRequest
 */
export interface ImageSegmentationApiImageSegmentationsCreateRequest {
  /**
   *
   * @type {ImageSegmentation}
   * @memberof ImageSegmentationApiImageSegmentationsCreate
   */
  readonly data: ImageSegmentation
}

/**
 * Request parameters for imageSegmentationsPartialUpdate operation in ImageSegmentationApi.
 * @export
 * @interface ImageSegmentationApiImageSegmentationsPartialUpdateRequest
 */
export interface ImageSegmentationApiImageSegmentationsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ImageSegmentationApiImageSegmentationsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {ImageSegmentation}
   * @memberof ImageSegmentationApiImageSegmentationsPartialUpdate
   */
  readonly data: ImageSegmentation
}

/**
 * Request parameters for imageSegmentationsRead operation in ImageSegmentationApi.
 * @export
 * @interface ImageSegmentationApiImageSegmentationsReadRequest
 */
export interface ImageSegmentationApiImageSegmentationsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ImageSegmentationApiImageSegmentationsRead
   */
  readonly id: string
}

/**
 * Request parameters for imageSegmentationsUpdate operation in ImageSegmentationApi.
 * @export
 * @interface ImageSegmentationApiImageSegmentationsUpdateRequest
 */
export interface ImageSegmentationApiImageSegmentationsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ImageSegmentationApiImageSegmentationsUpdate
   */
  readonly id: string

  /**
   *
   * @type {ImageSegmentation}
   * @memberof ImageSegmentationApiImageSegmentationsUpdate
   */
  readonly data: ImageSegmentation
}

/**
 * ImageSegmentationApi - object-oriented interface
 * @export
 * @class ImageSegmentationApi
 * @extends {BaseAPI}
 */
export class ImageSegmentationApi extends BaseAPI {
  /**
   * Global viewset for image segmentations
   * @summary Create Image Segmentation Record
   * @param {ImageSegmentationApiImageSegmentationsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageSegmentationApi
   */
  public imageSegmentationsCreate(
    requestParameters: ImageSegmentationApiImageSegmentationsCreateRequest,
    options?: any
  ) {
    return ImageSegmentationApiFp(this.configuration)
      .imageSegmentationsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Global viewset for image segmentations
   * @summary Update Image Segmentation Record
   * @param {ImageSegmentationApiImageSegmentationsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageSegmentationApi
   */
  public imageSegmentationsPartialUpdate(
    requestParameters: ImageSegmentationApiImageSegmentationsPartialUpdateRequest,
    options?: any
  ) {
    return ImageSegmentationApiFp(this.configuration)
      .imageSegmentationsPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Global viewset for image segmentations
   * @summary Get Image Segmentation Record
   * @param {ImageSegmentationApiImageSegmentationsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageSegmentationApi
   */
  public imageSegmentationsRead(
    requestParameters: ImageSegmentationApiImageSegmentationsReadRequest,
    options?: any
  ) {
    return ImageSegmentationApiFp(this.configuration)
      .imageSegmentationsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Global viewset for image segmentations
   * @summary Update Image Segmentation Record
   * @param {ImageSegmentationApiImageSegmentationsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageSegmentationApi
   */
  public imageSegmentationsUpdate(
    requestParameters: ImageSegmentationApiImageSegmentationsUpdateRequest,
    options?: any
  ) {
    return ImageSegmentationApiFp(this.configuration)
      .imageSegmentationsUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LabelingApi - axios parameter creator
 * @export
 */
export const LabelingApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Submit frame for labeling.
     * @param {string} frameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelingFramesSubmitCreate: async (
      frameId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'frameId' is not null or undefined
      if (frameId === null || frameId === undefined) {
        throw new RequiredError(
          'frameId',
          'Required parameter frameId was null or undefined when calling labelingFramesSubmitCreate.'
        )
      }
      const localVarPath = `/labeling/frames/{frame_id}/submit/`.replace(
        `{${'frame_id'}}`,
        encodeURIComponent(String(frameId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Labelbox webhook
     * @param {LabelboxWebhookResponse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelingLabelboxWebhookCreate: async (
      data: LabelboxWebhookResponse,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling labelingLabelboxWebhookCreate.'
        )
      }
      const localVarPath = `/labeling/labelbox/webhook/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LabelingApi - functional programming interface
 * @export
 */
export const LabelingApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Submit frame for labeling.
     * @param {string} frameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async labelingFramesSubmitCreate(
      frameId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelingImage>
    > {
      const localVarAxiosArgs = await LabelingApiAxiosParamCreator(
        configuration
      ).labelingFramesSubmitCreate(frameId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Labelbox webhook
     * @param {LabelboxWebhookResponse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async labelingLabelboxWebhookCreate(
      data: LabelboxWebhookResponse,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<LabelingSubmission>
    > {
      const localVarAxiosArgs = await LabelingApiAxiosParamCreator(
        configuration
      ).labelingLabelboxWebhookCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * LabelingApi - factory interface
 * @export
 */
export const LabelingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Submit frame for labeling.
     * @param {string} frameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelingFramesSubmitCreate(
      frameId: string,
      options?: any
    ): AxiosPromise<LabelingImage> {
      return LabelingApiFp(configuration)
        .labelingFramesSubmitCreate(frameId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Labelbox webhook
     * @param {LabelboxWebhookResponse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    labelingLabelboxWebhookCreate(
      data: LabelboxWebhookResponse,
      options?: any
    ): AxiosPromise<LabelingSubmission> {
      return LabelingApiFp(configuration)
        .labelingLabelboxWebhookCreate(data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for labelingFramesSubmitCreate operation in LabelingApi.
 * @export
 * @interface LabelingApiLabelingFramesSubmitCreateRequest
 */
export interface LabelingApiLabelingFramesSubmitCreateRequest {
  /**
   *
   * @type {string}
   * @memberof LabelingApiLabelingFramesSubmitCreate
   */
  readonly frameId: string
}

/**
 * Request parameters for labelingLabelboxWebhookCreate operation in LabelingApi.
 * @export
 * @interface LabelingApiLabelingLabelboxWebhookCreateRequest
 */
export interface LabelingApiLabelingLabelboxWebhookCreateRequest {
  /**
   *
   * @type {LabelboxWebhookResponse}
   * @memberof LabelingApiLabelingLabelboxWebhookCreate
   */
  readonly data: LabelboxWebhookResponse
}

/**
 * LabelingApi - object-oriented interface
 * @export
 * @class LabelingApi
 * @extends {BaseAPI}
 */
export class LabelingApi extends BaseAPI {
  /**
   * Submit frame for labeling.
   * @param {LabelingApiLabelingFramesSubmitCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelingApi
   */
  public labelingFramesSubmitCreate(
    requestParameters: LabelingApiLabelingFramesSubmitCreateRequest,
    options?: any
  ) {
    return LabelingApiFp(this.configuration)
      .labelingFramesSubmitCreate(requestParameters.frameId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Labelbox webhook
   * @param {LabelingApiLabelingLabelboxWebhookCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelingApi
   */
  public labelingLabelboxWebhookCreate(
    requestParameters: LabelingApiLabelingLabelboxWebhookCreateRequest,
    options?: any
  ) {
    return LabelingApiFp(this.configuration)
      .labelingLabelboxWebhookCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NoonlightIntegrationApi - axios parameter creator
 * @export
 */
export const NoonlightIntegrationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Webhook for Noonlight dispatch API
     * @summary Dispatch Webhook
     * @param {Array<NoonlightDispatchEvent>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    noonlightDispatchCreate: async (
      data: Array<NoonlightDispatchEvent>,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling noonlightDispatchCreate.'
        )
      }
      const localVarPath = `/noonlight/dispatch/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Webhook for Noonlight task API
     * @summary Task Webhook
     * @param {NoonlightTaskResult} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    noonlightTaskCreate: async (
      data: NoonlightTaskResult,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling noonlightTaskCreate.'
        )
      }
      const localVarPath = `/noonlight/task/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * NoonlightIntegrationApi - functional programming interface
 * @export
 */
export const NoonlightIntegrationApiFp = function (
  configuration?: Configuration
) {
  return {
    /**
     * Webhook for Noonlight dispatch API
     * @summary Dispatch Webhook
     * @param {Array<NoonlightDispatchEvent>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async noonlightDispatchCreate(
      data: Array<NoonlightDispatchEvent>,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await NoonlightIntegrationApiAxiosParamCreator(
        configuration
      ).noonlightDispatchCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Webhook for Noonlight task API
     * @summary Task Webhook
     * @param {NoonlightTaskResult} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async noonlightTaskCreate(
      data: NoonlightTaskResult,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await NoonlightIntegrationApiAxiosParamCreator(
        configuration
      ).noonlightTaskCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * NoonlightIntegrationApi - factory interface
 * @export
 */
export const NoonlightIntegrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Webhook for Noonlight dispatch API
     * @summary Dispatch Webhook
     * @param {Array<NoonlightDispatchEvent>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    noonlightDispatchCreate(
      data: Array<NoonlightDispatchEvent>,
      options?: any
    ): AxiosPromise<void> {
      return NoonlightIntegrationApiFp(configuration)
        .noonlightDispatchCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Webhook for Noonlight task API
     * @summary Task Webhook
     * @param {NoonlightTaskResult} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    noonlightTaskCreate(
      data: NoonlightTaskResult,
      options?: any
    ): AxiosPromise<void> {
      return NoonlightIntegrationApiFp(configuration)
        .noonlightTaskCreate(data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for noonlightDispatchCreate operation in NoonlightIntegrationApi.
 * @export
 * @interface NoonlightIntegrationApiNoonlightDispatchCreateRequest
 */
export interface NoonlightIntegrationApiNoonlightDispatchCreateRequest {
  /**
   *
   * @type {Array<NoonlightDispatchEvent>}
   * @memberof NoonlightIntegrationApiNoonlightDispatchCreate
   */
  readonly data: Array<NoonlightDispatchEvent>
}

/**
 * Request parameters for noonlightTaskCreate operation in NoonlightIntegrationApi.
 * @export
 * @interface NoonlightIntegrationApiNoonlightTaskCreateRequest
 */
export interface NoonlightIntegrationApiNoonlightTaskCreateRequest {
  /**
   *
   * @type {NoonlightTaskResult}
   * @memberof NoonlightIntegrationApiNoonlightTaskCreate
   */
  readonly data: NoonlightTaskResult
}

/**
 * NoonlightIntegrationApi - object-oriented interface
 * @export
 * @class NoonlightIntegrationApi
 * @extends {BaseAPI}
 */
export class NoonlightIntegrationApi extends BaseAPI {
  /**
   * Webhook for Noonlight dispatch API
   * @summary Dispatch Webhook
   * @param {NoonlightIntegrationApiNoonlightDispatchCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoonlightIntegrationApi
   */
  public noonlightDispatchCreate(
    requestParameters: NoonlightIntegrationApiNoonlightDispatchCreateRequest,
    options?: any
  ) {
    return NoonlightIntegrationApiFp(this.configuration)
      .noonlightDispatchCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Webhook for Noonlight task API
   * @summary Task Webhook
   * @param {NoonlightIntegrationApiNoonlightTaskCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoonlightIntegrationApi
   */
  public noonlightTaskCreate(
    requestParameters: NoonlightIntegrationApiNoonlightTaskCreateRequest,
    options?: any
  ) {
    return NoonlightIntegrationApiFp(this.configuration)
      .noonlightTaskCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * OneTimeTokenOTTApi - axios parameter creator
 * @export
 */
export const OneTimeTokenOTTApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Returns a one time use token for this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ottCreate: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/ott/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Returns a one time use token for this user.
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ottVerify: async (
      tokenId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tokenId' is not null or undefined
      if (tokenId === null || tokenId === undefined) {
        throw new RequiredError(
          'tokenId',
          'Required parameter tokenId was null or undefined when calling ottVerify.'
        )
      }
      const localVarPath = `/ott/{token_id}/`.replace(
        `{${'token_id'}}`,
        encodeURIComponent(String(tokenId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * OneTimeTokenOTTApi - functional programming interface
 * @export
 */
export const OneTimeTokenOTTApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Returns a one time use token for this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ottCreate(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OttToken>
    > {
      const localVarAxiosArgs = await OneTimeTokenOTTApiAxiosParamCreator(
        configuration
      ).ottCreate(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Returns a one time use token for this user.
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ottVerify(
      tokenId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await OneTimeTokenOTTApiAxiosParamCreator(
        configuration
      ).ottVerify(tokenId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * OneTimeTokenOTTApi - factory interface
 * @export
 */
export const OneTimeTokenOTTApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Returns a one time use token for this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ottCreate(options?: any): AxiosPromise<OttToken> {
      return OneTimeTokenOTTApiFp(configuration)
        .ottCreate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns a one time use token for this user.
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ottVerify(tokenId: string, options?: any): AxiosPromise<void> {
      return OneTimeTokenOTTApiFp(configuration)
        .ottVerify(tokenId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for ottVerify operation in OneTimeTokenOTTApi.
 * @export
 * @interface OneTimeTokenOTTApiOttVerifyRequest
 */
export interface OneTimeTokenOTTApiOttVerifyRequest {
  /**
   *
   * @type {string}
   * @memberof OneTimeTokenOTTApiOttVerify
   */
  readonly tokenId: string
}

/**
 * OneTimeTokenOTTApi - object-oriented interface
 * @export
 * @class OneTimeTokenOTTApi
 * @extends {BaseAPI}
 */
export class OneTimeTokenOTTApi extends BaseAPI {
  /**
   * Returns a one time use token for this user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OneTimeTokenOTTApi
   */
  public ottCreate(options?: any) {
    return OneTimeTokenOTTApiFp(this.configuration)
      .ottCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns a one time use token for this user.
   * @param {OneTimeTokenOTTApiOttVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OneTimeTokenOTTApi
   */
  public ottVerify(
    requestParameters: OneTimeTokenOTTApiOttVerifyRequest,
    options?: any
  ) {
    return OneTimeTokenOTTApiFp(this.configuration)
      .ottVerify(requestParameters.tokenId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PTGUIProxyApi - axios parameter creator
 * @export
 */
export const PTGUIProxyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Ptgui Jobs api code
     * @summary List PTGUI Job
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state] Choices: [initial, running, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsList: async (
      startTime?: string,
      endTime?: string,
      state?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/ptgui/jobs/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Mark the ptgui job as running.
     * @summary Mark PTGUI Job as Running
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsMarkRunning: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ptguiJobsMarkRunning.'
        )
      }
      const localVarPath = `/ptgui/jobs/{id}/mark_running/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsPartialUpdate: async (
      id: string,
      data: PTGUIProxyJob,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ptguiJobsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling ptguiJobsPartialUpdate.'
        )
      }
      const localVarPath = `/ptgui/jobs/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Get PTGUI Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ptguiJobsRead.'
        )
      }
      const localVarPath = `/ptgui/jobs/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsUpdate: async (
      id: string,
      data: PTGUIProxyJob,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ptguiJobsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling ptguiJobsUpdate.'
        )
      }
      const localVarPath = `/ptgui/jobs/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PTGUIProxyApi - functional programming interface
 * @export
 */
export const PTGUIProxyApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Ptgui Jobs api code
     * @summary List PTGUI Job
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state] Choices: [initial, running, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ptguiJobsList(
      startTime?: string,
      endTime?: string,
      state?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<PTGUIProxyJob>>
    > {
      const localVarAxiosArgs = await PTGUIProxyApiAxiosParamCreator(
        configuration
      ).ptguiJobsList(startTime, endTime, state, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Mark the ptgui job as running.
     * @summary Mark PTGUI Job as Running
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ptguiJobsMarkRunning(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await PTGUIProxyApiAxiosParamCreator(
        configuration
      ).ptguiJobsMarkRunning(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ptguiJobsPartialUpdate(
      id: string,
      data: PTGUIProxyJob,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PTGUIProxyJob>
    > {
      const localVarAxiosArgs = await PTGUIProxyApiAxiosParamCreator(
        configuration
      ).ptguiJobsPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Get PTGUI Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ptguiJobsRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PTGUIProxyJob>
    > {
      const localVarAxiosArgs = await PTGUIProxyApiAxiosParamCreator(
        configuration
      ).ptguiJobsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ptguiJobsUpdate(
      id: string,
      data: PTGUIProxyJob,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PTGUIProxyJob>
    > {
      const localVarAxiosArgs = await PTGUIProxyApiAxiosParamCreator(
        configuration
      ).ptguiJobsUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PTGUIProxyApi - factory interface
 * @export
 */
export const PTGUIProxyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Ptgui Jobs api code
     * @summary List PTGUI Job
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state] Choices: [initial, running, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsList(
      startTime?: string,
      endTime?: string,
      state?: string,
      options?: any
    ): AxiosPromise<Array<PTGUIProxyJob>> {
      return PTGUIProxyApiFp(configuration)
        .ptguiJobsList(startTime, endTime, state, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Mark the ptgui job as running.
     * @summary Mark PTGUI Job as Running
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsMarkRunning(id: string, options?: any): AxiosPromise<void> {
      return PTGUIProxyApiFp(configuration)
        .ptguiJobsMarkRunning(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsPartialUpdate(
      id: string,
      data: PTGUIProxyJob,
      options?: any
    ): AxiosPromise<PTGUIProxyJob> {
      return PTGUIProxyApiFp(configuration)
        .ptguiJobsPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ptgui Jobs api code
     * @summary Get PTGUI Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsRead(id: string, options?: any): AxiosPromise<PTGUIProxyJob> {
      return PTGUIProxyApiFp(configuration)
        .ptguiJobsRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ptgui Jobs api code
     * @summary Update PTGUI Job
     * @param {string} id
     * @param {PTGUIProxyJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ptguiJobsUpdate(
      id: string,
      data: PTGUIProxyJob,
      options?: any
    ): AxiosPromise<PTGUIProxyJob> {
      return PTGUIProxyApiFp(configuration)
        .ptguiJobsUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for ptguiJobsList operation in PTGUIProxyApi.
 * @export
 * @interface PTGUIProxyApiPtguiJobsListRequest
 */
export interface PTGUIProxyApiPtguiJobsListRequest {
  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsList
   */
  readonly endTime?: string

  /**
   * Choices: [initial, running, failed, completed]
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsList
   */
  readonly state?: string
}

/**
 * Request parameters for ptguiJobsMarkRunning operation in PTGUIProxyApi.
 * @export
 * @interface PTGUIProxyApiPtguiJobsMarkRunningRequest
 */
export interface PTGUIProxyApiPtguiJobsMarkRunningRequest {
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsMarkRunning
   */
  readonly id: string
}

/**
 * Request parameters for ptguiJobsPartialUpdate operation in PTGUIProxyApi.
 * @export
 * @interface PTGUIProxyApiPtguiJobsPartialUpdateRequest
 */
export interface PTGUIProxyApiPtguiJobsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {PTGUIProxyJob}
   * @memberof PTGUIProxyApiPtguiJobsPartialUpdate
   */
  readonly data: PTGUIProxyJob
}

/**
 * Request parameters for ptguiJobsRead operation in PTGUIProxyApi.
 * @export
 * @interface PTGUIProxyApiPtguiJobsReadRequest
 */
export interface PTGUIProxyApiPtguiJobsReadRequest {
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsRead
   */
  readonly id: string
}

/**
 * Request parameters for ptguiJobsUpdate operation in PTGUIProxyApi.
 * @export
 * @interface PTGUIProxyApiPtguiJobsUpdateRequest
 */
export interface PTGUIProxyApiPtguiJobsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PTGUIProxyApiPtguiJobsUpdate
   */
  readonly id: string

  /**
   *
   * @type {PTGUIProxyJob}
   * @memberof PTGUIProxyApiPtguiJobsUpdate
   */
  readonly data: PTGUIProxyJob
}

/**
 * PTGUIProxyApi - object-oriented interface
 * @export
 * @class PTGUIProxyApi
 * @extends {BaseAPI}
 */
export class PTGUIProxyApi extends BaseAPI {
  /**
   * Ptgui Jobs api code
   * @summary List PTGUI Job
   * @param {PTGUIProxyApiPtguiJobsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTGUIProxyApi
   */
  public ptguiJobsList(
    requestParameters: PTGUIProxyApiPtguiJobsListRequest = {},
    options?: any
  ) {
    return PTGUIProxyApiFp(this.configuration)
      .ptguiJobsList(
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.state,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Mark the ptgui job as running.
   * @summary Mark PTGUI Job as Running
   * @param {PTGUIProxyApiPtguiJobsMarkRunningRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTGUIProxyApi
   */
  public ptguiJobsMarkRunning(
    requestParameters: PTGUIProxyApiPtguiJobsMarkRunningRequest,
    options?: any
  ) {
    return PTGUIProxyApiFp(this.configuration)
      .ptguiJobsMarkRunning(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ptgui Jobs api code
   * @summary Update PTGUI Job
   * @param {PTGUIProxyApiPtguiJobsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTGUIProxyApi
   */
  public ptguiJobsPartialUpdate(
    requestParameters: PTGUIProxyApiPtguiJobsPartialUpdateRequest,
    options?: any
  ) {
    return PTGUIProxyApiFp(this.configuration)
      .ptguiJobsPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ptgui Jobs api code
   * @summary Get PTGUI Job
   * @param {PTGUIProxyApiPtguiJobsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTGUIProxyApi
   */
  public ptguiJobsRead(
    requestParameters: PTGUIProxyApiPtguiJobsReadRequest,
    options?: any
  ) {
    return PTGUIProxyApiFp(this.configuration)
      .ptguiJobsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ptgui Jobs api code
   * @summary Update PTGUI Job
   * @param {PTGUIProxyApiPtguiJobsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTGUIProxyApi
   */
  public ptguiJobsUpdate(
    requestParameters: PTGUIProxyApiPtguiJobsUpdateRequest,
    options?: any
  ) {
    return PTGUIProxyApiFp(this.configuration)
      .ptguiJobsUpdate(requestParameters.id, requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PTZApi - axios parameter creator
 * @export
 */
export const PTZApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Triggers the lens wiper on the camera once.
     * @summary Lens Wiper
     * @param {string} streamId
     * @param {object} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzLenswipeCreate: async (
      streamId: string,
      data: object,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzLenswipeCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsPtzLenswipeCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/lenswipe/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Locks or unlocks ptz capabilities on a stream.
     * @summary Lock/Unlock PTZ
     * @param {string} streamId
     * @param {PtzLock} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzLockstatusPartialUpdate: async (
      streamId: string,
      data: PtzLock,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzLockstatusPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsPtzLockstatusPartialUpdate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/lockstatus/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Moves the camera relative given pan tilt zoom values.
     * @summary Pan Tilt Zoom
     * @param {string} streamId
     * @param {PtzMovement} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzMovementCreate: async (
      streamId: string,
      data: PtzMovement,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzMovementCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsPtzMovementCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/movement/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List PTZ Presets
     * @summary List PTZ Presets
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsList: async (
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzPresetsList.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/presets/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Moves the camera to the given preset.
     * @summary Moves Camera to Selected Preset
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsMove: async (
      id: string,
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsPtzPresetsMove.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzPresetsMove.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/presets/{id}/move/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Saves the current camera position to the given preset.NOTE: This is a non standard endpoint.  if name is not provided, it isnot overwritten. Also, this acts like PATCH even though it\'s a PUT.
     * @summary Save Current Camera Preset
     * @param {string} id
     * @param {string} streamId
     * @param {CameraPreset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsSavePreset: async (
      id: string,
      streamId: string,
      data: CameraPreset,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsPtzPresetsSavePreset.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsPtzPresetsSavePreset.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsPtzPresetsSavePreset.'
        )
      }
      const localVarPath = `/streams/{stream_id}/ptz/presets/{id}/save/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PTZApi - functional programming interface
 * @export
 */
export const PTZApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Triggers the lens wiper on the camera once.
     * @summary Lens Wiper
     * @param {string} streamId
     * @param {object} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzLenswipeCreate(
      streamId: string,
      data: object,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzLenswipeCreate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Locks or unlocks ptz capabilities on a stream.
     * @summary Lock/Unlock PTZ
     * @param {string} streamId
     * @param {PtzLock} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzLockstatusPartialUpdate(
      streamId: string,
      data: PtzLock,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtzLock>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzLockstatusPartialUpdate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Moves the camera relative given pan tilt zoom values.
     * @summary Pan Tilt Zoom
     * @param {string} streamId
     * @param {PtzMovement} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzMovementCreate(
      streamId: string,
      data: PtzMovement,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PtzMovement>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzMovementCreate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List PTZ Presets
     * @summary List PTZ Presets
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzPresetsList(
      streamId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CameraPreset>>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzPresetsList(streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Moves the camera to the given preset.
     * @summary Moves Camera to Selected Preset
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzPresetsMove(
      id: string,
      streamId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraPreset>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzPresetsMove(id, streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Saves the current camera position to the given preset.NOTE: This is a non standard endpoint.  if name is not provided, it isnot overwritten. Also, this acts like PATCH even though it\'s a PUT.
     * @summary Save Current Camera Preset
     * @param {string} id
     * @param {string} streamId
     * @param {CameraPreset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsPtzPresetsSavePreset(
      id: string,
      streamId: string,
      data: CameraPreset,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraPreset>
    > {
      const localVarAxiosArgs = await PTZApiAxiosParamCreator(
        configuration
      ).streamsPtzPresetsSavePreset(id, streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PTZApi - factory interface
 * @export
 */
export const PTZApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Triggers the lens wiper on the camera once.
     * @summary Lens Wiper
     * @param {string} streamId
     * @param {object} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzLenswipeCreate(
      streamId: string,
      data: object,
      options?: any
    ): AxiosPromise<object> {
      return PTZApiFp(configuration)
        .streamsPtzLenswipeCreate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Locks or unlocks ptz capabilities on a stream.
     * @summary Lock/Unlock PTZ
     * @param {string} streamId
     * @param {PtzLock} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzLockstatusPartialUpdate(
      streamId: string,
      data: PtzLock,
      options?: any
    ): AxiosPromise<PtzLock> {
      return PTZApiFp(configuration)
        .streamsPtzLockstatusPartialUpdate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Moves the camera relative given pan tilt zoom values.
     * @summary Pan Tilt Zoom
     * @param {string} streamId
     * @param {PtzMovement} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzMovementCreate(
      streamId: string,
      data: PtzMovement,
      options?: any
    ): AxiosPromise<PtzMovement> {
      return PTZApiFp(configuration)
        .streamsPtzMovementCreate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List PTZ Presets
     * @summary List PTZ Presets
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsList(
      streamId: string,
      options?: any
    ): AxiosPromise<Array<CameraPreset>> {
      return PTZApiFp(configuration)
        .streamsPtzPresetsList(streamId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Moves the camera to the given preset.
     * @summary Moves Camera to Selected Preset
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsMove(
      id: string,
      streamId: string,
      options?: any
    ): AxiosPromise<CameraPreset> {
      return PTZApiFp(configuration)
        .streamsPtzPresetsMove(id, streamId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Saves the current camera position to the given preset.NOTE: This is a non standard endpoint.  if name is not provided, it isnot overwritten. Also, this acts like PATCH even though it\'s a PUT.
     * @summary Save Current Camera Preset
     * @param {string} id
     * @param {string} streamId
     * @param {CameraPreset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsPtzPresetsSavePreset(
      id: string,
      streamId: string,
      data: CameraPreset,
      options?: any
    ): AxiosPromise<CameraPreset> {
      return PTZApiFp(configuration)
        .streamsPtzPresetsSavePreset(id, streamId, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for streamsPtzLenswipeCreate operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzLenswipeCreateRequest
 */
export interface PTZApiStreamsPtzLenswipeCreateRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzLenswipeCreate
   */
  readonly streamId: string

  /**
   *
   * @type {object}
   * @memberof PTZApiStreamsPtzLenswipeCreate
   */
  readonly data: object
}

/**
 * Request parameters for streamsPtzLockstatusPartialUpdate operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzLockstatusPartialUpdateRequest
 */
export interface PTZApiStreamsPtzLockstatusPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzLockstatusPartialUpdate
   */
  readonly streamId: string

  /**
   *
   * @type {PtzLock}
   * @memberof PTZApiStreamsPtzLockstatusPartialUpdate
   */
  readonly data: PtzLock
}

/**
 * Request parameters for streamsPtzMovementCreate operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzMovementCreateRequest
 */
export interface PTZApiStreamsPtzMovementCreateRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzMovementCreate
   */
  readonly streamId: string

  /**
   *
   * @type {PtzMovement}
   * @memberof PTZApiStreamsPtzMovementCreate
   */
  readonly data: PtzMovement
}

/**
 * Request parameters for streamsPtzPresetsList operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzPresetsListRequest
 */
export interface PTZApiStreamsPtzPresetsListRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzPresetsList
   */
  readonly streamId: string
}

/**
 * Request parameters for streamsPtzPresetsMove operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzPresetsMoveRequest
 */
export interface PTZApiStreamsPtzPresetsMoveRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzPresetsMove
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzPresetsMove
   */
  readonly streamId: string
}

/**
 * Request parameters for streamsPtzPresetsSavePreset operation in PTZApi.
 * @export
 * @interface PTZApiStreamsPtzPresetsSavePresetRequest
 */
export interface PTZApiStreamsPtzPresetsSavePresetRequest {
  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzPresetsSavePreset
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PTZApiStreamsPtzPresetsSavePreset
   */
  readonly streamId: string

  /**
   *
   * @type {CameraPreset}
   * @memberof PTZApiStreamsPtzPresetsSavePreset
   */
  readonly data: CameraPreset
}

/**
 * PTZApi - object-oriented interface
 * @export
 * @class PTZApi
 * @extends {BaseAPI}
 */
export class PTZApi extends BaseAPI {
  /**
   * Triggers the lens wiper on the camera once.
   * @summary Lens Wiper
   * @param {PTZApiStreamsPtzLenswipeCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzLenswipeCreate(
    requestParameters: PTZApiStreamsPtzLenswipeCreateRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzLenswipeCreate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Locks or unlocks ptz capabilities on a stream.
   * @summary Lock/Unlock PTZ
   * @param {PTZApiStreamsPtzLockstatusPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzLockstatusPartialUpdate(
    requestParameters: PTZApiStreamsPtzLockstatusPartialUpdateRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzLockstatusPartialUpdate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Moves the camera relative given pan tilt zoom values.
   * @summary Pan Tilt Zoom
   * @param {PTZApiStreamsPtzMovementCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzMovementCreate(
    requestParameters: PTZApiStreamsPtzMovementCreateRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzMovementCreate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List PTZ Presets
   * @summary List PTZ Presets
   * @param {PTZApiStreamsPtzPresetsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzPresetsList(
    requestParameters: PTZApiStreamsPtzPresetsListRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzPresetsList(requestParameters.streamId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Moves the camera to the given preset.
   * @summary Moves Camera to Selected Preset
   * @param {PTZApiStreamsPtzPresetsMoveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzPresetsMove(
    requestParameters: PTZApiStreamsPtzPresetsMoveRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzPresetsMove(
        requestParameters.id,
        requestParameters.streamId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Saves the current camera position to the given preset.NOTE: This is a non standard endpoint.  if name is not provided, it isnot overwritten. Also, this acts like PATCH even though it\'s a PUT.
   * @summary Save Current Camera Preset
   * @param {PTZApiStreamsPtzPresetsSavePresetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PTZApi
   */
  public streamsPtzPresetsSavePreset(
    requestParameters: PTZApiStreamsPtzPresetsSavePresetRequest,
    options?: any
  ) {
    return PTZApiFp(this.configuration)
      .streamsPtzPresetsSavePreset(
        requestParameters.id,
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PasswordsApi - axios parameter creator
 * @export
 */
export const PasswordsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Initiates a password reset request.  This is an unauthenticated endpoint.  This will 204 whether or not the email  exists in the system.
     * @summary Request Password Reset
     * @param {PasswordResetRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordResetRequest: async (
      data: PasswordResetRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling passwordResetRequest.'
        )
      }
      const localVarPath = `/passwords/reset/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Sets a new password.  password1 and password2 must match.  token and uidb64 are sent from an email  when a password request is initiated.
     * @summary Set Password
     * @param {string} token
     * @param {string} uidb64
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordResetSet: async (
      token: string,
      uidb64: string,
      data: PasswordReset,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      if (token === null || token === undefined) {
        throw new RequiredError(
          'token',
          'Required parameter token was null or undefined when calling passwordResetSet.'
        )
      }
      // verify required parameter 'uidb64' is not null or undefined
      if (uidb64 === null || uidb64 === undefined) {
        throw new RequiredError(
          'uidb64',
          'Required parameter uidb64 was null or undefined when calling passwordResetSet.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling passwordResetSet.'
        )
      }
      const localVarPath = `/passwords/reset/{uidb64}/{token}/`
        .replace(`{${'token'}}`, encodeURIComponent(String(token)))
        .replace(`{${'uidb64'}}`, encodeURIComponent(String(uidb64)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PasswordsApi - functional programming interface
 * @export
 */
export const PasswordsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Initiates a password reset request.  This is an unauthenticated endpoint.  This will 204 whether or not the email  exists in the system.
     * @summary Request Password Reset
     * @param {PasswordResetRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async passwordResetRequest(
      data: PasswordResetRequest,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await PasswordsApiAxiosParamCreator(
        configuration
      ).passwordResetRequest(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sets a new password.  password1 and password2 must match.  token and uidb64 are sent from an email  when a password request is initiated.
     * @summary Set Password
     * @param {string} token
     * @param {string} uidb64
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async passwordResetSet(
      token: string,
      uidb64: string,
      data: PasswordReset,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await PasswordsApiAxiosParamCreator(
        configuration
      ).passwordResetSet(token, uidb64, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PasswordsApi - factory interface
 * @export
 */
export const PasswordsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Initiates a password reset request.  This is an unauthenticated endpoint.  This will 204 whether or not the email  exists in the system.
     * @summary Request Password Reset
     * @param {PasswordResetRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordResetRequest(
      data: PasswordResetRequest,
      options?: any
    ): AxiosPromise<void> {
      return PasswordsApiFp(configuration)
        .passwordResetRequest(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sets a new password.  password1 and password2 must match.  token and uidb64 are sent from an email  when a password request is initiated.
     * @summary Set Password
     * @param {string} token
     * @param {string} uidb64
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordResetSet(
      token: string,
      uidb64: string,
      data: PasswordReset,
      options?: any
    ): AxiosPromise<void> {
      return PasswordsApiFp(configuration)
        .passwordResetSet(token, uidb64, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for passwordResetRequest operation in PasswordsApi.
 * @export
 * @interface PasswordsApiPasswordResetRequestRequest
 */
export interface PasswordsApiPasswordResetRequestRequest {
  /**
   *
   * @type {PasswordResetRequest}
   * @memberof PasswordsApiPasswordResetRequest
   */
  readonly data: PasswordResetRequest
}

/**
 * Request parameters for passwordResetSet operation in PasswordsApi.
 * @export
 * @interface PasswordsApiPasswordResetSetRequest
 */
export interface PasswordsApiPasswordResetSetRequest {
  /**
   *
   * @type {string}
   * @memberof PasswordsApiPasswordResetSet
   */
  readonly token: string

  /**
   *
   * @type {string}
   * @memberof PasswordsApiPasswordResetSet
   */
  readonly uidb64: string

  /**
   *
   * @type {PasswordReset}
   * @memberof PasswordsApiPasswordResetSet
   */
  readonly data: PasswordReset
}

/**
 * PasswordsApi - object-oriented interface
 * @export
 * @class PasswordsApi
 * @extends {BaseAPI}
 */
export class PasswordsApi extends BaseAPI {
  /**
   * Initiates a password reset request.  This is an unauthenticated endpoint.  This will 204 whether or not the email  exists in the system.
   * @summary Request Password Reset
   * @param {PasswordsApiPasswordResetRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordsApi
   */
  public passwordResetRequest(
    requestParameters: PasswordsApiPasswordResetRequestRequest,
    options?: any
  ) {
    return PasswordsApiFp(this.configuration)
      .passwordResetRequest(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sets a new password.  password1 and password2 must match.  token and uidb64 are sent from an email  when a password request is initiated.
   * @summary Set Password
   * @param {PasswordsApiPasswordResetSetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordsApi
   */
  public passwordResetSet(
    requestParameters: PasswordsApiPasswordResetSetRequest,
    options?: any
  ) {
    return PasswordsApiFp(this.configuration)
      .passwordResetSet(
        requestParameters.token,
        requestParameters.uidb64,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PhotospheresApi - axios parameter creator
 * @export
 */
export const PhotospheresApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Notifies server that the drawing is uploaded.
     * @summary Confirm Drawing is Uploaded
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsConfirm: async (
      id: string,
      templateId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesDrawingsConfirm.'
        )
      }
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsConfirm.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/{id}/confirm/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'template_id'}}`, encodeURIComponent(String(templateId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary Create Photosphere Drawing
     * @param {string} templateId
     * @param {CreatePhotosphereDrawingRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsCreate: async (
      templateId: string,
      data: CreatePhotosphereDrawingRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling photosphereTemplatesDrawingsCreate.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/`.replace(
        `{${'template_id'}}`,
        encodeURIComponent(String(templateId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary Delete Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsDelete: async (
      id: string,
      templateId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesDrawingsDelete.'
        )
      }
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsDelete.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'template_id'}}`, encodeURIComponent(String(templateId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary List Photosphere Drawings
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsList: async (
      templateId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsList.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/`.replace(
        `{${'template_id'}}`,
        encodeURIComponent(String(templateId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsPartialUpdate: async (
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesDrawingsPartialUpdate.'
        )
      }
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling photosphereTemplatesDrawingsPartialUpdate.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'template_id'}}`, encodeURIComponent(String(templateId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary Get Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsRead: async (
      id: string,
      templateId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesDrawingsRead.'
        )
      }
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsRead.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'template_id'}}`, encodeURIComponent(String(templateId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsUpdate: async (
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesDrawingsUpdate.'
        )
      }
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling photosphereTemplatesDrawingsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling photosphereTemplatesDrawingsUpdate.'
        )
      }
      const localVarPath = `/photosphere_templates/{template_id}/drawings/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'template_id'}}`, encodeURIComponent(String(templateId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get information about a photosphere template.
     * @summary Get Photosphere Template
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photosphereTemplatesRead.'
        )
      }
      const localVarPath = `/photosphere_templates/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary List Photospheres
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresList: async (
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/photospheres/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (states !== undefined) {
        localVarQueryParameter['states'] = states
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresPartialUpdate: async (
      id: string,
      data: Photosphere,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photospheresPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling photospheresPartialUpdate.'
        )
      }
      const localVarPath = `/photospheres/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Get Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photospheresRead.'
        )
      }
      const localVarPath = `/photospheres/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists a photosphere\'s scan images used for stitching.
     * @summary List Scan Images for the Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresScanImages: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photospheresScanImages.'
        )
      }
      const localVarPath = `/photospheres/{id}/scan_images/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresUpdate: async (
      id: string,
      data: Photosphere,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling photospheresUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling photospheresUpdate.'
        )
      }
      const localVarPath = `/photospheres/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Shows listing of photosphere for a project.
     * @summary List Photospheres for a Project
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresList: async (
      projectId: string,
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsPhotospheresList.'
        )
      }
      const localVarPath = `/projects/{project_id}/photospheres/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (states !== undefined) {
        localVarQueryParameter['states'] = states
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresPartialUpdate: async (
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsPhotospheresPartialUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsPhotospheresPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsPhotospheresPartialUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/photospheres/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresUpdate: async (
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsPhotospheresUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsPhotospheresUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsPhotospheresUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/photospheres/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For viewing photospheres for the public
     * @summary Get Photosphere (Public)
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicPhotospheresRead: async (
      publicId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'publicId' is not null or undefined
      if (publicId === null || publicId === undefined) {
        throw new RequiredError(
          'publicId',
          'Required parameter publicId was null or undefined when calling publicPhotospheresRead.'
        )
      }
      const localVarPath = `/public_photospheres/{public_id}/`.replace(
        `{${'public_id'}}`,
        encodeURIComponent(String(publicId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Initiates a photosphere scan for this stream
     * @summary Make Stream Photosphere Scan
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsDemandPhotosphereScanCreate: async (
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsDemandPhotosphereScanCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/demand_photosphere_scan/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PhotospheresApi - functional programming interface
 * @export
 */
export const PhotospheresApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Notifies server that the drawing is uploaded.
     * @summary Confirm Drawing is Uploaded
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsConfirm(
      id: string,
      templateId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PhotosphereDrawing>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsConfirm(id, templateId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary Create Photosphere Drawing
     * @param {string} templateId
     * @param {CreatePhotosphereDrawingRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsCreate(
      templateId: string,
      data: CreatePhotosphereDrawingRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreatePhotosphereDrawingResponse>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsCreate(templateId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary Delete Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsDelete(
      id: string,
      templateId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsDelete(id, templateId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary List Photosphere Drawings
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsList(
      templateId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<PhotosphereDrawing>>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsList(templateId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsPartialUpdate(
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PhotosphereDrawing>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsPartialUpdate(id, templateId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary Get Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsRead(
      id: string,
      templateId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PhotosphereDrawing>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsRead(id, templateId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesDrawingsUpdate(
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PhotosphereDrawing>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesDrawingsUpdate(id, templateId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get information about a photosphere template.
     * @summary Get Photosphere Template
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photosphereTemplatesRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PhotosphereTemplate>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photosphereTemplatesRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary List Photospheres
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photospheresList(
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Photosphere>>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photospheresList(startTime, endTime, ordering, states, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photospheresPartialUpdate(
      id: string,
      data: Photosphere,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photospheresPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Get Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photospheresRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photospheresRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists a photosphere\'s scan images used for stitching.
     * @summary List Scan Images for the Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photospheresScanImages(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ScanImage>>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photospheresScanImages(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photospheresUpdate(
      id: string,
      data: Photosphere,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).photospheresUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Shows listing of photosphere for a project.
     * @summary List Photospheres for a Project
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPhotospheresList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Photosphere>>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).projectsPhotospheresList(
        projectId,
        startTime,
        endTime,
        ordering,
        states,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPhotospheresPartialUpdate(
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).projectsPhotospheresPartialUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPhotospheresUpdate(
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).projectsPhotospheresUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For viewing photospheres for the public
     * @summary Get Photosphere (Public)
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicPhotospheresRead(
      publicId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Photosphere>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).publicPhotospheresRead(publicId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Initiates a photosphere scan for this stream
     * @summary Make Stream Photosphere Scan
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsDemandPhotosphereScanCreate(
      streamId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await PhotospheresApiAxiosParamCreator(
        configuration
      ).streamsDemandPhotosphereScanCreate(streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PhotospheresApi - factory interface
 * @export
 */
export const PhotospheresApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Notifies server that the drawing is uploaded.
     * @summary Confirm Drawing is Uploaded
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsConfirm(
      id: string,
      templateId: string,
      options?: any
    ): AxiosPromise<PhotosphereDrawing> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsConfirm(id, templateId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary Create Photosphere Drawing
     * @param {string} templateId
     * @param {CreatePhotosphereDrawingRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsCreate(
      templateId: string,
      data: CreatePhotosphereDrawingRequest,
      options?: any
    ): AxiosPromise<CreatePhotosphereDrawingResponse> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsCreate(templateId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary Delete Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsDelete(
      id: string,
      templateId: string,
      options?: any
    ): AxiosPromise<void> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsDelete(id, templateId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary List Photosphere Drawings
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsList(
      templateId: string,
      options?: any
    ): AxiosPromise<Array<PhotosphereDrawing>> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsList(templateId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsPartialUpdate(
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options?: any
    ): AxiosPromise<PhotosphereDrawing> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsPartialUpdate(
          id,
          templateId,
          data,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary Get Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsRead(
      id: string,
      templateId: string,
      options?: any
    ): AxiosPromise<PhotosphereDrawing> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsRead(id, templateId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For manipulating drawings.
     * @summary Update Photosphere Drawing
     * @param {string} id
     * @param {string} templateId
     * @param {PhotosphereDrawing} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesDrawingsUpdate(
      id: string,
      templateId: string,
      data: PhotosphereDrawing,
      options?: any
    ): AxiosPromise<PhotosphereDrawing> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesDrawingsUpdate(id, templateId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get information about a photosphere template.
     * @summary Get Photosphere Template
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photosphereTemplatesRead(
      id: string,
      options?: any
    ): AxiosPromise<PhotosphereTemplate> {
      return PhotospheresApiFp(configuration)
        .photosphereTemplatesRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Root viewset for photospheres.
     * @summary List Photospheres
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresList(
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options?: any
    ): AxiosPromise<Array<Photosphere>> {
      return PhotospheresApiFp(configuration)
        .photospheresList(startTime, endTime, ordering, states, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresPartialUpdate(
      id: string,
      data: Photosphere,
      options?: any
    ): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .photospheresPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Root viewset for photospheres.
     * @summary Get Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresRead(id: string, options?: any): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .photospheresRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists a photosphere\'s scan images used for stitching.
     * @summary List Scan Images for the Photosphere
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresScanImages(
      id: string,
      options?: any
    ): AxiosPromise<Array<ScanImage>> {
      return PhotospheresApiFp(configuration)
        .photospheresScanImages(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Root viewset for photospheres.
     * @summary Update Photosphere
     * @param {string} id
     * @param {Photosphere} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photospheresUpdate(
      id: string,
      data: Photosphere,
      options?: any
    ): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .photospheresUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Shows listing of photosphere for a project.
     * @summary List Photospheres for a Project
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [ordering] Choices: [image_datetime, -image_datetime]. Default is image_datetime.
     * @param {string} [states] Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      ordering?: string,
      states?: string,
      options?: any
    ): AxiosPromise<Array<Photosphere>> {
      return PhotospheresApiFp(configuration)
        .projectsPhotospheresList(
          projectId,
          startTime,
          endTime,
          ordering,
          states,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresPartialUpdate(
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options?: any
    ): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .projectsPhotospheresPartialUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Limited photosphere update capability within a project
     * @summary Update Photosphere Within a Project
     * @param {string} id
     * @param {string} projectId
     * @param {PhotosphereUpdateByUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPhotospheresUpdate(
      id: string,
      projectId: string,
      data: PhotosphereUpdateByUser,
      options?: any
    ): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .projectsPhotospheresUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For viewing photospheres for the public
     * @summary Get Photosphere (Public)
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicPhotospheresRead(
      publicId: string,
      options?: any
    ): AxiosPromise<Photosphere> {
      return PhotospheresApiFp(configuration)
        .publicPhotospheresRead(publicId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Initiates a photosphere scan for this stream
     * @summary Make Stream Photosphere Scan
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsDemandPhotosphereScanCreate(
      streamId: string,
      options?: any
    ): AxiosPromise<void> {
      return PhotospheresApiFp(configuration)
        .streamsDemandPhotosphereScanCreate(streamId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for photosphereTemplatesDrawingsConfirm operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsConfirmRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsConfirmRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsConfirm
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsConfirm
   */
  readonly templateId: string
}

/**
 * Request parameters for photosphereTemplatesDrawingsCreate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsCreateRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsCreate
   */
  readonly templateId: string

  /**
   *
   * @type {CreatePhotosphereDrawingRequest}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsCreate
   */
  readonly data: CreatePhotosphereDrawingRequest
}

/**
 * Request parameters for photosphereTemplatesDrawingsDelete operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsDeleteRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsDelete
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsDelete
   */
  readonly templateId: string
}

/**
 * Request parameters for photosphereTemplatesDrawingsList operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsListRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsListRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsList
   */
  readonly templateId: string
}

/**
 * Request parameters for photosphereTemplatesDrawingsPartialUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdateRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdate
   */
  readonly templateId: string

  /**
   *
   * @type {PhotosphereDrawing}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdate
   */
  readonly data: PhotosphereDrawing
}

/**
 * Request parameters for photosphereTemplatesDrawingsRead operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsReadRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsReadRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsRead
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsRead
   */
  readonly templateId: string
}

/**
 * Request parameters for photosphereTemplatesDrawingsUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesDrawingsUpdateRequest
 */
export interface PhotospheresApiPhotosphereTemplatesDrawingsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsUpdate
   */
  readonly templateId: string

  /**
   *
   * @type {PhotosphereDrawing}
   * @memberof PhotospheresApiPhotosphereTemplatesDrawingsUpdate
   */
  readonly data: PhotosphereDrawing
}

/**
 * Request parameters for photosphereTemplatesRead operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotosphereTemplatesReadRequest
 */
export interface PhotospheresApiPhotosphereTemplatesReadRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotosphereTemplatesRead
   */
  readonly id: string
}

/**
 * Request parameters for photospheresList operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotospheresListRequest
 */
export interface PhotospheresApiPhotospheresListRequest {
  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PhotospheresApiPhotospheresList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PhotospheresApiPhotospheresList
   */
  readonly endTime?: string

  /**
   * Choices: [image_datetime, -image_datetime]. Default is image_datetime.
   * @type {string}
   * @memberof PhotospheresApiPhotospheresList
   */
  readonly ordering?: string

  /**
   * Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
   * @type {string}
   * @memberof PhotospheresApiPhotospheresList
   */
  readonly states?: string
}

/**
 * Request parameters for photospheresPartialUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotospheresPartialUpdateRequest
 */
export interface PhotospheresApiPhotospheresPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotospheresPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {Photosphere}
   * @memberof PhotospheresApiPhotospheresPartialUpdate
   */
  readonly data: Photosphere
}

/**
 * Request parameters for photospheresRead operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotospheresReadRequest
 */
export interface PhotospheresApiPhotospheresReadRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotospheresRead
   */
  readonly id: string
}

/**
 * Request parameters for photospheresScanImages operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotospheresScanImagesRequest
 */
export interface PhotospheresApiPhotospheresScanImagesRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotospheresScanImages
   */
  readonly id: string
}

/**
 * Request parameters for photospheresUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPhotospheresUpdateRequest
 */
export interface PhotospheresApiPhotospheresUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPhotospheresUpdate
   */
  readonly id: string

  /**
   *
   * @type {Photosphere}
   * @memberof PhotospheresApiPhotospheresUpdate
   */
  readonly data: Photosphere
}

/**
 * Request parameters for projectsPhotospheresList operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiProjectsPhotospheresListRequest
 */
export interface PhotospheresApiProjectsPhotospheresListRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresList
   */
  readonly projectId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresList
   */
  readonly endTime?: string

  /**
   * Choices: [image_datetime, -image_datetime]. Default is image_datetime.
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresList
   */
  readonly ordering?: string

  /**
   * Multiple values may be separated by commas.  Choices: [scanning, acquired, stitching, stitched, approved, rejected, makepano, projection, completed, failed]
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresList
   */
  readonly states?: string
}

/**
 * Request parameters for projectsPhotospheresPartialUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiProjectsPhotospheresPartialUpdateRequest
 */
export interface PhotospheresApiProjectsPhotospheresPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresPartialUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {PhotosphereUpdateByUser}
   * @memberof PhotospheresApiProjectsPhotospheresPartialUpdate
   */
  readonly data: PhotosphereUpdateByUser
}

/**
 * Request parameters for projectsPhotospheresUpdate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiProjectsPhotospheresUpdateRequest
 */
export interface PhotospheresApiProjectsPhotospheresUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof PhotospheresApiProjectsPhotospheresUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {PhotosphereUpdateByUser}
   * @memberof PhotospheresApiProjectsPhotospheresUpdate
   */
  readonly data: PhotosphereUpdateByUser
}

/**
 * Request parameters for publicPhotospheresRead operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiPublicPhotospheresReadRequest
 */
export interface PhotospheresApiPublicPhotospheresReadRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiPublicPhotospheresRead
   */
  readonly publicId: string
}

/**
 * Request parameters for streamsDemandPhotosphereScanCreate operation in PhotospheresApi.
 * @export
 * @interface PhotospheresApiStreamsDemandPhotosphereScanCreateRequest
 */
export interface PhotospheresApiStreamsDemandPhotosphereScanCreateRequest {
  /**
   *
   * @type {string}
   * @memberof PhotospheresApiStreamsDemandPhotosphereScanCreate
   */
  readonly streamId: string
}

/**
 * PhotospheresApi - object-oriented interface
 * @export
 * @class PhotospheresApi
 * @extends {BaseAPI}
 */
export class PhotospheresApi extends BaseAPI {
  /**
   * Notifies server that the drawing is uploaded.
   * @summary Confirm Drawing is Uploaded
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsConfirmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsConfirm(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsConfirmRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsConfirm(
        requestParameters.id,
        requestParameters.templateId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary Create Photosphere Drawing
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsCreate(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsCreateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsCreate(
        requestParameters.templateId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary Delete Photosphere Drawing
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsDelete(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsDeleteRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsDelete(
        requestParameters.id,
        requestParameters.templateId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary List Photosphere Drawings
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsList(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsListRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsList(requestParameters.templateId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary Update Photosphere Drawing
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsPartialUpdate(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsPartialUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsPartialUpdate(
        requestParameters.id,
        requestParameters.templateId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary Get Photosphere Drawing
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsRead(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsReadRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsRead(
        requestParameters.id,
        requestParameters.templateId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For manipulating drawings.
   * @summary Update Photosphere Drawing
   * @param {PhotospheresApiPhotosphereTemplatesDrawingsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesDrawingsUpdate(
    requestParameters: PhotospheresApiPhotosphereTemplatesDrawingsUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesDrawingsUpdate(
        requestParameters.id,
        requestParameters.templateId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get information about a photosphere template.
   * @summary Get Photosphere Template
   * @param {PhotospheresApiPhotosphereTemplatesReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photosphereTemplatesRead(
    requestParameters: PhotospheresApiPhotosphereTemplatesReadRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photosphereTemplatesRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Root viewset for photospheres.
   * @summary List Photospheres
   * @param {PhotospheresApiPhotospheresListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photospheresList(
    requestParameters: PhotospheresApiPhotospheresListRequest = {},
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photospheresList(
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.ordering,
        requestParameters.states,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Root viewset for photospheres.
   * @summary Update Photosphere
   * @param {PhotospheresApiPhotospheresPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photospheresPartialUpdate(
    requestParameters: PhotospheresApiPhotospheresPartialUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photospheresPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Root viewset for photospheres.
   * @summary Get Photosphere
   * @param {PhotospheresApiPhotospheresReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photospheresRead(
    requestParameters: PhotospheresApiPhotospheresReadRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photospheresRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists a photosphere\'s scan images used for stitching.
   * @summary List Scan Images for the Photosphere
   * @param {PhotospheresApiPhotospheresScanImagesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photospheresScanImages(
    requestParameters: PhotospheresApiPhotospheresScanImagesRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photospheresScanImages(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Root viewset for photospheres.
   * @summary Update Photosphere
   * @param {PhotospheresApiPhotospheresUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public photospheresUpdate(
    requestParameters: PhotospheresApiPhotospheresUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .photospheresUpdate(requestParameters.id, requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Shows listing of photosphere for a project.
   * @summary List Photospheres for a Project
   * @param {PhotospheresApiProjectsPhotospheresListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public projectsPhotospheresList(
    requestParameters: PhotospheresApiProjectsPhotospheresListRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .projectsPhotospheresList(
        requestParameters.projectId,
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.ordering,
        requestParameters.states,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Limited photosphere update capability within a project
   * @summary Update Photosphere Within a Project
   * @param {PhotospheresApiProjectsPhotospheresPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public projectsPhotospheresPartialUpdate(
    requestParameters: PhotospheresApiProjectsPhotospheresPartialUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .projectsPhotospheresPartialUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Limited photosphere update capability within a project
   * @summary Update Photosphere Within a Project
   * @param {PhotospheresApiProjectsPhotospheresUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public projectsPhotospheresUpdate(
    requestParameters: PhotospheresApiProjectsPhotospheresUpdateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .projectsPhotospheresUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For viewing photospheres for the public
   * @summary Get Photosphere (Public)
   * @param {PhotospheresApiPublicPhotospheresReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public publicPhotospheresRead(
    requestParameters: PhotospheresApiPublicPhotospheresReadRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .publicPhotospheresRead(requestParameters.publicId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Initiates a photosphere scan for this stream
   * @summary Make Stream Photosphere Scan
   * @param {PhotospheresApiStreamsDemandPhotosphereScanCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotospheresApi
   */
  public streamsDemandPhotosphereScanCreate(
    requestParameters: PhotospheresApiStreamsDemandPhotosphereScanCreateRequest,
    options?: any
  ) {
    return PhotospheresApiFp(this.configuration)
      .streamsDemandPhotosphereScanCreate(requestParameters.streamId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectMapsApi - axios parameter creator
 * @export
 */
export const ProjectMapsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Lists maps for a project. Only shows processed and enabled maps.
     * @summary List Maps for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMapdaysList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsMapdaysList.'
        )
      }
      const localVarPath = `/projects/{project_id}/mapdays/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Shows Details for a map, including the URLS.
     * @summary Show Map for a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMapdaysRead: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsMapdaysRead.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsMapdaysRead.'
        )
      }
      const localVarPath = `/projects/{project_id}/mapdays/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProjectMapsApi - functional programming interface
 * @export
 */
export const ProjectMapsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Lists maps for a project. Only shows processed and enabled maps.
     * @summary List Maps for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsMapdaysList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<MapSummary>>
    > {
      const localVarAxiosArgs = await ProjectMapsApiAxiosParamCreator(
        configuration
      ).projectsMapdaysList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Shows Details for a map, including the URLS.
     * @summary Show Map for a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsMapdaysRead(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MapDetailsSerialzer>
    > {
      const localVarAxiosArgs = await ProjectMapsApiAxiosParamCreator(
        configuration
      ).projectsMapdaysRead(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProjectMapsApi - factory interface
 * @export
 */
export const ProjectMapsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Lists maps for a project. Only shows processed and enabled maps.
     * @summary List Maps for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMapdaysList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<MapSummary>> {
      return ProjectMapsApiFp(configuration)
        .projectsMapdaysList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Shows Details for a map, including the URLS.
     * @summary Show Map for a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMapdaysRead(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<MapDetailsSerialzer> {
      return ProjectMapsApiFp(configuration)
        .projectsMapdaysRead(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsMapdaysList operation in ProjectMapsApi.
 * @export
 * @interface ProjectMapsApiProjectsMapdaysListRequest
 */
export interface ProjectMapsApiProjectsMapdaysListRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectMapsApiProjectsMapdaysList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsMapdaysRead operation in ProjectMapsApi.
 * @export
 * @interface ProjectMapsApiProjectsMapdaysReadRequest
 */
export interface ProjectMapsApiProjectsMapdaysReadRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectMapsApiProjectsMapdaysRead
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof ProjectMapsApiProjectsMapdaysRead
   */
  readonly projectId: string
}

/**
 * ProjectMapsApi - object-oriented interface
 * @export
 * @class ProjectMapsApi
 * @extends {BaseAPI}
 */
export class ProjectMapsApi extends BaseAPI {
  /**
   * Lists maps for a project. Only shows processed and enabled maps.
   * @summary List Maps for a Project
   * @param {ProjectMapsApiProjectsMapdaysListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectMapsApi
   */
  public projectsMapdaysList(
    requestParameters: ProjectMapsApiProjectsMapdaysListRequest,
    options?: any
  ) {
    return ProjectMapsApiFp(this.configuration)
      .projectsMapdaysList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Shows Details for a map, including the URLS.
   * @summary Show Map for a Project
   * @param {ProjectMapsApiProjectsMapdaysReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectMapsApi
   */
  public projectsMapdaysRead(
    requestParameters: ProjectMapsApiProjectsMapdaysReadRequest,
    options?: any
  ) {
    return ProjectMapsApiFp(this.configuration)
      .projectsMapdaysRead(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectSubcontractorsApi - axios parameter creator
 * @export
 */
export const ProjectSubcontractorsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for listing project subcontractors
     * @summary List Project Subcontractors
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSubcontractorsList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSubcontractorsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/subcontractors/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProjectSubcontractorsApi - functional programming interface
 * @export
 */
export const ProjectSubcontractorsApiFp = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for listing project subcontractors
     * @summary List Project Subcontractors
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSubcontractorsList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Subcontractor>>
    > {
      const localVarAxiosArgs = await ProjectSubcontractorsApiAxiosParamCreator(
        configuration
      ).projectsSubcontractorsList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProjectSubcontractorsApi - factory interface
 * @export
 */
export const ProjectSubcontractorsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for listing project subcontractors
     * @summary List Project Subcontractors
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSubcontractorsList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<Subcontractor>> {
      return ProjectSubcontractorsApiFp(configuration)
        .projectsSubcontractorsList(projectId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsSubcontractorsList operation in ProjectSubcontractorsApi.
 * @export
 * @interface ProjectSubcontractorsApiProjectsSubcontractorsListRequest
 */
export interface ProjectSubcontractorsApiProjectsSubcontractorsListRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectSubcontractorsApiProjectsSubcontractorsList
   */
  readonly projectId: string
}

/**
 * ProjectSubcontractorsApi - object-oriented interface
 * @export
 * @class ProjectSubcontractorsApi
 * @extends {BaseAPI}
 */
export class ProjectSubcontractorsApi extends BaseAPI {
  /**
   * Viewset for listing project subcontractors
   * @summary List Project Subcontractors
   * @param {ProjectSubcontractorsApiProjectsSubcontractorsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectSubcontractorsApi
   */
  public projectsSubcontractorsList(
    requestParameters: ProjectSubcontractorsApiProjectsSubcontractorsListRequest,
    options?: any
  ) {
    return ProjectSubcontractorsApiFp(this.configuration)
      .projectsSubcontractorsList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectUsersApi - axios parameter creator
 * @export
 */
export const ProjectUsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Adds a list of users to a project.
     * @summary Adds Users To Project By Email
     * @param {string} projectId
     * @param {ProjectUserViaEmail} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersAddUsersByEmail: async (
      projectId: string,
      data: ProjectUserViaEmail,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersAddUsersByEmail.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUsersAddUsersByEmail.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/add_users_by_email/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Removes a user from a project  This does not delete a user from the system.
     * @summary Remove User from Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersDelete: async (
      projectId: string,
      userId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersDelete.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling projectsUsersDelete.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/{user__id}/`
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
        .replace(`{${'user__id'}}`, encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists all users in a project.
     * @summary List Users of a Project
     * @param {string} projectId
     * @param {string} [ordering] Choices: [user__email, -user__email]. Default is user__email.
     * @param {string} [contactEligible] If given &#x60;true&#x60;, will only include users that can be addedas contacts for security
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersList: async (
      projectId: string,
      ordering?: string,
      contactEligible?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersList.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (contactEligible !== undefined) {
        localVarQueryParameter['contact_eligible'] = contactEligible
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersPartialUpdate: async (
      projectId: string,
      userId: string,
      data: ProjectUser,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersPartialUpdate.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling projectsUsersPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUsersPartialUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/{user__id}/`
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
        .replace(`{${'user__id'}}`, encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Describes one user in a project.
     * @summary Get User of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersRead: async (
      projectId: string,
      userId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersRead.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling projectsUsersRead.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/{user__id}/`
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
        .replace(`{${'user__id'}}`, encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Set password for a user.
     * @summary Set User Password
     * @param {string} projectId
     * @param {string} userId
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersSetPassword: async (
      projectId: string,
      userId: string,
      data: PasswordReset,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersSetPassword.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling projectsUsersSetPassword.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUsersSetPassword.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/{user__id}/set_password/`
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
        .replace(`{${'user__id'}}`, encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersUpdate: async (
      projectId: string,
      userId: string,
      data: ProjectUser,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUsersUpdate.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling projectsUsersUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUsersUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/users/{user__id}/`
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
        .replace(`{${'user__id'}}`, encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProjectUsersApi - functional programming interface
 * @export
 */
export const ProjectUsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Adds a list of users to a project.
     * @summary Adds Users To Project By Email
     * @param {string} projectId
     * @param {ProjectUserViaEmail} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersAddUsersByEmail(
      projectId: string,
      data: ProjectUserViaEmail,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ProjectUser>>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersAddUsersByEmail(projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Removes a user from a project  This does not delete a user from the system.
     * @summary Remove User from Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersDelete(
      projectId: string,
      userId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersDelete(projectId, userId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists all users in a project.
     * @summary List Users of a Project
     * @param {string} projectId
     * @param {string} [ordering] Choices: [user__email, -user__email]. Default is user__email.
     * @param {string} [contactEligible] If given &#x60;true&#x60;, will only include users that can be addedas contacts for security
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersList(
      projectId: string,
      ordering?: string,
      contactEligible?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ProjectUser>>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersList(projectId, ordering, contactEligible, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersPartialUpdate(
      projectId: string,
      userId: string,
      data: ProjectUser,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUser>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersPartialUpdate(projectId, userId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Describes one user in a project.
     * @summary Get User of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersRead(
      projectId: string,
      userId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUser>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersRead(projectId, userId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Set password for a user.
     * @summary Set User Password
     * @param {string} projectId
     * @param {string} userId
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersSetPassword(
      projectId: string,
      userId: string,
      data: PasswordReset,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersSetPassword(projectId, userId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUsersUpdate(
      projectId: string,
      userId: string,
      data: ProjectUser,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUser>
    > {
      const localVarAxiosArgs = await ProjectUsersApiAxiosParamCreator(
        configuration
      ).projectsUsersUpdate(projectId, userId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProjectUsersApi - factory interface
 * @export
 */
export const ProjectUsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Adds a list of users to a project.
     * @summary Adds Users To Project By Email
     * @param {string} projectId
     * @param {ProjectUserViaEmail} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersAddUsersByEmail(
      projectId: string,
      data: ProjectUserViaEmail,
      options?: any
    ): AxiosPromise<Array<ProjectUser>> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersAddUsersByEmail(projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Removes a user from a project  This does not delete a user from the system.
     * @summary Remove User from Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersDelete(
      projectId: string,
      userId: string,
      options?: any
    ): AxiosPromise<void> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersDelete(projectId, userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists all users in a project.
     * @summary List Users of a Project
     * @param {string} projectId
     * @param {string} [ordering] Choices: [user__email, -user__email]. Default is user__email.
     * @param {string} [contactEligible] If given &#x60;true&#x60;, will only include users that can be addedas contacts for security
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersList(
      projectId: string,
      ordering?: string,
      contactEligible?: string,
      options?: any
    ): AxiosPromise<Array<ProjectUser>> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersList(projectId, ordering, contactEligible, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersPartialUpdate(
      projectId: string,
      userId: string,
      data: ProjectUser,
      options?: any
    ): AxiosPromise<ProjectUser> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersPartialUpdate(projectId, userId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Describes one user in a project.
     * @summary Get User of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersRead(
      projectId: string,
      userId: string,
      options?: any
    ): AxiosPromise<ProjectUser> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersRead(projectId, userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Set password for a user.
     * @summary Set User Password
     * @param {string} projectId
     * @param {string} userId
     * @param {PasswordReset} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersSetPassword(
      projectId: string,
      userId: string,
      data: PasswordReset,
      options?: any
    ): AxiosPromise<void> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersSetPassword(projectId, userId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
     * @summary Update User\'s Role of a Project
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectUser} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUsersUpdate(
      projectId: string,
      userId: string,
      data: ProjectUser,
      options?: any
    ): AxiosPromise<ProjectUser> {
      return ProjectUsersApiFp(configuration)
        .projectsUsersUpdate(projectId, userId, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsUsersAddUsersByEmail operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersAddUsersByEmailRequest
 */
export interface ProjectUsersApiProjectsUsersAddUsersByEmailRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersAddUsersByEmail
   */
  readonly projectId: string

  /**
   *
   * @type {ProjectUserViaEmail}
   * @memberof ProjectUsersApiProjectsUsersAddUsersByEmail
   */
  readonly data: ProjectUserViaEmail
}

/**
 * Request parameters for projectsUsersDelete operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersDeleteRequest
 */
export interface ProjectUsersApiProjectsUsersDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersDelete
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersDelete
   */
  readonly userId: string
}

/**
 * Request parameters for projectsUsersList operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersListRequest
 */
export interface ProjectUsersApiProjectsUsersListRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersList
   */
  readonly projectId: string

  /**
   * Choices: [user__email, -user__email]. Default is user__email.
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersList
   */
  readonly ordering?: string

  /**
   * If given &#x60;true&#x60;, will only include users that can be addedas contacts for security
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersList
   */
  readonly contactEligible?: string
}

/**
 * Request parameters for projectsUsersPartialUpdate operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersPartialUpdateRequest
 */
export interface ProjectUsersApiProjectsUsersPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersPartialUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersPartialUpdate
   */
  readonly userId: string

  /**
   *
   * @type {ProjectUser}
   * @memberof ProjectUsersApiProjectsUsersPartialUpdate
   */
  readonly data: ProjectUser
}

/**
 * Request parameters for projectsUsersRead operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersReadRequest
 */
export interface ProjectUsersApiProjectsUsersReadRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersRead
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersRead
   */
  readonly userId: string
}

/**
 * Request parameters for projectsUsersSetPassword operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersSetPasswordRequest
 */
export interface ProjectUsersApiProjectsUsersSetPasswordRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersSetPassword
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersSetPassword
   */
  readonly userId: string

  /**
   *
   * @type {PasswordReset}
   * @memberof ProjectUsersApiProjectsUsersSetPassword
   */
  readonly data: PasswordReset
}

/**
 * Request parameters for projectsUsersUpdate operation in ProjectUsersApi.
 * @export
 * @interface ProjectUsersApiProjectsUsersUpdateRequest
 */
export interface ProjectUsersApiProjectsUsersUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof ProjectUsersApiProjectsUsersUpdate
   */
  readonly userId: string

  /**
   *
   * @type {ProjectUser}
   * @memberof ProjectUsersApiProjectsUsersUpdate
   */
  readonly data: ProjectUser
}

/**
 * ProjectUsersApi - object-oriented interface
 * @export
 * @class ProjectUsersApi
 * @extends {BaseAPI}
 */
export class ProjectUsersApi extends BaseAPI {
  /**
   * Adds a list of users to a project.
   * @summary Adds Users To Project By Email
   * @param {ProjectUsersApiProjectsUsersAddUsersByEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersAddUsersByEmail(
    requestParameters: ProjectUsersApiProjectsUsersAddUsersByEmailRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersAddUsersByEmail(
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Removes a user from a project  This does not delete a user from the system.
   * @summary Remove User from Project
   * @param {ProjectUsersApiProjectsUsersDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersDelete(
    requestParameters: ProjectUsersApiProjectsUsersDeleteRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersDelete(
        requestParameters.projectId,
        requestParameters.userId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists all users in a project.
   * @summary List Users of a Project
   * @param {ProjectUsersApiProjectsUsersListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersList(
    requestParameters: ProjectUsersApiProjectsUsersListRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersList(
        requestParameters.projectId,
        requestParameters.ordering,
        requestParameters.contactEligible,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
   * @summary Update User\'s Role of a Project
   * @param {ProjectUsersApiProjectsUsersPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersPartialUpdate(
    requestParameters: ProjectUsersApiProjectsUsersPartialUpdateRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersPartialUpdate(
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Describes one user in a project.
   * @summary Get User of a Project
   * @param {ProjectUsersApiProjectsUsersReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersRead(
    requestParameters: ProjectUsersApiProjectsUsersReadRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersRead(
        requestParameters.projectId,
        requestParameters.userId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Set password for a user.
   * @summary Set User Password
   * @param {ProjectUsersApiProjectsUsersSetPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersSetPassword(
    requestParameters: ProjectUsersApiProjectsUsersSetPasswordRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersSetPassword(
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update certain fields of a user\'s role in a project.  Note that there is a user payload.  This is not editable due to a bug in schema generation.
   * @summary Update User\'s Role of a Project
   * @param {ProjectUsersApiProjectsUsersUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectUsersApi
   */
  public projectsUsersUpdate(
    requestParameters: ProjectUsersApiProjectsUsersUpdateRequest,
    options?: any
  ) {
    return ProjectUsersApiFp(this.configuration)
      .projectsUsersUpdate(
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for showing crane project config
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCraneProjectConfigsRead: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsCraneProjectConfigsRead.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsCraneProjectConfigsRead.'
        )
      }
      const localVarPath = `/projects/{project_id}/crane_project_configs/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Create a new project.
     * @summary Project Create
     * @param {ProjectCreate} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCreate: async (
      data: ProjectCreate,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsCreate.'
        )
      }
      const localVarPath = `/projects/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List and show projects for the authenticated user.  Order returned is by name.
     * @summary Project List
     * @param {string} [slug]
     * @param {string} [legacyId]
     * @param {string} [ordering] Supports name, legacy_id, slug
     * @param {string} [annotation] If given &#x60;true&#x60;, will only include projects with annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsList: async (
      slug?: string,
      legacyId?: string,
      ordering?: string,
      annotation?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/projects/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (slug !== undefined) {
        localVarQueryParameter['slug'] = slug
      }

      if (legacyId !== undefined) {
        localVarQueryParameter['legacy_id'] = legacyId
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      if (annotation !== undefined) {
        localVarQueryParameter['annotation'] = annotation
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPartialUpdate: async (
      id: string,
      data: ProjectUpdateRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsPartialUpdate.'
        )
      }
      const localVarPath = `/projects/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Shows information about a single product.  Includes stream information.
     * @summary Project Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsRead.'
        )
      }
      const localVarPath = `/projects/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Sets a cookie for authentication with Grafana.
     * @summary Set Grafana Proxy User Cookie
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSetupGrafana: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSetupGrafana.'
        )
      }
      const localVarPath = `/projects/{id}/setup_grafana/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUpdate: async (
      id: string,
      data: ProjectUpdateRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUpdate.'
        )
      }
      const localVarPath = `/projects/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for showing crane project config
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsCraneProjectConfigsRead(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectConfig>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsCraneProjectConfigsRead(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Create a new project.
     * @summary Project Create
     * @param {ProjectCreate} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsCreate(
      data: ProjectCreate,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSummary>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List and show projects for the authenticated user.  Order returned is by name.
     * @summary Project List
     * @param {string} [slug]
     * @param {string} [legacyId]
     * @param {string} [ordering] Supports name, legacy_id, slug
     * @param {string} [annotation] If given &#x60;true&#x60;, will only include projects with annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsList(
      slug?: string,
      legacyId?: string,
      ordering?: string,
      annotation?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ProjectSummary>>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsList(slug, legacyId, ordering, annotation, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPartialUpdate(
      id: string,
      data: ProjectUpdateRequest,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetails>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Shows information about a single product.  Includes stream information.
     * @summary Project Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetails>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sets a cookie for authentication with Grafana.
     * @summary Set Grafana Proxy User Cookie
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSetupGrafana(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsSetupGrafana(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUpdate(
      id: string,
      data: ProjectUpdateRequest,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetails>
    > {
      const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(
        configuration
      ).projectsUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for showing crane project config
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCraneProjectConfigsRead(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<ProjectConfig> {
      return ProjectsApiFp(configuration)
        .projectsCraneProjectConfigsRead(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new project.
     * @summary Project Create
     * @param {ProjectCreate} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCreate(
      data: ProjectCreate,
      options?: any
    ): AxiosPromise<ProjectSummary> {
      return ProjectsApiFp(configuration)
        .projectsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List and show projects for the authenticated user.  Order returned is by name.
     * @summary Project List
     * @param {string} [slug]
     * @param {string} [legacyId]
     * @param {string} [ordering] Supports name, legacy_id, slug
     * @param {string} [annotation] If given &#x60;true&#x60;, will only include projects with annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsList(
      slug?: string,
      legacyId?: string,
      ordering?: string,
      annotation?: string,
      options?: any
    ): AxiosPromise<Array<ProjectSummary>> {
      return ProjectsApiFp(configuration)
        .projectsList(slug, legacyId, ordering, annotation, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPartialUpdate(
      id: string,
      data: ProjectUpdateRequest,
      options?: any
    ): AxiosPromise<ProjectDetails> {
      return ProjectsApiFp(configuration)
        .projectsPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Shows information about a single product.  Includes stream information.
     * @summary Project Details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRead(id: string, options?: any): AxiosPromise<ProjectDetails> {
      return ProjectsApiFp(configuration)
        .projectsRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sets a cookie for authentication with Grafana.
     * @summary Set Grafana Proxy User Cookie
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSetupGrafana(id: string, options?: any): AxiosPromise<void> {
      return ProjectsApiFp(configuration)
        .projectsSetupGrafana(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update a single project.  Can only update mapping annotations.
     * @summary Project Update
     * @param {string} id
     * @param {ProjectUpdateRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUpdate(
      id: string,
      data: ProjectUpdateRequest,
      options?: any
    ): AxiosPromise<ProjectDetails> {
      return ProjectsApiFp(configuration)
        .projectsUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsCraneProjectConfigsRead operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsCraneProjectConfigsReadRequest
 */
export interface ProjectsApiProjectsCraneProjectConfigsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsCraneProjectConfigsRead
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsCraneProjectConfigsRead
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsCreate operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsCreateRequest
 */
export interface ProjectsApiProjectsCreateRequest {
  /**
   *
   * @type {ProjectCreate}
   * @memberof ProjectsApiProjectsCreate
   */
  readonly data: ProjectCreate
}

/**
 * Request parameters for projectsList operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsListRequest
 */
export interface ProjectsApiProjectsListRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsList
   */
  readonly slug?: string

  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsList
   */
  readonly legacyId?: string

  /**
   * Supports name, legacy_id, slug
   * @type {string}
   * @memberof ProjectsApiProjectsList
   */
  readonly ordering?: string

  /**
   * If given &#x60;true&#x60;, will only include projects with annotation
   * @type {string}
   * @memberof ProjectsApiProjectsList
   */
  readonly annotation?: string
}

/**
 * Request parameters for projectsPartialUpdate operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsPartialUpdateRequest
 */
export interface ProjectsApiProjectsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {ProjectUpdateRequest}
   * @memberof ProjectsApiProjectsPartialUpdate
   */
  readonly data: ProjectUpdateRequest
}

/**
 * Request parameters for projectsRead operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsReadRequest
 */
export interface ProjectsApiProjectsReadRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsRead
   */
  readonly id: string
}

/**
 * Request parameters for projectsSetupGrafana operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsSetupGrafanaRequest
 */
export interface ProjectsApiProjectsSetupGrafanaRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsSetupGrafana
   */
  readonly id: string
}

/**
 * Request parameters for projectsUpdate operation in ProjectsApi.
 * @export
 * @interface ProjectsApiProjectsUpdateRequest
 */
export interface ProjectsApiProjectsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ProjectsApiProjectsUpdate
   */
  readonly id: string

  /**
   *
   * @type {ProjectUpdateRequest}
   * @memberof ProjectsApiProjectsUpdate
   */
  readonly data: ProjectUpdateRequest
}

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
  /**
   * Viewset for showing crane project config
   * @param {ProjectsApiProjectsCraneProjectConfigsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsCraneProjectConfigsRead(
    requestParameters: ProjectsApiProjectsCraneProjectConfigsReadRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsCraneProjectConfigsRead(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new project.
   * @summary Project Create
   * @param {ProjectsApiProjectsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsCreate(
    requestParameters: ProjectsApiProjectsCreateRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List and show projects for the authenticated user.  Order returned is by name.
   * @summary Project List
   * @param {ProjectsApiProjectsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsList(
    requestParameters: ProjectsApiProjectsListRequest = {},
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsList(
        requestParameters.slug,
        requestParameters.legacyId,
        requestParameters.ordering,
        requestParameters.annotation,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update a single project.  Can only update mapping annotations.
   * @summary Project Update
   * @param {ProjectsApiProjectsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsPartialUpdate(
    requestParameters: ProjectsApiProjectsPartialUpdateRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Shows information about a single product.  Includes stream information.
   * @summary Project Details
   * @param {ProjectsApiProjectsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsRead(
    requestParameters: ProjectsApiProjectsReadRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sets a cookie for authentication with Grafana.
   * @summary Set Grafana Proxy User Cookie
   * @param {ProjectsApiProjectsSetupGrafanaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsSetupGrafana(
    requestParameters: ProjectsApiProjectsSetupGrafanaRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsSetupGrafana(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update a single project.  Can only update mapping annotations.
   * @summary Project Update
   * @param {ProjectsApiProjectsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsUpdate(
    requestParameters: ProjectsApiProjectsUpdateRequest,
    options?: any
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsUpdate(requestParameters.id, requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PublicProjectApi - axios parameter creator
 * @export
 */
export const PublicProjectApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Set of public project views
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicProjectsRead: async (
      slug: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          'slug',
          'Required parameter slug was null or undefined when calling publicProjectsRead.'
        )
      }
      const localVarPath = `/public_projects/{slug}/`.replace(
        `{${'slug'}}`,
        encodeURIComponent(String(slug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PublicProjectApi - functional programming interface
 * @export
 */
export const PublicProjectApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Set of public project views
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicProjectsRead(
      slug: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicProject>
    > {
      const localVarAxiosArgs = await PublicProjectApiAxiosParamCreator(
        configuration
      ).publicProjectsRead(slug, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PublicProjectApi - factory interface
 * @export
 */
export const PublicProjectApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Set of public project views
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicProjectsRead(
      slug: string,
      options?: any
    ): AxiosPromise<PublicProject> {
      return PublicProjectApiFp(configuration)
        .publicProjectsRead(slug, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for publicProjectsRead operation in PublicProjectApi.
 * @export
 * @interface PublicProjectApiPublicProjectsReadRequest
 */
export interface PublicProjectApiPublicProjectsReadRequest {
  /**
   *
   * @type {string}
   * @memberof PublicProjectApiPublicProjectsRead
   */
  readonly slug: string
}

/**
 * PublicProjectApi - object-oriented interface
 * @export
 * @class PublicProjectApi
 * @extends {BaseAPI}
 */
export class PublicProjectApi extends BaseAPI {
  /**
   * Set of public project views
   * @param {PublicProjectApiPublicProjectsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicProjectApi
   */
  public publicProjectsRead(
    requestParameters: PublicProjectApiPublicProjectsReadRequest,
    options?: any
  ) {
    return PublicProjectApiFp(this.configuration)
      .publicProjectsRead(requestParameters.slug, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * List and show roles in this system
     * @summary Role List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rolesList: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/roles/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * List and show roles in this system
     * @summary Role List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rolesList(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Role>>
    > {
      const localVarAxiosArgs = await RolesApiAxiosParamCreator(
        configuration
      ).rolesList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * List and show roles in this system
     * @summary Role List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rolesList(options?: any): AxiosPromise<Array<Role>> {
      return RolesApiFp(configuration)
        .rolesList(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
  /**
   * List and show roles in this system
   * @summary Role List
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public rolesList(options?: any) {
    return RolesApiFp(this.configuration)
      .rolesList(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * History of arm/disarmings
     * @summary List Arming Logs
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityArmlogList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityArmlogList.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/armlog/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Add a Contact
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsCreate: async (
      projectId: string,
      data: AlarmContact,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsSecurityContactsCreate.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Delete Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsDelete: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSecurityContactsDelete.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsDelete.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary List Contacts
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsPartialUpdate: async (
      id: string,
      projectId: string,
      data: AlarmContact,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSecurityContactsPartialUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsSecurityContactsPartialUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Retrieve a Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsRead: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSecurityContactsRead.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsRead.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsUpdate: async (
      id: string,
      projectId: string,
      data: AlarmContact,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSecurityContactsUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityContactsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsSecurityContactsUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/contacts/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Cancel the alarm.
     * @summary Cancel Alarm on Event
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityEventsCancelAlarm: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsSecurityEventsCancelAlarm.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityEventsCancelAlarm.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/events/{id}/cancel_alarm/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Events from the camera that caused alarms
     * @summary List Security Events
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityEventsList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityEventsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/events/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Disable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleDisableNextEvent: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleDisableNextEvent.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/disable_next_event/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Enable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleEnableNextEvent: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleEnableNextEvent.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/enable_next_event/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Show history of schedule updates
     * @summary Get Schedule Update History
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleHistory: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleHistory.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/history/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Schedule items
     * @summary List Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleList.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Show surrounding schedule.
     * @summary Get Surrounding Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleSurroundingSchedule: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleSurroundingSchedule.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/surrounding_schedule/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Update the whole schedule
     * @summary Update Schedule
     * @param {string} projectId
     * @param {Array<ArmingScheduleItem>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleUpdateAll: async (
      projectId: string,
      data: Array<ArmingScheduleItem>,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsSecurityScheduleUpdateAll.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsSecurityScheduleUpdateAll.'
        )
      }
      const localVarPath = `/projects/{project_id}/security/schedule/update_all/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function (configuration?: Configuration) {
  return {
    /**
     * History of arm/disarmings
     * @summary List Arming Logs
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityArmlogList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ArmingEvent>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityArmlogList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Add a Contact
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsCreate(
      projectId: string,
      data: AlarmContact,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlarmContact>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsCreate(projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Delete Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsDelete(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsDelete(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary List Contacts
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<AlarmContact>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsPartialUpdate(
      id: string,
      projectId: string,
      data: AlarmContact,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlarmContact>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsPartialUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Retrieve a Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsRead(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlarmContact>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsRead(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityContactsUpdate(
      id: string,
      projectId: string,
      data: AlarmContact,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlarmContact>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityContactsUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Cancel the alarm.
     * @summary Cancel Alarm on Event
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityEventsCancelAlarm(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityEventsCancelAlarm(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Events from the camera that caused alarms
     * @summary List Security Events
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityEventsList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CamEvent>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityEventsList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Disable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleDisableNextEvent(
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleDisableNextEvent(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Enable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleEnableNextEvent(
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleEnableNextEvent(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Show history of schedule updates
     * @summary Get Schedule Update History
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleHistory(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ArmingScheduleUpdate>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleHistory(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Schedule items
     * @summary List Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleList(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ArmingScheduleItem>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Show surrounding schedule.
     * @summary Get Surrounding Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleSurroundingSchedule(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SurroundingArmSchedule>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleSurroundingSchedule(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update the whole schedule
     * @summary Update Schedule
     * @param {string} projectId
     * @param {Array<ArmingScheduleItem>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSecurityScheduleUpdateAll(
      projectId: string,
      data: Array<ArmingScheduleItem>,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ArmingScheduleItem>>
    > {
      const localVarAxiosArgs = await SecurityApiAxiosParamCreator(
        configuration
      ).projectsSecurityScheduleUpdateAll(projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * History of arm/disarmings
     * @summary List Arming Logs
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityArmlogList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<ArmingEvent>> {
      return SecurityApiFp(configuration)
        .projectsSecurityArmlogList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary Add a Contact
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsCreate(
      projectId: string,
      data: AlarmContact,
      options?: any
    ): AxiosPromise<AlarmContact> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsCreate(projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary Delete Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsDelete(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<void> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsDelete(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary List Contacts
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<AlarmContact>> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsPartialUpdate(
      id: string,
      projectId: string,
      data: AlarmContact,
      options?: any
    ): AxiosPromise<AlarmContact> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsPartialUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary Retrieve a Contact
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsRead(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<AlarmContact> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsRead(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for noonlight contacts
     * @summary Update Contact
     * @param {string} id
     * @param {string} projectId
     * @param {AlarmContact} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityContactsUpdate(
      id: string,
      projectId: string,
      data: AlarmContact,
      options?: any
    ): AxiosPromise<AlarmContact> {
      return SecurityApiFp(configuration)
        .projectsSecurityContactsUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Cancel the alarm.
     * @summary Cancel Alarm on Event
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityEventsCancelAlarm(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<void> {
      return SecurityApiFp(configuration)
        .projectsSecurityEventsCancelAlarm(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Events from the camera that caused alarms
     * @summary List Security Events
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityEventsList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<CamEvent>> {
      return SecurityApiFp(configuration)
        .projectsSecurityEventsList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Disable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleDisableNextEvent(
      projectId: string,
      options?: any
    ): AxiosPromise<void> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleDisableNextEvent(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Work to disable the next arming/disarming event
     * @summary Enable Next Arming/Disarming
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleEnableNextEvent(
      projectId: string,
      options?: any
    ): AxiosPromise<void> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleEnableNextEvent(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Show history of schedule updates
     * @summary Get Schedule Update History
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleHistory(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<ArmingScheduleUpdate>> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleHistory(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Schedule items
     * @summary List Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<ArmingScheduleItem>> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Show surrounding schedule.
     * @summary Get Surrounding Schedule
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleSurroundingSchedule(
      projectId: string,
      options?: any
    ): AxiosPromise<SurroundingArmSchedule> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleSurroundingSchedule(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update the whole schedule
     * @summary Update Schedule
     * @param {string} projectId
     * @param {Array<ArmingScheduleItem>} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSecurityScheduleUpdateAll(
      projectId: string,
      data: Array<ArmingScheduleItem>,
      options?: any
    ): AxiosPromise<Array<ArmingScheduleItem>> {
      return SecurityApiFp(configuration)
        .projectsSecurityScheduleUpdateAll(projectId, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsSecurityArmlogList operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityArmlogListRequest
 */
export interface SecurityApiProjectsSecurityArmlogListRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityArmlogList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityContactsCreate operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsCreateRequest
 */
export interface SecurityApiProjectsSecurityContactsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsCreate
   */
  readonly projectId: string

  /**
   *
   * @type {AlarmContact}
   * @memberof SecurityApiProjectsSecurityContactsCreate
   */
  readonly data: AlarmContact
}

/**
 * Request parameters for projectsSecurityContactsDelete operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsDeleteRequest
 */
export interface SecurityApiProjectsSecurityContactsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsDelete
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsDelete
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityContactsList operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsListRequest
 */
export interface SecurityApiProjectsSecurityContactsListRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityContactsPartialUpdate operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsPartialUpdateRequest
 */
export interface SecurityApiProjectsSecurityContactsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsPartialUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {AlarmContact}
   * @memberof SecurityApiProjectsSecurityContactsPartialUpdate
   */
  readonly data: AlarmContact
}

/**
 * Request parameters for projectsSecurityContactsRead operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsReadRequest
 */
export interface SecurityApiProjectsSecurityContactsReadRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsRead
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsRead
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityContactsUpdate operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityContactsUpdateRequest
 */
export interface SecurityApiProjectsSecurityContactsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityContactsUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {AlarmContact}
   * @memberof SecurityApiProjectsSecurityContactsUpdate
   */
  readonly data: AlarmContact
}

/**
 * Request parameters for projectsSecurityEventsCancelAlarm operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityEventsCancelAlarmRequest
 */
export interface SecurityApiProjectsSecurityEventsCancelAlarmRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityEventsCancelAlarm
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityEventsCancelAlarm
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityEventsList operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityEventsListRequest
 */
export interface SecurityApiProjectsSecurityEventsListRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityEventsList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleDisableNextEvent operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleDisableNextEventRequest
 */
export interface SecurityApiProjectsSecurityScheduleDisableNextEventRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleDisableNextEvent
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleEnableNextEvent operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleEnableNextEventRequest
 */
export interface SecurityApiProjectsSecurityScheduleEnableNextEventRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleEnableNextEvent
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleHistory operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleHistoryRequest
 */
export interface SecurityApiProjectsSecurityScheduleHistoryRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleHistory
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleList operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleListRequest
 */
export interface SecurityApiProjectsSecurityScheduleListRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleSurroundingSchedule operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleSurroundingScheduleRequest
 */
export interface SecurityApiProjectsSecurityScheduleSurroundingScheduleRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleSurroundingSchedule
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsSecurityScheduleUpdateAll operation in SecurityApi.
 * @export
 * @interface SecurityApiProjectsSecurityScheduleUpdateAllRequest
 */
export interface SecurityApiProjectsSecurityScheduleUpdateAllRequest {
  /**
   *
   * @type {string}
   * @memberof SecurityApiProjectsSecurityScheduleUpdateAll
   */
  readonly projectId: string

  /**
   *
   * @type {Array<ArmingScheduleItem>}
   * @memberof SecurityApiProjectsSecurityScheduleUpdateAll
   */
  readonly data: Array<ArmingScheduleItem>
}

/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
  /**
   * History of arm/disarmings
   * @summary List Arming Logs
   * @param {SecurityApiProjectsSecurityArmlogListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityArmlogList(
    requestParameters: SecurityApiProjectsSecurityArmlogListRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityArmlogList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary Add a Contact
   * @param {SecurityApiProjectsSecurityContactsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsCreate(
    requestParameters: SecurityApiProjectsSecurityContactsCreateRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsCreate(
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary Delete Contact
   * @param {SecurityApiProjectsSecurityContactsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsDelete(
    requestParameters: SecurityApiProjectsSecurityContactsDeleteRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsDelete(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary List Contacts
   * @param {SecurityApiProjectsSecurityContactsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsList(
    requestParameters: SecurityApiProjectsSecurityContactsListRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary Update Contact
   * @param {SecurityApiProjectsSecurityContactsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsPartialUpdate(
    requestParameters: SecurityApiProjectsSecurityContactsPartialUpdateRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsPartialUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary Retrieve a Contact
   * @param {SecurityApiProjectsSecurityContactsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsRead(
    requestParameters: SecurityApiProjectsSecurityContactsReadRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsRead(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for noonlight contacts
   * @summary Update Contact
   * @param {SecurityApiProjectsSecurityContactsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityContactsUpdate(
    requestParameters: SecurityApiProjectsSecurityContactsUpdateRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityContactsUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Cancel the alarm.
   * @summary Cancel Alarm on Event
   * @param {SecurityApiProjectsSecurityEventsCancelAlarmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityEventsCancelAlarm(
    requestParameters: SecurityApiProjectsSecurityEventsCancelAlarmRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityEventsCancelAlarm(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Events from the camera that caused alarms
   * @summary List Security Events
   * @param {SecurityApiProjectsSecurityEventsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityEventsList(
    requestParameters: SecurityApiProjectsSecurityEventsListRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityEventsList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Work to disable the next arming/disarming event
   * @summary Disable Next Arming/Disarming
   * @param {SecurityApiProjectsSecurityScheduleDisableNextEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleDisableNextEvent(
    requestParameters: SecurityApiProjectsSecurityScheduleDisableNextEventRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleDisableNextEvent(
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Work to disable the next arming/disarming event
   * @summary Enable Next Arming/Disarming
   * @param {SecurityApiProjectsSecurityScheduleEnableNextEventRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleEnableNextEvent(
    requestParameters: SecurityApiProjectsSecurityScheduleEnableNextEventRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleEnableNextEvent(
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Show history of schedule updates
   * @summary Get Schedule Update History
   * @param {SecurityApiProjectsSecurityScheduleHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleHistory(
    requestParameters: SecurityApiProjectsSecurityScheduleHistoryRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleHistory(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Schedule items
   * @summary List Schedule
   * @param {SecurityApiProjectsSecurityScheduleListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleList(
    requestParameters: SecurityApiProjectsSecurityScheduleListRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Show surrounding schedule.
   * @summary Get Surrounding Schedule
   * @param {SecurityApiProjectsSecurityScheduleSurroundingScheduleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleSurroundingSchedule(
    requestParameters: SecurityApiProjectsSecurityScheduleSurroundingScheduleRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleSurroundingSchedule(
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update the whole schedule
   * @summary Update Schedule
   * @param {SecurityApiProjectsSecurityScheduleUpdateAllRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public projectsSecurityScheduleUpdateAll(
    requestParameters: SecurityApiProjectsSecurityScheduleUpdateAllRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration)
      .projectsSecurityScheduleUpdateAll(
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SegmentationReportingApi - axios parameter creator
 * @export
 */
export const SegmentationReportingApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Analysis
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationAnalysesList: async (
      projectId: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling segmentationAnalysesList.'
        )
      }
      const localVarPath = `/segmentation/analyses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Drawings
     * @param {number} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationDrawingsList: async (
      analysisId: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling segmentationDrawingsList.'
        )
      }
      const localVarPath = `/segmentation/drawings/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (analysisId !== undefined) {
        localVarQueryParameter['analysis_id'] = analysisId
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for list of segmentation labels
     * @summary List Segmentation Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationLabelsList: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/segmentation/labels/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * View set for Masterplans
     * @summary Get Masterplan
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationMasterplansRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling segmentationMasterplansRead.'
        )
      }
      const localVarPath = `/segmentation/masterplans/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * View set for Progress
     * @summary List Progress
     * @param {number} analysisId
     * @param {string} [startDatetime]
     * @param {string} [endDatetime]
     * @param {number} [labelId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationProgressList: async (
      analysisId: number,
      startDatetime?: string,
      endDatetime?: string,
      labelId?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling segmentationProgressList.'
        )
      }
      const localVarPath = `/segmentation/progress/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (analysisId !== undefined) {
        localVarQueryParameter['analysis_id'] = analysisId
      }

      if (startDatetime !== undefined) {
        localVarQueryParameter['start_datetime'] = startDatetime
      }

      if (endDatetime !== undefined) {
        localVarQueryParameter['end_datetime'] = endDatetime
      }

      if (labelId !== undefined) {
        localVarQueryParameter['label_id'] = labelId
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SegmentationReportingApi - functional programming interface
 * @export
 */
export const SegmentationReportingApiFp = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Analysis
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async segmentationAnalysesList(
      projectId: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Analysis>>
    > {
      const localVarAxiosArgs = await SegmentationReportingApiAxiosParamCreator(
        configuration
      ).segmentationAnalysesList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Drawings
     * @param {number} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async segmentationDrawingsList(
      analysisId: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<SegmentationDrawing>>
    > {
      const localVarAxiosArgs = await SegmentationReportingApiAxiosParamCreator(
        configuration
      ).segmentationDrawingsList(analysisId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for list of segmentation labels
     * @summary List Segmentation Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async segmentationLabelsList(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<SegmentationLabel>>
    > {
      const localVarAxiosArgs = await SegmentationReportingApiAxiosParamCreator(
        configuration
      ).segmentationLabelsList(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * View set for Masterplans
     * @summary Get Masterplan
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async segmentationMasterplansRead(
      id: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Masterplan>>
    > {
      const localVarAxiosArgs = await SegmentationReportingApiAxiosParamCreator(
        configuration
      ).segmentationMasterplansRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * View set for Progress
     * @summary List Progress
     * @param {number} analysisId
     * @param {string} [startDatetime]
     * @param {string} [endDatetime]
     * @param {number} [labelId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async segmentationProgressList(
      analysisId: number,
      startDatetime?: string,
      endDatetime?: string,
      labelId?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<SegmentationProgress>>
    > {
      const localVarAxiosArgs = await SegmentationReportingApiAxiosParamCreator(
        configuration
      ).segmentationProgressList(
        analysisId,
        startDatetime,
        endDatetime,
        labelId,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * SegmentationReportingApi - factory interface
 * @export
 */
export const SegmentationReportingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Analysis
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationAnalysesList(
      projectId: number,
      options?: any
    ): AxiosPromise<Array<Analysis>> {
      return SegmentationReportingApiFp(configuration)
        .segmentationAnalysesList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for list of segmentation analyses
     * @summary List Segmentation Drawings
     * @param {number} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationDrawingsList(
      analysisId: number,
      options?: any
    ): AxiosPromise<Array<SegmentationDrawing>> {
      return SegmentationReportingApiFp(configuration)
        .segmentationDrawingsList(analysisId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for list of segmentation labels
     * @summary List Segmentation Labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationLabelsList(
      options?: any
    ): AxiosPromise<Array<SegmentationLabel>> {
      return SegmentationReportingApiFp(configuration)
        .segmentationLabelsList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View set for Masterplans
     * @summary Get Masterplan
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationMasterplansRead(
      id: string,
      options?: any
    ): AxiosPromise<Array<Masterplan>> {
      return SegmentationReportingApiFp(configuration)
        .segmentationMasterplansRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View set for Progress
     * @summary List Progress
     * @param {number} analysisId
     * @param {string} [startDatetime]
     * @param {string} [endDatetime]
     * @param {number} [labelId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    segmentationProgressList(
      analysisId: number,
      startDatetime?: string,
      endDatetime?: string,
      labelId?: number,
      options?: any
    ): AxiosPromise<Array<SegmentationProgress>> {
      return SegmentationReportingApiFp(configuration)
        .segmentationProgressList(
          analysisId,
          startDatetime,
          endDatetime,
          labelId,
          options
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for segmentationAnalysesList operation in SegmentationReportingApi.
 * @export
 * @interface SegmentationReportingApiSegmentationAnalysesListRequest
 */
export interface SegmentationReportingApiSegmentationAnalysesListRequest {
  /**
   *
   * @type {number}
   * @memberof SegmentationReportingApiSegmentationAnalysesList
   */
  readonly projectId: number
}

/**
 * Request parameters for segmentationDrawingsList operation in SegmentationReportingApi.
 * @export
 * @interface SegmentationReportingApiSegmentationDrawingsListRequest
 */
export interface SegmentationReportingApiSegmentationDrawingsListRequest {
  /**
   *
   * @type {number}
   * @memberof SegmentationReportingApiSegmentationDrawingsList
   */
  readonly analysisId: number
}

/**
 * Request parameters for segmentationMasterplansRead operation in SegmentationReportingApi.
 * @export
 * @interface SegmentationReportingApiSegmentationMasterplansReadRequest
 */
export interface SegmentationReportingApiSegmentationMasterplansReadRequest {
  /**
   *
   * @type {string}
   * @memberof SegmentationReportingApiSegmentationMasterplansRead
   */
  readonly id: string
}

/**
 * Request parameters for segmentationProgressList operation in SegmentationReportingApi.
 * @export
 * @interface SegmentationReportingApiSegmentationProgressListRequest
 */
export interface SegmentationReportingApiSegmentationProgressListRequest {
  /**
   *
   * @type {number}
   * @memberof SegmentationReportingApiSegmentationProgressList
   */
  readonly analysisId: number

  /**
   *
   * @type {string}
   * @memberof SegmentationReportingApiSegmentationProgressList
   */
  readonly startDatetime?: string

  /**
   *
   * @type {string}
   * @memberof SegmentationReportingApiSegmentationProgressList
   */
  readonly endDatetime?: string

  /**
   *
   * @type {number}
   * @memberof SegmentationReportingApiSegmentationProgressList
   */
  readonly labelId?: number
}

/**
 * SegmentationReportingApi - object-oriented interface
 * @export
 * @class SegmentationReportingApi
 * @extends {BaseAPI}
 */
export class SegmentationReportingApi extends BaseAPI {
  /**
   * Viewset for list of segmentation analyses
   * @summary List Segmentation Analysis
   * @param {SegmentationReportingApiSegmentationAnalysesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SegmentationReportingApi
   */
  public segmentationAnalysesList(
    requestParameters: SegmentationReportingApiSegmentationAnalysesListRequest,
    options?: any
  ) {
    return SegmentationReportingApiFp(this.configuration)
      .segmentationAnalysesList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for list of segmentation analyses
   * @summary List Segmentation Drawings
   * @param {SegmentationReportingApiSegmentationDrawingsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SegmentationReportingApi
   */
  public segmentationDrawingsList(
    requestParameters: SegmentationReportingApiSegmentationDrawingsListRequest,
    options?: any
  ) {
    return SegmentationReportingApiFp(this.configuration)
      .segmentationDrawingsList(requestParameters.analysisId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for list of segmentation labels
   * @summary List Segmentation Labels
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SegmentationReportingApi
   */
  public segmentationLabelsList(options?: any) {
    return SegmentationReportingApiFp(this.configuration)
      .segmentationLabelsList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View set for Masterplans
   * @summary Get Masterplan
   * @param {SegmentationReportingApiSegmentationMasterplansReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SegmentationReportingApi
   */
  public segmentationMasterplansRead(
    requestParameters: SegmentationReportingApiSegmentationMasterplansReadRequest,
    options?: any
  ) {
    return SegmentationReportingApiFp(this.configuration)
      .segmentationMasterplansRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View set for Progress
   * @summary List Progress
   * @param {SegmentationReportingApiSegmentationProgressListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SegmentationReportingApi
   */
  public segmentationProgressList(
    requestParameters: SegmentationReportingApiSegmentationProgressListRequest,
    options?: any
  ) {
    return SegmentationReportingApiFp(this.configuration)
      .segmentationProgressList(
        requestParameters.analysisId,
        requestParameters.startDatetime,
        requestParameters.endDatetime,
        requestParameters.labelId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ShoringApi - axios parameter creator
 * @export
 */
export const ShoringApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Adds one bay relation to an analysis.
     * @summary Create Bay Relation
     * @param {string} analysisId
     * @param {ShoringBayRelation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsCreate: async (
      analysisId: string,
      data: ShoringBayRelation,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbayrelationsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesShoringbayrelationsCreate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbayrelations/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes bay relation from an analysis
     * @summary Delete Bay Relation
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsDelete: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbayrelationsDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesShoringbayrelationsDelete.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbayrelations/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List bay relations for an analysis.
     * @summary List Shoring Bay Relations
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsList: async (
      analysisId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbayrelationsList.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbayrelations/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Adds one bay to an analysis.
     * @summary Create Bay
     * @param {string} analysisId
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysCreate: async (
      analysisId: string,
      data: ShoringBay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesShoringbaysCreate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes bay from an analysis
     * @summary Delete Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysDelete: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesShoringbaysDelete.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List bays for an analysis.
     * @summary List Bays
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysList: async (
      analysisId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysList.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysPartialUpdate: async (
      analysisId: string,
      id: string,
      data: ShoringBay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysPartialUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesShoringbaysPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesShoringbaysPartialUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get bays for an analysis.
     * @summary Retrieve Bays
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysRead: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysRead.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesShoringbaysRead.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysUpdate: async (
      analysisId: string,
      id: string,
      data: ShoringBay,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesShoringbaysUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesShoringbaysUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesShoringbaysUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/shoringbays/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ShoringApi - functional programming interface
 * @export
 */
export const ShoringApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Adds one bay relation to an analysis.
     * @summary Create Bay Relation
     * @param {string} analysisId
     * @param {ShoringBayRelation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbayrelationsCreate(
      analysisId: string,
      data: ShoringBayRelation,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ShoringBayRelation>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbayrelationsCreate(
        analysisId,
        data,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes bay relation from an analysis
     * @summary Delete Bay Relation
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbayrelationsDelete(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbayrelationsDelete(
        analysisId,
        id,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List bay relations for an analysis.
     * @summary List Shoring Bay Relations
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbayrelationsList(
      analysisId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ShoringBayRelation>>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbayrelationsList(analysisId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Adds one bay to an analysis.
     * @summary Create Bay
     * @param {string} analysisId
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysCreate(
      analysisId: string,
      data: ShoringBay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoringBay>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysCreate(analysisId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes bay from an analysis
     * @summary Delete Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysDelete(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysDelete(analysisId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List bays for an analysis.
     * @summary List Bays
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysList(
      analysisId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ShoringBay>>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysList(analysisId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysPartialUpdate(
      analysisId: string,
      id: string,
      data: ShoringBay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoringBay>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysPartialUpdate(
        analysisId,
        id,
        data,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get bays for an analysis.
     * @summary Retrieve Bays
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysRead(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoringBay>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysRead(analysisId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesShoringbaysUpdate(
      analysisId: string,
      id: string,
      data: ShoringBay,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoringBay>
    > {
      const localVarAxiosArgs = await ShoringApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesShoringbaysUpdate(analysisId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ShoringApi - factory interface
 * @export
 */
export const ShoringApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Adds one bay relation to an analysis.
     * @summary Create Bay Relation
     * @param {string} analysisId
     * @param {ShoringBayRelation} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsCreate(
      analysisId: string,
      data: ShoringBayRelation,
      options?: any
    ): AxiosPromise<ShoringBayRelation> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbayrelationsCreate(
          analysisId,
          data,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes bay relation from an analysis
     * @summary Delete Bay Relation
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsDelete(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbayrelationsDelete(
          analysisId,
          id,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List bay relations for an analysis.
     * @summary List Shoring Bay Relations
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbayrelationsList(
      analysisId: string,
      options?: any
    ): AxiosPromise<Array<ShoringBayRelation>> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbayrelationsList(analysisId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Adds one bay to an analysis.
     * @summary Create Bay
     * @param {string} analysisId
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysCreate(
      analysisId: string,
      data: ShoringBay,
      options?: any
    ): AxiosPromise<ShoringBay> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysCreate(analysisId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes bay from an analysis
     * @summary Delete Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysDelete(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysDelete(analysisId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List bays for an analysis.
     * @summary List Bays
     * @param {string} analysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysList(
      analysisId: string,
      options?: any
    ): AxiosPromise<Array<ShoringBay>> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysList(analysisId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysPartialUpdate(
      analysisId: string,
      id: string,
      data: ShoringBay,
      options?: any
    ): AxiosPromise<ShoringBay> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysPartialUpdate(
          analysisId,
          id,
          data,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get bays for an analysis.
     * @summary Retrieve Bays
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysRead(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<ShoringBay> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysRead(analysisId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates information about a bay
     * @summary Edit Bay
     * @param {string} analysisId
     * @param {string} id
     * @param {ShoringBay} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesShoringbaysUpdate(
      analysisId: string,
      id: string,
      data: ShoringBay,
      options?: any
    ): AxiosPromise<ShoringBay> {
      return ShoringApiFp(configuration)
        .videoannotationAnalysesShoringbaysUpdate(analysisId, id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for videoannotationAnalysesShoringbayrelationsCreate operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbayrelationsCreateRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbayrelationsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbayrelationsCreate
   */
  readonly analysisId: string

  /**
   *
   * @type {ShoringBayRelation}
   * @memberof ShoringApiVideoannotationAnalysesShoringbayrelationsCreate
   */
  readonly data: ShoringBayRelation
}

/**
 * Request parameters for videoannotationAnalysesShoringbayrelationsDelete operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbayrelationsDeleteRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbayrelationsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbayrelationsDelete
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbayrelationsDelete
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesShoringbayrelationsList operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbayrelationsListRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbayrelationsListRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbayrelationsList
   */
  readonly analysisId: string
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysCreate operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysCreateRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysCreateRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysCreate
   */
  readonly analysisId: string

  /**
   *
   * @type {ShoringBay}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysCreate
   */
  readonly data: ShoringBay
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysDelete operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysDeleteRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysDelete
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysDelete
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysList operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysListRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysListRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysList
   */
  readonly analysisId: string
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysPartialUpdate operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysPartialUpdateRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysPartialUpdate
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {ShoringBay}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysPartialUpdate
   */
  readonly data: ShoringBay
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysRead operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysReadRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysReadRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysRead
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysRead
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesShoringbaysUpdate operation in ShoringApi.
 * @export
 * @interface ShoringApiVideoannotationAnalysesShoringbaysUpdateRequest
 */
export interface ShoringApiVideoannotationAnalysesShoringbaysUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysUpdate
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysUpdate
   */
  readonly id: string

  /**
   *
   * @type {ShoringBay}
   * @memberof ShoringApiVideoannotationAnalysesShoringbaysUpdate
   */
  readonly data: ShoringBay
}

/**
 * ShoringApi - object-oriented interface
 * @export
 * @class ShoringApi
 * @extends {BaseAPI}
 */
export class ShoringApi extends BaseAPI {
  /**
   * Adds one bay relation to an analysis.
   * @summary Create Bay Relation
   * @param {ShoringApiVideoannotationAnalysesShoringbayrelationsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbayrelationsCreate(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbayrelationsCreateRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbayrelationsCreate(
        requestParameters.analysisId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes bay relation from an analysis
   * @summary Delete Bay Relation
   * @param {ShoringApiVideoannotationAnalysesShoringbayrelationsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbayrelationsDelete(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbayrelationsDeleteRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbayrelationsDelete(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List bay relations for an analysis.
   * @summary List Shoring Bay Relations
   * @param {ShoringApiVideoannotationAnalysesShoringbayrelationsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbayrelationsList(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbayrelationsListRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbayrelationsList(
        requestParameters.analysisId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Adds one bay to an analysis.
   * @summary Create Bay
   * @param {ShoringApiVideoannotationAnalysesShoringbaysCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysCreate(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysCreateRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysCreate(
        requestParameters.analysisId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes bay from an analysis
   * @summary Delete Bay
   * @param {ShoringApiVideoannotationAnalysesShoringbaysDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysDelete(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysDeleteRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysDelete(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List bays for an analysis.
   * @summary List Bays
   * @param {ShoringApiVideoannotationAnalysesShoringbaysListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysList(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysListRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysList(
        requestParameters.analysisId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates information about a bay
   * @summary Edit Bay
   * @param {ShoringApiVideoannotationAnalysesShoringbaysPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysPartialUpdate(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysPartialUpdateRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysPartialUpdate(
        requestParameters.analysisId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get bays for an analysis.
   * @summary Retrieve Bays
   * @param {ShoringApiVideoannotationAnalysesShoringbaysReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysRead(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysReadRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysRead(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates information about a bay
   * @summary Edit Bay
   * @param {ShoringApiVideoannotationAnalysesShoringbaysUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShoringApi
   */
  public videoannotationAnalysesShoringbaysUpdate(
    requestParameters: ShoringApiVideoannotationAnalysesShoringbaysUpdateRequest,
    options?: any
  ) {
    return ShoringApiFp(this.configuration)
      .videoannotationAnalysesShoringbaysUpdate(
        requestParameters.analysisId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * StatusApi - axios parameter creator
 * @export
 */
export const StatusApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Sanity check that the server app hasn\'t crashed.  This endpoint has no authentication.
     * @summary Server Heartbeat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * StatusApi - functional programming interface
 * @export
 */
export const StatusApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Sanity check that the server app hasn\'t crashed.  This endpoint has no authentication.
     * @summary Server Heartbeat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await StatusApiAxiosParamCreator(
        configuration
      ).list(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * StatusApi - factory interface
 * @export
 */
export const StatusApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Sanity check that the server app hasn\'t crashed.  This endpoint has no authentication.
     * @summary Server Heartbeat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list(options?: any): AxiosPromise<void> {
      return StatusApiFp(configuration)
        .list(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
export class StatusApi extends BaseAPI {
  /**
   * Sanity check that the server app hasn\'t crashed.  This endpoint has no authentication.
   * @summary Server Heartbeat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatusApi
   */
  public list(options?: any) {
    return StatusApiFp(this.configuration)
      .list(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * StreamsApi - axios parameter creator
 * @export
 */
export const StreamsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * List and show stream information.
     * @summary List Streams
     * @param {string} [sourceStreamName]
     * @param {string} [live]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsList: async (
      sourceStreamName?: string,
      live?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/streams/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (sourceStreamName !== undefined) {
        localVarQueryParameter['source_stream_name'] = sourceStreamName
      }

      if (live !== undefined) {
        localVarQueryParameter['live'] = live
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * StreamsApi - functional programming interface
 * @export
 */
export const StreamsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * List and show stream information.
     * @summary List Streams
     * @param {string} [sourceStreamName]
     * @param {string} [live]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsList(
      sourceStreamName?: string,
      live?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<StreamSerializerWithProjects>>
    > {
      const localVarAxiosArgs = await StreamsApiAxiosParamCreator(
        configuration
      ).streamsList(sourceStreamName, live, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * StreamsApi - factory interface
 * @export
 */
export const StreamsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * List and show stream information.
     * @summary List Streams
     * @param {string} [sourceStreamName]
     * @param {string} [live]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsList(
      sourceStreamName?: string,
      live?: string,
      options?: any
    ): AxiosPromise<Array<StreamSerializerWithProjects>> {
      return StreamsApiFp(configuration)
        .streamsList(sourceStreamName, live, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for streamsList operation in StreamsApi.
 * @export
 * @interface StreamsApiStreamsListRequest
 */
export interface StreamsApiStreamsListRequest {
  /**
   *
   * @type {string}
   * @memberof StreamsApiStreamsList
   */
  readonly sourceStreamName?: string

  /**
   *
   * @type {string}
   * @memberof StreamsApiStreamsList
   */
  readonly live?: string
}

/**
 * StreamsApi - object-oriented interface
 * @export
 * @class StreamsApi
 * @extends {BaseAPI}
 */
export class StreamsApi extends BaseAPI {
  /**
   * List and show stream information.
   * @summary List Streams
   * @param {StreamsApiStreamsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamsApi
   */
  public streamsList(
    requestParameters: StreamsApiStreamsListRequest = {},
    options?: any
  ) {
    return StreamsApiFp(this.configuration)
      .streamsList(
        requestParameters.sourceStreamName,
        requestParameters.live,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TimelapsesApi - axios parameter creator
 * @export
 */
export const TimelapsesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Start request for timelapse.
     * @summary Create Timelapse
     * @param {string} projectId
     * @param {Timelapse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsTimelapsesCreate: async (
      projectId: string,
      data: Timelapse,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsTimelapsesCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsTimelapsesCreate.'
        )
      }
      const localVarPath = `/projects/{project_id}/timelapses/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List timelapses for a project
     * @summary List Timelapses
     * @param {string} projectId
     * @param {string} [reqDatetimeStart]
     * @param {string} [reqDatetimeEnd]
     * @param {string} [state] Choices: [initial, processing, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsTimelapsesList: async (
      projectId: string,
      reqDatetimeStart?: string,
      reqDatetimeEnd?: string,
      state?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsTimelapsesList.'
        )
      }
      const localVarPath = `/projects/{project_id}/timelapses/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (reqDatetimeStart !== undefined) {
        localVarQueryParameter['req_datetime_start'] = reqDatetimeStart
      }

      if (reqDatetimeEnd !== undefined) {
        localVarQueryParameter['req_datetime_end'] = reqDatetimeEnd
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TimelapsesApi - functional programming interface
 * @export
 */
export const TimelapsesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Start request for timelapse.
     * @summary Create Timelapse
     * @param {string} projectId
     * @param {Timelapse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsTimelapsesCreate(
      projectId: string,
      data: Timelapse,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Timelapse>
    > {
      const localVarAxiosArgs = await TimelapsesApiAxiosParamCreator(
        configuration
      ).projectsTimelapsesCreate(projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List timelapses for a project
     * @summary List Timelapses
     * @param {string} projectId
     * @param {string} [reqDatetimeStart]
     * @param {string} [reqDatetimeEnd]
     * @param {string} [state] Choices: [initial, processing, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsTimelapsesList(
      projectId: string,
      reqDatetimeStart?: string,
      reqDatetimeEnd?: string,
      state?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Timelapse>>
    > {
      const localVarAxiosArgs = await TimelapsesApiAxiosParamCreator(
        configuration
      ).projectsTimelapsesList(
        projectId,
        reqDatetimeStart,
        reqDatetimeEnd,
        state,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * TimelapsesApi - factory interface
 * @export
 */
export const TimelapsesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Start request for timelapse.
     * @summary Create Timelapse
     * @param {string} projectId
     * @param {Timelapse} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsTimelapsesCreate(
      projectId: string,
      data: Timelapse,
      options?: any
    ): AxiosPromise<Timelapse> {
      return TimelapsesApiFp(configuration)
        .projectsTimelapsesCreate(projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List timelapses for a project
     * @summary List Timelapses
     * @param {string} projectId
     * @param {string} [reqDatetimeStart]
     * @param {string} [reqDatetimeEnd]
     * @param {string} [state] Choices: [initial, processing, failed, completed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsTimelapsesList(
      projectId: string,
      reqDatetimeStart?: string,
      reqDatetimeEnd?: string,
      state?: string,
      options?: any
    ): AxiosPromise<Array<Timelapse>> {
      return TimelapsesApiFp(configuration)
        .projectsTimelapsesList(
          projectId,
          reqDatetimeStart,
          reqDatetimeEnd,
          state,
          options
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsTimelapsesCreate operation in TimelapsesApi.
 * @export
 * @interface TimelapsesApiProjectsTimelapsesCreateRequest
 */
export interface TimelapsesApiProjectsTimelapsesCreateRequest {
  /**
   *
   * @type {string}
   * @memberof TimelapsesApiProjectsTimelapsesCreate
   */
  readonly projectId: string

  /**
   *
   * @type {Timelapse}
   * @memberof TimelapsesApiProjectsTimelapsesCreate
   */
  readonly data: Timelapse
}

/**
 * Request parameters for projectsTimelapsesList operation in TimelapsesApi.
 * @export
 * @interface TimelapsesApiProjectsTimelapsesListRequest
 */
export interface TimelapsesApiProjectsTimelapsesListRequest {
  /**
   *
   * @type {string}
   * @memberof TimelapsesApiProjectsTimelapsesList
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof TimelapsesApiProjectsTimelapsesList
   */
  readonly reqDatetimeStart?: string

  /**
   *
   * @type {string}
   * @memberof TimelapsesApiProjectsTimelapsesList
   */
  readonly reqDatetimeEnd?: string

  /**
   * Choices: [initial, processing, failed, completed]
   * @type {string}
   * @memberof TimelapsesApiProjectsTimelapsesList
   */
  readonly state?: string
}

/**
 * TimelapsesApi - object-oriented interface
 * @export
 * @class TimelapsesApi
 * @extends {BaseAPI}
 */
export class TimelapsesApi extends BaseAPI {
  /**
   * Start request for timelapse.
   * @summary Create Timelapse
   * @param {TimelapsesApiProjectsTimelapsesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TimelapsesApi
   */
  public projectsTimelapsesCreate(
    requestParameters: TimelapsesApiProjectsTimelapsesCreateRequest,
    options?: any
  ) {
    return TimelapsesApiFp(this.configuration)
      .projectsTimelapsesCreate(
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List timelapses for a project
   * @summary List Timelapses
   * @param {TimelapsesApiProjectsTimelapsesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TimelapsesApi
   */
  public projectsTimelapsesList(
    requestParameters: TimelapsesApiProjectsTimelapsesListRequest,
    options?: any
  ) {
    return TimelapsesApiFp(this.configuration)
      .projectsTimelapsesList(
        requestParameters.projectId,
        requestParameters.reqDatetimeStart,
        requestParameters.reqDatetimeEnd,
        requestParameters.state,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UndistortApi - axios parameter creator
 * @export
 */
export const UndistortApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Job view set
     * @summary Create Undistort Job
     * @param {UndistortJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undistortJobsCreate: async (
      data: UndistortJob,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling undistortJobsCreate.'
        )
      }
      const localVarPath = `/undistort/jobs/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Job view set
     * @summary Check Undistort Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undistortJobsRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling undistortJobsRead.'
        )
      }
      const localVarPath = `/undistort/jobs/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UndistortApi - functional programming interface
 * @export
 */
export const UndistortApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Job view set
     * @summary Create Undistort Job
     * @param {UndistortJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undistortJobsCreate(
      data: UndistortJob,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndistortJob>
    > {
      const localVarAxiosArgs = await UndistortApiAxiosParamCreator(
        configuration
      ).undistortJobsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Job view set
     * @summary Check Undistort Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undistortJobsRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndistortJob>
    > {
      const localVarAxiosArgs = await UndistortApiAxiosParamCreator(
        configuration
      ).undistortJobsRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * UndistortApi - factory interface
 * @export
 */
export const UndistortApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Job view set
     * @summary Create Undistort Job
     * @param {UndistortJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undistortJobsCreate(
      data: UndistortJob,
      options?: any
    ): AxiosPromise<UndistortJob> {
      return UndistortApiFp(configuration)
        .undistortJobsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Job view set
     * @summary Check Undistort Job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undistortJobsRead(id: string, options?: any): AxiosPromise<UndistortJob> {
      return UndistortApiFp(configuration)
        .undistortJobsRead(id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for undistortJobsCreate operation in UndistortApi.
 * @export
 * @interface UndistortApiUndistortJobsCreateRequest
 */
export interface UndistortApiUndistortJobsCreateRequest {
  /**
   *
   * @type {UndistortJob}
   * @memberof UndistortApiUndistortJobsCreate
   */
  readonly data: UndistortJob
}

/**
 * Request parameters for undistortJobsRead operation in UndistortApi.
 * @export
 * @interface UndistortApiUndistortJobsReadRequest
 */
export interface UndistortApiUndistortJobsReadRequest {
  /**
   *
   * @type {string}
   * @memberof UndistortApiUndistortJobsRead
   */
  readonly id: string
}

/**
 * UndistortApi - object-oriented interface
 * @export
 * @class UndistortApi
 * @extends {BaseAPI}
 */
export class UndistortApi extends BaseAPI {
  /**
   * Job view set
   * @summary Create Undistort Job
   * @param {UndistortApiUndistortJobsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UndistortApi
   */
  public undistortJobsCreate(
    requestParameters: UndistortApiUndistortJobsCreateRequest,
    options?: any
  ) {
    return UndistortApiFp(this.configuration)
      .undistortJobsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Job view set
   * @summary Check Undistort Job
   * @param {UndistortApiUndistortJobsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UndistortApi
   */
  public undistortJobsRead(
    requestParameters: UndistortApiUndistortJobsReadRequest,
    options?: any
  ) {
    return UndistortApiFp(this.configuration)
      .undistortJobsRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UploadsApi - axios parameter creator
 * @export
 */
export const UploadsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Notifies server that the upload is uploaded.
     * @summary Confirm Upload is Uploaded
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsConfirm: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsUploadsConfirm.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsConfirm.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/{id}/confirm/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsDelete: async (
      id: string,
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsUploadsDelete.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsDelete.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Initialize an upload.
     * @summary Initiate Upload
     * @param {string} projectId
     * @param {UploadInitRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsInit: async (
      projectId: string,
      data: UploadInitRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsInit.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUploadsInit.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/init/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For project uploads
     * @summary List Uploads for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsList: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsList.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For project uploads
     * @summary Update a Upload in a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsPartialUpdate: async (
      id: string,
      projectId: string,
      data: Upload,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsUploadsPartialUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUploadsPartialUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsUpdate: async (
      id: string,
      projectId: string,
      data: Upload,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling projectsUploadsUpdate.'
        )
      }
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsUploadsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling projectsUploadsUpdate.'
        )
      }
      const localVarPath = `/projects/{project_id}/uploads/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'project_id'}}`, encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UploadsApi - functional programming interface
 * @export
 */
export const UploadsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Notifies server that the upload is uploaded.
     * @summary Confirm Upload is Uploaded
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsConfirm(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Upload>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsConfirm(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsDelete(
      id: string,
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsDelete(id, projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Initialize an upload.
     * @summary Initiate Upload
     * @param {string} projectId
     * @param {UploadInitRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsInit(
      projectId: string,
      data: UploadInitRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UploadInitResponse>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsInit(projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For project uploads
     * @summary List Uploads for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsList(
      projectId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Upload>>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsList(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For project uploads
     * @summary Update a Upload in a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsPartialUpdate(
      id: string,
      projectId: string,
      data: Upload,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Upload>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsPartialUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUploadsUpdate(
      id: string,
      projectId: string,
      data: Upload,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Upload>
    > {
      const localVarAxiosArgs = await UploadsApiAxiosParamCreator(
        configuration
      ).projectsUploadsUpdate(id, projectId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * UploadsApi - factory interface
 * @export
 */
export const UploadsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Notifies server that the upload is uploaded.
     * @summary Confirm Upload is Uploaded
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsConfirm(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<Upload> {
      return UploadsApiFp(configuration)
        .projectsUploadsConfirm(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsDelete(
      id: string,
      projectId: string,
      options?: any
    ): AxiosPromise<void> {
      return UploadsApiFp(configuration)
        .projectsUploadsDelete(id, projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Initialize an upload.
     * @summary Initiate Upload
     * @param {string} projectId
     * @param {UploadInitRequest} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsInit(
      projectId: string,
      data: UploadInitRequest,
      options?: any
    ): AxiosPromise<UploadInitResponse> {
      return UploadsApiFp(configuration)
        .projectsUploadsInit(projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For project uploads
     * @summary List Uploads for a Project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsList(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<Upload>> {
      return UploadsApiFp(configuration)
        .projectsUploadsList(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For project uploads
     * @summary Update a Upload in a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsPartialUpdate(
      id: string,
      projectId: string,
      data: Upload,
      options?: any
    ): AxiosPromise<Upload> {
      return UploadsApiFp(configuration)
        .projectsUploadsPartialUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * For project uploads
     * @summary Delete a Upload from a Project
     * @param {string} id
     * @param {string} projectId
     * @param {Upload} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUploadsUpdate(
      id: string,
      projectId: string,
      data: Upload,
      options?: any
    ): AxiosPromise<Upload> {
      return UploadsApiFp(configuration)
        .projectsUploadsUpdate(id, projectId, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsUploadsConfirm operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsConfirmRequest
 */
export interface UploadsApiProjectsUploadsConfirmRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsConfirm
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsConfirm
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsUploadsDelete operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsDeleteRequest
 */
export interface UploadsApiProjectsUploadsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsDelete
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsDelete
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsUploadsInit operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsInitRequest
 */
export interface UploadsApiProjectsUploadsInitRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsInit
   */
  readonly projectId: string

  /**
   *
   * @type {UploadInitRequest}
   * @memberof UploadsApiProjectsUploadsInit
   */
  readonly data: UploadInitRequest
}

/**
 * Request parameters for projectsUploadsList operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsListRequest
 */
export interface UploadsApiProjectsUploadsListRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsList
   */
  readonly projectId: string
}

/**
 * Request parameters for projectsUploadsPartialUpdate operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsPartialUpdateRequest
 */
export interface UploadsApiProjectsUploadsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsPartialUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {Upload}
   * @memberof UploadsApiProjectsUploadsPartialUpdate
   */
  readonly data: Upload
}

/**
 * Request parameters for projectsUploadsUpdate operation in UploadsApi.
 * @export
 * @interface UploadsApiProjectsUploadsUpdateRequest
 */
export interface UploadsApiProjectsUploadsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof UploadsApiProjectsUploadsUpdate
   */
  readonly projectId: string

  /**
   *
   * @type {Upload}
   * @memberof UploadsApiProjectsUploadsUpdate
   */
  readonly data: Upload
}

/**
 * UploadsApi - object-oriented interface
 * @export
 * @class UploadsApi
 * @extends {BaseAPI}
 */
export class UploadsApi extends BaseAPI {
  /**
   * Notifies server that the upload is uploaded.
   * @summary Confirm Upload is Uploaded
   * @param {UploadsApiProjectsUploadsConfirmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsConfirm(
    requestParameters: UploadsApiProjectsUploadsConfirmRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsConfirm(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For project uploads
   * @summary Delete a Upload from a Project
   * @param {UploadsApiProjectsUploadsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsDelete(
    requestParameters: UploadsApiProjectsUploadsDeleteRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsDelete(
        requestParameters.id,
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Initialize an upload.
   * @summary Initiate Upload
   * @param {UploadsApiProjectsUploadsInitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsInit(
    requestParameters: UploadsApiProjectsUploadsInitRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsInit(
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For project uploads
   * @summary List Uploads for a Project
   * @param {UploadsApiProjectsUploadsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsList(
    requestParameters: UploadsApiProjectsUploadsListRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsList(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For project uploads
   * @summary Update a Upload in a Project
   * @param {UploadsApiProjectsUploadsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsPartialUpdate(
    requestParameters: UploadsApiProjectsUploadsPartialUpdateRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsPartialUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * For project uploads
   * @summary Delete a Upload from a Project
   * @param {UploadsApiProjectsUploadsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadsApi
   */
  public projectsUploadsUpdate(
    requestParameters: UploadsApiProjectsUploadsUpdateRequest,
    options?: any
  ) {
    return UploadsApiFp(this.configuration)
      .projectsUploadsUpdate(
        requestParameters.id,
        requestParameters.projectId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMePartialUpdate: async (
      data: UserSummary,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling usersMePartialUpdate.'
        )
      }
      const localVarPath = `/users/me/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Endpoints about an authenticated user.
     * @summary List Information About Logged In User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeRead: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/me/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeUpdate: async (
      data: UserSummary,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling usersMeUpdate.'
        )
      }
      const localVarPath = `/users/me/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMePartialUpdate(
      data: UserSummary,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSummary>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersMePartialUpdate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Endpoints about an authenticated user.
     * @summary List Information About Logged In User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeRead(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSummary>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersMeRead(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeUpdate(
      data: UserSummary,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSummary>
    > {
      const localVarAxiosArgs = await UsersApiAxiosParamCreator(
        configuration
      ).usersMeUpdate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMePartialUpdate(
      data: UserSummary,
      options?: any
    ): AxiosPromise<UserSummary> {
      return UsersApiFp(configuration)
        .usersMePartialUpdate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Endpoints about an authenticated user.
     * @summary List Information About Logged In User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeRead(options?: any): AxiosPromise<UserSummary> {
      return UsersApiFp(configuration)
        .usersMeRead(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Endpoints about an authenticated user.
     * @summary Update Information About Logged In User
     * @param {UserSummary} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeUpdate(data: UserSummary, options?: any): AxiosPromise<UserSummary> {
      return UsersApiFp(configuration)
        .usersMeUpdate(data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for usersMePartialUpdate operation in UsersApi.
 * @export
 * @interface UsersApiUsersMePartialUpdateRequest
 */
export interface UsersApiUsersMePartialUpdateRequest {
  /**
   *
   * @type {UserSummary}
   * @memberof UsersApiUsersMePartialUpdate
   */
  readonly data: UserSummary
}

/**
 * Request parameters for usersMeUpdate operation in UsersApi.
 * @export
 * @interface UsersApiUsersMeUpdateRequest
 */
export interface UsersApiUsersMeUpdateRequest {
  /**
   *
   * @type {UserSummary}
   * @memberof UsersApiUsersMeUpdate
   */
  readonly data: UserSummary
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   * Endpoints about an authenticated user.
   * @summary Update Information About Logged In User
   * @param {UsersApiUsersMePartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersMePartialUpdate(
    requestParameters: UsersApiUsersMePartialUpdateRequest,
    options?: any
  ) {
    return UsersApiFp(this.configuration)
      .usersMePartialUpdate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Endpoints about an authenticated user.
   * @summary List Information About Logged In User
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersMeRead(options?: any) {
    return UsersApiFp(this.configuration)
      .usersMeRead(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Endpoints about an authenticated user.
   * @summary Update Information About Logged In User
   * @param {UsersApiUsersMeUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersMeUpdate(
    requestParameters: UsersApiUsersMeUpdateRequest,
    options?: any
  ) {
    return UsersApiFp(this.configuration)
      .usersMeUpdate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Viewset for scale image reading detections.
     * @summary Create Scale Image Reading
     * @param {ScaleImageReading} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scaleImageReadingsCreate: async (
      data: ScaleImageReading,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling scaleImageReadingsCreate.'
        )
      }
      const localVarPath = `/scale_image_readings/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List out scale trip report between given start date and end date inclusive
     * @summary Get Scale Trip Reports
     * @param {string} projectId
     * @param {string} startdate Greater than or equal to this date.
     * @param {string} enddate Less than or equal to this date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsScaletripreportingList: async (
      projectId: string,
      startdate: string,
      enddate: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling vehiclesProjectsScaletripreportingList.'
        )
      }
      // verify required parameter 'startdate' is not null or undefined
      if (startdate === null || startdate === undefined) {
        throw new RequiredError(
          'startdate',
          'Required parameter startdate was null or undefined when calling vehiclesProjectsScaletripreportingList.'
        )
      }
      // verify required parameter 'enddate' is not null or undefined
      if (enddate === null || enddate === undefined) {
        throw new RequiredError(
          'enddate',
          'Required parameter enddate was null or undefined when calling vehiclesProjectsScaletripreportingList.'
        )
      }
      const localVarPath = `/vehicles/projects/{project_id}/scaletripreporting/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startdate !== undefined) {
        localVarQueryParameter['startdate'] = startdate
      }

      if (enddate !== undefined) {
        localVarQueryParameter['enddate'] = enddate
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get stream configuration for vehicle trips app
     * @summary Get Stream Configuration
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsStreamconfigStreammap: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling vehiclesProjectsStreamconfigStreammap.'
        )
      }
      const localVarPath = `/vehicles/projects/{project_id}/streamconfig/streammap/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for a trip\'s projects.
     * @summary List Project Trips
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsTripsList: async (
      projectId: string,
      startTime?: string,
      endTime?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling vehiclesProjectsTripsList.'
        )
      }
      const localVarPath = `/vehicles/projects/{project_id}/trips/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Viewset for scale image reading detections.
     * @summary Create Scale Image Reading
     * @param {ScaleImageReading} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scaleImageReadingsCreate(
      data: ScaleImageReading,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ScaleImageReading>
    > {
      const localVarAxiosArgs = await VehiclesApiAxiosParamCreator(
        configuration
      ).scaleImageReadingsCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List out scale trip report between given start date and end date inclusive
     * @summary Get Scale Trip Reports
     * @param {string} projectId
     * @param {string} startdate Greater than or equal to this date.
     * @param {string} enddate Less than or equal to this date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async vehiclesProjectsScaletripreportingList(
      projectId: string,
      startdate: string,
      enddate: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ScaleTripDayMetric>>
    > {
      const localVarAxiosArgs = await VehiclesApiAxiosParamCreator(
        configuration
      ).vehiclesProjectsScaletripreportingList(
        projectId,
        startdate,
        enddate,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get stream configuration for vehicle trips app
     * @summary Get Stream Configuration
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async vehiclesProjectsStreamconfigStreammap(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<VehicleStreamMap>
    > {
      const localVarAxiosArgs = await VehiclesApiAxiosParamCreator(
        configuration
      ).vehiclesProjectsStreamconfigStreammap(projectId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Viewset for a trip\'s projects.
     * @summary List Project Trips
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async vehiclesProjectsTripsList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Trip>>
    > {
      const localVarAxiosArgs = await VehiclesApiAxiosParamCreator(
        configuration
      ).vehiclesProjectsTripsList(projectId, startTime, endTime, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Viewset for scale image reading detections.
     * @summary Create Scale Image Reading
     * @param {ScaleImageReading} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scaleImageReadingsCreate(
      data: ScaleImageReading,
      options?: any
    ): AxiosPromise<ScaleImageReading> {
      return VehiclesApiFp(configuration)
        .scaleImageReadingsCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List out scale trip report between given start date and end date inclusive
     * @summary Get Scale Trip Reports
     * @param {string} projectId
     * @param {string} startdate Greater than or equal to this date.
     * @param {string} enddate Less than or equal to this date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsScaletripreportingList(
      projectId: string,
      startdate: string,
      enddate: string,
      options?: any
    ): AxiosPromise<Array<ScaleTripDayMetric>> {
      return VehiclesApiFp(configuration)
        .vehiclesProjectsScaletripreportingList(
          projectId,
          startdate,
          enddate,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get stream configuration for vehicle trips app
     * @summary Get Stream Configuration
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsStreamconfigStreammap(
      projectId: string,
      options?: any
    ): AxiosPromise<VehicleStreamMap> {
      return VehiclesApiFp(configuration)
        .vehiclesProjectsStreamconfigStreammap(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for a trip\'s projects.
     * @summary List Project Trips
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vehiclesProjectsTripsList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      options?: any
    ): AxiosPromise<Array<Trip>> {
      return VehiclesApiFp(configuration)
        .vehiclesProjectsTripsList(projectId, startTime, endTime, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for scaleImageReadingsCreate operation in VehiclesApi.
 * @export
 * @interface VehiclesApiScaleImageReadingsCreateRequest
 */
export interface VehiclesApiScaleImageReadingsCreateRequest {
  /**
   *
   * @type {ScaleImageReading}
   * @memberof VehiclesApiScaleImageReadingsCreate
   */
  readonly data: ScaleImageReading
}

/**
 * Request parameters for vehiclesProjectsScaletripreportingList operation in VehiclesApi.
 * @export
 * @interface VehiclesApiVehiclesProjectsScaletripreportingListRequest
 */
export interface VehiclesApiVehiclesProjectsScaletripreportingListRequest {
  /**
   *
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsScaletripreportingList
   */
  readonly projectId: string

  /**
   * Greater than or equal to this date.
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsScaletripreportingList
   */
  readonly startdate: string

  /**
   * Less than or equal to this date.
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsScaletripreportingList
   */
  readonly enddate: string
}

/**
 * Request parameters for vehiclesProjectsStreamconfigStreammap operation in VehiclesApi.
 * @export
 * @interface VehiclesApiVehiclesProjectsStreamconfigStreammapRequest
 */
export interface VehiclesApiVehiclesProjectsStreamconfigStreammapRequest {
  /**
   *
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsStreamconfigStreammap
   */
  readonly projectId: string
}

/**
 * Request parameters for vehiclesProjectsTripsList operation in VehiclesApi.
 * @export
 * @interface VehiclesApiVehiclesProjectsTripsListRequest
 */
export interface VehiclesApiVehiclesProjectsTripsListRequest {
  /**
   *
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsTripsList
   */
  readonly projectId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsTripsList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VehiclesApiVehiclesProjectsTripsList
   */
  readonly endTime?: string
}

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
  /**
   * Viewset for scale image reading detections.
   * @summary Create Scale Image Reading
   * @param {VehiclesApiScaleImageReadingsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VehiclesApi
   */
  public scaleImageReadingsCreate(
    requestParameters: VehiclesApiScaleImageReadingsCreateRequest,
    options?: any
  ) {
    return VehiclesApiFp(this.configuration)
      .scaleImageReadingsCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List out scale trip report between given start date and end date inclusive
   * @summary Get Scale Trip Reports
   * @param {VehiclesApiVehiclesProjectsScaletripreportingListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VehiclesApi
   */
  public vehiclesProjectsScaletripreportingList(
    requestParameters: VehiclesApiVehiclesProjectsScaletripreportingListRequest,
    options?: any
  ) {
    return VehiclesApiFp(this.configuration)
      .vehiclesProjectsScaletripreportingList(
        requestParameters.projectId,
        requestParameters.startdate,
        requestParameters.enddate,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get stream configuration for vehicle trips app
   * @summary Get Stream Configuration
   * @param {VehiclesApiVehiclesProjectsStreamconfigStreammapRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VehiclesApi
   */
  public vehiclesProjectsStreamconfigStreammap(
    requestParameters: VehiclesApiVehiclesProjectsStreamconfigStreammapRequest,
    options?: any
  ) {
    return VehiclesApiFp(this.configuration)
      .vehiclesProjectsStreamconfigStreammap(
        requestParameters.projectId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for a trip\'s projects.
   * @summary List Project Trips
   * @param {VehiclesApiVehiclesProjectsTripsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VehiclesApi
   */
  public vehiclesProjectsTripsList(
    requestParameters: VehiclesApiVehiclesProjectsTripsListRequest,
    options?: any
  ) {
    return VehiclesApiFp(this.configuration)
      .vehiclesProjectsTripsList(
        requestParameters.projectId,
        requestParameters.startTime,
        requestParameters.endTime,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VideoAnnotationsApi - axios parameter creator
 * @export
 */
export const VideoAnnotationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Lists analyses in video annotation.
     * @summary List Analyses
     * @param {string} projectId
     * @param {string} [completed]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsVideoannotationAnalysesList: async (
      projectId: string,
      completed?: string,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsVideoannotationAnalysesList.'
        )
      }
      const localVarPath = `/projects/{project_id}/videoannotation_analyses/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (completed !== undefined) {
        localVarQueryParameter['completed'] = completed
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Adds one clip to an analysis.  This triggers an extraction job a minute after creation.
     * @summary Create Clip
     * @param {string} analysisId
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsCreate: async (
      analysisId: string,
      data: Clip,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesClipsCreate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes clip from an analysis
     * @summary Delete Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsDelete: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsDelete.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesClipsDelete.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Generate a downloadable video from a clip.
     * @summary Generate Video from Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsGenerateClip: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsGenerateClip.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesClipsGenerateClip.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/{id}/generate_clip/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * List clips for an analysis.
     * @summary List Clips
     * @param {string} analysisId
     * @param {string} [state]
     * @param {string} [ordering] Choices: [start_datetime, -start_datetime]. Default is start_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsList: async (
      analysisId: string,
      state?: string,
      ordering?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsList.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/`.replace(
        `{${'analysis_id'}}`,
        encodeURIComponent(String(analysisId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsPartialUpdate: async (
      analysisId: string,
      id: string,
      data: Clip,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsPartialUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesClipsPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesClipsPartialUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Get clips for an analysis.
     * @summary Retrieve Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsRead: async (
      analysisId: string,
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsRead.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesClipsRead.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsUpdate: async (
      analysisId: string,
      id: string,
      data: Clip,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'analysisId' is not null or undefined
      if (analysisId === null || analysisId === undefined) {
        throw new RequiredError(
          'analysisId',
          'Required parameter analysisId was null or undefined when calling videoannotationAnalysesClipsUpdate.'
        )
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesClipsUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesClipsUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{analysis_id}/clips/{id}/`
        .replace(`{${'analysis_id'}}`, encodeURIComponent(String(analysisId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Create Analysis
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesCreate: async (
      data: Analysis,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesCreate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Delete Clip
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesDelete: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesDelete.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary List Analysis
     * @param {string} [completed]
     * @param {number} [projectId]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesList: async (
      completed?: string,
      projectId?: number,
      page?: number,
      per?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/videoannotation/analyses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (completed !== undefined) {
        localVarQueryParameter['completed'] = completed
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (per !== undefined) {
        localVarQueryParameter['per'] = per
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesPartialUpdate: async (
      id: string,
      data: Analysis,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesPartialUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Retrieve Analysis
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesRead: async (
      id: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesRead.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesUpdate: async (
      id: string,
      data: Analysis,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling videoannotationAnalysesUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videoannotationAnalysesUpdate.'
        )
      }
      const localVarPath = `/videoannotation/analyses/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VideoAnnotationsApi - functional programming interface
 * @export
 */
export const VideoAnnotationsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Lists analyses in video annotation.
     * @summary List Analyses
     * @param {string} projectId
     * @param {string} [completed]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsVideoannotationAnalysesList(
      projectId: string,
      completed?: string,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2004>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).projectsVideoannotationAnalysesList(
        projectId,
        completed,
        page,
        per,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Adds one clip to an analysis.  This triggers an extraction job a minute after creation.
     * @summary Create Clip
     * @param {string} analysisId
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsCreate(
      analysisId: string,
      data: Clip,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Clip>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsCreate(analysisId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes clip from an analysis
     * @summary Delete Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsDelete(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsDelete(analysisId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Generate a downloadable video from a clip.
     * @summary Generate Video from Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsGenerateClip(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsGenerateClip(analysisId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List clips for an analysis.
     * @summary List Clips
     * @param {string} analysisId
     * @param {string} [state]
     * @param {string} [ordering] Choices: [start_datetime, -start_datetime]. Default is start_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsList(
      analysisId: string,
      state?: string,
      ordering?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Clip>>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsList(analysisId, state, ordering, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsPartialUpdate(
      analysisId: string,
      id: string,
      data: Clip,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Clip>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsPartialUpdate(analysisId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get clips for an analysis.
     * @summary Retrieve Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsRead(
      analysisId: string,
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Clip>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsRead(analysisId, id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesClipsUpdate(
      analysisId: string,
      id: string,
      data: Clip,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Clip>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesClipsUpdate(analysisId, id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Create Analysis
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesCreate(
      data: Analysis,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Analysis>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesCreate(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Delete Clip
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesDelete(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesDelete(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary List Analysis
     * @param {string} [completed]
     * @param {number} [projectId]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesList(
      completed?: string,
      projectId?: number,
      page?: number,
      per?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2004>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesList(completed, projectId, page, per, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesPartialUpdate(
      id: string,
      data: Analysis,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Analysis>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesPartialUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Retrieve Analysis
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesRead(
      id: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Analysis>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesRead(id, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoannotationAnalysesUpdate(
      id: string,
      data: Analysis,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Analysis>
    > {
      const localVarAxiosArgs = await VideoAnnotationsApiAxiosParamCreator(
        configuration
      ).videoannotationAnalysesUpdate(id, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * VideoAnnotationsApi - factory interface
 * @export
 */
export const VideoAnnotationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Lists analyses in video annotation.
     * @summary List Analyses
     * @param {string} projectId
     * @param {string} [completed]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsVideoannotationAnalysesList(
      projectId: string,
      completed?: string,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse2004> {
      return VideoAnnotationsApiFp(configuration)
        .projectsVideoannotationAnalysesList(
          projectId,
          completed,
          page,
          per,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Adds one clip to an analysis.  This triggers an extraction job a minute after creation.
     * @summary Create Clip
     * @param {string} analysisId
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsCreate(
      analysisId: string,
      data: Clip,
      options?: any
    ): AxiosPromise<Clip> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsCreate(analysisId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes clip from an analysis
     * @summary Delete Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsDelete(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsDelete(analysisId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Generate a downloadable video from a clip.
     * @summary Generate Video from Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsGenerateClip(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsGenerateClip(analysisId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List clips for an analysis.
     * @summary List Clips
     * @param {string} analysisId
     * @param {string} [state]
     * @param {string} [ordering] Choices: [start_datetime, -start_datetime]. Default is start_datetime.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsList(
      analysisId: string,
      state?: string,
      ordering?: string,
      options?: any
    ): AxiosPromise<Array<Clip>> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsList(analysisId, state, ordering, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsPartialUpdate(
      analysisId: string,
      id: string,
      data: Clip,
      options?: any
    ): AxiosPromise<Clip> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsPartialUpdate(
          analysisId,
          id,
          data,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get clips for an analysis.
     * @summary Retrieve Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsRead(
      analysisId: string,
      id: string,
      options?: any
    ): AxiosPromise<Clip> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsRead(analysisId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates information about an clip
     * @summary Edit Clip
     * @param {string} analysisId
     * @param {string} id
     * @param {Clip} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesClipsUpdate(
      analysisId: string,
      id: string,
      data: Clip,
      options?: any
    ): AxiosPromise<Clip> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesClipsUpdate(analysisId, id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Create Analysis
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesCreate(
      data: Analysis,
      options?: any
    ): AxiosPromise<Analysis> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesCreate(data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Delete Clip
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesDelete(
      id: string,
      options?: any
    ): AxiosPromise<void> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesDelete(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary List Analysis
     * @param {string} [completed]
     * @param {number} [projectId]
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [per] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesList(
      completed?: string,
      projectId?: number,
      page?: number,
      per?: number,
      options?: any
    ): AxiosPromise<InlineResponse2004> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesList(completed, projectId, page, per, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesPartialUpdate(
      id: string,
      data: Analysis,
      options?: any
    ): AxiosPromise<Analysis> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesPartialUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Retrieve Analysis
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesRead(
      id: string,
      options?: any
    ): AxiosPromise<Analysis> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesRead(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists analyses scoped by a project.
     * @summary Edit Analysis
     * @param {string} id
     * @param {Analysis} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoannotationAnalysesUpdate(
      id: string,
      data: Analysis,
      options?: any
    ): AxiosPromise<Analysis> {
      return VideoAnnotationsApiFp(configuration)
        .videoannotationAnalysesUpdate(id, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsVideoannotationAnalysesList operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiProjectsVideoannotationAnalysesListRequest
 */
export interface VideoAnnotationsApiProjectsVideoannotationAnalysesListRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiProjectsVideoannotationAnalysesList
   */
  readonly projectId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiProjectsVideoannotationAnalysesList
   */
  readonly completed?: string

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof VideoAnnotationsApiProjectsVideoannotationAnalysesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof VideoAnnotationsApiProjectsVideoannotationAnalysesList
   */
  readonly per?: number
}

/**
 * Request parameters for videoannotationAnalysesClipsCreate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsCreateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsCreate
   */
  readonly analysisId: string

  /**
   *
   * @type {Clip}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsCreate
   */
  readonly data: Clip
}

/**
 * Request parameters for videoannotationAnalysesClipsDelete operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsDeleteRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsDelete
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsDelete
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesClipsGenerateClip operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClipRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClipRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClip
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClip
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesClipsList operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsListRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsListRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsList
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsList
   */
  readonly state?: string

  /**
   * Choices: [start_datetime, -start_datetime]. Default is start_datetime.
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsList
   */
  readonly ordering?: string
}

/**
 * Request parameters for videoannotationAnalysesClipsPartialUpdate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdate
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {Clip}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdate
   */
  readonly data: Clip
}

/**
 * Request parameters for videoannotationAnalysesClipsRead operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsReadRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsReadRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsRead
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsRead
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesClipsUpdate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesClipsUpdateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesClipsUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsUpdate
   */
  readonly analysisId: string

  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsUpdate
   */
  readonly id: string

  /**
   *
   * @type {Clip}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesClipsUpdate
   */
  readonly data: Clip
}

/**
 * Request parameters for videoannotationAnalysesCreate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesCreateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesCreateRequest {
  /**
   *
   * @type {Analysis}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesCreate
   */
  readonly data: Analysis
}

/**
 * Request parameters for videoannotationAnalysesDelete operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesDeleteRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesDelete
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesList operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesListRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesListRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesList
   */
  readonly completed?: string

  /**
   *
   * @type {number}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesList
   */
  readonly projectId?: number

  /**
   * A page number within the paginated result set.
   * @type {number}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesList
   */
  readonly page?: number

  /**
   * Number of results to return per page.
   * @type {number}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesList
   */
  readonly per?: number
}

/**
 * Request parameters for videoannotationAnalysesPartialUpdate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesPartialUpdateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {Analysis}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesPartialUpdate
   */
  readonly data: Analysis
}

/**
 * Request parameters for videoannotationAnalysesRead operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesReadRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesReadRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesRead
   */
  readonly id: string
}

/**
 * Request parameters for videoannotationAnalysesUpdate operation in VideoAnnotationsApi.
 * @export
 * @interface VideoAnnotationsApiVideoannotationAnalysesUpdateRequest
 */
export interface VideoAnnotationsApiVideoannotationAnalysesUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesUpdate
   */
  readonly id: string

  /**
   *
   * @type {Analysis}
   * @memberof VideoAnnotationsApiVideoannotationAnalysesUpdate
   */
  readonly data: Analysis
}

/**
 * VideoAnnotationsApi - object-oriented interface
 * @export
 * @class VideoAnnotationsApi
 * @extends {BaseAPI}
 */
export class VideoAnnotationsApi extends BaseAPI {
  /**
   * Lists analyses in video annotation.
   * @summary List Analyses
   * @param {VideoAnnotationsApiProjectsVideoannotationAnalysesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public projectsVideoannotationAnalysesList(
    requestParameters: VideoAnnotationsApiProjectsVideoannotationAnalysesListRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .projectsVideoannotationAnalysesList(
        requestParameters.projectId,
        requestParameters.completed,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Adds one clip to an analysis.  This triggers an extraction job a minute after creation.
   * @summary Create Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsCreate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsCreateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsCreate(
        requestParameters.analysisId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes clip from an analysis
   * @summary Delete Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsDelete(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsDeleteRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsDelete(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Generate a downloadable video from a clip.
   * @summary Generate Video from Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClipRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsGenerateClip(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsGenerateClipRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsGenerateClip(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List clips for an analysis.
   * @summary List Clips
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsList(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsListRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsList(
        requestParameters.analysisId,
        requestParameters.state,
        requestParameters.ordering,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates information about an clip
   * @summary Edit Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsPartialUpdate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsPartialUpdateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsPartialUpdate(
        requestParameters.analysisId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get clips for an analysis.
   * @summary Retrieve Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsRead(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsReadRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsRead(
        requestParameters.analysisId,
        requestParameters.id,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates information about an clip
   * @summary Edit Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesClipsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesClipsUpdate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesClipsUpdateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesClipsUpdate(
        requestParameters.analysisId,
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary Create Analysis
   * @param {VideoAnnotationsApiVideoannotationAnalysesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesCreate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesCreateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesCreate(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary Delete Clip
   * @param {VideoAnnotationsApiVideoannotationAnalysesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesDelete(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesDeleteRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesDelete(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary List Analysis
   * @param {VideoAnnotationsApiVideoannotationAnalysesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesList(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesListRequest = {},
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesList(
        requestParameters.completed,
        requestParameters.projectId,
        requestParameters.page,
        requestParameters.per,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary Edit Analysis
   * @param {VideoAnnotationsApiVideoannotationAnalysesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesPartialUpdate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesPartialUpdateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesPartialUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary Retrieve Analysis
   * @param {VideoAnnotationsApiVideoannotationAnalysesReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesRead(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesReadRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists analyses scoped by a project.
   * @summary Edit Analysis
   * @param {VideoAnnotationsApiVideoannotationAnalysesUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoAnnotationsApi
   */
  public videoannotationAnalysesUpdate(
    requestParameters: VideoAnnotationsApiVideoannotationAnalysesUpdateRequest,
    options?: any
  ) {
    return VideoAnnotationsApiFp(this.configuration)
      .videoannotationAnalysesUpdate(
        requestParameters.id,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VideoProcessingApi - axios parameter creator
 * @export
 */
export const VideoProcessingApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * For video processing requests
     * @summary Make Video Processing Request
     * @param {string} streamId
     * @param {VideoStabilizationJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideostabilizationjobsCreate: async (
      streamId: string,
      data: VideoStabilizationJob,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideostabilizationjobsCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideostabilizationjobsCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videostabilizationjobs/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VideoProcessingApi - functional programming interface
 * @export
 */
export const VideoProcessingApiFp = function (configuration?: Configuration) {
  return {
    /**
     * For video processing requests
     * @summary Make Video Processing Request
     * @param {string} streamId
     * @param {VideoStabilizationJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideostabilizationjobsCreate(
      streamId: string,
      data: VideoStabilizationJob,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<VideoStabilizationJob>
    > {
      const localVarAxiosArgs = await VideoProcessingApiAxiosParamCreator(
        configuration
      ).streamsVideostabilizationjobsCreate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * VideoProcessingApi - factory interface
 * @export
 */
export const VideoProcessingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * For video processing requests
     * @summary Make Video Processing Request
     * @param {string} streamId
     * @param {VideoStabilizationJob} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideostabilizationjobsCreate(
      streamId: string,
      data: VideoStabilizationJob,
      options?: any
    ): AxiosPromise<VideoStabilizationJob> {
      return VideoProcessingApiFp(configuration)
        .streamsVideostabilizationjobsCreate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for streamsVideostabilizationjobsCreate operation in VideoProcessingApi.
 * @export
 * @interface VideoProcessingApiStreamsVideostabilizationjobsCreateRequest
 */
export interface VideoProcessingApiStreamsVideostabilizationjobsCreateRequest {
  /**
   *
   * @type {string}
   * @memberof VideoProcessingApiStreamsVideostabilizationjobsCreate
   */
  readonly streamId: string

  /**
   *
   * @type {VideoStabilizationJob}
   * @memberof VideoProcessingApiStreamsVideostabilizationjobsCreate
   */
  readonly data: VideoStabilizationJob
}

/**
 * VideoProcessingApi - object-oriented interface
 * @export
 * @class VideoProcessingApi
 * @extends {BaseAPI}
 */
export class VideoProcessingApi extends BaseAPI {
  /**
   * For video processing requests
   * @summary Make Video Processing Request
   * @param {VideoProcessingApiStreamsVideostabilizationjobsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideoProcessingApi
   */
  public streamsVideostabilizationjobsCreate(
    requestParameters: VideoProcessingApiStreamsVideostabilizationjobsCreateRequest,
    options?: any
  ) {
    return VideoProcessingApiFp(this.configuration)
      .streamsVideostabilizationjobsCreate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VideosApi - axios parameter creator
 * @export
 */
export const VideosApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Lists a stream\'s videos, sorted by local_start_time. This omits missing videos
     * @summary List a Project\'s Videos
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [service] Choices: [S3, B2]
     * @param {string} [videoType] Choices: [1x, 20x, 200x, 4x-stab, 20x-stab, 200x-stab, daily]
     * @param {string} [state] Choices: [available, locked, pending, archived, unarchiving, limited, missing]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsVideosList: async (
      projectId: string,
      startTime?: string,
      endTime?: string,
      service?: string,
      videoType?: string,
      state?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
        throw new RequiredError(
          'projectId',
          'Required parameter projectId was null or undefined when calling projectsVideosList.'
        )
      }
      const localVarPath = `/projects/{project_id}/videos/`.replace(
        `{${'project_id'}}`,
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (service !== undefined) {
        localVarQueryParameter['service'] = service
      }

      if (videoType !== undefined) {
        localVarQueryParameter['video_type'] = videoType
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Adds one video to a stream to the system. Important Note: This will do an update if you pass in a video with the same (stream, start_time, video_type)
     * @summary Add (or Update) a Video To A Stream
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosCreate: async (
      streamId: string,
      data: Video,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosCreate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideosCreate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes record of a video from this stream.
     * @summary Deletes a Video from a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosDelete: async (
      id: string,
      streamId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsVideosDelete.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosDelete.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Returns image download of an archived video.
     * @summary Extract Image from a Video
     * @param {string} id
     * @param {string} streamId
     * @param {VideoScreenshotRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosExtractImage: async (
      id: string,
      streamId: string,
      data: VideoScreenshotRequestSerialzer,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsVideosExtractImage.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosExtractImage.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideosExtractImage.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/{id}/extract_image/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists a stream\'s videos, sorted by local_start_time.
     * @summary List a Stream\'s Videos
     * @param {string} streamId
     * @param {string} [service]
     * @param {string} [videoType]
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosList: async (
      streamId: string,
      service?: string,
      videoType?: string,
      startTime?: string,
      endTime?: string,
      state?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosList.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/`.replace(
        `{${'stream_id'}}`,
        encodeURIComponent(String(streamId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      if (service !== undefined) {
        localVarQueryParameter['service'] = service
      }

      if (videoType !== undefined) {
        localVarQueryParameter['video_type'] = videoType
      }

      if (startTime !== undefined) {
        localVarQueryParameter['start_time'] = startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['end_time'] = endTime
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosPartialUpdate: async (
      id: string,
      streamId: string,
      data: Video,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsVideosPartialUpdate.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosPartialUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideosPartialUpdate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Requests video to be archived.
     * @summary Requests Video Archival
     * @param {string} id
     * @param {string} streamId
     * @param {VideoRestoreRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosRequestRestore: async (
      id: string,
      streamId: string,
      data: VideoRestoreRequestSerialzer,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsVideosRequestRestore.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosRequestRestore.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideosRequestRestore.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/{id}/request_restore/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      // authentication Standard Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Standard Authentication', [
                'standard',
              ])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosUpdate: async (
      id: string,
      streamId: string,
      data: Video,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling streamsVideosUpdate.'
        )
      }
      // verify required parameter 'streamId' is not null or undefined
      if (streamId === null || streamId === undefined) {
        throw new RequiredError(
          'streamId',
          'Required parameter streamId was null or undefined when calling streamsVideosUpdate.'
        )
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling streamsVideosUpdate.'
        )
      }
      const localVarPath = `/streams/{stream_id}/videos/{id}/`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'stream_id'}}`, encodeURIComponent(String(streamId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes videos from this list of urls.
     * @summary Deletes Videos Given A URL List
     * @param {VideoUrlList} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosUrllistDelete: async (
      data: VideoUrlList,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          'data',
          'Required parameter data was null or undefined when calling videosUrllistDelete.'
        )
      }
      const localVarPath = `/videos/urllist/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com')
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Root Authentication required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken('Root Authentication', ['root'])
            : await configuration.accessToken
        localVarHeaderParameter['Authorization'] =
          'Bearer ' + localVarAccessTokenValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      const queryParameters = new URLSearchParams(localVarUrlObj.search)
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key])
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key])
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString()
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const nonString = typeof data !== 'string'
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(
              localVarRequestOptions.headers['Content-Type']
            )
          : nonString
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(data !== undefined ? data : {})
        : data || ''

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VideosApi - functional programming interface
 * @export
 */
export const VideosApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Lists a stream\'s videos, sorted by local_start_time. This omits missing videos
     * @summary List a Project\'s Videos
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [service] Choices: [S3, B2]
     * @param {string} [videoType] Choices: [1x, 20x, 200x, 4x-stab, 20x-stab, 200x-stab, daily]
     * @param {string} [state] Choices: [available, locked, pending, archived, unarchiving, limited, missing]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsVideosList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      service?: string,
      videoType?: string,
      state?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<StreamVideos>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).projectsVideosList(
        projectId,
        startTime,
        endTime,
        service,
        videoType,
        state,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Adds one video to a stream to the system. Important Note: This will do an update if you pass in a video with the same (stream, start_time, video_type)
     * @summary Add (or Update) a Video To A Stream
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosCreate(
      streamId: string,
      data: Video,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Video>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosCreate(streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes record of a video from this stream.
     * @summary Deletes a Video from a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosDelete(
      id: string,
      streamId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosDelete(id, streamId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Returns image download of an archived video.
     * @summary Extract Image from a Video
     * @param {string} id
     * @param {string} streamId
     * @param {VideoScreenshotRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosExtractImage(
      id: string,
      streamId: string,
      data: VideoScreenshotRequestSerialzer,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosExtractImage(id, streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists a stream\'s videos, sorted by local_start_time.
     * @summary List a Stream\'s Videos
     * @param {string} streamId
     * @param {string} [service]
     * @param {string} [videoType]
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosList(
      streamId: string,
      service?: string,
      videoType?: string,
      startTime?: string,
      endTime?: string,
      state?: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<VideoSummary>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosList(
        streamId,
        service,
        videoType,
        startTime,
        endTime,
        state,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosPartialUpdate(
      id: string,
      streamId: string,
      data: Video,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Video>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosPartialUpdate(id, streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Requests video to be archived.
     * @summary Requests Video Archival
     * @param {string} id
     * @param {string} streamId
     * @param {VideoRestoreRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosRequestRestore(
      id: string,
      streamId: string,
      data: VideoRestoreRequestSerialzer,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosRequestRestore(id, streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async streamsVideosUpdate(
      id: string,
      streamId: string,
      data: Video,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Video>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).streamsVideosUpdate(id, streamId, data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes videos from this list of urls.
     * @summary Deletes Videos Given A URL List
     * @param {VideoUrlList} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosUrllistDelete(
      data: VideoUrlList,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<VideoUrlListDeleteResponse>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosUrllistDelete(data, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * VideosApi - factory interface
 * @export
 */
export const VideosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Lists a stream\'s videos, sorted by local_start_time. This omits missing videos
     * @summary List a Project\'s Videos
     * @param {string} projectId
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [service] Choices: [S3, B2]
     * @param {string} [videoType] Choices: [1x, 20x, 200x, 4x-stab, 20x-stab, 200x-stab, daily]
     * @param {string} [state] Choices: [available, locked, pending, archived, unarchiving, limited, missing]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsVideosList(
      projectId: string,
      startTime?: string,
      endTime?: string,
      service?: string,
      videoType?: string,
      state?: string,
      options?: any
    ): AxiosPromise<Array<StreamVideos>> {
      return VideosApiFp(configuration)
        .projectsVideosList(
          projectId,
          startTime,
          endTime,
          service,
          videoType,
          state,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Adds one video to a stream to the system. Important Note: This will do an update if you pass in a video with the same (stream, start_time, video_type)
     * @summary Add (or Update) a Video To A Stream
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosCreate(
      streamId: string,
      data: Video,
      options?: any
    ): AxiosPromise<Video> {
      return VideosApiFp(configuration)
        .streamsVideosCreate(streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes record of a video from this stream.
     * @summary Deletes a Video from a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosDelete(
      id: string,
      streamId: string,
      options?: any
    ): AxiosPromise<void> {
      return VideosApiFp(configuration)
        .streamsVideosDelete(id, streamId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns image download of an archived video.
     * @summary Extract Image from a Video
     * @param {string} id
     * @param {string} streamId
     * @param {VideoScreenshotRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosExtractImage(
      id: string,
      streamId: string,
      data: VideoScreenshotRequestSerialzer,
      options?: any
    ): AxiosPromise<void> {
      return VideosApiFp(configuration)
        .streamsVideosExtractImage(id, streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists a stream\'s videos, sorted by local_start_time.
     * @summary List a Stream\'s Videos
     * @param {string} streamId
     * @param {string} [service]
     * @param {string} [videoType]
     * @param {string} [startTime] Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [endTime] Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosList(
      streamId: string,
      service?: string,
      videoType?: string,
      startTime?: string,
      endTime?: string,
      state?: string,
      options?: any
    ): AxiosPromise<Array<VideoSummary>> {
      return VideosApiFp(configuration)
        .streamsVideosList(
          streamId,
          service,
          videoType,
          startTime,
          endTime,
          state,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosPartialUpdate(
      id: string,
      streamId: string,
      data: Video,
      options?: any
    ): AxiosPromise<Video> {
      return VideosApiFp(configuration)
        .streamsVideosPartialUpdate(id, streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Requests video to be archived.
     * @summary Requests Video Archival
     * @param {string} id
     * @param {string} streamId
     * @param {VideoRestoreRequestSerialzer} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosRequestRestore(
      id: string,
      streamId: string,
      data: VideoRestoreRequestSerialzer,
      options?: any
    ): AxiosPromise<void> {
      return VideosApiFp(configuration)
        .streamsVideosRequestRestore(id, streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates attributes of a video.
     * @summary Updates a Video of a Stream
     * @param {string} id
     * @param {string} streamId
     * @param {Video} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    streamsVideosUpdate(
      id: string,
      streamId: string,
      data: Video,
      options?: any
    ): AxiosPromise<Video> {
      return VideosApiFp(configuration)
        .streamsVideosUpdate(id, streamId, data, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes videos from this list of urls.
     * @summary Deletes Videos Given A URL List
     * @param {VideoUrlList} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosUrllistDelete(
      data: VideoUrlList,
      options?: any
    ): AxiosPromise<VideoUrlListDeleteResponse> {
      return VideosApiFp(configuration)
        .videosUrllistDelete(data, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for projectsVideosList operation in VideosApi.
 * @export
 * @interface VideosApiProjectsVideosListRequest
 */
export interface VideosApiProjectsVideosListRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly projectId: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly endTime?: string

  /**
   * Choices: [S3, B2]
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly service?: string

  /**
   * Choices: [1x, 20x, 200x, 4x-stab, 20x-stab, 200x-stab, daily]
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly videoType?: string

  /**
   * Choices: [available, locked, pending, archived, unarchiving, limited, missing]
   * @type {string}
   * @memberof VideosApiProjectsVideosList
   */
  readonly state?: string
}

/**
 * Request parameters for streamsVideosCreate operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosCreateRequest
 */
export interface VideosApiStreamsVideosCreateRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosCreate
   */
  readonly streamId: string

  /**
   *
   * @type {Video}
   * @memberof VideosApiStreamsVideosCreate
   */
  readonly data: Video
}

/**
 * Request parameters for streamsVideosDelete operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosDeleteRequest
 */
export interface VideosApiStreamsVideosDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosDelete
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosDelete
   */
  readonly streamId: string
}

/**
 * Request parameters for streamsVideosExtractImage operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosExtractImageRequest
 */
export interface VideosApiStreamsVideosExtractImageRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosExtractImage
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosExtractImage
   */
  readonly streamId: string

  /**
   *
   * @type {VideoScreenshotRequestSerialzer}
   * @memberof VideosApiStreamsVideosExtractImage
   */
  readonly data: VideoScreenshotRequestSerialzer
}

/**
 * Request parameters for streamsVideosList operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosListRequest
 */
export interface VideosApiStreamsVideosListRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly streamId: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly service?: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly videoType?: string

  /**
   * Greater than or equal to this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly startTime?: string

  /**
   * Less than this time. Time must be in ISO 8601 format. https://en.wikipedia.org/wiki/ISO_8601.
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly endTime?: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosList
   */
  readonly state?: string
}

/**
 * Request parameters for streamsVideosPartialUpdate operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosPartialUpdateRequest
 */
export interface VideosApiStreamsVideosPartialUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosPartialUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosPartialUpdate
   */
  readonly streamId: string

  /**
   *
   * @type {Video}
   * @memberof VideosApiStreamsVideosPartialUpdate
   */
  readonly data: Video
}

/**
 * Request parameters for streamsVideosRequestRestore operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosRequestRestoreRequest
 */
export interface VideosApiStreamsVideosRequestRestoreRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosRequestRestore
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosRequestRestore
   */
  readonly streamId: string

  /**
   *
   * @type {VideoRestoreRequestSerialzer}
   * @memberof VideosApiStreamsVideosRequestRestore
   */
  readonly data: VideoRestoreRequestSerialzer
}

/**
 * Request parameters for streamsVideosUpdate operation in VideosApi.
 * @export
 * @interface VideosApiStreamsVideosUpdateRequest
 */
export interface VideosApiStreamsVideosUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosUpdate
   */
  readonly id: string

  /**
   *
   * @type {string}
   * @memberof VideosApiStreamsVideosUpdate
   */
  readonly streamId: string

  /**
   *
   * @type {Video}
   * @memberof VideosApiStreamsVideosUpdate
   */
  readonly data: Video
}

/**
 * Request parameters for videosUrllistDelete operation in VideosApi.
 * @export
 * @interface VideosApiVideosUrllistDeleteRequest
 */
export interface VideosApiVideosUrllistDeleteRequest {
  /**
   *
   * @type {VideoUrlList}
   * @memberof VideosApiVideosUrllistDelete
   */
  readonly data: VideoUrlList
}

/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
export class VideosApi extends BaseAPI {
  /**
   * Lists a stream\'s videos, sorted by local_start_time. This omits missing videos
   * @summary List a Project\'s Videos
   * @param {VideosApiProjectsVideosListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public projectsVideosList(
    requestParameters: VideosApiProjectsVideosListRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .projectsVideosList(
        requestParameters.projectId,
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.service,
        requestParameters.videoType,
        requestParameters.state,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Adds one video to a stream to the system. Important Note: This will do an update if you pass in a video with the same (stream, start_time, video_type)
   * @summary Add (or Update) a Video To A Stream
   * @param {VideosApiStreamsVideosCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosCreate(
    requestParameters: VideosApiStreamsVideosCreateRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosCreate(
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes record of a video from this stream.
   * @summary Deletes a Video from a Stream
   * @param {VideosApiStreamsVideosDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosDelete(
    requestParameters: VideosApiStreamsVideosDeleteRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosDelete(
        requestParameters.id,
        requestParameters.streamId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns image download of an archived video.
   * @summary Extract Image from a Video
   * @param {VideosApiStreamsVideosExtractImageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosExtractImage(
    requestParameters: VideosApiStreamsVideosExtractImageRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosExtractImage(
        requestParameters.id,
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists a stream\'s videos, sorted by local_start_time.
   * @summary List a Stream\'s Videos
   * @param {VideosApiStreamsVideosListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosList(
    requestParameters: VideosApiStreamsVideosListRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosList(
        requestParameters.streamId,
        requestParameters.service,
        requestParameters.videoType,
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.state,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates attributes of a video.
   * @summary Updates a Video of a Stream
   * @param {VideosApiStreamsVideosPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosPartialUpdate(
    requestParameters: VideosApiStreamsVideosPartialUpdateRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosPartialUpdate(
        requestParameters.id,
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Requests video to be archived.
   * @summary Requests Video Archival
   * @param {VideosApiStreamsVideosRequestRestoreRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosRequestRestore(
    requestParameters: VideosApiStreamsVideosRequestRestoreRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosRequestRestore(
        requestParameters.id,
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates attributes of a video.
   * @summary Updates a Video of a Stream
   * @param {VideosApiStreamsVideosUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public streamsVideosUpdate(
    requestParameters: VideosApiStreamsVideosUpdateRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .streamsVideosUpdate(
        requestParameters.id,
        requestParameters.streamId,
        requestParameters.data,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes videos from this list of urls.
   * @summary Deletes Videos Given A URL List
   * @param {VideosApiVideosUrllistDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public videosUrllistDelete(
    requestParameters: VideosApiVideosUrllistDeleteRequest,
    options?: any
  ) {
    return VideosApiFp(this.configuration)
      .videosUrllistDelete(requestParameters.data, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
